import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The javascript `Date` as string. Type represents date and time as the ISO Date string. */
  DateTime: any;
  /** Time represented in ISO string format */
  IsoTime: any;
  JSON: any;
  /** The javascript `Date` as integer. Type represents date and time as number of milliseconds from start of UNIX epoch. */
  Timestamp: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};

export type Query = {
  __typename?: "Query";
  /** Fetches the entire graph in SDL format */
  _sdl: Scalars["String"];
  achievementById?: Maybe<Achievement>;
  /** Get comment by ID. */
  activityCommentById?: Maybe<ActivityComment>;
  /** Admin API Requires the admin role to use. */
  admin: Admin;
  badgeById?: Maybe<Badge>;
  /** A list of badges earned by the user grouped by year. Requires the user role to use. */
  badgesByYear: Array<BadgeYearGroup>;
  /** A list of badges earned by the user. Requires the user role to use. */
  badgesGetByUsername: Array<UserBadge>;
  /** Get published categories. Requires the user role to use. */
  categoriesPublic: CategoryConnection;
  /** Get published category by slug. Requires the user role to use. */
  categoryBySlugPublic?: Maybe<ClassCategory>;
  /** Get published challenge by ID. Requires the user role to use. */
  challengeById?: Maybe<Challenge>;
  /**
   * Get filterable challenges. Requires the admin role to use.
   * @deprecated Use admin.challenges instead
   */
  challenges: ChallengeConnection;
  /** Get published challenges. Requires the user role to use. */
  challengesAvailable: ChallengeConnection;
  /** Get active challenges. Requires the user role to use. */
  challengesPromoted: Array<Challenge>;
  /** Get estimated pricing for checkout. */
  checkoutEstimate?: Maybe<CheckoutEstimate>;
  /** Check if a specific coupon code is applied to a subscription. Requires the user role to use. */
  checkSubscriptionCoupon: Scalars["Boolean"];
  /** Get class by ID. */
  classById: Class;
  /** Get published class video by ID. Requires the user role to use. */
  classVideoById: ClassVideo;
  /** Get filterable class videos. Requires the admin role to use. */
  classVideos: ClassVideoConnection;
  /** Fetch all remote config parameters. Requires the user role to use. */
  configs: Config;
  /** Featured classes. Requires the user role to use. */
  featured: Array<FeaturedContent>;
  /** Featured playlists. Requires the user role to use. */
  featuredPlaylists: Array<PlaylistV2>;
  /** Get filterable flagged activities. Requires the admin role to use. */
  flaggedActivities: FlaggedActivityConnection;
  /** Get flagged activity by ID. Requires the admin role to use. */
  flaggedActivityById?: Maybe<FlaggedActivity>;
  /** Generates a Stripe payment intent for the requesting user. Requires the user role to use. */
  generateStripePaymentIntent?: Maybe<StripePaymentIntent>;
  getAllAchievements: Array<Achievement>;
  getBadgesForAchievement: Array<Badge>;
  getCalendarData: GetCalendarDataOutput;
  /** Get a cancel survey by subscription ID Requires the user role to use. */
  getCancelSurveyBySubscriptionId: CancelSurvey;
  /** Given a list of category slugs, this query will fetch data related to a category. If no slugs are provided, the query will fetch all categories */
  getCategories: Array<Category>;
  /** Fetches class details and optionally a next program class given a reference ID */
  getClass: GetClassResponse;
  /** Fetches class details on its own given a class' reference ID */
  getClassById?: Maybe<Class>;
  getClassCompletedAchievementBadges: UserAchievement;
  /** Fetches a paginated list of classes */
  getClasses: GetClassesConnection;
  getClassMinutesSpentAchievementBadges: UserAchievement;
  /** Fetch presentational content by features */
  getContent?: Maybe<Content>;
  getFreeDailyClasses: Array<Maybe<Class>>;
  /**
   * Fetch the users history class and program data in descending order of last viewed date.
   * @deprecated Use getHistoryDataV3
   */
  getHistoryData: SavedOrHistoryDataConnection;
  /**
   * Fetch the users history class and programV2 data in descending order of last viewed date.
   * @deprecated Use getHistoryDataV3
   */
  getHistoryDataV2: SavedOrHistoryDataConnectionV2;
  /** Fetch the users history class and programV2 data based on ordering params. */
  getHistoryDataV3: SavedOrHistoryDataConnectionV2;
  /** Fetches all programs in progress or return a default program */
  getInProgressPrograms: InProgressProgramData;
  /** Given an instructor slug, this query will fetch all related data for the specified instructor. */
  getInstructor: Instructor;
  /** Fetch the markup data for dance preferences. */
  getOnboardingData: OnboardingData;
  /** Fetches a playlist for the user by a specific date. The date should be a string with the format YYYY-MM-DD */
  getPlaylist?: Maybe<Playlist>;
  getPostCommentAchievementBadges: UserAchievement;
  getPostUploadAchievementBadges: UserAchievement;
  /**
   * Fetches a paginated list of programs
   * @deprecated Use searchProgramsV2
   */
  getPrograms: GetProgramsConnection;
  /** Fetches all programs in progress */
  getProgramsHistory: ProgramsHistoryData;
  /** Fetches a program V2 */
  getProgramV2?: Maybe<ProgramV2>;
  /** Fetches a program V2 provided a class reference ID */
  getProgramV2WithRef?: Maybe<ProgramV2>;
  getRecommendedClasses?: Maybe<RecommendedClassesConnection>;
  /**
   * Fetch the users saved class and program data in descending order of saved date.
   * @deprecated Use getSavedDataV2
   */
  getSavedData: SavedOrHistoryDataConnection;
  /** Fetch the users saved class and programV2 data in descending order of saved date. */
  getSavedDataV2: SavedOrHistoryDataConnectionV2;
  /** Fetch the users streak progress. */
  getStreakProgress: StreakProgress;
  getStyles: Array<Style>;
  /** Get published instructor by slug. Requires the user role to use. */
  instructorBySlugPublic?: Maybe<ClassInstructor>;
  /** Get published instructors. Requires the user role to use. */
  instructorsPublic: InstructorConnection;
  /** Get metadata for requesting user. Requires the user role to use. */
  me?: Maybe<User>;
  plans: Array<Plan>;
  /** Get playlist details. Requires the user role to use. */
  playlist: PlaylistV2;
  /** Get class by ID. Requires the user role to use. */
  playlistClassById: PlaylistClass;
  /** Get STEEZY curated playlists. Requires the user role to use. */
  playlistsSteezy: PlaylistV2Connection;
  /** @deprecated Use getProgramV2 */
  program?: Maybe<Program>;
  schedule?: Maybe<Schedule>;
  /**
   * Algolia proxy query to search classes.
   * @deprecated Use getClasses
   */
  searchClasses: AlgoliaClassesConnection;
  /** Algolia proxy query to search instructors. */
  searchInstructors: AlgoliaInstructorsConnection;
  /**
   * Algolia proxy query to search programs.
   * @deprecated Use searchProgramsV2
   */
  searchPrograms: AlgoliaProgramsConnection;
  /** Fetches a paginated list of programs V2 */
  searchProgramsV2: SearchProgramsV2Connection;
  /** Search for users by name or username. Requires the user role to use. */
  searchUsers: UserConnection;
  /** Get styles. Requires the user role to use. */
  styles: Array<Tag>;
  /** Get available plans for switching based on user's current subscription */
  switchablePlans: Array<Plan>;
  /** Get all artists. Requires the admin role to use. */
  trackArtists: Array<AutocompleteValue>;
  /** Get track by ID. Requires the admin role to use. */
  trackById?: Maybe<Track>;
  /** Get all genres. Requires the admin role to use. */
  trackGenres: Array<AutocompleteValue>;
  /** Get filterable tracks. Requires the admin role to use. */
  tracks: TrackConnection;
  user?: Maybe<User>;
  /** Get user by email. Requires the admin role to use. */
  userByEmail?: Maybe<User>;
  /** Get user by ID. Requires the admin role to use. */
  userById?: Maybe<User>;
  /** Get user by uid. Requires the admin role to use. */
  userByUid?: Maybe<User>;
  /** Generate a username for a user. Requires the user role to use. */
  userGenerateUsername: UserUsername;
  /** Fetch user preference data. Requires the user role to use. */
  userPreferenceOptions: Array<UserPreferenceOption>;
  /** Fetch user profile data by username. Requires the user role to use. */
  userProfileGetByUsername: UserProfileWithVideos;
  /** Get filterable users. Requires the admin role to use. */
  users: UserConnection;
  /** Validate a user's parental controls pin. Requires the user role to use. */
  userValidatePin: Scalars["Boolean"];
  /** Get UGC video metadata by ID. Requires the admin role to use. */
  videoUploadById: VideoUpload;
  /** Get encoded and approved UGC video by ID. */
  videoUploadByIdPublic: VideoUpload;
  /** Get filterable UGC videos. Requires the admin role to use. */
  videoUploads: VideoUploadConnection;
  /** Get filterable published UGC videos. Requires the user role to use. */
  videoUploadsPublished: VideoUploadConnection;
};

export type QueryAchievementByIdArgs = {
  id: Scalars["String"];
};

export type QueryActivityCommentByIdArgs = {
  id: Scalars["String"];
};

export type QueryBadgeByIdArgs = {
  id: Scalars["String"];
};

export type QueryBadgesByYearArgs = {
  username: Scalars["String"];
};

export type QueryBadgesGetByUsernameArgs = {
  username: Scalars["String"];
};

export type QueryCategoriesPublicArgs = {
  filter?: InputMaybe<CategoryFilterInput>;
  pagination?: InputMaybe<ConnectionArgs>;
  sort?: InputMaybe<OrderByInput>;
};

export type QueryCategoryBySlugPublicArgs = {
  slug: Scalars["String"];
};

export type QueryChallengeByIdArgs = {
  id: Scalars["String"];
};

export type QueryChallengesArgs = {
  filter?: InputMaybe<ChallengeFilterInput>;
  pagination?: InputMaybe<ConnectionArgs>;
  sort?: InputMaybe<OrderByInput>;
};

export type QueryChallengesAvailableArgs = {
  pagination: ConnectionArgs;
};

export type QueryCheckoutEstimateArgs = {
  input: CheckoutEstimateInput;
};

export type QueryCheckSubscriptionCouponArgs = {
  input: CheckSubscriptionCouponInput;
};

export type QueryClassByIdArgs = {
  id: Scalars["String"];
};

export type QueryClassVideoByIdArgs = {
  videoId: Scalars["String"];
};

export type QueryClassVideosArgs = {
  filter?: InputMaybe<ClassVideoFilterInput>;
  pagination?: InputMaybe<ConnectionArgs>;
  sort?: InputMaybe<OrderByInput>;
};

export type QueryFlaggedActivitiesArgs = {
  filter?: InputMaybe<FlaggedActivityFilterInput>;
  pagination?: InputMaybe<ConnectionArgs>;
  sort?: InputMaybe<OrderByInput>;
};

export type QueryFlaggedActivityByIdArgs = {
  id: Scalars["String"];
};

export type QueryGenerateStripePaymentIntentArgs = {
  input: StripePaymentInput;
};

export type QueryGetBadgesForAchievementArgs = {
  achievementId: Scalars["String"];
};

export type QueryGetCalendarDataArgs = {
  input?: InputMaybe<GetCalendarDataInput>;
};

export type QueryGetCancelSurveyBySubscriptionIdArgs = {
  subscriptionId: Scalars["String"];
};

export type QueryGetCategoriesArgs = {
  input: GetCategoriesInput;
};

export type QueryGetClassArgs = {
  input: GetClassInput;
};

export type QueryGetClassByIdArgs = {
  input: Scalars["ID"];
};

export type QueryGetClassesArgs = {
  input?: InputMaybe<GetClassesInput>;
};

export type QueryGetHistoryDataArgs = {
  input?: InputMaybe<GetPaginatedInput>;
};

export type QueryGetHistoryDataV2Args = {
  input?: InputMaybe<GetPaginatedInput>;
};

export type QueryGetHistoryDataV3Args = {
  input?: InputMaybe<HistoryV3Input>;
};

export type QueryGetInProgressProgramsArgs = {
  input: GetInProgressProgramsInput;
};

export type QueryGetInstructorArgs = {
  input: GetInstructorInput;
};

export type QueryGetPlaylistArgs = {
  date: Scalars["String"];
};

export type QueryGetProgramsArgs = {
  input?: InputMaybe<GetProgramsInput>;
};

export type QueryGetProgramsHistoryArgs = {
  input: GetProgramsHistoryInput;
};

export type QueryGetProgramV2Args = {
  slug: Scalars["String"];
};

export type QueryGetProgramV2WithRefArgs = {
  input: GetProgramV2WithRefInput;
};

export type QueryGetRecommendedClassesArgs = {
  input?: InputMaybe<GetRecommendedClassesInput>;
};

export type QueryGetSavedDataArgs = {
  input?: InputMaybe<GetPaginatedInput>;
};

export type QueryGetSavedDataV2Args = {
  input?: InputMaybe<GetPaginatedInput>;
};

export type QueryGetStreakProgressArgs = {
  input?: InputMaybe<GetStreakProgressInput>;
};

export type QueryInstructorBySlugPublicArgs = {
  slug: Scalars["String"];
};

export type QueryInstructorsPublicArgs = {
  filter?: InputMaybe<InstructorFilterInput>;
  pagination?: InputMaybe<ConnectionArgs>;
  sort?: InputMaybe<OrderByInput>;
};

export type QueryMeArgs = {
  input?: InputMaybe<UserMeInput>;
};

export type QueryPlansArgs = {
  input: PlansInput;
};

export type QueryPlaylistArgs = {
  playlistId: Scalars["String"];
};

export type QueryPlaylistClassByIdArgs = {
  id: Scalars["String"];
};

export type QueryPlaylistsSteezyArgs = {
  pagination: ConnectionArgs;
};

export type QueryProgramArgs = {
  slug: Scalars["String"];
};

export type QueryScheduleArgs = {
  date?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["String"]>;
};

export type QuerySearchClassesArgs = {
  input: AlgoliaSearchInput;
};

export type QuerySearchInstructorsArgs = {
  input: AlgoliaSearchInput;
};

export type QuerySearchProgramsArgs = {
  input: AlgoliaSearchInput;
};

export type QuerySearchProgramsV2Args = {
  input: SearchProgramsV2Input;
};

export type QuerySearchUsersArgs = {
  filter?: InputMaybe<UserSearchFilterInput>;
  pagination?: InputMaybe<ConnectionArgs>;
  sort?: InputMaybe<OrderByInput>;
};

export type QueryTrackByIdArgs = {
  id: Scalars["String"];
};

export type QueryTracksArgs = {
  filter?: InputMaybe<TrackFilterInput>;
  pagination?: InputMaybe<ConnectionArgs>;
  sort?: InputMaybe<OrderByInput>;
};

export type QueryUserArgs = {
  uid?: InputMaybe<Scalars["ID"]>;
};

export type QueryUserByEmailArgs = {
  email: Scalars["String"];
};

export type QueryUserByIdArgs = {
  id: Scalars["String"];
};

export type QueryUserByUidArgs = {
  uid: Scalars["String"];
};

export type QueryUserGenerateUsernameArgs = {
  input: UserGenerateUsernameInput;
};

export type QueryUserPreferenceOptionsArgs = {
  type: UserPreferenceType;
};

export type QueryUserProfileGetByUsernameArgs = {
  input: UserProfileInput;
};

export type QueryUsersArgs = {
  filter?: InputMaybe<UserFilterInput>;
  pagination?: InputMaybe<ConnectionArgs>;
  sort?: InputMaybe<OrderByInput>;
};

export type QueryUserValidatePinArgs = {
  input: UserValidatePinInput;
};

export type QueryVideoUploadByIdArgs = {
  input: VideoUploadByIdInput;
};

export type QueryVideoUploadByIdPublicArgs = {
  input: VideoUploadByIdInput;
};

export type QueryVideoUploadsArgs = {
  filter?: InputMaybe<VideoUploadsFilterInput>;
  pagination?: InputMaybe<ConnectionArgs>;
  sort?: InputMaybe<OrderByInput>;
};

export type QueryVideoUploadsPublishedArgs = {
  filter?: InputMaybe<VideoUploadsPublishedFilterInput>;
  pagination?: InputMaybe<ConnectionArgs>;
  sort?: InputMaybe<OrderByInput>;
};

export type Achievement = {
  __typename?: "Achievement";
  badges: Array<Badge>;
  challenge?: Maybe<Challenge>;
  createdAt: Scalars["DateTime"];
  description?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  name: Scalars["String"];
  /** The published studio classes required to earn this achievement. Requires the user role to use. */
  requiredPublishedStudioClasses?: Maybe<Array<StudioClass>>;
  triggerType: AchievementTriggerType;
  updatedAt: Scalars["DateTime"];
};

export type Badge = {
  __typename?: "Badge";
  achievement: Achievement;
  activeImageId?: Maybe<Scalars["String"]>;
  /** The active badge image URL. */
  activeImageUrl?: Maybe<Scalars["String"]>;
  amountToEarn: Scalars["Float"];
  challenge?: Maybe<Challenge>;
  createdAt: Scalars["DateTime"];
  description?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  inactiveImageId?: Maybe<Scalars["String"]>;
  /** The inactive badge image URL. */
  inactiveImageUrl?: Maybe<Scalars["String"]>;
  name: Scalars["String"];
  updatedAt: Scalars["DateTime"];
};

export type Challenge = {
  __typename?: "Challenge";
  achievement?: Maybe<Achievement>;
  badges: Array<BadgeWithEarnedStatus>;
  challengeStatus: ChallengeStatus;
  /** Comments for this challenge. */
  comments?: Maybe<ActivityCommentConnection>;
  createdAt: Scalars["DateTime"];
  description?: Maybe<Scalars["String"]>;
  displayText?: Maybe<ChallengeDisplayText>;
  endTime: Scalars["DateTime"];
  forClass?: Maybe<Class>;
  id: Scalars["ID"];
  /** True if the challenge is active. */
  isActive: Scalars["Boolean"];
  participantLeaderboard: Array<ChallengeParticipant>;
  participants: Array<ChallengeParticipant>;
  /** Number of reactions to this challenge by type. */
  reactions: Array<ActivityReactionsCount>;
  startTime: Scalars["DateTime"];
  /** The total number of published video uploads for this challenge. */
  submissionsCount: Scalars["Int"];
  thumbnailImageId?: Maybe<Scalars["String"]>;
  /** The challenge thumbnail image URL. */
  thumbnailImageUrl?: Maybe<Scalars["String"]>;
  title: Scalars["String"];
  updatedAt: Scalars["DateTime"];
  /** User progress for this challenge. This will calculate a user's progress on the challenge when being called. */
  userProgress?: Maybe<UserProgressChallenge>;
  /** User reactions for this challenge. */
  userReactions?: Maybe<Array<UserReactionType>>;
  /** The published video uploads for this challenge. */
  videos?: Maybe<VideoUploadConnection>;
};

export type ChallengeCommentsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Float"]>;
  last?: InputMaybe<Scalars["Float"]>;
};

export type ChallengeVideosArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Float"]>;
  last?: InputMaybe<Scalars["Float"]>;
};

export type BadgeWithEarnedStatus = {
  __typename?: "BadgeWithEarnedStatus";
  badge: Badge;
  isEarned: Scalars["Boolean"];
};

/** The challenge's status */
export enum ChallengeStatus {
  Approved = "approved",
  Deleted = "deleted",
  None = "none"
}

export type ActivityCommentConnection = {
  __typename?: "ActivityCommentConnection";
  edges: Array<ActivityCommentEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Float"];
};

export type ActivityCommentEdge = {
  __typename?: "ActivityCommentEdge";
  /** Used in `before` and `after` args */
  cursor: Scalars["String"];
  node: ActivityComment;
};

export type ActivityComment = {
  __typename?: "ActivityComment";
  body: Scalars["String"];
  /** The profile of the user who created the comment. */
  commentBy: UserProfile;
  createdAt: Scalars["DateTime"];
  /** The number of times the video has been flagged. Requires the admin role to use. */
  flaggedCount: Scalars["Float"];
  id: Scalars["ID"];
  /** True if the comment was created by the requesting user. */
  isAuthoredByMe: Scalars["Boolean"];
  /** The number of reactions to this comment by type. */
  reactions: Array<ActivityReactionsCount>;
  /** A paginated list of this comment's replies. */
  replies?: Maybe<ActivityCommentConnection>;
  /** True if the requesting user has reported this comment. */
  reportedByMe: Scalars["Boolean"];
  timeSince: Scalars["String"];
  updatedAt: Scalars["DateTime"];
  user: User;
  /** The requesting user's reactions to the comment. */
  userReactions: Array<UserReactionType>;
};

export type ActivityCommentRepliesArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Float"]>;
  last?: InputMaybe<Scalars["Float"]>;
};

/** Represents a user's public profile information */
export type UserProfile = {
  __typename?: "UserProfile";
  /** List of badges earned by the user */
  badges?: Maybe<Array<UserBadge>>;
  /** User's self-written biography or description */
  bio?: Maybe<Scalars["String"]>;
  /** User's birth date */
  birthDate?: Maybe<Scalars["DateTime"]>;
  /** Unique identifier for the user profile */
  id: Scalars["ID"];
  /** Slug of the user's instructor profile */
  instructorSlug?: Maybe<Scalars["String"]>;
  /** List of social media or other relevant links */
  links?: Maybe<Array<UserProfileLink>>;
  /** User's name */
  name?: Maybe<Scalars["String"]>;
  /** URL to the user's profile photo */
  photoURL?: Maybe<Scalars["String"]>;
  /** Firebase user ID associated with this profile */
  uid?: Maybe<Scalars["String"]>;
  /** User's chosen display name */
  username?: Maybe<Scalars["String"]>;
};

export type UserBadge = {
  __typename?: "UserBadge";
  badge: Badge;
  earnedAt: Scalars["DateTime"];
  earnedById?: Maybe<Scalars["String"]>;
  earnedByType?: Maybe<EarnedByType>;
  id: Scalars["ID"];
  user: User;
};

/** The type of the entity that earned the badge */
export enum EarnedByType {
  Challenges = "Challenges",
  Classes = "Classes",
  Events = "Events",
  Playlists = "Playlists",
  Programs = "Programs",
  UserComments = "UserComments",
  UserVideos = "UserVideos"
}

export type User = {
  __typename?: "User";
  badges: Array<UserBadge>;
  bio?: Maybe<Scalars["String"]>;
  birthDate?: Maybe<Scalars["DateTime"]>;
  challenges: Array<ChallengeParticipant>;
  createdAt: Scalars["DateTime"];
  dancePreferences?: Maybe<DancePreferences>;
  email: Scalars["String"];
  hasCommunityAccess: Scalars["Boolean"];
  hasExtendedTrial: Scalars["Boolean"];
  /** PRIVATE - Indicates if the user has any unread notifications. Only accessible to the requesting user. Requires the PRIVATE_FIELD role to use. */
  hasNewNotifications: Scalars["Boolean"];
  hasTrialed: Scalars["Boolean"];
  id: Scalars["ID"];
  instructor?: Maybe<ClassInstructor>;
  isActive: Scalars["Boolean"];
  /** PRIVATE - Total number of class unlocks earned by this user (including used ones). Only accessible to the requesting user. Requires the PRIVATE_FIELD role to use. */
  lifetimeClassUnlocks: Scalars["Int"];
  /** PRIVATE - Total credit cents earned by this user through invites and rewards. Only accessible to the requesting user. Requires the PRIVATE_FIELD role to use. */
  lifetimeCreditCents: Scalars["Int"];
  links?: Maybe<Array<UserProfileLink>>;
  /** PRIVATE - Playlists created by this user. Only accessible to the requesting user. Requires the PRIVATE_FIELD role to use. */
  myPlaylists: PlaylistV2Connection;
  name?: Maybe<Scalars["String"]>;
  /** PRIVATE - User's notification preferences. Only accessible to the requesting user. Requires the PRIVATE_FIELD role to use. */
  notificationPreferences: Array<NotificationPreference>;
  /** PRIVATE - Paginated list of notifications for this user. Only accessible to the requesting user. Requires the PRIVATE_FIELD role to use. */
  notifications: NotificationConnection;
  parentalControls: ParentalControls;
  /** PRIVATE - List of pending (not yet rewarded) invites sent by this user. Accessible to requesting user and admins. Requires the PRIVATE_FIELD role to use. */
  pendingInvites: Array<Invite>;
  /** PRIVATE - Personalized playlist recommendations for this user. Only accessible to the requesting user. Requires the PRIVATE_FIELD role to use. */
  personalizedPlaylist?: Maybe<Array<Class>>;
  photoURL?: Maybe<Scalars["String"]>;
  preferred?: Maybe<PreferredContent>;
  primaryPaymentSource?: Maybe<PaymentSource>;
  primarySubscription?: Maybe<Subscription>;
  progress?: Maybe<UserProgress>;
  /** PRIVATE - User's unique referral link for inviting others. Only accessible to the requesting user. Requires the PRIVATE_FIELD role to use. */
  referralUrl: Scalars["String"];
  remainingClassUnlocks: Scalars["Int"];
  remainingCreditCents: Scalars["Int"];
  /** PRIVATE - List of successfully rewarded invites sent by this user. Accessible to requesting user and admins. Requires the PRIVATE_FIELD role to use. */
  rewardedInvites: Array<Invite>;
  roles: Array<Role>;
  /** PRIVATE - Playlists saved by this user. Only accessible to the requesting user. Requires the PRIVATE_FIELD role to use. */
  savedPlaylists: PlaylistV2Connection;
  /** PRIVATE - Information about pending subscription changes. Only accessible to the requesting user. Requires the PRIVATE_FIELD role to use. */
  scheduledSubscriptionChange?: Maybe<Subscription>;
  streakProgress?: Maybe<StreakProgress>;
  /** PUBLIC - Total number of likes received on this user's videos. Accessible to all authenticated users. Requires the user role to use. */
  totalLikesCount: Scalars["Int"];
  uid: Scalars["String"];
  /** PRIVATE - List of classes unlocked by this user. Accessible to requesting user and admins. Requires the PRIVATE_FIELD role to use. */
  unlockedClasses: Array<Maybe<Class>>;
  updatedAt: Scalars["DateTime"];
  /** PUBLIC - Paginated list of video uploads submitted by this user. Accessible to all authenticated users. Requires the user role to use. */
  uploadedVideos?: Maybe<VideoUploadConnection>;
  /** Get the username for the requesting user. Requires the user role to use. */
  username: Scalars["String"];
  /** PRIVATE - User's weekly activity statistics. Only accessible to the requesting user. Requires the PRIVATE_FIELD role to use. */
  weeklyStats: UserWeeklyStats;
  /** PRIVATE - User's yearly activity statistics and achievements. Only accessible to the requesting user. Requires the PRIVATE_FIELD role to use. */
  yearlyStats: UserYearlyStats;
};

export type UserMyPlaylistsArgs = {
  pagination: ConnectionArgs;
};

export type UserNotificationsArgs = {
  pagination: ConnectionArgs;
};

export type UserSavedPlaylistsArgs = {
  pagination: ConnectionArgs;
};

export type UserUploadedVideosArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Float"]>;
  last?: InputMaybe<Scalars["Float"]>;
};

export type UserWeeklyStatsArgs = {
  date?: InputMaybe<Scalars["String"]>;
};

export type UserYearlyStatsArgs = {
  input?: InputMaybe<UserYearlyStatsInput>;
};

export type ChallengeParticipant = {
  __typename?: "ChallengeParticipant";
  challenge: Challenge;
  createdAt: Scalars["DateTime"];
  id: Scalars["ID"];
  joinedAt: Scalars["DateTime"];
  progressAmount: Scalars["Float"];
  updatedAt: Scalars["DateTime"];
  user: User;
};

export type DancePreferences = {
  __typename?: "DancePreferences";
  /** A list a user's followed categories. */
  categories: Array<Category>;
  /** A user's duration preference. */
  duration?: Maybe<DurationOption>;
  /** A user's level preference. */
  level?: Maybe<LevelOption>;
  /** A user's reason preference. */
  reason?: Maybe<ReasonOption>;
};

export type Category = {
  __typename?: "Category";
  description?: Maybe<Scalars["String"]>;
  isFollowing?: Maybe<Scalars["Boolean"]>;
  latestClasses: Array<Class>;
  movesClasses: Array<Class>;
  name: Scalars["String"];
  previewThumbnailUrl?: Maybe<Scalars["String"]>;
  previewVideoUrl?: Maybe<Scalars["String"]>;
  /** @deprecated Use ProgramsV2 */
  programs: Array<Program>;
  programsV2: Array<ProgramV2>;
  shortClasses: Array<Class>;
  slug: Scalars["String"];
};

export type Class = {
  __typename?: "Class";
  /** Access type to determine user access on class. */
  accessType: AccessType;
  /** True if user has access to class based on given set of criteria. */
  canUserTakeClass: Scalars["Boolean"];
  categories: Array<Scalars["String"]>;
  challenges?: Maybe<Array<Challenge>>;
  /** Returns comments for a class given a studioClassId or classNumber Requires the user role to use. */
  comments?: Maybe<ActivityCommentConnection>;
  createdAt: Scalars["DateTime"];
  description?: Maybe<Scalars["String"]>;
  duration: Scalars["String"];
  duration_in_seconds: Scalars["Int"];
  /** Returns URL to external preview video. Requires the user role to use. */
  externalPreviewUrl?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  instructor?: Maybe<Instructor>;
  /** True if class has licensing rights to all its tracks */
  isClassFullyLicensed: Scalars["Boolean"];
  /** True if this class contains an explicit track. Requires the user role to use. */
  isExplicit?: Maybe<Scalars["Boolean"]>;
  /** The published preview video for the class. Requires the user role to use. */
  isFamilyFriendly: Scalars["Boolean"];
  isFree: Scalars["Boolean"];
  /** True if this class has muted cuepoints. Requires the user role to use. */
  isPreviewVideoMuted?: Maybe<Scalars["Boolean"]>;
  isPurchased?: Maybe<Scalars["Boolean"]>;
  isSaved?: Maybe<Scalars["Boolean"]>;
  /** True if class is unlocked for the authenticated user. Only applies to FUX users. */
  isUnlocked: Scalars["Boolean"];
  level?: Maybe<Scalars["String"]>;
  /** The muted cuepoints for the class. Requires the user role to use. */
  mutedCuepoints: Array<MutedCuepoint>;
  preview_url: Scalars["String"];
  /** The published preview video for the class. Requires the user role to use. */
  previewVideo?: Maybe<ClassVideo>;
  /** Available for program classes. Represents metadata related to the program */
  programMetadata?: Maybe<ProgramClassMetadata>;
  progress?: Maybe<ClassProgress>;
  publish_date?: Maybe<Scalars["String"]>;
  /** Represents a program class reference ID when defined */
  refId?: Maybe<Scalars["String"]>;
  /** The class sections Requires the user role to use. */
  sections: Array<StudioClassSectionEntity>;
  slug: Scalars["String"];
  songs?: Maybe<Array<Maybe<Song>>>;
  /** Studio class PK Requires the user role to use. */
  studioClassId: Scalars["String"];
  style?: Maybe<Scalars["String"]>;
  thumbnail?: Maybe<Scalars["String"]>;
  title: Scalars["String"];
  /** The tracks (with full metadata) associated with the class. Requires the user role to use. */
  tracks: Array<StudioClassTrack>;
  type: Scalars["String"];
  updatedAt: Scalars["DateTime"];
  /** The user video uploads for this class. Requires the user role to use. */
  userVideos: VideoUploadConnection;
  /** The published video for the class. Requires the user role to use. */
  video?: Maybe<ClassVideo>;
};

export type ClassCommentsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Float"]>;
  last?: InputMaybe<Scalars["Float"]>;
};

export type ClassUserVideosArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Float"]>;
  last?: InputMaybe<Scalars["Float"]>;
};

export type ClassVideoArgs = {
  hidden?: InputMaybe<Scalars["Boolean"]>;
};

/** Access type for plans and classes denoting type of sub */
export enum AccessType {
  Basic = "basic",
  Free = "free",
  Premium = "premium",
  Standard = "standard"
}

export type Instructor = {
  __typename?: "Instructor";
  /** The biography description for the instructor. */
  bio?: Maybe<Scalars["String"]>;
  /** A list of classes published by the instructor in order of publish date. */
  classes?: Maybe<Array<Class>>;
  /** Instructor related content */
  content?: Maybe<InstructorContent>;
  /** A comma separated list of teams or organizations the instructor was apart of. */
  credits?: Maybe<Scalars["String"]>;
  /** A boolean value describing whether the current authenticated user is following (true) or not following (false) the instructor. */
  isFollowing?: Maybe<Scalars["Boolean"]>;
  /** The city and country the instructor currently resides. */
  location?: Maybe<Scalars["String"]>;
  /** The full name of the instructor. */
  name: Scalars["String"];
  /**
   * A list of programs published by the instructor in order of publish date.
   * @deprecated Use programsV2
   */
  programs?: Maybe<Array<Program>>;
  /** A list of programsV2 published by the instructor in order of publish date. */
  programsV2?: Maybe<Array<ProgramV2>>;
  /** The slug of the instructor. */
  slug: Scalars["String"];
  /** A list of social media handles for the instructor. */
  socialMediaHandles?: Maybe<Array<SocialMediaHandle>>;
  /** A list of styles associated with the instructor based on published classes. */
  styles?: Maybe<Array<Style>>;
};

export type InstructorContent = {
  __typename?: "InstructorContent";
  /** Media assets for the instructor */
  assets?: Maybe<InstructorAssets>;
};

export type InstructorAssets = {
  __typename?: "InstructorAssets";
  /** The instructor avatar profile URL */
  avatarURL?: Maybe<Scalars["String"]>;
  /** The instructor landscape profile URL */
  landscapeURL?: Maybe<Scalars["String"]>;
  /** The instructor portrait profile URL */
  portraitURL?: Maybe<Scalars["String"]>;
};

export type Program = {
  __typename?: "Program";
  about_instructor?: Maybe<Scalars["String"]>;
  benefits: Array<Scalars["String"]>;
  /** A list of associated category slugs. */
  categories: Array<Scalars["String"]>;
  completed_classes?: Maybe<Scalars["Int"]>;
  description: Scalars["String"];
  difficulty: Scalars["String"];
  duration_in_seconds: Scalars["Int"];
  instructor?: Maybe<Instructor>;
  /** Set to true if this program is at least partially free to unsubscribed users. */
  isFree: Scalars["Boolean"];
  /** Boolean value describing whether the user has saved the program or not. */
  isSaved?: Maybe<Scalars["Boolean"]>;
  level: Array<Scalars["String"]>;
  preview_url: Scalars["String"];
  progress?: Maybe<ProgramProgress>;
  progression: Array<Maybe<Class>>;
  publish_date?: Maybe<Scalars["String"]>;
  recommendations: Array<Scalars["String"]>;
  slug: Scalars["String"];
  style: Scalars["String"];
  subtitle: Scalars["String"];
  thumbnail?: Maybe<Scalars["String"]>;
  title: Scalars["String"];
  total_classes: Scalars["Int"];
  total_moves?: Maybe<Scalars["Int"]>;
  total_time_spent?: Maybe<Scalars["Int"]>;
};

export type ProgramProgress = {
  __typename?: "ProgramProgress";
  completed?: Maybe<Scalars["String"]>;
  percent?: Maybe<Scalars["Float"]>;
  queued_class?: Maybe<Class>;
  started?: Maybe<Scalars["String"]>;
};

export type ProgramV2 = {
  __typename?: "ProgramV2";
  /** The average amount of time spent per session */
  averageSessionTime?: Maybe<Scalars["String"]>;
  /** A list of blocks within the program */
  blocks: Array<ProgramBlock>;
  /** A list of associated categories with the program */
  categories: Array<Scalars["String"]>;
  /** A list of all the classes on the program */
  classes: Array<Class>;
  /** The markup content describing a program */
  content?: Maybe<ProgramOverview>;
  /** The program instructor */
  instructor?: Maybe<Instructor>;
  /** If true the program is accessible by account-completed users */
  isFree?: Maybe<Scalars["Boolean"]>;
  /** If true the program is saved by the user */
  isSaved?: Maybe<Scalars["Boolean"]>;
  /** The difficulty level of the program */
  level?: Maybe<Scalars["String"]>;
  /** The program's preview URL */
  previewUrl?: Maybe<Scalars["String"]>;
  /** The progress data for the program */
  progress?: Maybe<ProgramProgressV2>;
  /** The date the program was published */
  publishDate?: Maybe<Scalars["String"]>;
  /** A list of related classes to the program */
  relatedClasses: Array<Class>;
  /** The program slug */
  slug: Scalars["ID"];
  /** The style name the program is associated too */
  style?: Maybe<Scalars["String"]>;
  /** The program title */
  title?: Maybe<Scalars["String"]>;
  /** The total number of classes in a program */
  totalClassesCount?: Maybe<Scalars["Int"]>;
  /** The total number of sections in a program */
  totalSectionCount?: Maybe<Scalars["Int"]>;
};

export type ProgramV2ClassesArgs = {
  input?: InputMaybe<ProgramV2ClassesInput>;
};

export type ProgramBlock = {
  __typename?: "ProgramBlock";
  progress?: Maybe<ProgramBlockProgress>;
  /** The block ID */
  refId: Scalars["ID"];
  /** The list of sections of a block */
  sections: Array<ProgramSection>;
  /** The number of sections on the block */
  sectionsCount?: Maybe<Scalars["Int"]>;
  /** Where the block is in relation to other blocks of a program */
  sortIndex?: Maybe<Scalars["Int"]>;
  /** The block superscript title */
  superscript?: Maybe<Scalars["String"]>;
  /** The block title */
  title?: Maybe<Scalars["String"]>;
};

export type ProgramBlockProgress = {
  __typename?: "ProgramBlockProgress";
  /** The percentage of completed classes within the block */
  classesCompletedPercent?: Maybe<Scalars["Int"]>;
  /** True if the block was completed */
  isCompleted?: Maybe<Scalars["Boolean"]>;
  /** The number of sections completed within the block */
  sectionsCompletedCount?: Maybe<Scalars["Int"]>;
};

export type ProgramSection = {
  __typename?: "ProgramSection";
  /** The list of classes in a section */
  classes: Array<Class>;
  /** The number of classes on the section */
  classesCount?: Maybe<Scalars["Int"]>;
  /** The length of the section in minutes */
  durationInMins?: Maybe<Scalars["Int"]>;
  progress?: Maybe<ProgramSectionProgress>;
  /** The section ID */
  refId: Scalars["ID"];
  /** Where the section is in relation to other sections of a module */
  sortIndex?: Maybe<Scalars["Int"]>;
  /** The section title */
  title?: Maybe<Scalars["String"]>;
};

export type ProgramSectionProgress = {
  __typename?: "ProgramSectionProgress";
  /** True if the section was completed */
  isCompleted?: Maybe<Scalars["Boolean"]>;
};

export type ProgramV2ClassesInput = {
  isFree?: InputMaybe<Scalars["Boolean"]>;
};

export type ProgramOverview = {
  __typename?: "ProgramOverview";
  assets?: Maybe<ProgramAssets>;
  competencies?: Maybe<ProgramOverviewCompetencies>;
  introduction?: Maybe<ProgramOverviewIntroduction>;
  needs?: Maybe<ProgramOverviewNeeds>;
};

export type ProgramAssets = {
  __typename?: "ProgramAssets";
  /** The program's preview video URL */
  previewVideoURL?: Maybe<Scalars["String"]>;
  /** The program's thumbnail preview URL */
  thumbnailURL?: Maybe<Scalars["String"]>;
  /** The program's title SVG URL */
  titleSvgURL?: Maybe<Scalars["String"]>;
};

export type ProgramOverviewCompetencies = {
  __typename?: "ProgramOverviewCompetencies";
  skills: Array<Scalars["String"]>;
  title?: Maybe<Scalars["String"]>;
};

export type ProgramOverviewIntroduction = {
  __typename?: "ProgramOverviewIntroduction";
  description?: Maybe<Scalars["String"]>;
  title?: Maybe<Scalars["String"]>;
};

export type ProgramOverviewNeeds = {
  __typename?: "ProgramOverviewNeeds";
  description?: Maybe<Scalars["String"]>;
  title?: Maybe<Scalars["String"]>;
};

export type ProgramProgressV2 = {
  __typename?: "ProgramProgressV2";
  /** The total number of completed classes in a program */
  completedClassesCount?: Maybe<Scalars["Int"]>;
  /** The date the program was completed */
  completedDate?: Maybe<Scalars["String"]>;
  /** The number of minutes the user spent on the program */
  minutesSpent?: Maybe<Scalars["Float"]>;
  /** The percentage the program is completed (number of classes completed/total classes in program) */
  percentCompleted?: Maybe<Scalars["Float"]>;
  /** The class the user should return to when resuming a program */
  queuedClass?: Maybe<Class>;
  /** The total number of sections completed by the user */
  sectionsCompletedCount?: Maybe<Scalars["Int"]>;
  /** The date the program was started */
  startedDate?: Maybe<Scalars["String"]>;
};

export type SocialMediaHandle = {
  __typename?: "SocialMediaHandle";
  /** A string representing the social media platform. */
  platform: Scalars["String"];
  /** A URL linking to the social media platform. */
  url: Scalars["String"];
};

export type Style = {
  __typename?: "Style";
  isFollowing?: Maybe<Scalars["Boolean"]>;
  name: Scalars["String"];
  slug: Scalars["String"];
};

export type MutedCuepoint = {
  __typename?: "MutedCuepoint";
  endsAtTime: Scalars["String"];
  endsAtTimeSec: Scalars["Int"];
  externalUrl?: Maybe<Scalars["String"]>;
  startsAtTime: Scalars["String"];
  startsAtTimeSec: Scalars["Int"];
};

export type ClassVideo = {
  __typename?: "ClassVideo";
  classVideoType: ClassVideoType;
  createdAt: Scalars["DateTime"];
  downloadSource?: Maybe<Scalars["String"]>;
  /** DRM DASH playback urls for the video. */
  drmDashPlaybackUrls?: Maybe<VideoPlaybackResponse>;
  /** DRM HLS playback urls for the video. */
  drmHlsPlaybackUrls?: Maybe<VideoPlaybackResponse>;
  durationInMs?: Maybe<Scalars["String"]>;
  encodingStatus: VideoEncodingStatus;
  error?: Maybe<Scalars["String"]>;
  /** HLS playback urls for the video. */
  hlsPlaybackUrls?: Maybe<VideoPlaybackResponse>;
  id: Scalars["ID"];
  mediaConvertJobIds?: Maybe<Array<Scalars["String"]>>;
  stepFunctionArn?: Maybe<Scalars["String"]>;
  studioClass: StudioClass;
  type: VideoType;
  updatedAt: Scalars["DateTime"];
  uploadedAt?: Maybe<Scalars["DateTime"]>;
};

/** The type of video for the class */
export enum ClassVideoType {
  FrontBackView = "front_back_view",
  Preview = "preview",
  SingleView = "single_view"
}

export type VideoPlaybackResponse = {
  __typename?: "VideoPlaybackResponse";
  backUrl?: Maybe<Scalars["String"]>;
  default1080Url: Scalars["String"];
  default360LowUrl: Scalars["String"];
  default360Url: Scalars["String"];
  default540Url: Scalars["String"];
  default720Url: Scalars["String"];
  defaultUrl: Scalars["String"];
  fairplayCertificateUrl?: Maybe<Scalars["String"]>;
  frontUrl?: Maybe<Scalars["String"]>;
};

/** The user's video upload status */
export enum VideoEncodingStatus {
  Available = "available",
  Error = "error",
  Requested = "requested",
  Uploaded = "uploaded"
}

export type StudioClass = {
  __typename?: "StudioClass";
  accessType?: Maybe<AccessType>;
  classId: Scalars["Float"];
  createdAt: Scalars["DateTime"];
  externalPreviewUrl?: Maybe<Scalars["String"]>;
  /** @deprecated Use accessType */
  free: Scalars["Boolean"];
  hidden: Scalars["Boolean"];
  id: Scalars["ID"];
  instructor?: Maybe<ClassInstructor>;
  /** True if class has licensing rights to all its tracks */
  isClassFullyLicensed: Scalars["Boolean"];
  /** True if this class contains an explicit track. Requires the user role to use. */
  isExplicit: Scalars["Boolean"];
  isFamilyFriendly: Scalars["Boolean"];
  /** @deprecated Use classVideoType on video instead. */
  isSingleView: Scalars["Boolean"];
  level?: Maybe<Scalars["String"]>;
  mutedCuepoints?: Maybe<Array<MutedCuepoint>>;
  /** Requires the user role to use. */
  previewVideo: ClassVideo;
  publishDate?: Maybe<Scalars["DateTime"]>;
  sections?: Maybe<Array<StudioClassSectionEntity>>;
  /** @deprecated Use isClassFullyLicensed resolver */
  shouldBeMuted: Scalars["Boolean"];
  slug: Scalars["String"];
  /** @deprecated Use StyleV2. */
  style?: Maybe<Scalars["String"]>;
  /** Requires the user role to use. */
  styleV2?: Maybe<ClassStyle>;
  tags: Array<Tag>;
  thumbnailImageId?: Maybe<Scalars["String"]>;
  /** Full thumbnail image url. Requires the user role to use. */
  thumbnailImageUrl?: Maybe<Scalars["String"]>;
  title: Scalars["String"];
  type?: Maybe<Scalars["String"]>;
  updatedAt: Scalars["DateTime"];
  /** User progress for class. Requires the user role to use. */
  userProgress: UserClassProgress;
  /** Requires the user role to use. */
  video: ClassVideo;
};

export type ClassInstructor = {
  __typename?: "ClassInstructor";
  avatarImageId?: Maybe<Scalars["String"]>;
  /** The full avatar image url. Requires the user role to use. */
  avatarImageUrl?: Maybe<Scalars["String"]>;
  bio?: Maybe<Scalars["String"]>;
  createdAt: Scalars["DateTime"];
  credits?: Maybe<Array<Scalars["String"]>>;
  facebook?: Maybe<Scalars["String"]>;
  /** Featured class for an instructor. Requires the user role to use. */
  featuredClass?: Maybe<StudioClass>;
  hidden: Scalars["Boolean"];
  id: Scalars["ID"];
  instagram?: Maybe<Scalars["String"]>;
  location?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  profileImageId?: Maybe<Scalars["String"]>;
  /** The full profile image url. Requires the user role to use. */
  profileImageUrl?: Maybe<Scalars["String"]>;
  slug: Scalars["String"];
  /** Studio classes taught by this instructor. Requires the user role to use. */
  studioClasses: StudioClassConnection;
  tiktok?: Maybe<Scalars["String"]>;
  twitter?: Maybe<Scalars["String"]>;
  updatedAt: Scalars["DateTime"];
  user?: Maybe<User>;
  /** The user profile associated with this instructor. Requires the user role to use. */
  userProfile?: Maybe<UserProfile>;
  youtube?: Maybe<Scalars["String"]>;
};

export type ClassInstructorStudioClassesArgs = {
  filter?: InputMaybe<ClassFilterInput>;
  pagination?: InputMaybe<ConnectionArgs>;
  sort?: InputMaybe<OrderByInput>;
};

export type ClassFilterInput = {
  accessType?: InputMaybe<AccessType>;
  categoryId?: InputMaybe<Scalars["String"]>;
  classId?: InputMaybe<Scalars["String"]>;
  free?: InputMaybe<Scalars["Boolean"]>;
  hidden?: InputMaybe<Scalars["Boolean"]>;
  id?: InputMaybe<Scalars["String"]>;
  instructor?: InputMaybe<Scalars["String"]>;
  instructorName?: InputMaybe<Scalars["String"]>;
  level?: InputMaybe<Scalars["String"]>;
  slug?: InputMaybe<Scalars["String"]>;
  style?: InputMaybe<Scalars["String"]>;
  title?: InputMaybe<Scalars["String"]>;
  trackArtist?: InputMaybe<Scalars["String"]>;
  trackId?: InputMaybe<Scalars["String"]>;
  trackLabel?: InputMaybe<Scalars["String"]>;
  trackTitle?: InputMaybe<Scalars["String"]>;
  type?: InputMaybe<Scalars["String"]>;
};

export type ConnectionArgs = {
  /** Paginate after opaque cursor */
  after?: InputMaybe<Scalars["String"]>;
  /** Paginate before opaque cursor */
  before?: InputMaybe<Scalars["String"]>;
  /** Paginate first */
  first?: InputMaybe<Scalars["Float"]>;
  /** Paginate last */
  last?: InputMaybe<Scalars["Float"]>;
};

export type OrderByInput = {
  /** The field used when ordering */
  sortBy: Scalars["String"];
  /** The direction by which to sort the results when sorted on the 'orderBy' field. */
  sortOrder: SortOrder;
};

export enum SortOrder {
  Asc = "asc",
  Desc = "desc"
}

export type StudioClassConnection = {
  __typename?: "StudioClassConnection";
  edges: Array<StudioClassEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Float"];
};

export type StudioClassEdge = {
  __typename?: "StudioClassEdge";
  /** Used in `before` and `after` args */
  cursor: Scalars["String"];
  node: StudioClass;
};

export type PageInfo = {
  __typename?: "PageInfo";
  endCursor?: Maybe<Scalars["String"]>;
  hasNextPage: Scalars["Boolean"];
  hasPreviousPage: Scalars["Boolean"];
  startCursor?: Maybe<Scalars["String"]>;
};

export type StudioClassSectionEntity = {
  __typename?: "StudioClassSectionEntity";
  cuepoints?: Maybe<Array<SectionCuepoint>>;
  name: Scalars["String"];
};

export type SectionCuepoint = {
  __typename?: "SectionCuepoint";
  name?: Maybe<Scalars["String"]>;
  time?: Maybe<Scalars["String"]>;
  timeSec?: Maybe<Scalars["Int"]>;
};

export type ClassStyle = {
  __typename?: "ClassStyle";
  name: Scalars["String"];
  slug: Scalars["String"];
};

export type Tag = {
  __typename?: "Tag";
  createdAt: Scalars["DateTime"];
  displayIndex?: Maybe<Scalars["Int"]>;
  id: Scalars["ID"];
  name: Scalars["String"];
  previewVideoId?: Maybe<Scalars["String"]>;
  previewVideoUrl?: Maybe<Scalars["String"]>;
  slug?: Maybe<Scalars["String"]>;
  thumbnailImageId?: Maybe<Scalars["String"]>;
  thumbnailImageUrl?: Maybe<Scalars["String"]>;
  type: Scalars["String"];
  updatedAt: Scalars["DateTime"];
};

export type UserClassProgress = {
  __typename?: "UserClassProgress";
  completed: Scalars["Boolean"];
  /** PK */
  id: Scalars["ID"];
  percent: Scalars["Float"];
  time: TimeV2;
};

export type TimeV2 = {
  __typename?: "TimeV2";
  hour: Scalars["Int"];
  minute: Scalars["Int"];
  second: Scalars["Int"];
};

/** The type of video */
export enum VideoType {
  Category = "category",
  Class = "class",
  UserChallenge = "user_challenge"
}

export type ProgramClassMetadata = {
  __typename?: "ProgramClassMetadata";
  /** The program block the class is associated with */
  block?: Maybe<ProgramBlock>;
  /** True if this is the last class in the program */
  isLastClass?: Maybe<Scalars["Boolean"]>;
  /** The program section the class is associated with */
  section?: Maybe<ProgramSection>;
};

export type ClassProgress = {
  __typename?: "ClassProgress";
  /** The date the class was first completed by reaching the end of the video */
  completed?: Maybe<Scalars["String"]>;
  /** If the class is associated with a program, this progress represents the progress of the class within the context of the program */
  programClassProgress?: Maybe<Array<ProgramClassProgress>>;
  /** The date the class was first started */
  started?: Maybe<Scalars["String"]>;
  /** Timestamp object representing where the user is in the playback by hour, minute, and seconds */
  time?: Maybe<Time>;
};

export type ProgramClassProgress = {
  __typename?: "ProgramClassProgress";
  /** True if the class is completed within the program. This value is separate from ClassProgress.complete since user's have the ability to toggle completion for program classes. */
  isCompleted?: Maybe<Scalars["Boolean"]>;
  /** The program slug associated with the class */
  programSlug: Scalars["String"];
};

export type Time = {
  __typename?: "Time";
  hour?: Maybe<Scalars["Int"]>;
  minute?: Maybe<Scalars["Int"]>;
  second?: Maybe<Scalars["Int"]>;
};

export type Song = {
  __typename?: "Song";
  artist?: Maybe<Scalars["String"]>;
  isExplicit?: Maybe<Scalars["Boolean"]>;
  title?: Maybe<Scalars["String"]>;
};

export type StudioClassTrack = {
  __typename?: "StudioClassTrack";
  id: Scalars["ID"];
  startsAt: Scalars["Float"];
  studioClass: StudioClass;
  track: Track;
};

export type Track = {
  __typename?: "Track";
  albumName?: Maybe<Scalars["String"]>;
  appleMusic?: Maybe<Scalars["String"]>;
  artists: Array<Scalars["String"]>;
  copyright?: Maybe<Scalars["String"]>;
  createdAt: Scalars["DateTime"];
  genre: Array<Scalars["String"]>;
  id: Scalars["ID"];
  image?: Maybe<Scalars["String"]>;
  isExplicit: Scalars["Boolean"];
  isLicensed: Scalars["Boolean"];
  isrc: Scalars["String"];
  label?: Maybe<Scalars["String"]>;
  releaseDate?: Maybe<Scalars["String"]>;
  songId?: Maybe<Scalars["String"]>;
  soundcloud?: Maybe<Scalars["String"]>;
  source: TrackSource;
  spotify?: Maybe<Scalars["String"]>;
  tikTokSound?: Maybe<Scalars["String"]>;
  title?: Maybe<Scalars["String"]>;
  trackId?: Maybe<Scalars["String"]>;
  updatedAt: Scalars["DateTime"];
  youtube?: Maybe<Scalars["String"]>;
};

/** The track's info source */
export enum TrackSource {
  Manual = "manual",
  TunedGlobal = "tuned_global"
}

export type VideoUploadConnection = {
  __typename?: "VideoUploadConnection";
  edges: Array<VideoUploadEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Float"];
};

export type VideoUploadEdge = {
  __typename?: "VideoUploadEdge";
  /** Used in `before` and `after` args */
  cursor: Scalars["String"];
  node: VideoUpload;
};

export type VideoUpload = {
  __typename?: "VideoUpload";
  approvalStatus: VideoApprovalStatus;
  challenge?: Maybe<Challenge>;
  /** A paginated list of all approved comments on this video. */
  comments?: Maybe<ActivityCommentConnection>;
  createdAt: Scalars["DateTime"];
  description?: Maybe<Scalars["String"]>;
  durationInMs?: Maybe<Scalars["String"]>;
  encodingStatus: VideoEncodingStatus;
  error?: Maybe<Scalars["String"]>;
  /** The number of times the video has been flagged/reported. Requires the admin role to use. */
  flaggedCount: Scalars["Float"];
  id: Scalars["ID"];
  /** True if the video was created by the requesting user. */
  isAuthoredByMe: Scalars["Boolean"];
  isUserDeleted: Scalars["Boolean"];
  isUserSubmitted: Scalars["Boolean"];
  mediaConvertJobIds?: Maybe<Array<Scalars["String"]>>;
  /** The HLS url for the video. */
  playbackUrl?: Maybe<Scalars["String"]>;
  /** The number of reactions to this video by type. */
  reactions: Array<ActivityReactionsCount>;
  /** True if the user has flagged/reported this video at some point */
  reportedByMe: Scalars["Boolean"];
  stepFunctionArn?: Maybe<Scalars["String"]>;
  studioClass?: Maybe<StudioClass>;
  /** The full thumbnail url for the video (without query params). */
  thumbnailUrl?: Maybe<Scalars["String"]>;
  type: VideoType;
  updatedAt: Scalars["DateTime"];
  uploadedAt?: Maybe<Scalars["DateTime"]>;
  /** The profile of the user that uploaded the video. */
  uploadedBy: UserProfile;
  /** The associated user reactions to this video. */
  userReactions?: Maybe<Array<UserReactionType>>;
};

export type VideoUploadCommentsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Float"]>;
  last?: InputMaybe<Scalars["Float"]>;
};

/** The user's video approval status */
export enum VideoApprovalStatus {
  Approved = "approved",
  None = "none",
  Rejected = "rejected"
}

export type ActivityReactionsCount = {
  __typename?: "ActivityReactionsCount";
  reactionType: UserReactionType;
  totalCount: Scalars["Int"];
};

/** Type of the user reaction */
export enum UserReactionType {
  DoNotUse = "do_not_use",
  Like = "like"
}

export type DurationOption = {
  __typename?: "DurationOption";
  /** The description of a duration option. */
  description: Scalars["String"];
  /** The end time of a duration option. */
  end: Scalars["Int"];
  /** The name of a duration option. */
  name: Scalars["String"];
  /** The slug of a duration option. */
  slug: Scalars["ID"];
  /** The start time of a duration option. */
  start: Scalars["Int"];
};

export type LevelOption = {
  __typename?: "LevelOption";
  /** The description of a dance level option. */
  description: Scalars["String"];
  /** The name of a dance level option. */
  name: Scalars["String"];
  /** A preview GIF URL for each level option. */
  previewGIFUrl?: Maybe<Scalars["String"]>;
  /** The slug of a dance level option. */
  slug: Scalars["ID"];
};

export type ReasonOption = {
  __typename?: "ReasonOption";
  /** The description of a dance reason option. */
  description?: Maybe<Scalars["String"]>;
  /** The goal of a dance reason option. */
  goal?: Maybe<Scalars["String"]>;
  /** The label of a dance reason option. */
  label?: Maybe<Scalars["String"]>;
  /** A preview image URL for each dance reason option. */
  previewImgURL?: Maybe<Scalars["String"]>;
  /** The slug of a dance reason option. */
  slug: Scalars["ID"];
  /** The experiment variant of the user. */
  variant?: Maybe<Scalars["String"]>;
};

/** Represents a link in a user's profile */
export type UserProfileLink = {
  __typename?: "UserProfileLink";
  /** Title or label for the link */
  title?: Maybe<Scalars["String"]>;
  /** URL of the link */
  url: Scalars["String"];
};

export type PlaylistV2Connection = {
  __typename?: "PlaylistV2Connection";
  edges: Array<PlaylistV2Edge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Float"];
};

export type PlaylistV2Edge = {
  __typename?: "PlaylistV2Edge";
  /** Used in `before` and `after` args */
  cursor: Scalars["String"];
  node: PlaylistV2;
};

export type PlaylistV2 = {
  __typename?: "PlaylistV2";
  createdAt: Scalars["DateTime"];
  displayIndex?: Maybe<Scalars["Int"]>;
  /** If studio class(es) is in playlist. Requires the user role to use. */
  hasStudioClasses: Array<PlaylistHasStudioClass>;
  hidden: Scalars["Boolean"];
  id: Scalars["ID"];
  /** Is Playlist saved by user. Requires the user role to use. */
  isSaved: Scalars["Boolean"];
  name: Scalars["String"];
  /** Playlist Owner Requires the user role to use. */
  owner?: Maybe<PlaylistOwner>;
  /** Get studio classes in a playlist. Requires the user role to use. */
  studioClasses: StudioClassConnection;
  thumbnailImageId?: Maybe<Scalars["String"]>;
  /** Playlist thumbnail. Requires the user role to use. */
  thumbnailImageUrl?: Maybe<Scalars["String"]>;
  updatedAt: Scalars["DateTime"];
};

export type PlaylistV2HasStudioClassesArgs = {
  studioClassIds: Array<Scalars["String"]>;
};

export type PlaylistV2StudioClassesArgs = {
  pagination: ConnectionArgs;
};

export type PlaylistHasStudioClass = {
  __typename?: "PlaylistHasStudioClass";
  hasStudioClass: Scalars["Boolean"];
  id: Scalars["ID"];
  /** For convenience, same as second part of `id`. */
  studioClassId: Scalars["String"];
};

export type PlaylistOwner = {
  __typename?: "PlaylistOwner";
  /** List of badges earned by the user */
  badges?: Maybe<Array<UserBadge>>;
  /** User's self-written biography or description */
  bio?: Maybe<Scalars["String"]>;
  /** User's birth date */
  birthDate?: Maybe<Scalars["DateTime"]>;
  /** Unique identifier for the user profile */
  id: Scalars["ID"];
  /** Slug of the user's instructor profile */
  instructorSlug?: Maybe<Scalars["String"]>;
  isMe: Scalars["Boolean"];
  /** List of social media or other relevant links */
  links?: Maybe<Array<UserProfileLink>>;
  /** User's name */
  name?: Maybe<Scalars["String"]>;
  /** URL to the user's profile photo */
  photoURL?: Maybe<Scalars["String"]>;
  /** Firebase user ID associated with this profile */
  uid?: Maybe<Scalars["String"]>;
  /** User's chosen display name */
  username?: Maybe<Scalars["String"]>;
};

export type NotificationPreference = {
  __typename?: "NotificationPreference";
  allowAll: Scalars["Boolean"];
  enabled: Scalars["Boolean"];
  /** Currently same value as source */
  id: Scalars["ID"];
  source: NotificationSourcePreference;
};

export enum NotificationSourcePreference {
  EmailFeedback = "email_feedback",
  EmailNews = "email_news",
  EmailReminder = "email_reminder",
  EmailSupport = "email_support",
  PushMessage = "push_message",
  PushNewClass = "push_new_class",
  PushNewFollower = "push_new_follower",
  PushRecommendedClasses = "push_recommended_classes",
  PushReminder = "push_reminder",
  PushUgcComment = "push_ugc_comment",
  PushUgcCommentReply = "push_ugc_comment_reply",
  PushUgcReaction = "push_ugc_reaction"
}

export type NotificationConnection = {
  __typename?: "NotificationConnection";
  edges: Array<NotificationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Float"];
};

export type NotificationEdge = {
  __typename?: "NotificationEdge";
  /** Used in `before` and `after` args */
  cursor: Scalars["String"];
  node: Notification;
};

export type Notification = {
  __typename?: "Notification";
  createdAt: Scalars["DateTime"];
  header: Scalars["String"];
  id: Scalars["ID"];
  message: Scalars["String"];
  seen: Scalars["Boolean"];
  /** Profile details of notification sender Requires the user role to use. */
  senderProfile?: Maybe<UserProfile>;
  sourceParamsCSV: Scalars["String"];
  sourceType: NotificationSourceType;
  timeSince: Scalars["String"];
  updatedAt: Scalars["DateTime"];
};

/** Source of the notification */
export enum NotificationSourceType {
  BadgeEarned = "BadgeEarned",
  UgcComment = "UGCComment",
  UgcCommentReply = "UGCCommentReply",
  UgcReactionLike = "UGCReactionLike"
}

export type ParentalControls = {
  __typename?: "ParentalControls";
  isEnabled: Scalars["Boolean"];
  pin?: Maybe<Scalars["String"]>;
};

export type Invite = {
  __typename?: "Invite";
  /** The number of class unlocks granted to the advocate after a successful conversion. */
  advocateClassUnlocksEarned?: Maybe<Scalars["Int"]>;
  /** The USD credits granted to the advocate after a successful conversion. */
  advocateCreditCentsEarned?: Maybe<Scalars["Int"]>;
  /** The time at which the recipient subscribed (trial or active subscription). If the recipient has not converted, the value will be `null`. */
  convertedAt?: Maybe<Scalars["IsoTime"]>;
  createdAt: Scalars["DateTime"];
  id: Scalars["ID"];
  /** The time at which the recipient registered with STEEZY through web as a valid referral. This is different from the time of conversion (see `convertedAt`). */
  joinedAt: Scalars["IsoTime"];
  /** The number of class unlocks granted to the recipient after a successful conversion. */
  recipientClassUnlocksEarned?: Maybe<Scalars["Int"]>;
  /** The USD credits granted to the recipient after a successful conversion. */
  recipientCreditCentsEarned?: Maybe<Scalars["Int"]>;
  /** The time at which the advocate's referral was rewarded. If the advocate has not been rewarded, the value will be `null`. */
  rewardedAt?: Maybe<Scalars["IsoTime"]>;
  updatedAt: Scalars["DateTime"];
};

export type PreferredContent = {
  __typename?: "PreferredContent";
  categories: Array<PreferredCategory>;
  programs: Array<ProgramV2>;
};

export type PreferredCategory = {
  __typename?: "PreferredCategory";
  classes: Array<Class>;
  name: Scalars["String"];
  slug: Scalars["String"];
};

export type PaymentSource = {
  __typename?: "PaymentSource";
  card?: Maybe<Card>;
  createdAt: Scalars["DateTime"];
  gateway: GatewayProvider;
  id: Scalars["ID"];
  provider: ProviderInfo;
  type: Scalars["String"];
  updatedAt: Scalars["DateTime"];
  user: User;
};

export type Card = {
  __typename?: "Card";
  brand?: Maybe<Scalars["String"]>;
  fundingType?: Maybe<Scalars["String"]>;
  lastFour?: Maybe<Scalars["String"]>;
  object?: Maybe<Scalars["String"]>;
};

export enum GatewayProvider {
  Braintree = "braintree",
  Stripe = "stripe"
}

export type ProviderInfo = {
  __typename?: "ProviderInfo";
  id: Scalars["String"];
  name: SubscriptionProvider;
};

export enum SubscriptionProvider {
  Chargebee = "chargebee",
  Revenuecat = "revenuecat",
  Steezy = "steezy"
}

export type Subscription = {
  __typename?: "Subscription";
  cancelationTime?: Maybe<Scalars["Float"]>;
  createdAt: Scalars["DateTime"];
  currentTermEnd?: Maybe<Scalars["Float"]>;
  id: Scalars["ID"];
  invoiceDue?: Maybe<Invoice>;
  invoiceEstimate?: Maybe<SubscriptionInvoiceEstimate>;
  isActive: Scalars["Boolean"];
  isCancelable: Scalars["Boolean"];
  isPastDue: Scalars["Boolean"];
  isPauseScheduled: Scalars["Boolean"];
  isReactivatable: Scalars["Boolean"];
  isReactivatableV2: Scalars["Boolean"];
  nextBillingAt?: Maybe<Scalars["Float"]>;
  pauseTime?: Maybe<Scalars["Float"]>;
  plan: Plan;
  provider: ProviderInfo;
  resumeTime?: Maybe<Scalars["Float"]>;
  status: SubscriptionStatus;
  trialEndTime?: Maybe<Scalars["Float"]>;
  updatedAt: Scalars["DateTime"];
  user: User;
};

export type Invoice = {
  __typename?: "Invoice";
  amountDue: Scalars["Float"];
  createdAt: Scalars["DateTime"];
  dueDate?: Maybe<Scalars["Float"]>;
  dunningAttemptsCount: Scalars["Float"];
  dunningStatus?: Maybe<DunningStatus>;
  id: Scalars["ID"];
  nextRetryAt?: Maybe<Scalars["Float"]>;
  status: InvoiceStatus;
  subscription?: Maybe<Subscription>;
  updatedAt: Scalars["DateTime"];
  user?: Maybe<User>;
};

/** An invoice's dunning status */
export enum DunningStatus {
  Exhausted = "exhausted",
  InProgress = "in_progress",
  Stopped = "stopped",
  Success = "success"
}

/** The invoice's current status */
export enum InvoiceStatus {
  NotPaid = "not_paid",
  Paid = "paid",
  PaymentDue = "payment_due",
  Pending = "pending",
  Posted = "posted",
  Voided = "voided"
}

export type SubscriptionInvoiceEstimate = {
  __typename?: "SubscriptionInvoiceEstimate";
  amountDue?: Maybe<Scalars["Float"]>;
  creditsApplied?: Maybe<Scalars["Float"]>;
  subTotal?: Maybe<Scalars["Float"]>;
  total?: Maybe<Scalars["Float"]>;
};

export type Plan = {
  __typename?: "Plan";
  accessType: AccessType;
  annualSavingsInCents: Scalars["Float"];
  canTrial: Scalars["Boolean"];
  /** The estimate for invoice. Requires the user role to use. */
  changePlanEstimate?: Maybe<ChangePlanEstimate>;
  countries: Array<Country>;
  createdAt: Scalars["DateTime"];
  currencyCode?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  invoiceEstimate?: Maybe<SubscriptionInvoiceEstimate>;
  isBestValue: Scalars["Boolean"];
  isDisplayed: Scalars["Boolean"];
  isLegacy: Scalars["Boolean"];
  isSpecial: Scalars["Boolean"];
  isSubscribed: Scalars["Boolean"];
  monthlyCostInCents?: Maybe<Scalars["Float"]>;
  monthlySavingsInPercent: Scalars["Float"];
  name: Scalars["String"];
  nextBillingAt?: Maybe<Scalars["Float"]>;
  partnerAssetUrl?: Maybe<Scalars["String"]>;
  partnerId?: Maybe<Scalars["String"]>;
  period: Scalars["Float"];
  periodUnit?: Maybe<BillingPeriodUnit>;
  platform: Platform;
  priceInCents?: Maybe<Scalars["Float"]>;
  provider: ProviderInfo;
  trialEndTime?: Maybe<Scalars["Float"]>;
  trialPeriod?: Maybe<Scalars["Float"]>;
  trialPeriodUnit?: Maybe<BillingPeriodUnit>;
  updatedAt: Scalars["DateTime"];
};

export type PlanCanTrialArgs = {
  input?: InputMaybe<PlansInput>;
};

export type PlanChangePlanEstimateArgs = {
  input?: InputMaybe<PlansInput>;
};

export type PlanInvoiceEstimateArgs = {
  input?: InputMaybe<PlansInput>;
};

export type PlanNextBillingAtArgs = {
  input?: InputMaybe<PlansInput>;
};

export type PlanTrialEndTimeArgs = {
  input?: InputMaybe<PlansInput>;
};

export type PlansInput = {
  accessType?: InputMaybe<AccessType>;
  countryCode?: InputMaybe<Scalars["String"]>;
  partnerId?: InputMaybe<Scalars["String"]>;
  providerName: SubscriptionProvider;
};

export type ChangePlanEstimate = {
  __typename?: "ChangePlanEstimate";
  changePlanType: ChangePlanType;
  invoiceEstimate?: Maybe<SubscriptionInvoiceEstimate>;
  isEndOfTerm: Scalars["Boolean"];
};

/** The type of switch that a user is making when switching plans. */
export enum ChangePlanType {
  BillingPeriod = "billing_period",
  Downgrade = "downgrade",
  None = "none",
  Upgrade = "upgrade"
}

export type Country = {
  __typename?: "Country";
  createdAt: Scalars["DateTime"];
  id: Scalars["ID"];
  /** ISO 3166-1 alpha-2 two-letter country code (e.g. 'US', 'GB', 'DE') */
  isoCode: Scalars["String"];
  name: Scalars["String"];
  plans: Array<Plan>;
  updatedAt: Scalars["DateTime"];
};

/** The unit of measure for the plan's billing period */
export enum BillingPeriodUnit {
  Day = "day",
  Month = "month",
  Week = "week",
  Year = "year"
}

/** The STEEZY device platform. */
export enum Platform {
  Android = "android",
  Ios = "ios",
  Web = "web"
}

/** The subscription's current status */
export enum SubscriptionStatus {
  Active = "active",
  Canceled = "canceled",
  Future = "future",
  InTrial = "in_trial",
  NonRenewing = "non_renewing",
  Paused = "paused"
}

export type UserProgress = {
  __typename?: "UserProgress";
  acknowledgedContent?: Maybe<Scalars["JSON"]>;
  /** @deprecated Use classes_completed_count */
  classes_completed: Scalars["Int"];
  classes_completed_count: Scalars["Int"];
  id: Scalars["ID"];
  topStreak: Scalars["Int"];
  total_time_spent: Scalars["Int"];
};

export type Role = {
  __typename?: "Role";
  createdAt: Scalars["DateTime"];
  id: Scalars["ID"];
  name: Scalars["String"];
  updatedAt: Scalars["DateTime"];
};

export type StreakProgress = {
  __typename?: "StreakProgress";
  dailyStreaks?: Maybe<Array<Maybe<DailyStreak>>>;
  weeklyStreakCount?: Maybe<Scalars["Int"]>;
  weeklyStreakGoal: Scalars["Int"];
};

export type DailyStreak = {
  __typename?: "DailyStreak";
  achievedDailyStreakDate: Scalars["String"];
  date: Scalars["String"];
  id: Scalars["String"];
};

export type UserWeeklyStats = {
  __typename?: "UserWeeklyStats";
  classesTakenPerDay: Array<ClassesTakenPerDay>;
  secondsSpentPerDay: Array<SecondsSpentPerDay>;
  totalClassesTaken: Scalars["Int"];
  totalSecondsSpent: Scalars["Int"];
};

export type ClassesTakenPerDay = {
  __typename?: "ClassesTakenPerDay";
  count: Scalars["Int"];
  date: Scalars["String"];
};

export type SecondsSpentPerDay = {
  __typename?: "SecondsSpentPerDay";
  date: Scalars["String"];
  seconds: Scalars["Int"];
};

export type UserYearlyStatsInput = {
  limit: Scalars["Float"];
  year?: InputMaybe<Scalars["Float"]>;
};

export type UserYearlyStats = {
  __typename?: "UserYearlyStats";
  topCategoryStyles: Array<ClassCategory>;
  topInstructors: Array<ClassInstructor>;
  totalSecondsSpent: Scalars["Int"];
};

export type ClassCategory = {
  __typename?: "ClassCategory";
  createdAt: Scalars["DateTime"];
  description?: Maybe<Scalars["String"]>;
  hidden: Scalars["Boolean"];
  id: Scalars["ID"];
  isOnboarding: Scalars["Boolean"];
  name?: Maybe<Scalars["String"]>;
  /** The published preview video. Requires the user role to use. */
  previewVideo?: Maybe<CategoryVideo>;
  slug: Scalars["String"];
  sortIndex: Scalars["Float"];
  thumbnailImageId?: Maybe<Scalars["String"]>;
  /** Full thumbnail image url. Requires the user role to use. */
  thumbnailImageUrl?: Maybe<Scalars["String"]>;
  updatedAt: Scalars["DateTime"];
};

export type CategoryVideo = {
  __typename?: "CategoryVideo";
  category: ClassCategory;
  createdAt: Scalars["DateTime"];
  durationInMs?: Maybe<Scalars["String"]>;
  encodingStatus: VideoEncodingStatus;
  error?: Maybe<Scalars["String"]>;
  /** HLS playback urls for the video. Requires the user role to use. */
  hlsPlaybackUrls?: Maybe<VideoPlaybackResponse>;
  id: Scalars["ID"];
  mediaConvertJobIds?: Maybe<Array<Scalars["String"]>>;
  stepFunctionArn?: Maybe<Scalars["String"]>;
  type: VideoType;
  updatedAt: Scalars["DateTime"];
  uploadedAt?: Maybe<Scalars["DateTime"]>;
};

/** Challenge display text */
export type ChallengeDisplayText = {
  __typename?: "ChallengeDisplayText";
  earnedByHeader?: Maybe<Scalars["String"]>;
  goalHeader?: Maybe<Scalars["String"]>;
  subtitleHeader?: Maybe<Scalars["String"]>;
};

export type UserProgressChallenge = {
  __typename?: "UserProgressChallenge";
  achievementId: Scalars["String"];
  currentBadge?: Maybe<Badge>;
  currentBadgeProgress: Scalars["Float"];
  nextBadge?: Maybe<Badge>;
  triggerType: AchievementTriggerType;
};

/** The type of the trigger for the achievement */
export enum AchievementTriggerType {
  ClassCompletion = "ClassCompletion",
  ClassMinutesSpent = "ClassMinutesSpent",
  ClassTaken = "ClassTaken",
  PostComment = "PostComment",
  PostUpload = "PostUpload",
  RequiredClassCompletion = "RequiredClassCompletion",
  RequiredClassTaken = "RequiredClassTaken"
}

export type Admin = {
  __typename?: "Admin";
  /** Get achievement by ID. Requires the admin role to use. */
  achievementById?: Maybe<AdminAchievement>;
  /** Get filterable achievements. Requires the admin role to use. */
  achievements: AdminAchievementConnection;
  /** Get all class levels. Requires the admin role to use. */
  allClassLevels: Array<ClassLevel>;
  /** Get all class styles. Requires the admin role to use. */
  allClassStyles: Array<ClassStyle>;
  /** Get all class types. Requires the admin role to use. */
  allClassTypes: Array<ClassType>;
  /** Get filterable categories. Requires the admin role to use. */
  categories: CategoryConnection;
  /** Get category by ID. Requires the admin role to use. */
  categoryById?: Maybe<ClassCategory>;
  /** Get filterable videos in a category. Requires the admin role to use. */
  categoryVideos: AdminCategoryVideoConnection;
  /** Get challenge by ID. Requires the admin role to use. */
  challengeById?: Maybe<Challenge>;
  /** Get filterable challenges. Requires the admin role to use. */
  challenges: ChallengeConnection;
  /** Get filterable countries. Requires the admin role to use. */
  countries: CountryConnection;
  /** Get country by ID. Requires the admin role to use. */
  countryById?: Maybe<Country>;
  /** Get instructor by ID. Requires the admin role to use. */
  instructorById?: Maybe<ClassInstructor>;
  /** Get instructor credits. Requires the admin role to use. */
  instructorCredits: Array<InstructorCredit>;
  /** Get filterable instructors. Requires the admin role to use. */
  instructors: InstructorConnection;
  /** Get plan by ID. Requires the admin role to use. */
  planById?: Maybe<Plan>;
  /** Get plan by ID. Requires the admin role to use. */
  planByProviderId?: Maybe<Plan>;
  /** Get filterable plans. Requires the admin role to use. */
  plans: PlanConnection;
  /** Get filterable playlists. Requires the admin role to use. */
  playlists: PlaylistV2Connection;
  /** All available roles Requires the admin role to use. */
  roles: Array<Role>;
  /** Get class by class number. Requires the admin role to use. */
  studioClassByClassId?: Maybe<AdminStudioClass>;
  /** Get class by ID. Requires the admin role to use. */
  studioClassById?: Maybe<AdminStudioClass>;
  /** Get filterable classes. Requires the admin role to use. */
  studioClasses: AdminStudioClassConnection;
  /** Get tags. Requires the admin role to use. */
  tagById: Tag;
  /** Get tags. Requires the admin role to use. */
  tags: TagConnection;
  /** User Requires the admin role to use. */
  user: AdminUser;
};

export type AdminAchievementByIdArgs = {
  id: Scalars["String"];
};

export type AdminAchievementsArgs = {
  filter?: InputMaybe<AchievementFilter>;
  pagination?: InputMaybe<ConnectionArgs>;
  sort?: InputMaybe<OrderByInput>;
};

export type AdminCategoriesArgs = {
  filter?: InputMaybe<CategoryFilterInput>;
  pagination?: InputMaybe<ConnectionArgs>;
  sort?: InputMaybe<OrderByInput>;
};

export type AdminCategoryByIdArgs = {
  id: Scalars["String"];
};

export type AdminCategoryVideosArgs = {
  filter?: InputMaybe<CategoryVideoFilterInput>;
  pagination?: InputMaybe<ConnectionArgs>;
  sort?: InputMaybe<OrderByInput>;
};

export type AdminChallengeByIdArgs = {
  id: Scalars["String"];
};

export type AdminChallengesArgs = {
  filter?: InputMaybe<ChallengeFilterInput>;
  pagination?: InputMaybe<ConnectionArgs>;
  sort?: InputMaybe<OrderByInput>;
};

export type AdminCountriesArgs = {
  filter?: InputMaybe<CountryFilter>;
  pagination?: InputMaybe<ConnectionArgs>;
  sort?: InputMaybe<OrderByInput>;
};

export type AdminCountryByIdArgs = {
  id: Scalars["String"];
};

export type AdminInstructorByIdArgs = {
  id: Scalars["String"];
};

export type AdminInstructorsArgs = {
  filter?: InputMaybe<InstructorFilterInput>;
  pagination?: InputMaybe<ConnectionArgs>;
  sort?: InputMaybe<OrderByInput>;
};

export type AdminPlanByIdArgs = {
  id: Scalars["String"];
};

export type AdminPlanByProviderIdArgs = {
  providerId: Scalars["String"];
};

export type AdminPlansArgs = {
  filter?: InputMaybe<PlanFilter>;
  pagination?: InputMaybe<ConnectionArgs>;
  sort?: InputMaybe<OrderByInput>;
};

export type AdminPlaylistsArgs = {
  filter?: InputMaybe<PlaylistFilterInput>;
  pagination?: InputMaybe<ConnectionArgs>;
  sort?: InputMaybe<OrderByInput>;
};

export type AdminStudioClassByClassIdArgs = {
  classId: Scalars["Float"];
};

export type AdminStudioClassByIdArgs = {
  id: Scalars["String"];
};

export type AdminStudioClassesArgs = {
  filter?: InputMaybe<ClassFilterInput>;
  pagination?: InputMaybe<ConnectionArgs>;
  sort?: InputMaybe<OrderByInput>;
};

export type AdminTagByIdArgs = {
  id?: InputMaybe<Scalars["String"]>;
};

export type AdminTagsArgs = {
  filter?: InputMaybe<TagFilterInput>;
  pagination?: InputMaybe<ConnectionArgs>;
  sort?: InputMaybe<OrderByInput>;
};

export type AdminUserArgs = {
  uid: Scalars["String"];
};

export type AdminAchievement = {
  __typename?: "AdminAchievement";
  /** All required studio classes for an achievement. Requires the admin role to use. */
  allRequiredStudioClasses?: Maybe<Array<AdminStudioClass>>;
  badges: Array<Badge>;
  challenge?: Maybe<Challenge>;
  createdAt: Scalars["DateTime"];
  description?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  name: Scalars["String"];
  /** The published studio classes required to earn this achievement. Requires the user role to use. */
  requiredPublishedStudioClasses?: Maybe<Array<StudioClass>>;
  triggerType: AchievementTriggerType;
  updatedAt: Scalars["DateTime"];
};

export type AdminStudioClass = {
  __typename?: "AdminStudioClass";
  accessType?: Maybe<AccessType>;
  /** The categories for this class. Requires the admin role to use. */
  categories: Array<ClassCategory>;
  classId: Scalars["Float"];
  createdAt: Scalars["DateTime"];
  externalPreviewUrl?: Maybe<Scalars["String"]>;
  /** @deprecated Use accessType */
  free: Scalars["Boolean"];
  hidden: Scalars["Boolean"];
  id: Scalars["ID"];
  instructor?: Maybe<ClassInstructor>;
  /** True if class has licensing rights to all its tracks */
  isClassFullyLicensed: Scalars["Boolean"];
  /** True if this class contains an explicit track. Requires the user role to use. */
  isExplicit: Scalars["Boolean"];
  isFamilyFriendly: Scalars["Boolean"];
  /** @deprecated Use classVideoType on video instead. */
  isSingleView: Scalars["Boolean"];
  level?: Maybe<Scalars["String"]>;
  /** The muted cuepoints for the class. Requires the admin role to use. */
  mutedCuepoints: Array<MutedCuepoint>;
  /** Currently published preview video Requires the admin role to use. */
  previewVideo?: Maybe<ClassVideo>;
  publishDate?: Maybe<Scalars["DateTime"]>;
  sections?: Maybe<Array<StudioClassSectionEntity>>;
  /** @deprecated Use isClassFullyLicensed resolver */
  shouldBeMuted: Scalars["Boolean"];
  slug: Scalars["String"];
  /** @deprecated Use StyleV2. */
  style?: Maybe<Scalars["String"]>;
  /** Requires the user role to use. */
  styleV2?: Maybe<ClassStyle>;
  tags: Array<Tag>;
  thumbnailImageId?: Maybe<Scalars["String"]>;
  /** Full thumbnail image url. Requires the user role to use. */
  thumbnailImageUrl?: Maybe<Scalars["String"]>;
  title: Scalars["String"];
  /** The tracks in this class. Requires the admin role to use. */
  tracks: Array<StudioClassTrack>;
  type?: Maybe<Scalars["String"]>;
  updatedAt: Scalars["DateTime"];
  /** User progress for class. Requires the user role to use. */
  userProgress: UserClassProgress;
  /** Currently published video Requires the admin role to use. */
  video?: Maybe<ClassVideo>;
};

export type AchievementFilter = {
  name?: InputMaybe<Scalars["String"]>;
  triggerType?: InputMaybe<AchievementTriggerType>;
};

export type AdminAchievementConnection = {
  __typename?: "AdminAchievementConnection";
  edges: Array<AdminAchievementEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Float"];
};

export type AdminAchievementEdge = {
  __typename?: "AdminAchievementEdge";
  /** Used in `before` and `after` args */
  cursor: Scalars["String"];
  node: AdminAchievement;
};

export type ClassLevel = {
  __typename?: "ClassLevel";
  name: Scalars["String"];
};

export type ClassType = {
  __typename?: "ClassType";
  name: Scalars["String"];
};

export type CategoryFilterInput = {
  hidden?: InputMaybe<Scalars["Boolean"]>;
  isOnboarding?: InputMaybe<Scalars["Boolean"]>;
  name?: InputMaybe<Scalars["String"]>;
  slug?: InputMaybe<Scalars["String"]>;
};

export type CategoryConnection = {
  __typename?: "CategoryConnection";
  edges: Array<CategoryEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Float"];
};

export type CategoryEdge = {
  __typename?: "CategoryEdge";
  /** Used in `before` and `after` args */
  cursor: Scalars["String"];
  node: ClassCategory;
};

export type CategoryVideoFilterInput = {
  categoryId?: InputMaybe<Scalars["String"]>;
  encodingStatus?: InputMaybe<VideoEncodingStatus>;
  updatedAfter?: InputMaybe<Scalars["DateTime"]>;
  updatedBefore?: InputMaybe<Scalars["DateTime"]>;
};

export type AdminCategoryVideoConnection = {
  __typename?: "AdminCategoryVideoConnection";
  edges: Array<AdminCategoryVideoEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Float"];
};

export type AdminCategoryVideoEdge = {
  __typename?: "AdminCategoryVideoEdge";
  /** Used in `before` and `after` args */
  cursor: Scalars["String"];
  node: AdminCategoryVideo;
};

export type AdminCategoryVideo = {
  __typename?: "AdminCategoryVideo";
  category: ClassCategory;
  createdAt: Scalars["DateTime"];
  durationInMs?: Maybe<Scalars["String"]>;
  encodingStatus: VideoEncodingStatus;
  error?: Maybe<Scalars["String"]>;
  /** HLS playback urls for the video. Requires the user role to use. */
  hlsPlaybackUrls?: Maybe<VideoPlaybackResponse>;
  id: Scalars["ID"];
  mediaConvertJobIds?: Maybe<Array<Scalars["String"]>>;
  stepFunctionArn?: Maybe<Scalars["String"]>;
  type: VideoType;
  updatedAt: Scalars["DateTime"];
  uploadedAt?: Maybe<Scalars["DateTime"]>;
};

export type ChallengeFilterInput = {
  activeAfter?: InputMaybe<Scalars["DateTime"]>;
  activeBefore?: InputMaybe<Scalars["DateTime"]>;
  challengeStatus?: InputMaybe<Array<ChallengeStatus>>;
  classId?: InputMaybe<Scalars["String"]>;
};

export type ChallengeConnection = {
  __typename?: "ChallengeConnection";
  edges: Array<ChallengeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Float"];
};

export type ChallengeEdge = {
  __typename?: "ChallengeEdge";
  /** Used in `before` and `after` args */
  cursor: Scalars["String"];
  node: Challenge;
};

export type CountryFilter = {
  isoCode?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
};

export type CountryConnection = {
  __typename?: "CountryConnection";
  edges: Array<CountryEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Float"];
};

export type CountryEdge = {
  __typename?: "CountryEdge";
  /** Used in `before` and `after` args */
  cursor: Scalars["String"];
  node: Country;
};

export type InstructorCredit = {
  __typename?: "InstructorCredit";
  id: Scalars["ID"];
  name: Scalars["String"];
};

export type InstructorFilterInput = {
  hidden?: InputMaybe<Scalars["Boolean"]>;
  name?: InputMaybe<Scalars["String"]>;
  slug?: InputMaybe<Scalars["String"]>;
};

export type InstructorConnection = {
  __typename?: "InstructorConnection";
  edges: Array<InstructorEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Float"];
};

export type InstructorEdge = {
  __typename?: "InstructorEdge";
  /** Used in `before` and `after` args */
  cursor: Scalars["String"];
  node: ClassInstructor;
};

export type PlanFilter = {
  accessType?: InputMaybe<AccessType>;
  billingPeriodUnit?: InputMaybe<BillingPeriodUnit>;
  countryIsoCode?: InputMaybe<Scalars["String"]>;
  isDisplayed?: InputMaybe<Scalars["Boolean"]>;
  name?: InputMaybe<Scalars["String"]>;
  platform?: InputMaybe<Platform>;
  providerId?: InputMaybe<Scalars["String"]>;
  providerName?: InputMaybe<Scalars["String"]>;
};

export type PlanConnection = {
  __typename?: "PlanConnection";
  edges: Array<PlanEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Float"];
};

export type PlanEdge = {
  __typename?: "PlanEdge";
  /** Used in `before` and `after` args */
  cursor: Scalars["String"];
  node: Plan;
};

export type PlaylistFilterInput = {
  name?: InputMaybe<Scalars["String"]>;
};

export type AdminStudioClassConnection = {
  __typename?: "AdminStudioClassConnection";
  edges: Array<AdminStudioClassEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Float"];
};

export type AdminStudioClassEdge = {
  __typename?: "AdminStudioClassEdge";
  /** Used in `before` and `after` args */
  cursor: Scalars["String"];
  node: AdminStudioClass;
};

export type TagFilterInput = {
  displayIndex?: InputMaybe<Scalars["Float"]>;
  name?: InputMaybe<Scalars["String"]>;
  slug?: InputMaybe<Scalars["String"]>;
  type?: InputMaybe<Scalars["String"]>;
};

export type TagConnection = {
  __typename?: "TagConnection";
  edges: Array<TagEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Float"];
};

export type TagEdge = {
  __typename?: "TagEdge";
  /** Used in `before` and `after` args */
  cursor: Scalars["String"];
  node: Tag;
};

export type AdminUser = {
  __typename?: "AdminUser";
  /** User's PII data in JSON Requires the admin role to use. */
  PII: Scalars["String"];
};

export type BadgeYearGroup = {
  __typename?: "BadgeYearGroup";
  userBadges: Array<UserBadge>;
  year: Scalars["Int"];
};

export type CheckoutEstimateInput = {
  couponId?: InputMaybe<Scalars["String"]>;
  planInfo: PlanInfoInput;
  referralCode?: InputMaybe<Scalars["String"]>;
};

export type PlanInfoInput = {
  id: Scalars["String"];
  name: SubscriptionProvider;
};

export type CheckoutEstimate = {
  __typename?: "CheckoutEstimate";
  coupon?: Maybe<Coupon>;
  discountPlanPriceInCents: Scalars["Float"];
  /** Determines the monthly price of the plan, given the plan's discounted price and period unit (i.e. a $99.99 annual plan would return 833 here to represent the cost per month in cents) */
  monthlyDiscountPlanPriceInCents?: Maybe<Scalars["Float"]>;
  /** Determines the monthly savings of the plan, given the plan's discounted price and period unit. */
  monthlySavingsAfterDiscountInPercent?: Maybe<Scalars["Float"]>;
  /**
   * Determines the date value at which a user will be billed the normal plan price, assuming they apply a valid coupon
   * @deprecated No longer used for copy on checkout page.
   */
  nextNormalBillingAt?: Maybe<Scalars["Float"]>;
};

export type Coupon = {
  __typename?: "Coupon";
  createdAt: Scalars["DateTime"];
  discountAmount?: Maybe<Scalars["Float"]>;
  discountDuration?: Maybe<Scalars["Float"]>;
  discountPercentage?: Maybe<Scalars["Float"]>;
  discountType: DiscountType;
  durationType: DurationType;
  id: Scalars["ID"];
  name: Scalars["String"];
  planConstraint: PlanConstraint;
  planIds?: Maybe<Array<Scalars["String"]>>;
  provider: ProviderInfo;
  status: CouponStatus;
  updatedAt: Scalars["DateTime"];
  validTill?: Maybe<Scalars["DateTime"]>;
};

/** The type of discount */
export enum DiscountType {
  FixedAmount = "fixed_amount",
  Percentage = "percentage"
}

/** Specifies the time duration this coupon is applicable */
export enum DurationType {
  Forever = "forever",
  LimitedPeriod = "limited_period",
  OneTime = "one_time"
}

/** The plan that a coupon is applicable to */
export enum PlanConstraint {
  All = "all",
  None = "none",
  NotApplicable = "not_applicable",
  Specific = "specific"
}

/** The coupon's current status */
export enum CouponStatus {
  Active = "active",
  Archived = "archived",
  Expired = "expired"
}

export type CheckSubscriptionCouponInput = {
  /** The coupon code to check for. */
  couponId: Scalars["String"];
  /** The ID of the subscription to check. */
  subscriptionId: Scalars["String"];
};

export type ClassVideoFilterInput = {
  classId?: InputMaybe<Scalars["Float"]>;
  encodingStatus?: InputMaybe<VideoEncodingStatus>;
  encodingStatuses?: InputMaybe<Array<VideoEncodingStatus>>;
  updatedAfter?: InputMaybe<Scalars["DateTime"]>;
  updatedBefore?: InputMaybe<Scalars["DateTime"]>;
};

export type ClassVideoConnection = {
  __typename?: "ClassVideoConnection";
  edges: Array<ClassVideoEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Float"];
};

export type ClassVideoEdge = {
  __typename?: "ClassVideoEdge";
  /** Used in `before` and `after` args */
  cursor: Scalars["String"];
  node: ClassVideo;
};

export type Config = {
  __typename?: "Config";
  appUpdateConfig: AppUpdateConfig;
  featureFlags: Array<FeatureFlag>;
  versionReviewConfig: VersionReviewConfig;
};

export type ConfigAppUpdateConfigArgs = {
  platform: Scalars["String"];
};

export type AppUpdateConfig = {
  __typename?: "AppUpdateConfig";
  isMandatory: Scalars["Boolean"];
  minimumPlatformVersion: Scalars["Float"];
  storeUrl: Scalars["String"];
  version: Scalars["String"];
};

export type FeatureFlag = {
  __typename?: "FeatureFlag";
  enabled: Scalars["Boolean"];
  name: Scalars["String"];
};

export type VersionReviewConfig = {
  __typename?: "VersionReviewConfig";
  isInReview: Scalars["Boolean"];
  versionNumber: Scalars["String"];
};

export type FeaturedContent = {
  __typename?: "FeaturedContent";
  content: FeaturedContentUnion;
  sortIndex: Scalars["Int"];
};

export type FeaturedContentUnion = Class;

export type FlaggedActivityFilterInput = {
  activityId?: InputMaybe<Scalars["String"]>;
  activityType?: InputMaybe<ActivityType>;
  activityUserId?: InputMaybe<Scalars["String"]>;
  reportedAfter?: InputMaybe<Scalars["DateTime"]>;
  reportedBefore?: InputMaybe<Scalars["DateTime"]>;
  reportReason?: InputMaybe<ActivityReportReason>;
  reportStatus?: InputMaybe<ActivityReportStatus>;
};

/** Type of the reported activity */
export enum ActivityType {
  UserComment = "user_comment",
  UserVideo = "user_video"
}

/** Reason why the user reported the activity */
export enum ActivityReportReason {
  Harassment = "harassment",
  Hate = "hate",
  Irrelevant = "irrelevant",
  Nudity = "nudity",
  Other = "other",
  Spam = "spam",
  Violence = "violence"
}

/** Status of the reported activity */
export enum ActivityReportStatus {
  PendingReview = "pending_review",
  Reported = "reported",
  Reviewed = "reviewed"
}

export type FlaggedActivityConnection = {
  __typename?: "FlaggedActivityConnection";
  edges: Array<FlaggedActivityEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Float"];
};

export type FlaggedActivityEdge = {
  __typename?: "FlaggedActivityEdge";
  /** Used in `before` and `after` args */
  cursor: Scalars["String"];
  node: FlaggedActivity;
};

export type FlaggedActivity = {
  __typename?: "FlaggedActivity";
  activityId: Scalars["String"];
  activityType: ActivityType;
  activityUserId?: Maybe<Scalars["String"]>;
  /** Get video or comment associated with the flagged activity. Requires the admin role to use. */
  content?: Maybe<FlaggedActivityContent>;
  createdAt: Scalars["DateTime"];
  description?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  reportReason: ActivityReportReason;
  reportStatus: ActivityReportStatus;
  reviewDecision: ActivityReviewDecision;
  reviewedBy?: Maybe<User>;
  reviewNotes?: Maybe<Scalars["String"]>;
  updatedAt: Scalars["DateTime"];
};

export type FlaggedActivityContent = ActivityComment | VideoUpload;

/** The result of the activity's report review */
export enum ActivityReviewDecision {
  Allow = "allow",
  Block = "block",
  None = "none"
}

export type StripePaymentInput = {
  amountInCents: Scalars["Float"];
};

export type StripePaymentIntent = {
  __typename?: "StripePaymentIntent";
  clientSecret: Scalars["String"];
  id: Scalars["String"];
};

export type GetCalendarDataInput = {
  endDate?: InputMaybe<Scalars["String"]>;
  startDate?: InputMaybe<Scalars["String"]>;
};

export type GetCalendarDataOutput = {
  __typename?: "GetCalendarDataOutput";
  dailyStreaks?: Maybe<Array<Maybe<DailyStreak>>>;
  userCreatedPlaylists?: Maybe<Array<Maybe<Playlist>>>;
  weeklyStreakCount?: Maybe<Scalars["Int"]>;
  weeklyStreakGoal: Scalars["Int"];
};

export type Playlist = {
  __typename?: "Playlist";
  classes?: Maybe<Array<Maybe<PlaylistClass>>>;
  date?: Maybe<Scalars["String"]>;
  duration_in_seconds?: Maybe<Scalars["Int"]>;
  id?: Maybe<Scalars["String"]>;
  isGenerated: Scalars["Boolean"];
  lastModifiedDate?: Maybe<Scalars["String"]>;
  progress?: Maybe<PlaylistProgress>;
  schedule_index?: Maybe<Scalars["Int"]>;
  takenClasses?: Maybe<Array<Maybe<Class>>>;
};

export type PlaylistClass = {
  __typename?: "PlaylistClass";
  /** Access type to determine user access on class. */
  accessType: AccessType;
  /** True if user has access to class based on given set of criteria. */
  canUserTakeClass: Scalars["Boolean"];
  categories: Array<Scalars["String"]>;
  challenges?: Maybe<Array<Challenge>>;
  /** Returns comments for a class given a studioClassId or classNumber Requires the user role to use. */
  comments?: Maybe<ActivityCommentConnection>;
  createdAt: Scalars["DateTime"];
  duration: Scalars["String"];
  duration_in_seconds: Scalars["Int"];
  /** Returns URL to external preview video. Requires the user role to use. */
  externalPreviewUrl?: Maybe<Scalars["String"]>;
  /** True if the user has taken the playlist class */
  hasTaken: Scalars["Boolean"];
  id: Scalars["ID"];
  instructor?: Maybe<Instructor>;
  /** True if class has licensing rights to all its tracks */
  isClassFullyLicensed: Scalars["Boolean"];
  /** True if this class contains an explicit track. Requires the user role to use. */
  isExplicit?: Maybe<Scalars["Boolean"]>;
  /** The published preview video for the class. Requires the user role to use. */
  isFamilyFriendly: Scalars["Boolean"];
  isFree: Scalars["Boolean"];
  /** True if this class has muted cuepoints. Requires the user role to use. */
  isPreviewVideoMuted?: Maybe<Scalars["Boolean"]>;
  isSaved?: Maybe<Scalars["Boolean"]>;
  /** True if class is unlocked for the authenticated user. Only applies to FUX users. Requires the user role to use. */
  isUnlocked: Scalars["Boolean"];
  level?: Maybe<Scalars["String"]>;
  /** The muted cuepoints for the class. Requires the user role to use. */
  mutedCuepoints: Array<MutedCuepoint>;
  /** The playlist ID the class is associated with */
  playlistId?: Maybe<Scalars["String"]>;
  preview_url: Scalars["String"];
  /** The published preview video for the class. Requires the user role to use. */
  previewVideo?: Maybe<ClassVideo>;
  progress?: Maybe<PlaylistClassProgress>;
  publish_date?: Maybe<Scalars["String"]>;
  /** Represents a program class reference ID when defined */
  refId?: Maybe<Scalars["String"]>;
  /** The class sections Requires the user role to use. */
  sections: Array<StudioClassSectionEntity>;
  slug: Scalars["String"];
  songs?: Maybe<Array<Maybe<Song>>>;
  /** Studio class PK Requires the user role to use. */
  studioClassId: Scalars["String"];
  style?: Maybe<Scalars["String"]>;
  thumbnail?: Maybe<Scalars["String"]>;
  title: Scalars["String"];
  /** The tracks (with full metadata) associated with the class. Requires the user role to use. */
  tracks: Array<StudioClassTrack>;
  type: Scalars["String"];
  updatedAt: Scalars["DateTime"];
  /** The user video uploads for this class. Requires the user role to use. */
  userVideos: VideoUploadConnection;
  /** The published video for the class. Requires the user role to use. */
  video?: Maybe<ClassVideo>;
  /** The class video metadata */
  video_metadata?: Maybe<VideoMetadata>;
};

export type PlaylistClassCommentsArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Float"]>;
  last?: InputMaybe<Scalars["Float"]>;
};

export type PlaylistClassUserVideosArgs = {
  after?: InputMaybe<Scalars["String"]>;
  before?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Float"]>;
  last?: InputMaybe<Scalars["Float"]>;
};

export type PlaylistClassVideoArgs = {
  hidden?: InputMaybe<Scalars["Boolean"]>;
};

export type PlaylistClassProgress = {
  __typename?: "PlaylistClassProgress";
  completed?: Maybe<Scalars["String"]>;
};

export type VideoMetadata = {
  __typename?: "VideoMetadata";
  hls_sources?: Maybe<HlsSources>;
  sections?: Maybe<Array<Maybe<VideoSection>>>;
};

export type HlsSources = {
  __typename?: "HlsSources";
  back_view?: Maybe<VideoUrls>;
  both_views?: Maybe<VideoUrls>;
  front_view?: Maybe<VideoUrls>;
};

export type VideoUrls = {
  __typename?: "VideoUrls";
  video_1080p: Scalars["String"];
  video_360p: Scalars["String"];
  video_540p: Scalars["String"];
  video_720p: Scalars["String"];
  video_auto: Scalars["String"];
  video_cast: Scalars["String"];
};

export type VideoSection = {
  __typename?: "VideoSection";
  cuepoints?: Maybe<Array<Maybe<VideoCuepoint>>>;
  name: Scalars["String"];
};

export type VideoCuepoint = {
  __typename?: "VideoCuepoint";
  duration_in_seconds: Scalars["Int"];
  name: Scalars["String"];
  time: Scalars["String"];
};

export type PlaylistProgress = {
  __typename?: "PlaylistProgress";
  completed?: Maybe<Scalars["String"]>;
  seen_completed_modal?: Maybe<Scalars["String"]>;
  started?: Maybe<Scalars["String"]>;
};

export type CancelSurvey = {
  __typename?: "CancelSurvey";
  additionalFeedback?: Maybe<Scalars["String"]>;
  createdAt: Scalars["DateTime"];
  id: Scalars["ID"];
  joinAgainReason?: Maybe<Scalars["String"]>;
  otherReason?: Maybe<Scalars["String"]>;
  overallExperienceRating: Scalars["Int"];
  reason: CancelReason;
  subscription: Subscription;
  updatedAt: Scalars["DateTime"];
};

/** Reasons for canceling a subscription */
export enum CancelReason {
  HardToUse = "hard_to_use",
  MissingContent = "missing_content",
  NoTime = "no_time",
  NotEnoughClasses = "not_enough_classes",
  Other = "other",
  TakingBreak = "taking_break",
  TechnicalIssues = "technical_issues",
  TooExpensive = "too_expensive"
}

export type GetCategoriesInput = {
  /** Determines which categories to return; if null, return all; if >=1 given, find categories that match at least 1 filter. */
  filters?: InputMaybe<Array<CategoryFilter>>;
  /** String value of goal provided during onboarding for G17 experiment, will return categories in certain order depending on goal */
  goal?: InputMaybe<GoalType>;
  /** A list of category slugs. If no slugs are provided then all of the categories will be returned. */
  slugs: Array<Scalars["ID"]>;
};

export enum CategoryFilter {
  IsOnboarding = "isOnboarding"
}

export enum GoalType {
  Choreo = "CHOREO",
  Fitness = "FITNESS",
  Public = "PUBLIC",
  Style = "STYLE"
}

export type GetClassInput = {
  /** The class ID */
  id: Scalars["String"];
  /** The program class reference ID */
  programClassRefId?: InputMaybe<Scalars["String"]>;
};

export type GetClassResponse = {
  __typename?: "GetClassResponse";
  current: Class;
  nextProgramClass?: Maybe<Class>;
};

export type UserAchievement = {
  __typename?: "UserAchievement";
  earnedBadges: Array<UserBadge>;
  newBadges: Array<UserBadge>;
};

export type GetClassesInput = {
  /** If set to true, all returned classes must be free. */
  freeOnly?: InputMaybe<Scalars["Boolean"]>;
  /** Defines the desired pagination state for the results. */
  pagination: PaginationBody;
  /** Controls the way results are sorted. Default value for 'orderBy' is 'publish_date' Default value for 'orderDirection' is 'desc'. */
  sort?: InputMaybe<SortBody>;
};

export type PaginationBody = {
  /** The number of results to return per page. */
  count: Scalars["Int"];
  /** The zero-indexed page's results to return. */
  page: Scalars["Int"];
};

export type SortBody = {
  /** The field used when ordering classes. */
  orderBy?: InputMaybe<Scalars["String"]>;
  /** Either 'asc' or 'desc'. The direction by which to sort the results when filtered on the 'orderBy' field. */
  orderDirection?: InputMaybe<Scalars["String"]>;
};

export type GetClassesConnection = {
  __typename?: "GetClassesConnection";
  /** The list of matched classes. */
  classes: Array<Class>;
  /** Pagination metadata. */
  pageInfo: PaginationInfo;
};

export type PaginationInfo = {
  __typename?: "PaginationInfo";
  /** Boolean value describing whether the page input parameter can be incremented to fetch further results. (page < totalPages - 1) */
  hasNextPage: Scalars["Boolean"];
  /** Boolean value describing whether there are previous pages. (page !== 0) */
  hasPreviousPage: Scalars["Boolean"];
  /** The total number of hits matching the search state. */
  hits?: Maybe<Scalars["Int"]>;
  /** The current, zero-indexed page of responses. */
  page: Scalars["Int"];
  /** The total number of pages available for the given request. */
  totalPages: Scalars["Int"];
};

/** The base type for namespacing content-related queries */
export type Content = {
  __typename?: "Content";
  featuredModal?: Maybe<FeaturedModalContent>;
  freeUserExperience?: Maybe<FreeUserExperienceContent>;
};

/** The base type for namespacing content-related queries */
export type ContentFeaturedModalArgs = {
  input: FeaturedModalSlugInput;
};

export type FeaturedModalSlugInput = {
  /** The slug of the featured modal */
  slug: Scalars["ID"];
};

export type FeaturedModalContent = {
  __typename?: "FeaturedModalContent";
  /** Body text for featured modal */
  body?: Maybe<Scalars["String"]>;
  /** Text on button of featured modal */
  ctaText?: Maybe<Scalars["String"]>;
  /** The date the user observed the featured modal */
  hasSeen: Scalars["Boolean"];
  /** Header text for featured modal */
  header?: Maybe<Scalars["String"]>;
  /** Program data for featured modal */
  program?: Maybe<ProgramV2>;
  /** The slug referencing this featured modal */
  slug: Scalars["String"];
  /** Subheader text for featured modal */
  subHeader?: Maybe<Scalars["String"]>;
};

/** The base type for namespacing FreeUserExperience-related content */
export type FreeUserExperienceContent = {
  __typename?: "FreeUserExperienceContent";
  firstLaunchModal?: Maybe<FuxFirstLaunchModal>;
};

/** The base type for namespacing FreeUserExperience-related content */
export type FreeUserExperienceContentFirstLaunchModalArgs = {
  programSlug: Scalars["String"];
};

/** The content to render a FreeUserExperience first-launch modal */
export type FuxFirstLaunchModal = {
  __typename?: "FUXFirstLaunchModal";
  /** The body text of the modal */
  body?: Maybe<Scalars["String"]>;
  /** The call to action button text of the modal */
  callToAction?: Maybe<Scalars["String"]>;
  /** The header text of the modal */
  header?: Maybe<Scalars["String"]>;
  headerVariant?: Maybe<Scalars["JSON"]>;
  /** @deprecated Use programV2 */
  program?: Maybe<Program>;
  /** The program V2 to render for the modal */
  programV2?: Maybe<ProgramV2>;
  /** The subheader text of the modal */
  subheader?: Maybe<Scalars["String"]>;
};

export type GetPaginatedInput = {
  /** The pointer reference to where in the list the pagination should offset from. */
  after?: InputMaybe<Scalars["String"]>;
  /** Enumerator describing what content to fetch. Can be CLASSES or PROGRAMS */
  contentType?: InputMaybe<ContentType>;
  /** The number of items to offset based from the provided 'after' cursor or the start of the paginated list. */
  first?: InputMaybe<Scalars["Int"]>;
};

/** Type of the content */
export enum ContentType {
  Challenge = "challenge",
  ClassVideo = "class_video",
  Classes = "CLASSES",
  Programs = "PROGRAMS",
  UserComment = "user_comment",
  UserVideo = "user_video"
}

export type SavedOrHistoryDataConnection = {
  __typename?: "SavedOrHistoryDataConnection";
  /** The list of Steezy saved or history data edges. */
  edges: Array<SavedOrHistoryEdge>;
  /** Pagination metadata. */
  pageInfo: PageInfo;
};

export type SavedOrHistoryEdge = {
  __typename?: "SavedOrHistoryEdge";
  /** The pointer reference to where the edge is in respect to the list. */
  cursor: Scalars["String"];
  /** The saved or history data node. A union type that can be either a Class or Program type. */
  node: ClassOrProgram;
};

export type ClassOrProgram = Class | Program;

export type SavedOrHistoryDataConnectionV2 = {
  __typename?: "SavedOrHistoryDataConnectionV2";
  /** The list of Steezy saved or history data edges. */
  edges: Array<ClassProgramV2Edge>;
  /** Pagination metadata. */
  pageInfo: PageInfo;
};

export type ClassProgramV2Edge = {
  __typename?: "ClassProgramV2Edge";
  /** The pointer reference to where the edge is in respect to the list. */
  cursor: Scalars["String"];
  /** The saved or history data node. A union type that can be either a Class or ProgramV2 type. */
  node: ClassOrProgramV2;
};

export type ClassOrProgramV2 = Class | ProgramV2;

export type HistoryV3Input = {
  /** Defines the desired pagination state for the results. */
  pagination?: InputMaybe<GetPaginatedInput>;
  /** Controls the way results are sorted. Default value for 'orderBy' is 'publishDate'. Default value for 'orderDirection' is 'desc'. */
  sort?: InputMaybe<SortBodyV2>;
};

export type SortBodyV2 = {
  /** Either 'all', 'incomplete', or 'completed'. Filters based on progress. */
  filterBy?: InputMaybe<ProgressFilter>;
  /** The field used when ordering classes. */
  orderBy?: InputMaybe<SortBy>;
  /** Either 'asc' or 'desc'. The direction by which to sort the results when filtered on the 'orderBy' field. */
  orderDirection?: InputMaybe<SortOrder>;
};

export enum ProgressFilter {
  All = "all",
  Completed = "completed",
  Incomplete = "incomplete"
}

export enum SortBy {
  DateLastViewed = "dateLastViewed",
  DateSaved = "dateSaved"
}

export type GetInProgressProgramsInput = {
  /** The pointer reference to where in the list the pagination should offset from. */
  after?: InputMaybe<Scalars["String"]>;
  /** The number of items to offset based from the provided 'after' cursor or the start of the paginated list. */
  first?: InputMaybe<Scalars["Int"]>;
  /** The slug of the default program if no in progress programs exist */
  slug: Scalars["ID"];
};

export type InProgressProgramData = {
  __typename?: "InProgressProgramData";
  /** Pagination connection */
  connection?: Maybe<InProgressProgramsConnection>;
  /** Signifies if user has programs in progress */
  hasProgress?: Maybe<Scalars["Boolean"]>;
};

export type InProgressProgramsConnection = {
  __typename?: "InProgressProgramsConnection";
  /** The list of Steezy in progress program data edges. */
  edges: Array<ProgramV2Edge>;
  /** Pagination metadata. */
  pageInfo: PageInfo;
};

export type ProgramV2Edge = {
  __typename?: "ProgramV2Edge";
  /** The pointer reference to where the edge is in respect to the list. */
  cursor: Scalars["String"];
  /** The in progress program data node. */
  node: ProgramV2;
};

export type GetInstructorInput = {
  /** A slug identifier for an instructor. */
  slug: Scalars["ID"];
};

export type OnboardingData = {
  __typename?: "OnboardingData";
  /** A list of class duration options. */
  durationOptions: Array<DurationOption>;
  /** A list of dance level options. */
  levelOptions: Array<LevelOption>;
  /** A list of reason option dance preferences. */
  reasonOptions: Array<ReasonOption>;
};

export type GetProgramsInput = {
  /** If set to true, all returned programs must be free, and all their associated class data will only be classes accessible to free users. */
  freeOnly?: InputMaybe<Scalars["Boolean"]>;
  /** Defines the desired pagination state for the results. */
  pagination: PaginationBody;
  /** Controls the way results are sorted. Default value for 'orderBy' is 'publish_date'. Default value for 'orderDirection' is 'desc'. */
  sort?: InputMaybe<SortBody>;
};

export type GetProgramsConnection = {
  __typename?: "GetProgramsConnection";
  /** Pagination metadata. */
  pageInfo: PaginationInfo;
  /** The list of matched programs. */
  programs: Array<Program>;
};

export type GetProgramsHistoryInput = {
  /** The pointer reference to where in the list the pagination should offset from. */
  after?: InputMaybe<Scalars["String"]>;
  /** The number of items to offset based from the provided 'after' cursor or the start of the paginated list. */
  first?: InputMaybe<Scalars["Int"]>;
};

export type ProgramsHistoryData = {
  __typename?: "ProgramsHistoryData";
  /** Pagination connection */
  connection?: Maybe<ProgramsHistoryConnection>;
};

export type ProgramsHistoryConnection = {
  __typename?: "ProgramsHistoryConnection";
  /** The list of Steezy in progress program data edges. */
  edges: Array<ProgramV2Edge>;
  /** Pagination metadata. */
  pageInfo: PageInfo;
};

export type GetProgramV2WithRefInput = {
  /** The program class reference ID */
  classRefId: Scalars["String"];
};

export type GetRecommendedClassesInput = {
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Int"]>;
};

export type RecommendedClassesConnection = {
  __typename?: "RecommendedClassesConnection";
  edges: Array<RecommendedClassesEdge>;
  pageInfo?: Maybe<PageInfo>;
};

export type RecommendedClassesEdge = {
  __typename?: "RecommendedClassesEdge";
  cursor: Scalars["String"];
  node: RecommendedClass;
};

export type RecommendedClass = {
  __typename?: "RecommendedClass";
  duration?: Maybe<Scalars["String"]>;
  duration_in_seconds?: Maybe<Scalars["Int"]>;
  id?: Maybe<Scalars["String"]>;
  instructorName?: Maybe<Scalars["String"]>;
  recommendationIndex?: Maybe<Scalars["Int"]>;
  slug?: Maybe<Scalars["String"]>;
  title?: Maybe<Scalars["String"]>;
};

export type GetStreakProgressInput = {
  endDate?: InputMaybe<Scalars["String"]>;
  startDate?: InputMaybe<Scalars["String"]>;
};

export type UserMeInput = {
  refreshEstimate?: InputMaybe<Scalars["Boolean"]>;
};

export type Schedule = {
  __typename?: "Schedule";
  date?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  playlists?: Maybe<Array<Maybe<Playlist>>>;
  progress?: Maybe<ScheduleProgress>;
};

export type ScheduleProgress = {
  __typename?: "ScheduleProgress";
  completed?: Maybe<Scalars["String"]>;
  seen_completed_modal?: Maybe<Scalars["String"]>;
  seen_started_modal?: Maybe<Scalars["String"]>;
  started?: Maybe<Scalars["String"]>;
};

export type AlgoliaSearchInput = {
  /** Filter the query with numeric, facet and/or tag filters. */
  filters?: InputMaybe<Scalars["String"]>;
  /** Set the number of hits per page. */
  hitsPerPage?: InputMaybe<Scalars["Int"]>;
  /** The name of the index to query against. */
  index: Scalars["String"];
  /** Specify the page to retrieve. */
  page?: InputMaybe<Scalars["Int"]>;
  /** The query used to search. Accepts every character, and every character entered will be used in the search. An empty query can be used to fetch all records. */
  query: Scalars["String"];
};

export type AlgoliaClassesConnection = {
  __typename?: "AlgoliaClassesConnection";
  /** The list of Steezy class edges. */
  edges: Array<ClassEdge>;
  /** Pagination metadata. */
  pageInfo: AlgoliaPageInfo;
};

export type ClassEdge = {
  __typename?: "ClassEdge";
  /** The class data node. */
  node: Class;
};

export type AlgoliaPageInfo = {
  __typename?: "AlgoliaPageInfo";
  /** Boolean value describing whether the page input parameter can be incremented to fetch further results. (page < nbPages - 1) */
  hasNextPage: Scalars["Boolean"];
  /** Boolean value describing whether there are previous pages. (page !== 0) */
  hasPreviousPage: Scalars["Boolean"];
  /** The total number of hits matching the search state. */
  nbHits: Scalars["Int"];
  /** The total number of pages in the search response. */
  nbPages: Scalars["Int"];
  /** The current, zero-indexed page of responses. */
  page: Scalars["Int"];
};

export type AlgoliaInstructorsConnection = {
  __typename?: "AlgoliaInstructorsConnection";
  /** The list of Steezy instructor edges. */
  edges: Array<InstructorEdge>;
  /** Pagination metadata. */
  pageInfo: AlgoliaPageInfo;
};

export type AlgoliaProgramsConnection = {
  __typename?: "AlgoliaProgramsConnection";
  /** The list of Steezy program edges. */
  edges: Array<ProgramEdge>;
  /** Pagination metadata. */
  pageInfo: AlgoliaPageInfo;
};

export type ProgramEdge = {
  __typename?: "ProgramEdge";
  /** The program data node. */
  node: Program;
};

export type SearchProgramsV2Input = {
  /** Filter the query with numeric, facet and/or tag filters. */
  filters?: InputMaybe<Scalars["String"]>;
  /** If set to true, all returned programs must be free, and all their associated class data will only be classes accessible to free users. */
  freeOnly?: InputMaybe<Scalars["Boolean"]>;
  /** If set to true, all returned programs will be programs that the user has started. */
  inProgressOnly?: InputMaybe<Scalars["Boolean"]>;
  /** Defines the desired pagination state for the results. */
  pagination: PaginationBody;
  /** The query used to search. Accepts every character, and every character entered will be used in the search. An empty query can be used to fetch all records. */
  query: Scalars["String"];
  /** Controls the way results are sorted. Default value for 'orderBy' is 'publishDate'. Default value for 'orderDirection' is 'desc'. */
  sort?: InputMaybe<SortBody>;
};

export type SearchProgramsV2Connection = {
  __typename?: "SearchProgramsV2Connection";
  /** Pagination metadata. */
  pageInfo: PaginationInfo;
  /** The list of matched programs */
  programs: Array<ProgramV2>;
};

export type UserSearchFilterInput = {
  text?: InputMaybe<Scalars["String"]>;
};

export type UserConnection = {
  __typename?: "UserConnection";
  edges: Array<UserEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Float"];
};

export type UserEdge = {
  __typename?: "UserEdge";
  /** Used in `before` and `after` args */
  cursor: Scalars["String"];
  node: User;
};

export type AutocompleteValue = {
  __typename?: "AutocompleteValue";
  id: Scalars["ID"];
  name: Scalars["String"];
};

export type TrackFilterInput = {
  artist?: InputMaybe<Scalars["String"]>;
  classId?: InputMaybe<Scalars["String"]>;
  classNum?: InputMaybe<Scalars["String"]>;
  genre?: InputMaybe<Scalars["String"]>;
  isExplicit?: InputMaybe<Scalars["Boolean"]>;
  isLicensed?: InputMaybe<Scalars["Boolean"]>;
  isrc?: InputMaybe<Scalars["String"]>;
  label?: InputMaybe<Scalars["String"]>;
  songId?: InputMaybe<Scalars["String"]>;
  source?: InputMaybe<Scalars["String"]>;
  title?: InputMaybe<Scalars["String"]>;
  trackId?: InputMaybe<Scalars["String"]>;
};

export type TrackConnection = {
  __typename?: "TrackConnection";
  edges: Array<TrackEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Float"];
};

export type TrackEdge = {
  __typename?: "TrackEdge";
  /** Used in `before` and `after` args */
  cursor: Scalars["String"];
  node: Track;
};

export type UserGenerateUsernameInput = {
  name: Scalars["String"];
};

export type UserUsername = {
  __typename?: "UserUsername";
  exists?: Maybe<Scalars["Boolean"]>;
  username?: Maybe<Scalars["String"]>;
};

export enum UserPreferenceType {
  AccountType = "account_type",
  Age = "age",
  DanceEnergy = "dance_energy",
  DanceGoalsCommunity = "dance_goals_community",
  DanceGoalsLearnAndPractice = "dance_goals_learn_and_practice",
  DanceGoalsPersonal = "dance_goals_personal",
  DanceGoalsProfessional = "dance_goals_professional",
  DanceHabit = "dance_habit",
  DanceLocation = "dance_location",
  DaysOfWeek = "days_of_week",
  FamilyGoal = "family_goal",
  HdyhauSurveyResponse = "hdyhau_survey_response",
  Level = "level",
  LevelV2 = "levelV2",
  NumOfDays = "num_of_days",
  Reason = "reason"
}

export type UserPreferenceOption = {
  __typename?: "UserPreferenceOption";
  description: Scalars["String"];
  displayIndex: Scalars["Int"];
  label: Scalars["String"];
  previewUrl: Scalars["String"];
  slug: Scalars["String"];
};

export type UserProfileInput = {
  username?: InputMaybe<Scalars["String"]>;
  videoPagination?: InputMaybe<ConnectionArgs>;
};

export type UserProfileWithVideos = {
  __typename?: "UserProfileWithVideos";
  /** List of badges earned by the user */
  badges?: Maybe<Array<UserBadge>>;
  /** User's self-written biography or description */
  bio?: Maybe<Scalars["String"]>;
  /** User's birth date */
  birthDate?: Maybe<Scalars["DateTime"]>;
  /** Unique identifier for the user profile */
  id: Scalars["ID"];
  /** Slug of the user's instructor profile */
  instructorSlug?: Maybe<Scalars["String"]>;
  isMe: Scalars["Boolean"];
  /** List of social media or other relevant links */
  links?: Maybe<Array<UserProfileLink>>;
  /** User's name */
  name?: Maybe<Scalars["String"]>;
  /** URL to the user's profile photo */
  photoURL?: Maybe<Scalars["String"]>;
  totalLikesCount: Scalars["Float"];
  /** Firebase user ID associated with this profile */
  uid?: Maybe<Scalars["String"]>;
  /** User's chosen display name */
  username?: Maybe<Scalars["String"]>;
  videoUploads: VideoUploadConnection;
};

export type UserFilterInput = {
  hasCommunityAccess?: InputMaybe<Scalars["Boolean"]>;
  role?: InputMaybe<Scalars["String"]>;
};

export type UserValidatePinInput = {
  pin: Scalars["String"];
};

export type VideoUploadByIdInput = {
  id: Scalars["String"];
};

export type VideoUploadsFilterInput = {
  approvalStatus?: InputMaybe<VideoApprovalStatus>;
  challengeId?: InputMaybe<Scalars["String"]>;
  encodingStatus?: InputMaybe<VideoEncodingStatus>;
  id?: InputMaybe<Scalars["String"]>;
  isUserDeleted?: InputMaybe<Scalars["Boolean"]>;
  isUserSubmitted?: InputMaybe<Scalars["Boolean"]>;
  updatedAfter?: InputMaybe<Scalars["DateTime"]>;
  updatedBefore?: InputMaybe<Scalars["DateTime"]>;
  userId?: InputMaybe<Scalars["String"]>;
};

export type VideoUploadsPublishedFilterInput = {
  challengeId?: InputMaybe<Scalars["String"]>;
  classNum?: InputMaybe<Scalars["String"]>;
};

export type Mutation = {
  __typename?: "Mutation";
  /** Create a comment. */
  activityCommentCreate: ActivityComment;
  /** Delete a comment. */
  activityCommentDelete: Scalars["Boolean"];
  /** Update a comment body. */
  activityCommentUpdate: ActivityComment;
  /** Create a reaction. */
  activityReactionCreate: ActivityReaction;
  /** Delete a reaction. */
  activityReactionDelete: Scalars["Boolean"];
  /** @deprecated Use addClassesForSchedulePlaylistV2 */
  addClassesForSchedulePlaylist?: Maybe<Playlist>;
  addClassesForSchedulePlaylistV2?: Maybe<Playlist>;
  /** Add a required studio class to an achievement. Requires the admin role to use. */
  adminAchievementAddStudioClass: AdminAchievement;
  /** Create an achievement. Requires the admin role to use. */
  adminAchievementCreate: AdminAchievement;
  /** Delete an achievement and its associated badges. Requires the admin role to use. */
  adminAchievementDelete: Scalars["Boolean"];
  /** Remove challenge from an achievement. Requires the admin role to use. */
  adminAchievementRemoveChallenge: AdminAchievement;
  /** Remove a required studio class from an achievement. Requires the admin role to use. */
  adminAchievementRemoveStudioClass: AdminAchievement;
  /** Update an achievement. Requires the admin role to use. */
  adminAchievementUpdate: AdminAchievement;
  /** Upload badge image file. Requires the admin role to use. */
  adminBadgeAssetUploadCreate: CreateAssetUploadResponse;
  /** Create a badge. Requires the admin role to use. */
  adminBadgeCreate: Badge;
  /** Delete a badge. Requires the admin role to use. */
  adminBadgeDelete: Scalars["Boolean"];
  /** Update a badge. Requires the admin role to use. */
  adminBadgeUpdate: Badge;
  /** Upload category image file. Requires the admin role to use. */
  adminCategoryAssetUploadCreate: CreateAssetUploadResponse;
  /** Create a category. Requires the admin role to use. */
  adminCategoryCreate: ClassCategory;
  /** Update a category. Requires the admin role to use. */
  adminCategoryUpdate: ClassCategory;
  /** Complete a category video file upload. Requires the admin role to use. */
  adminCategoryVideoFileUploadComplete: AdminCategoryVideo;
  /** Initiate a category video file upload. Requires the admin role to use. */
  adminCategoryVideoFileUploadCreate: VideoUploadCreateResponse;
  /** Assign a plan to a country Requires the admin role to use. */
  adminCountryAssignPlan: Country;
  /** Create a new country Requires the admin role to use. */
  adminCountryCreate: Country;
  /** Delete a country Requires the admin role to use. */
  adminCountryDelete: Scalars["Boolean"];
  /** Update an existing country Requires the admin role to use. */
  adminCountryUpdate: Country;
  /** Upload instructor image file. Requires the admin role to use. */
  adminInstructorAssetUploadCreate: CreateAssetUploadResponse;
  /** Create an instructor. Requires the admin role to use. */
  adminInstructorCreate: ClassInstructor;
  /** Update an instructor. Requires the admin role to use. */
  adminInstructorUpdate: ClassInstructor;
  /** Assign a country to a plan Requires the admin role to use. */
  adminPlanAssignCountry: Plan;
  /** Remove a country from a plan Requires the admin role to use. */
  adminPlanRemoveCountry: Plan;
  /** Update plan display and access settings Requires the admin role to use. */
  adminPlanUpdateSettings: Plan;
  /** Add studio class to playlist. Requires the admin role to use. */
  adminPlaylistAddClass: Scalars["Boolean"];
  /** Upload playlist image file. Requires the admin role to use. */
  adminPlaylistAssetUploadCreate: CreateAssetUploadResponse;
  /** Create a playlist. Requires the admin role to use. */
  adminPlaylistCreate: PlaylistV2;
  /** Remove studio class from playlist. Requires the admin role to use. */
  adminPlaylistRemoveClass: Scalars["Boolean"];
  /** Update a playlist. Requires the admin role to use. */
  adminPlaylistUpdate: PlaylistV2;
  /** Add a track to a class. Requires the admin role to use. */
  adminStudioClassAddTrack: AdminStudioClass;
  /** Upload class image file. Requires the admin role to use. */
  adminStudioClassAssetUploadCreate: CreateAssetUploadResponse;
  /** Create a class. Slug for class is auto-generated. Requires the admin role to use. */
  adminStudioClassCreate: AdminStudioClass;
  /** Publish a studio class Requires the admin role to use. */
  adminStudioClassPublish: AdminStudioClass;
  /** Remove a track from a class. Requires the admin role to use. */
  adminStudioClassRemoveTrack: AdminStudioClass;
  /** Un-publish a studio class. Requires the admin role to use. */
  adminStudioClassUnPublish: AdminStudioClass;
  /** Update a class. Requires the admin role to use. */
  adminStudioClassUpdate?: Maybe<AdminStudioClass>;
  /** Create content tag. Requires the admin role to use. */
  adminTagCreate: Tag;
  /** Update content tag. Requires the admin role to use. */
  adminTagUpdate: Tag;
  /** Deletes user's PII. Requires the admin role to use. */
  adminUserAuthDelete: Scalars["Boolean"];
  /** Returns a Firebase Custom Token for user Requires the admin role to use. */
  adminUserAutoLoginToken: Scalars["String"];
  /** Create a randomized personalized playlist Requires the admin role to use. */
  adminUserRandomizePersonalizedPlaylist: Scalars["String"];
  /** Update a user's login credentials. Requires the admin role to use. */
  adminUserUpdateLogin: Scalars["String"];
  approvePartyMember: SuccessPayload;
  /** Calculate progress for all active challenges and return newly earned badges Requires the user role to use. */
  calculateChallengesProgress: ChallengeProgressResult;
  /** Upload challenge thumbnail image. Requires the admin role to use. */
  challengeAssetUploadCreate: CreateAssetUploadResponse;
  /** Create a challenge. Requires the admin role to use. */
  challengeCreate: Challenge;
  /** Delete a challenge. Requires the admin role to use. */
  challengeDelete: Challenge;
  /** Update a challenge. Requires the admin role to use. */
  challengeUpdate: Challenge;
  /** Creates a comment for a class given a studioClassId Requires the user role to use. */
  classCommentCreate: ActivityComment;
  /** Unlock the class for the requesting user. Requires the user role to use. */
  classUnlock: Class;
  /** Complete class video file upload. Requires the admin role to use. */
  classVideoFileUploadComplete: ClassVideo;
  /** Initiate class video file upload. Requires the admin role to use. */
  classVideoFileUploadCreate: VideoUploadCreateResponse;
  /** @deprecated Use completeClassV2 */
  completeClass: SuccessPayload;
  completeClassV2: Class;
  /** Create or update a cancel survey for a subscription Requires the user role to use. */
  createCancelSurvey: CancelSurvey;
  createParty: CreatePartyOutput;
  /** @deprecated Use createRecommendedSchedulePlaylistV2 */
  createRecommendedSchedulePlaylist?: Maybe<Playlist>;
  createRecommendedSchedulePlaylistV2?: Maybe<Playlist>;
  /** @deprecated Use createSchedulePlaylistV2 */
  createSchedulePlaylist?: Maybe<Playlist>;
  createSchedulePlaylistV2?: Maybe<Playlist>;
  /** Create a user. Requires the user role to use. */
  createUser: User;
  endParty: SuccessPayload;
  /** Create a flagged activity (report on content). Requires the user role to use. */
  flaggedActivityCreate: FlaggedActivity;
  /** Review a flagged activity. Requires the admin role to use. */
  flaggedActivityReview: FlaggedActivity;
  /** Follows a list of categories for given slugs. Applies to the currently authenticated user. */
  followCategories: Array<FollowCategoryOutput>;
  /** Follows a category for a given slug. Applies to the currently authenticated user. */
  followCategory: FollowCategoryOutput;
  /** Follows a class given an ID for the currently authenticated user. */
  followClass: FollowClassOutput;
  /** Follows an instructor given a slug for the currently authenticated user. */
  followInstructor: FollowInstructorOutput;
  /** Collect payment on invoice. Requires the user role to use. */
  invoiceCollectPayment: Invoice;
  joinParty: JoinPartyOutput;
  leaveParty: LeavePartyOutput;
  leavePartyQueue: SuccessPayload;
  /** Add studio class to playlist. Requires the user role to use. */
  playlistAddStudioClass: PlaylistHasStudioClass;
  /** Create user playlist. Requires the user role to use. */
  playlistCreate: PlaylistV2;
  /** Delete playlist. Requires the user role to use. */
  playlistDelete: Scalars["Boolean"];
  /** Remove studio class from playlist. Requires the user role to use. */
  playlistRemoveStudioClass: PlaylistHasStudioClass;
  /** Follow a playlist. Requires the user role to use. */
  playlistSave: Scalars["Boolean"];
  /** Unfollow a playlist. Requires the user role to use. */
  playlistUnsave: Scalars["Boolean"];
  /** Update playlist details. Requires the user role to use. */
  playlistUpdateDetails: PlaylistV2;
  /** Create a play session. */
  playSessionCreate: Scalars["String"];
  /** Refresh a play session. */
  playSessionRefresh: Scalars["Boolean"];
  queuePartyMember: QueuePartyMemberOutput;
  /** Saves a user's rating for a class as a numeric value between 1 and 5. */
  rateClass: RateClassOutput;
  /** @deprecated Use removeClassesForSchedulePlaylistV2 */
  removeClassesForSchedulePlaylist?: Maybe<Playlist>;
  removeClassesForSchedulePlaylistV2?: Maybe<Playlist>;
  /** @deprecated Use removeTakenClassV2 */
  removeTakenClass: SuccessPayload;
  /** Removes a class from a user's list of taken classes for a specified date */
  removeTakenClassV2: SuccessPayload;
  /** Refresh session for requesting user. Requires the user role to use. */
  sessionRefresh?: Maybe<Scalars["String"]>;
  /** Given a family goal slug, set the family goal preference for a user. */
  setAccountTypePreference: AccountTypeOption;
  /**
   * Given a class duration slug, set the dance reason preference for a user.
   * @deprecated Duration options no longer relevant
   */
  setClassDurationPreference: DurationOption;
  /** Set dance cadence for user. Requires the user role to use. */
  setDanceCadencePreference: Scalars["Boolean"];
  /** Set dance energy for user. Requires the user role to use. */
  setDanceEnergyPreference: Scalars["Boolean"];
  /**
   * Set dance frequency for user. Requires the user role to use.
   * @deprecated Renaming. Use setDanceHabitPreference instead.
   */
  setDanceFrequencyPreference: Scalars["Boolean"];
  /** Set dance goals for user. Requires the user role to use. */
  setDanceGoalsPreference: Scalars["Boolean"];
  /** Set dance habit for user. Requires the user role to use. */
  setDanceHabitPreference: Scalars["Boolean"];
  /** Given a dance level slug, set the dance level preference for a user. */
  setDanceLevelPreference: LevelOption;
  /** Set dance level for user. Requires the user role to use. */
  setDanceLevelPreferenceV2: Scalars["Boolean"];
  /** Set dance locations for user. Requires the user role to use. */
  setDanceLocationsPreference: Scalars["Boolean"];
  /** Given a account type slug, set the account type preference for a user. */
  setDanceReasonPreference: ReasonOption;
  setExperiment: SetExperimentOutput;
  /** Given a dance reason slug, set the dance level preference for a user. */
  setFamilyGoalPreference: FamilyGoalOption;
  /** Set HDYHAU survey response slugs for user. Requires the user role to use. */
  setHDYHAUSurveyResponse: Scalars["Boolean"];
  /**
   * Sets a date seen for a featured content modal
   * @deprecated Use userAcknowledgeContent on Jarvis
   */
  setSeenModalDate: SuccessPayload;
  /** Set user age. Requires the user role to use. */
  setUserAgeResponse: Scalars["Boolean"];
  setUsersTimezone: SuccessPayload;
  /** @deprecated Use startClassV2 */
  startClass: SuccessPayload;
  startClassV2: Class;
  /** Allows user to submit feedback when canceling their subscription */
  submitCancelationFeedback: SuccessPayload;
  /** Cancel a subscription for the requesting user. Requires the user role to use. */
  subscriptionCancel: Subscription;
  /** Create a subscription for the requesting user. Requires the user role to use. */
  subscriptionCreate: Subscription;
  /** Create a subscription for existing customer. Requires the user role to use. */
  subscriptionCreateForCustomer: Subscription;
  /** Create a subscription for the requesting user. Requires the user role to use. */
  subscriptionCreateV2: UserSubscription;
  /** Extend a trial for a subscription. Requires the user role to use. */
  subscriptionExtendTrial: Subscription;
  /** Pause a subscription for the requesting user. Requires the user role to use. */
  subscriptionPause: Subscription;
  /** Reactivate a subscription for the requesting user. Requires the user role to use. */
  subscriptionReactivate: Subscription;
  /** Reactivate a canceled subscription by applying coupons. Requires the user role to use. */
  subscriptionReactivateUsingCoupon: Subscription;
  /** Remove scheduled changes for the requesting user's subscription. Requires the user role to use. */
  subscriptionRemoveScheduledChanges: Subscription;
  /** Resume a subscription for the requesting user. Requires the user role to use. */
  subscriptionResume: Subscription;
  /** Switch a requesting users's subscription plan. Requires the user role to use. */
  subscriptionSwitchPlan: Subscription;
  /** Upgrade a subscription from a monthly to a yearly plan for the requesting user. Requires the user role to use. */
  subscriptionUpgrade: Subscription;
  timeoutPartyMember: SuccessPayload;
  /** Toggles a program class as complete or incomplete based on the given input */
  toggleClassComplete: ProgramV2;
  toggleNotifications?: Maybe<ToggleNotificationsOutput>;
  /** Allows users to save or unsave a class based on given input */
  toggleSaveClass: Class;
  /** Allows users to save or unsave a program based on given input */
  toggleSaveProgram: ProgramV2;
  /** Log a play event for a track. Requires the user role to use. */
  trackLogPlay: Scalars["Boolean"];
  /** Create a track. If track ISRC/song ID is from Tuned Global, data is pulled from there. Requires the admin role to use. */
  trackUpsert: Track;
  /**
   * Updates the class progress for a user. This mutation should be invoked every 10 seconds. It should not be invoked when the class video is paused.
   * It should be invoked immediately when the user navigates away from the video or the application.
   * @deprecated Use updateClassProgressV2
   */
  updateClassProgress: SuccessPayload;
  updateClassProgressV2: Class;
  /** @deprecated Use updateClassSessionV2 */
  updateClassSession: SuccessPayload;
  updateClassSessionV2: Class;
  /** @deprecated Use updateSchedulePlaylistV2 */
  updateSchedulePlaylist?: Maybe<Playlist>;
  updateSchedulePlaylistV2?: Maybe<Playlist>;
  /** License or unlicense a track. Requires the admin role to use. */
  updateTrackLicense: Track;
  /** Update the user's profile information. Requires the user role to use. */
  updateUserProfile: UserProfile;
  /** Updates the users last_seen property to the current date in UTC ISO8601. */
  updateUsersLastSeen: SuccessPayload;
  updateWeeklyStreakGoal: WeeklyStreakGoalOutput;
  /** Saves a datetime when a user acknowledges content. Requires the user role to use. */
  userAcknowledgeContent: User;
  /** Updates a user's apple authorization code and refresh token. Requires the user role to use. */
  userAuthUpdate: Scalars["Boolean"];
  /** Allow community access to multiple users (by email). Requires the admin role to use. */
  userBulkEnableCommunity: Scalars["Float"];
  /** Check if a username exists. Requires the user role to use. */
  userCheckUsername: UserUsername;
  /** Unlock a class for the requesting user. Requires the user role to use. */
  userClassUnlock: User;
  /** Create a referral invite for the requesting user. Requires the user role to use. */
  userCreateReferralInvite: User;
  /** Update user's notification preference Requires the user role to use. */
  userNotificationPreferenceUpdate: NotificationPreference;
  /** Remove a photo for the requesting user. Requires the user role to use. */
  userRemovePhoto: User;
  /** Set parental controls for a user. Requires the user role to use. */
  userSetParentalControls: User;
  /** Set a photo for the requesting user. Requires the user role to use. */
  userSetPhoto: User;
  /** Sets user's username */
  userSetUsername: User;
  /** Update a user. Requires the admin role to use. */
  userUpdate: User;
  /** Update the birth date for the requesting user. Requires the user role to use. */
  userUpdateBirthDate: User;
  /** Update the name for the requesting user. Requires the user role to use. */
  userUpdateName: User;
  /** Update the payment source for the requesting user. Requires the user role to use. */
  userUpdatePaymentSource: User;
  /** Update a user's username. Requires the user role to use. */
  userUpdateUsername: UserUsername;
  /** Update a UGC video approval status. Requires the admin role to use. */
  videoUploadAdminUpdate: VideoUpload;
  /** Complete a UGC video file upload. */
  videoUploadComplete: VideoUpload;
  /** Initiate a UGC video file upload. */
  videoUploadCreate: VideoUploadCreateResponse;
  /** Delete a UGC video. Requires the user role to use. */
  videoUploadDelete: VideoUpload;
  /** Submit a UGC video (post it). */
  videoUploadSubmit: VideoUpload;
  /** Update a UGC video description. */
  videoUploadUpdate: VideoUpload;
};

export type MutationActivityCommentCreateArgs = {
  input: ActivityCommentCreateInput;
};

export type MutationActivityCommentDeleteArgs = {
  commentId: Scalars["String"];
};

export type MutationActivityCommentUpdateArgs = {
  input: ActivityCommentUpdateInput;
};

export type MutationActivityReactionCreateArgs = {
  input: ActivityReactionCreateInput;
};

export type MutationActivityReactionDeleteArgs = {
  input: ActivityReactionDeleteInput;
};

export type MutationAddClassesForSchedulePlaylistArgs = {
  input: ModifyPlaylistInput;
};

export type MutationAddClassesForSchedulePlaylistV2Args = {
  input: ModifyPlaylistInputV2;
};

export type MutationAdminAchievementAddStudioClassArgs = {
  input: AchievementStudioClassInput;
};

export type MutationAdminAchievementCreateArgs = {
  input: AchievementCreateInput;
};

export type MutationAdminAchievementDeleteArgs = {
  id: Scalars["String"];
};

export type MutationAdminAchievementRemoveChallengeArgs = {
  achievementId: Scalars["String"];
};

export type MutationAdminAchievementRemoveStudioClassArgs = {
  input: AchievementStudioClassInput;
};

export type MutationAdminAchievementUpdateArgs = {
  input: AchievementUpdateInput;
};

export type MutationAdminBadgeAssetUploadCreateArgs = {
  assetType: BadgeAssetType;
};

export type MutationAdminBadgeCreateArgs = {
  input: BadgeCreateInput;
};

export type MutationAdminBadgeDeleteArgs = {
  id: Scalars["String"];
};

export type MutationAdminBadgeUpdateArgs = {
  input: BadgeUpdateInput;
};

export type MutationAdminCategoryAssetUploadCreateArgs = {
  assetType: CategoryAssetType;
};

export type MutationAdminCategoryCreateArgs = {
  input: CategoryCreateInput;
};

export type MutationAdminCategoryUpdateArgs = {
  input: CategoryUpdateInput;
};

export type MutationAdminCategoryVideoFileUploadCompleteArgs = {
  input: VideoUploadCompleteInput;
};

export type MutationAdminCategoryVideoFileUploadCreateArgs = {
  input: CategoryVideoFileCreateInput;
};

export type MutationAdminCountryAssignPlanArgs = {
  input: AssignPlanToCountryInput;
};

export type MutationAdminCountryCreateArgs = {
  input: CreateCountryInput;
};

export type MutationAdminCountryDeleteArgs = {
  id: Scalars["String"];
};

export type MutationAdminCountryUpdateArgs = {
  id: Scalars["String"];
  input: UpdateCountryInput;
};

export type MutationAdminInstructorAssetUploadCreateArgs = {
  assetType: InstructorAssetType;
};

export type MutationAdminInstructorCreateArgs = {
  input: InstructorCreateInput;
};

export type MutationAdminInstructorUpdateArgs = {
  input: InstructorUpdateInput;
};

export type MutationAdminPlanAssignCountryArgs = {
  input: AssignPlanToCountryInput;
};

export type MutationAdminPlanRemoveCountryArgs = {
  input: RemovePlanFromCountryInput;
};

export type MutationAdminPlanUpdateSettingsArgs = {
  id: Scalars["String"];
  input: UpdatePlanSettingsInput;
};

export type MutationAdminPlaylistAddClassArgs = {
  input: PlaylistAddOrRemoveStudioClassInput;
};

export type MutationAdminPlaylistAssetUploadCreateArgs = {
  assetType: PlaylistAssetType;
};

export type MutationAdminPlaylistCreateArgs = {
  name: Scalars["String"];
};

export type MutationAdminPlaylistRemoveClassArgs = {
  input: PlaylistAddOrRemoveStudioClassInput;
};

export type MutationAdminPlaylistUpdateArgs = {
  input: PlaylistUpdateInput;
};

export type MutationAdminStudioClassAddTrackArgs = {
  input: ClassTrackInput;
};

export type MutationAdminStudioClassAssetUploadCreateArgs = {
  assetType: StudioClassAssetType;
};

export type MutationAdminStudioClassCreateArgs = {
  input: StudioClassCreateInput;
};

export type MutationAdminStudioClassPublishArgs = {
  studioClassId: Scalars["String"];
};

export type MutationAdminStudioClassRemoveTrackArgs = {
  input: ClassTrackInput;
};

export type MutationAdminStudioClassUnPublishArgs = {
  studioClassId: Scalars["String"];
};

export type MutationAdminStudioClassUpdateArgs = {
  input: StudioClassUpdateInput;
};

export type MutationAdminTagCreateArgs = {
  input: TagCreateInput;
};

export type MutationAdminTagUpdateArgs = {
  input: TagUpdateInput;
};

export type MutationAdminUserAuthDeleteArgs = {
  input: UserAuthDeleteInput;
};

export type MutationAdminUserAutoLoginTokenArgs = {
  uid: Scalars["String"];
};

export type MutationAdminUserRandomizePersonalizedPlaylistArgs = {
  input: UserRandomizePersonalizedPlaylistInput;
};

export type MutationAdminUserUpdateLoginArgs = {
  input: AdminUserUpdateLogin;
};

export type MutationApprovePartyMemberArgs = {
  input: ApprovePartyMemberInput;
};

export type MutationCalculateChallengesProgressArgs = {
  triggerType: AchievementTriggerType;
};

export type MutationChallengeCreateArgs = {
  input: ChallengeCreateInput;
};

export type MutationChallengeDeleteArgs = {
  challengeId: Scalars["String"];
};

export type MutationChallengeUpdateArgs = {
  input: ChallengeUpdateInput;
};

export type MutationClassCommentCreateArgs = {
  input: ActivityClassCommentCreateInput;
};

export type MutationClassUnlockArgs = {
  input: ClassUnlockInput;
};

export type MutationClassVideoFileUploadCompleteArgs = {
  input: VideoUploadCompleteInput;
};

export type MutationClassVideoFileUploadCreateArgs = {
  input: ClassVideoFileCreateInput;
};

export type MutationCompleteClassArgs = {
  input: ClassCompleteInput;
};

export type MutationCompleteClassV2Args = {
  input: ClassCompleteInput;
};

export type MutationCreateCancelSurveyArgs = {
  input: CancelSurveyInput;
};

export type MutationCreatePartyArgs = {
  input: CreatePartyInput;
};

export type MutationCreateRecommendedSchedulePlaylistArgs = {
  input: CreateRecommendedSchedulePlaylistInput;
};

export type MutationCreateRecommendedSchedulePlaylistV2Args = {
  input: CreateRecommendedSchedulePlaylistInput;
};

export type MutationCreateSchedulePlaylistArgs = {
  input: CreateSchedulePlaylistInput;
};

export type MutationCreateSchedulePlaylistV2Args = {
  input: CreateSchedulePlaylistInputV2;
};

export type MutationCreateUserArgs = {
  input: UserCreateInput;
};

export type MutationEndPartyArgs = {
  input: PartyInput;
};

export type MutationFlaggedActivityCreateArgs = {
  input: FlaggedActivityCreateInput;
};

export type MutationFlaggedActivityReviewArgs = {
  input: FlaggedActivityReviewInput;
};

export type MutationFollowCategoriesArgs = {
  input: FollowCategoriesInput;
};

export type MutationFollowCategoryArgs = {
  input: FollowCategoryInput;
};

export type MutationFollowClassArgs = {
  input: FollowClassInput;
};

export type MutationFollowInstructorArgs = {
  input: FollowInstructorInput;
};

export type MutationInvoiceCollectPaymentArgs = {
  input: CollectPaymentInput;
};

export type MutationJoinPartyArgs = {
  input: PartyInput;
};

export type MutationLeavePartyArgs = {
  input: PartyInput;
};

export type MutationLeavePartyQueueArgs = {
  input: PartyInput;
};

export type MutationPlaylistAddStudioClassArgs = {
  input: PlaylistAddOrRemoveStudioClassInput;
};

export type MutationPlaylistCreateArgs = {
  input: PlaylistCreateInput;
};

export type MutationPlaylistDeleteArgs = {
  input: PlaylistDeleteInput;
};

export type MutationPlaylistRemoveStudioClassArgs = {
  input: PlaylistAddOrRemoveStudioClassInput;
};

export type MutationPlaylistSaveArgs = {
  input: PlaylistSaveOrUnsaveInput;
};

export type MutationPlaylistUnsaveArgs = {
  input: PlaylistSaveOrUnsaveInput;
};

export type MutationPlaylistUpdateDetailsArgs = {
  input: PlaylistUpdateDetailsInput;
};

export type MutationPlaySessionRefreshArgs = {
  playSessionId: Scalars["String"];
};

export type MutationQueuePartyMemberArgs = {
  input: PartyInput;
};

export type MutationRateClassArgs = {
  input: RateClassInput;
};

export type MutationRemoveClassesForSchedulePlaylistArgs = {
  input: ModifyPlaylistInput;
};

export type MutationRemoveClassesForSchedulePlaylistV2Args = {
  input: ModifyPlaylistInputV2;
};

export type MutationRemoveTakenClassArgs = {
  input: RemoveTakenClassInput;
};

export type MutationRemoveTakenClassV2Args = {
  input: RemoveTakenClassInputV2;
};

export type MutationSessionRefreshArgs = {
  input?: InputMaybe<UserSessionInput>;
};

export type MutationSetAccountTypePreferenceArgs = {
  input: SetAccountTypePreferenceInput;
};

export type MutationSetClassDurationPreferenceArgs = {
  input: SetClassDurationPreferenceInput;
};

export type MutationSetDanceCadencePreferenceArgs = {
  input: SetDanceCadenceInput;
};

export type MutationSetDanceEnergyPreferenceArgs = {
  input: SetDanceEnergyInput;
};

export type MutationSetDanceFrequencyPreferenceArgs = {
  input: SetDanceFrequencyInput;
};

export type MutationSetDanceGoalsPreferenceArgs = {
  input: SetDanceGoalsInput;
};

export type MutationSetDanceHabitPreferenceArgs = {
  input: SetDanceHabitInput;
};

export type MutationSetDanceLevelPreferenceArgs = {
  input: SetDanceLevelPreferenceInput;
};

export type MutationSetDanceLevelPreferenceV2Args = {
  input: SetDanceLevelInput;
};

export type MutationSetDanceLocationsPreferenceArgs = {
  input: SetDanceLocationsInput;
};

export type MutationSetDanceReasonPreferenceArgs = {
  input: SetDanceReasonPreferenceInput;
};

export type MutationSetExperimentArgs = {
  input: SetExperimentInput;
};

export type MutationSetFamilyGoalPreferenceArgs = {
  input: SetFamilyGoalPreferenceInput;
};

export type MutationSetHdyhauSurveyResponseArgs = {
  input: SetHdyhauSurveyResponseInput;
};

export type MutationSetSeenModalDateArgs = {
  input: FeaturedModalSlugInput;
};

export type MutationSetUserAgeResponseArgs = {
  input: SetUserAgeInput;
};

export type MutationSetUsersTimezoneArgs = {
  input: SetUsersTimezoneInput;
};

export type MutationStartClassArgs = {
  input: ClassStartInput;
};

export type MutationStartClassV2Args = {
  input: ClassStartInput;
};

export type MutationSubmitCancelationFeedbackArgs = {
  input: SubmitCancelationFeedbackInput;
};

export type MutationSubscriptionCancelArgs = {
  input: SubscriptionCancelInput;
};

export type MutationSubscriptionCreateArgs = {
  input: SubscriptionCreateInput;
};

export type MutationSubscriptionCreateForCustomerArgs = {
  input: SubscriptionCreateForCustomerInput;
};

export type MutationSubscriptionCreateV2Args = {
  input: SubscriptionCreateInput;
};

export type MutationSubscriptionExtendTrialArgs = {
  input: SubscriptionExtendTrialInput;
};

export type MutationSubscriptionPauseArgs = {
  input: SubscriptionPauseInput;
};

export type MutationSubscriptionReactivateArgs = {
  input: SubscriptionReactivateInput;
};

export type MutationSubscriptionReactivateUsingCouponArgs = {
  input: SubscriptionReactivateUsingCouponInput;
};

export type MutationSubscriptionRemoveScheduledChangesArgs = {
  input: SubscriptionRemoveScheduledChangesInput;
};

export type MutationSubscriptionResumeArgs = {
  input: SubscriptionResumeInput;
};

export type MutationSubscriptionSwitchPlanArgs = {
  input: SubscriptionSwitchInput;
};

export type MutationSubscriptionUpgradeArgs = {
  input: SubscriptionUpgradeInput;
};

export type MutationTimeoutPartyMemberArgs = {
  input: PartyInput;
};

export type MutationToggleClassCompleteArgs = {
  input: ToggleClassCompleteInput;
};

export type MutationToggleNotificationsArgs = {
  input: ToggleNotificationsInput;
};

export type MutationToggleSaveClassArgs = {
  input: ToggleSaveClassInput;
};

export type MutationToggleSaveProgramArgs = {
  input: ToggleSaveProgramInput;
};

export type MutationTrackLogPlayArgs = {
  input: TrackLogPlayInput;
};

export type MutationTrackUpsertArgs = {
  input: TrackUpsertInput;
};

export type MutationUpdateClassProgressArgs = {
  input: ClassProgressInput;
};

export type MutationUpdateClassProgressV2Args = {
  input: ClassProgressInput;
};

export type MutationUpdateClassSessionArgs = {
  input: ClassSessionInput;
};

export type MutationUpdateClassSessionV2Args = {
  input: ClassSessionInput;
};

export type MutationUpdateSchedulePlaylistArgs = {
  input: ModifyPlaylistInput;
};

export type MutationUpdateSchedulePlaylistV2Args = {
  input: ModifyPlaylistInputV2;
};

export type MutationUpdateTrackLicenseArgs = {
  input: TrackLicenseUpdateInput;
};

export type MutationUpdateUserProfileArgs = {
  input: UserProfileUpdateInput;
};

export type MutationUpdateWeeklyStreakGoalArgs = {
  input: WeeklyStreakGoalInput;
};

export type MutationUserAcknowledgeContentArgs = {
  input?: InputMaybe<UserAcknowledgeContentInput>;
};

export type MutationUserAuthUpdateArgs = {
  input: UserAuthUpdateInput;
};

export type MutationUserBulkEnableCommunityArgs = {
  emails: Array<Scalars["String"]>;
};

export type MutationUserCheckUsernameArgs = {
  input: UserCheckUsernameInput;
};

export type MutationUserClassUnlockArgs = {
  input: ClassUnlockInput;
};

export type MutationUserCreateReferralInviteArgs = {
  input: UserCreateReferralInviteInput;
};

export type MutationUserNotificationPreferenceUpdateArgs = {
  input: UserNotificationPreferenceUpdateInput;
};

export type MutationUserSetParentalControlsArgs = {
  input: UserSetParentalControlsInput;
};

export type MutationUserSetPhotoArgs = {
  input: UserSetProfilePhoto;
};

export type MutationUserSetUsernameArgs = {
  input: SetUsernameInput;
};

export type MutationUserUpdateArgs = {
  input: UserUpdateInput;
};

export type MutationUserUpdateBirthDateArgs = {
  input: UserBirthDateInput;
};

export type MutationUserUpdateNameArgs = {
  input: UserNameInput;
};

export type MutationUserUpdatePaymentSourceArgs = {
  input: UserUpdatePaymentSourceInput;
};

export type MutationUserUpdateUsernameArgs = {
  input: UserUpdateUsernameInput;
};

export type MutationVideoUploadAdminUpdateArgs = {
  input: VideoUploadAdminUpdateInput;
};

export type MutationVideoUploadCompleteArgs = {
  input: VideoUploadCompleteInput;
};

export type MutationVideoUploadCreateArgs = {
  input: VideoUploadCreateInput;
};

export type MutationVideoUploadDeleteArgs = {
  videoId: Scalars["String"];
};

export type MutationVideoUploadSubmitArgs = {
  input: VideoUploadSubmitInput;
};

export type MutationVideoUploadUpdateArgs = {
  input: VideoUploadUpdateInput;
};

export type ActivityCommentCreateInput = {
  body: Scalars["String"];
  contentId: Scalars["String"];
  contentType: ContentType;
  parentCommentId?: InputMaybe<Scalars["String"]>;
};

export type ActivityCommentUpdateInput = {
  body: Scalars["String"];
  commentId: Scalars["String"];
};

export type ActivityReactionCreateInput = {
  contentId: Scalars["String"];
  contentType: ContentType;
  reactionType: UserReactionType;
};

export type ActivityReaction = {
  __typename?: "ActivityReaction";
  createdAt: Scalars["DateTime"];
  id: Scalars["ID"];
  reactionType: UserReactionType;
  timeSince: Scalars["String"];
  updatedAt: Scalars["DateTime"];
  user: User;
};

export type ActivityReactionDeleteInput = {
  contentId: Scalars["String"];
  contentType: ContentType;
  reactionType: UserReactionType;
};

export type ModifyPlaylistInput = {
  classIds: Array<Scalars["String"]>;
  fromModule?: InputMaybe<Scalars["String"]>;
  id: Scalars["String"];
};

export type ModifyPlaylistInputV2 = {
  classIds: Array<ClassIdentifier>;
  fromModule?: InputMaybe<Scalars["String"]>;
  id: Scalars["String"];
};

export type ClassIdentifier = {
  id: Scalars["String"];
  refId?: InputMaybe<Scalars["String"]>;
};

export type AchievementStudioClassInput = {
  achievementId: Scalars["String"];
  studioClassId: Scalars["String"];
};

export type AchievementCreateInput = {
  description?: InputMaybe<Scalars["String"]>;
  name: Scalars["String"];
  triggerType: AchievementTriggerType;
};

export type AchievementUpdateInput = {
  achievementId: Scalars["String"];
  challengeId?: InputMaybe<Scalars["String"]>;
  description?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  requiredStudioClassIds?: InputMaybe<Array<Scalars["String"]>>;
  triggerType: AchievementTriggerType;
};

/** Badge asset types */
export enum BadgeAssetType {
  Active = "active",
  Inactive = "inactive"
}

export type CreateAssetUploadResponse = {
  __typename?: "CreateAssetUploadResponse";
  id: Scalars["ID"];
  signedUrl: Scalars["String"];
};

export type BadgeCreateInput = {
  achievementId: Scalars["String"];
  amountToEarn?: InputMaybe<Scalars["Int"]>;
  description?: InputMaybe<Scalars["String"]>;
  name: Scalars["String"];
};

export type BadgeUpdateInput = {
  activeImageId?: InputMaybe<Scalars["String"]>;
  amountToEarn?: InputMaybe<Scalars["Int"]>;
  badgeId: Scalars["String"];
  description?: InputMaybe<Scalars["String"]>;
  inactiveImageId?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
};

/** Category asset types */
export enum CategoryAssetType {
  Thumbnail = "thumbnail"
}

export type CategoryCreateInput = {
  name: Scalars["String"];
};

export type CategoryUpdateInput = {
  categoryId: Scalars["String"];
  description?: InputMaybe<Scalars["String"]>;
  hidden?: InputMaybe<Scalars["Boolean"]>;
  isOnboarding?: InputMaybe<Scalars["Boolean"]>;
  name?: InputMaybe<Scalars["String"]>;
  previewVideoId?: InputMaybe<Scalars["String"]>;
  slug?: InputMaybe<Scalars["String"]>;
  sortIndex?: InputMaybe<Scalars["Float"]>;
  thumbnailImageId?: InputMaybe<Scalars["String"]>;
};

export type VideoUploadCompleteInput = {
  parts: Array<MultipartUploadInput>;
  uploadId: Scalars["String"];
  videoId: Scalars["String"];
};

export type MultipartUploadInput = {
  eTag: Scalars["String"];
  partNumber: Scalars["Int"];
};

export type CategoryVideoFileCreateInput = {
  categoryId: Scalars["String"];
  parts: Scalars["Float"];
};

export type VideoUploadCreateResponse = {
  __typename?: "VideoUploadCreateResponse";
  id: Scalars["ID"];
  s3PartsUrls: Array<UploadPart>;
  totalParts?: Maybe<Scalars["Int"]>;
  uploadId?: Maybe<Scalars["String"]>;
};

export type UploadPart = {
  __typename?: "UploadPart";
  partNumber: Scalars["Int"];
  url: Scalars["String"];
};

export type AssignPlanToCountryInput = {
  /** The unique identifier of the country */
  countryId?: InputMaybe<Scalars["String"]>;
  /** The ISO 3166-1 alpha-2 code of the country (e.g., 'US', 'GB') */
  countryIsoCode?: InputMaybe<Scalars["String"]>;
  /** The unique identifier of the plan to assign */
  planId?: InputMaybe<Scalars["String"]>;
  /** The provider identifier of the plan to assign */
  providerId?: InputMaybe<Scalars["String"]>;
  /** The provider name (required if providerId is provided) */
  providerName?: InputMaybe<SubscriptionProvider>;
};

export type CreateCountryInput = {
  isoCode: Scalars["String"];
  name: Scalars["String"];
};

export type UpdateCountryInput = {
  name: Scalars["String"];
};

/** Instructor asset types */
export enum InstructorAssetType {
  Avatar = "avatar",
  Profile = "profile"
}

export type InstructorCreateInput = {
  name: Scalars["String"];
};

export type InstructorUpdateInput = {
  avatarImageId?: InputMaybe<Scalars["String"]>;
  bio?: InputMaybe<Scalars["String"]>;
  credits?: InputMaybe<Array<Scalars["String"]>>;
  facebook?: InputMaybe<Scalars["String"]>;
  featuredClassId?: InputMaybe<Scalars["Float"]>;
  hidden?: InputMaybe<Scalars["Boolean"]>;
  instagram?: InputMaybe<Scalars["String"]>;
  instructorId: Scalars["String"];
  location?: InputMaybe<Scalars["String"]>;
  name?: InputMaybe<Scalars["String"]>;
  profileImageId?: InputMaybe<Scalars["String"]>;
  slug?: InputMaybe<Scalars["String"]>;
  tiktok?: InputMaybe<Scalars["String"]>;
  twitter?: InputMaybe<Scalars["String"]>;
  userId?: InputMaybe<Scalars["ID"]>;
  youtube?: InputMaybe<Scalars["String"]>;
};

export type RemovePlanFromCountryInput = {
  countryId?: InputMaybe<Scalars["String"]>;
  countryIsoCode?: InputMaybe<Scalars["String"]>;
  planId?: InputMaybe<Scalars["String"]>;
  providerId?: InputMaybe<Scalars["String"]>;
  providerName?: InputMaybe<SubscriptionProvider>;
};

export type UpdatePlanSettingsInput = {
  /** The access type for the plan */
  accessType?: InputMaybe<AccessType>;
  /** Whether the plan should be displayed */
  isDisplayed?: InputMaybe<Scalars["Boolean"]>;
};

export type PlaylistAddOrRemoveStudioClassInput = {
  playlistId: Scalars["String"];
  studioClassId: Scalars["String"];
};

/** Playlist asset types */
export enum PlaylistAssetType {
  Thumbnail = "thumbnail"
}

export type PlaylistUpdateInput = {
  displayIndex?: InputMaybe<Scalars["Float"]>;
  hidden?: InputMaybe<Scalars["Boolean"]>;
  name?: InputMaybe<Scalars["String"]>;
  playlistId: Scalars["String"];
  thumbnailImageId?: InputMaybe<Scalars["String"]>;
};

export type ClassTrackInput = {
  classId: Scalars["String"];
  isrc: Scalars["String"];
  startsAt: Scalars["Int"];
};

/** Studio class asset types */
export enum StudioClassAssetType {
  Thumbnail = "thumbnail"
}

export type StudioClassCreateInput = {
  classId: Scalars["Float"];
  title: Scalars["String"];
};

export type StudioClassUpdateInput = {
  accessType?: InputMaybe<AccessType>;
  categoryIds?: InputMaybe<Array<Scalars["String"]>>;
  classId: Scalars["String"];
  externalPreviewUrl?: InputMaybe<Scalars["String"]>;
  free?: InputMaybe<Scalars["Boolean"]>;
  hidden?: InputMaybe<Scalars["Boolean"]>;
  instructorId?: InputMaybe<Scalars["String"]>;
  isFamilyFriendly?: InputMaybe<Scalars["Boolean"]>;
  level?: InputMaybe<Scalars["String"]>;
  mutedCuepoints?: InputMaybe<Array<MutedCuepointInput>>;
  previewVideoId?: InputMaybe<Scalars["String"]>;
  publishDate?: InputMaybe<Scalars["DateTime"]>;
  sections?: InputMaybe<Array<StudioClassSectionInput>>;
  shouldBeMuted?: InputMaybe<Scalars["Boolean"]>;
  slug?: InputMaybe<Scalars["String"]>;
  style?: InputMaybe<Scalars["String"]>;
  tagIds?: InputMaybe<Array<Scalars["String"]>>;
  thumbnailImageId?: InputMaybe<Scalars["String"]>;
  title?: InputMaybe<Scalars["String"]>;
  type?: InputMaybe<Scalars["String"]>;
  videoId?: InputMaybe<Scalars["String"]>;
};

export type MutedCuepointInput = {
  endsAtTimeSec: Scalars["Int"];
  externalUrl?: InputMaybe<Scalars["String"]>;
  startsAtTimeSec: Scalars["Int"];
};

export type StudioClassSectionInput = {
  cuepoints: Array<SectionCuepointInput>;
  name: Scalars["String"];
};

export type SectionCuepointInput = {
  name: Scalars["String"];
  timeSec: Scalars["Int"];
};

export type TagCreateInput = {
  displayIndex?: InputMaybe<Scalars["Int"]>;
  name: Scalars["String"];
  previewVideoId?: InputMaybe<Scalars["String"]>;
  slug?: InputMaybe<Scalars["String"]>;
  thumbnailImageId?: InputMaybe<Scalars["String"]>;
  type: Scalars["String"];
};

export type TagUpdateInput = {
  displayIndex?: InputMaybe<Scalars["Int"]>;
  id: Scalars["String"];
  name: Scalars["String"];
  previewVideoId?: InputMaybe<Scalars["String"]>;
  slug: Scalars["String"];
  thumbnailImageId?: InputMaybe<Scalars["String"]>;
  type: Scalars["String"];
};

export type UserAuthDeleteInput = {
  uid: Scalars["String"];
};

export type UserRandomizePersonalizedPlaylistInput = {
  uid: Scalars["String"];
};

export type AdminUserUpdateLogin = {
  password: Scalars["String"];
  uid: Scalars["String"];
};

export type ApprovePartyMemberInput = {
  isApproved: Scalars["Boolean"];
  pid: Scalars["String"];
  uid: Scalars["String"];
};

export type SuccessPayload = {
  __typename?: "SuccessPayload";
  success?: Maybe<Scalars["Boolean"]>;
};

export type ChallengeProgressResult = {
  __typename?: "ChallengeProgressResult";
  challengesProgressed: Array<CalculatedChallengeProgress>;
  newlyEarnedBadges: Array<UserBadge>;
};

export type CalculatedChallengeProgress = {
  __typename?: "CalculatedChallengeProgress";
  challenge: Challenge;
  isCompleted: Scalars["Boolean"];
};

export type ChallengeCreateInput = {
  achievementId?: InputMaybe<Scalars["String"]>;
  challengeStatus: ChallengeStatus;
  classId?: InputMaybe<Scalars["String"]>;
  description?: InputMaybe<Scalars["String"]>;
  displayText?: InputMaybe<ChallengeDisplayTextInput>;
  endTime: Scalars["DateTime"];
  startTime: Scalars["DateTime"];
  title: Scalars["String"];
};

export type ChallengeDisplayTextInput = {
  earnedByHeader?: InputMaybe<Scalars["String"]>;
  goalHeader?: InputMaybe<Scalars["String"]>;
  subtitleHeader?: InputMaybe<Scalars["String"]>;
};

export type ChallengeUpdateInput = {
  achievementId?: InputMaybe<Scalars["String"]>;
  challengeId: Scalars["String"];
  challengeStatus: ChallengeStatus;
  description?: InputMaybe<Scalars["String"]>;
  displayText?: InputMaybe<ChallengeDisplayTextInput>;
  endTime: Scalars["DateTime"];
  startTime: Scalars["DateTime"];
  thumbnailImageId?: InputMaybe<Scalars["String"]>;
  title: Scalars["String"];
};

export type ActivityClassCommentCreateInput = {
  body: Scalars["String"];
  classNumber?: InputMaybe<Scalars["Float"]>;
  parentCommentId?: InputMaybe<Scalars["String"]>;
  studioClassId?: InputMaybe<Scalars["String"]>;
};

export type ClassUnlockInput = {
  classId: Scalars["String"];
};

export type ClassVideoFileCreateInput = {
  classId: Scalars["String"];
  classVideoType: ClassVideoType;
  parts: Scalars["Float"];
};

export type ClassCompleteInput = {
  classId: Scalars["String"];
  /** The datetime the class was completed. UTC in ISO8601 format */
  completedDateTime: Scalars["String"];
  context?: InputMaybe<Context>;
};

/** The context the current class is being played in. This helps determine what progress nodes to update when classes have many-to-many relationships. */
export type Context = {
  partyId?: InputMaybe<Scalars["String"]>;
  /** The playlistDate is a date string formatted as YYYY-MM-DD. The playlistDate refers to the playlist associated with the date of a user's schedule. */
  playlistDate?: InputMaybe<Scalars["String"]>;
  /** The playlistId is an ID for PlaylistV2. */
  playlistId?: InputMaybe<Scalars["String"]>;
  /** The program reference ID. This helps reference what block and section the program class is associated with. */
  programClassRefId?: InputMaybe<Scalars["String"]>;
  /** The schedulePlaylistId is an ID for the SchedulePlaylist. */
  schedulePlaylistId?: InputMaybe<Scalars["String"]>;
};

export type CancelSurveyInput = {
  additionalFeedback?: InputMaybe<Scalars["String"]>;
  joinAgainReason?: InputMaybe<Scalars["String"]>;
  otherReason?: InputMaybe<Scalars["String"]>;
  overallExperienceRating: Scalars["Int"];
  reason: CancelReason;
  subscriptionId: Scalars["String"];
};

export type CreatePartyInput = {
  classId: Scalars["Int"];
  /** A boolean flag determining whether or not the party was started from a free class */
  isFreeClass?: InputMaybe<Scalars["Boolean"]>;
};

export type CreatePartyOutput = {
  __typename?: "CreatePartyOutput";
  accessToken: Scalars["String"];
  classId: Scalars["Int"];
  expiresAt: Scalars["String"];
  id: Scalars["String"];
  sessionId: Scalars["String"];
  status: Scalars["String"];
};

export type CreateRecommendedSchedulePlaylistInput = {
  /** Date for the requested playlist day. Format is YYYY-MM-DD. */
  date: Scalars["String"];
};

export type CreateSchedulePlaylistInput = {
  classIds: Array<Scalars["String"]>;
  /** Date for the requested playlist day. Format is YYYY-MM-DD. */
  date: Scalars["String"];
};

export type CreateSchedulePlaylistInputV2 = {
  classIds: Array<ClassIdentifier>;
  /** Date for the requested playlist day. Format is YYYY-MM-DD. */
  date: Scalars["String"];
};

export type UserCreateInput = {
  email: Scalars["String"];
  uid: Scalars["String"];
};

export type PartyInput = {
  pid: Scalars["String"];
};

export type FlaggedActivityCreateInput = {
  activityId: Scalars["String"];
  activityType: ActivityType;
  description?: InputMaybe<Scalars["String"]>;
  reportReason: ActivityReportReason;
};

export type FlaggedActivityReviewInput = {
  reportId: Scalars["String"];
  reviewDecision: ActivityReviewDecision;
  reviewNotes?: InputMaybe<Scalars["String"]>;
};

export type FollowCategoriesInput = {
  categories: Array<FollowingInput>;
  /** String value describing where the user invoked the mutation */
  fromModule?: InputMaybe<Scalars["String"]>;
};

export type FollowingInput = {
  isFollowing: Scalars["Boolean"];
  slug: Scalars["ID"];
};

export type FollowCategoryOutput = {
  __typename?: "FollowCategoryOutput";
  /** A boolean value describing if the user has followed (true) or unfollowed (false). */
  isFollowing: Scalars["Boolean"];
  /** The slug of the category. */
  slug: Scalars["ID"];
};

export type FollowCategoryInput = {
  /** String value describing where the user invoked the mutation */
  fromModule?: InputMaybe<Scalars["String"]>;
  /** Boolean value describing whether the user is following (true) or unfollowing (false) the category. */
  isFollowing: Scalars["Boolean"];
  /** The category slug. */
  slug: Scalars["ID"];
};

export type FollowClassInput = {
  /** String value describing where the user invoked the mutation. */
  fromModule?: InputMaybe<Scalars["String"]>;
  /** The class ID. */
  id: Scalars["ID"];
  /** Boolean value describing whether the user is following (true) or unfollowing (false) the class. */
  isFollowing: Scalars["Boolean"];
};

export type FollowClassOutput = {
  __typename?: "FollowClassOutput";
  /** The class ID (Int/String are both applicable) being followed */
  id: Scalars["ID"];
  /** A boolean value describing if the user has followed (true) or unfollowed (false). */
  isFollowing: Scalars["Boolean"];
};

export type FollowInstructorInput = {
  /** String value describing where the user invoked the mutation. */
  fromModule?: InputMaybe<Scalars["String"]>;
  /** Boolean value describing whether the user is following (true) or unfollowing (false) the instructor. */
  isFollowing: Scalars["Boolean"];
  /** The instructor slug. */
  slug: Scalars["ID"];
};

export type FollowInstructorOutput = {
  __typename?: "FollowInstructorOutput";
  /** A boolean value describing if the user has followed (true) or unfollowed (false). */
  isFollowing: Scalars["Boolean"];
  /** The slug of an instructor */
  slug: Scalars["ID"];
};

export type CollectPaymentInput = {
  gateway: GatewayInput;
  invoiceId: Scalars["String"];
  type: PaymentMethodType;
};

export type GatewayInput = {
  provider: GatewayProvider;
  token: Scalars["String"];
};

export enum PaymentMethodType {
  ApplePay = "apple_pay",
  Card = "card",
  GooglePay = "google_pay",
  PaypalExpressCheckout = "paypal_express_checkout"
}

export type JoinPartyOutput = {
  __typename?: "JoinPartyOutput";
  sessionId: Scalars["String"];
};

export type LeavePartyOutput = {
  __typename?: "LeavePartyOutput";
  classId: Scalars["Int"];
  id: Scalars["String"];
};

export type PlaylistCreateInput = {
  hidden: Scalars["Boolean"];
  name: Scalars["String"];
};

export type PlaylistDeleteInput = {
  playlistId: Scalars["String"];
};

export type PlaylistSaveOrUnsaveInput = {
  playlistId: Scalars["String"];
};

export type PlaylistUpdateDetailsInput = {
  hidden?: InputMaybe<Scalars["Boolean"]>;
  name?: InputMaybe<Scalars["String"]>;
  playlistId: Scalars["String"];
};

export type QueuePartyMemberOutput = {
  __typename?: "QueuePartyMemberOutput";
  accessToken?: Maybe<Scalars["String"]>;
  classId: Scalars["Int"];
  expiresAt: Scalars["String"];
  id: Scalars["String"];
  status: Scalars["String"];
};

export type RateClassInput = {
  classId: Scalars["Int"];
  /** Optional comment elaborating why the user gave a certain rating */
  comment?: InputMaybe<Scalars["String"]>;
  /** A rating value between 1 and 5 for a class. */
  rating: Scalars["Int"];
};

export type RateClassOutput = {
  __typename?: "RateClassOutput";
  classId: Scalars["String"];
  /** Optional comment elaborating why the user gave a certain rating */
  comment?: Maybe<Scalars["String"]>;
  /** The date the rating was created in ISO8601 */
  createdAt: Scalars["String"];
  /** A rating value between 1 and 5 for a class. */
  rating: Scalars["Int"];
};

export type RemoveTakenClassInput = {
  classId: Scalars["Int"];
  date: Scalars["String"];
};

export type RemoveTakenClassInputV2 = {
  classIdentifier: ClassIdentifier;
  date: Scalars["String"];
};

export type UserSessionInput = {
  idToken: Scalars["String"];
};

export type SetAccountTypePreferenceInput = {
  /** The slug of a account type option. */
  slug: Scalars["ID"];
};

export type AccountTypeOption = {
  __typename?: "AccountTypeOption";
  /** The description of a account type option. */
  description: Scalars["String"];
  /** The label of a account type option. */
  lable: Scalars["String"];
  /** A preview GIF URL for each account type option. */
  previewGIFUrl?: Maybe<Scalars["String"]>;
  /** The slug of a account type option. */
  slug: Scalars["ID"];
};

export type SetClassDurationPreferenceInput = {
  /** The slug of a class duration option. */
  slug: Scalars["ID"];
};

export type SetDanceCadenceInput = {
  daysPerWeek: Scalars["String"];
  /** Days of the week (e.g. monday) */
  slugs: Array<Scalars["String"]>;
};

export type SetDanceEnergyInput = {
  slug: Scalars["String"];
};

export type SetDanceFrequencyInput = {
  slug: Scalars["String"];
};

export type SetDanceGoalsInput = {
  slugs: Array<Scalars["String"]>;
};

export type SetDanceHabitInput = {
  slug: Scalars["String"];
};

export type SetDanceLevelPreferenceInput = {
  /** The slug of a dance level option. */
  slug: Scalars["ID"];
};

export type SetDanceLevelInput = {
  slug: Scalars["String"];
};

export type SetDanceLocationsInput = {
  slugs: Array<Scalars["String"]>;
};

export type SetDanceReasonPreferenceInput = {
  /** The slug of a dance reason option. */
  slug: Scalars["ID"];
};

export type SetExperimentInput = {
  experimentId: Scalars["ID"];
};

export type SetExperimentOutput = {
  __typename?: "SetExperimentOutput";
  experimentId: Scalars["String"];
  variant: Scalars["String"];
};

export type SetFamilyGoalPreferenceInput = {
  /** The slug of a family goal option. */
  slug: Scalars["ID"];
};

export type FamilyGoalOption = {
  __typename?: "FamilyGoalOption";
  /** The description of a family goal option. */
  description: Scalars["String"];
  /** The label of a family goal option. */
  label: Scalars["String"];
  /** A preview GIF URL for each family goal option. */
  previewGIFUrl?: Maybe<Scalars["String"]>;
  /** The slug of a family goal option. */
  slug: Scalars["ID"];
};

export type SetHdyhauSurveyResponseInput = {
  slugs: Array<Scalars["String"]>;
};

export type SetUserAgeInput = {
  slug: Scalars["String"];
};

export type SetUsersTimezoneInput = {
  zoneName: Scalars["String"];
};

export type ClassStartInput = {
  classId: Scalars["String"];
  context?: InputMaybe<Context>;
  /** The datetime the class was started. UTC in ISO8601 format */
  startedDateTime: Scalars["String"];
};

export type SubmitCancelationFeedbackInput = {
  feedbackText: Scalars["String"];
};

export type SubscriptionCancelInput = {
  cancelNow?: InputMaybe<Scalars["Boolean"]>;
  cancelReason?: InputMaybe<Scalars["String"]>;
  subscriptionId: Scalars["String"];
};

export type SubscriptionCreateInput = {
  couponIds?: InputMaybe<Array<Scalars["String"]>>;
  gateway: GatewayInput;
  ipInfo?: InputMaybe<IpInfoInput>;
  paymentMethodType: PaymentMethodType;
  planInfo: PlanInfoInput;
  trialEndTime?: InputMaybe<Scalars["Timestamp"]>;
  trialOverrideTime?: InputMaybe<Scalars["Timestamp"]>;
};

export type IpInfoInput = {
  countryName?: InputMaybe<Scalars["String"]>;
  regionName?: InputMaybe<Scalars["String"]>;
};

export type SubscriptionCreateForCustomerInput = {
  couponIds?: InputMaybe<Array<Scalars["String"]>>;
  ipInfo?: InputMaybe<IpInfoInput>;
  planInfo: PlanInfoInput;
};

export type UserSubscription = {
  __typename?: "UserSubscription";
  cancelationTime?: Maybe<Scalars["Float"]>;
  currentTermEnd?: Maybe<Scalars["Float"]>;
  id: Scalars["String"];
  invoiceDue?: Maybe<Invoice>;
  invoiceEstimate?: Maybe<SubscriptionInvoiceEstimate>;
  isActive: Scalars["Boolean"];
  isCancelable: Scalars["Boolean"];
  isPastDue: Scalars["Boolean"];
  isPauseScheduled: Scalars["Boolean"];
  isReactivatable: Scalars["Boolean"];
  nextBillingAt?: Maybe<Scalars["Float"]>;
  pauseTime?: Maybe<Scalars["Float"]>;
  plan: Plan;
  provider: ProviderInfo;
  resumeTime?: Maybe<Scalars["Float"]>;
  status: SubscriptionStatus;
  trialEndTime?: Maybe<Scalars["Float"]>;
  user: User;
};

export type SubscriptionExtendTrialInput = {
  subscriptionId: Scalars["String"];
  trialEndTime: Scalars["DateTime"];
};

export type SubscriptionPauseInput = {
  resumeTime: Scalars["DateTime"];
  subscriptionId: Scalars["String"];
};

export type SubscriptionReactivateInput = {
  subscriptionId: Scalars["String"];
};

export type SubscriptionReactivateUsingCouponInput = {
  couponId: Scalars["String"];
  subscriptionId: Scalars["String"];
};

export type SubscriptionRemoveScheduledChangesInput = {
  subscriptionId: Scalars["String"];
};

export type SubscriptionResumeInput = {
  resumeTime?: InputMaybe<Scalars["DateTime"]>;
  shouldResumeNow?: InputMaybe<Scalars["Boolean"]>;
  subscriptionId: Scalars["String"];
};

export type SubscriptionSwitchInput = {
  planId: Scalars["String"];
  subscriptionId: Scalars["String"];
};

export type SubscriptionUpgradeInput = {
  planId: Scalars["String"];
  subscriptionId: Scalars["String"];
};

export type ToggleClassCompleteInput = {
  /** True if the program class should be toggled completed */
  isComplete: Scalars["Boolean"];
  /** The program class reference ID */
  programClassRefId: Scalars["String"];
};

export type ToggleNotificationsInput = {
  isEnabled: Scalars["Boolean"];
};

export type ToggleNotificationsOutput = {
  __typename?: "ToggleNotificationsOutput";
  isEnabled: Scalars["Boolean"];
};

export type ToggleSaveClassInput = {
  /** The class ID */
  classId: Scalars["String"];
  /** The program class reference ID */
  programClassRefId?: InputMaybe<Scalars["String"]>;
  /** True if the operation intends to save the class */
  willSave: Scalars["Boolean"];
};

export type ToggleSaveProgramInput = {
  /** The program slug */
  programSlug: Scalars["String"];
  /** True if the operation intends to save the program */
  willSave: Scalars["Boolean"];
};

export type TrackLogPlayInput = {
  countryCode: Scalars["String"];
  trackId: Scalars["String"];
};

export type TrackUpsertInput = {
  albumName?: InputMaybe<Scalars["String"]>;
  appleMusic?: InputMaybe<Scalars["String"]>;
  artists?: InputMaybe<Array<Scalars["String"]>>;
  copyright?: InputMaybe<Scalars["String"]>;
  genre?: InputMaybe<Array<Scalars["String"]>>;
  image?: InputMaybe<Scalars["String"]>;
  isExplicit?: InputMaybe<Scalars["Boolean"]>;
  isLicensed?: InputMaybe<Scalars["Boolean"]>;
  isrc?: InputMaybe<Scalars["String"]>;
  label?: InputMaybe<Scalars["String"]>;
  releaseDate?: InputMaybe<Scalars["String"]>;
  songId?: InputMaybe<Scalars["String"]>;
  soundcloud?: InputMaybe<Scalars["String"]>;
  source: TrackSource;
  spotify?: InputMaybe<Scalars["String"]>;
  tikTokSound?: InputMaybe<Scalars["String"]>;
  title?: InputMaybe<Scalars["String"]>;
  youtube?: InputMaybe<Scalars["String"]>;
};

export type ClassProgressInput = {
  classId: Scalars["String"];
  context?: InputMaybe<Context>;
  /** A datetime string of when the user was progressing in the class. ISO8601 UTC time */
  playedDate?: InputMaybe<Scalars["String"]>;
  playedFragments?: InputMaybe<Array<PlayedFragment>>;
  /**
   * The exact seconds a user has watched since the last invocation of the updateClassProgress mutation. For example,
   * if a user watched each second of a video between 20 and 25 seconds and rewinded it back to 22 seconds and continued
   * to watch until the 30 second timestamp and then fired the updateClassProgress call, a client would send a request
   * with the following array [20, 21, 22, 23, 24, 25, 22, 23, 24, 25, 26, 27, 28, 29, 30]. Duplicate seconds are valid.
   * The array can be reset between requests.
   */
  playedSeconds?: InputMaybe<Array<Scalars["Int"]>>;
  /**
   * The amount of seconds that has elapsed when the user started watching the class and since the last invocation of
   * the updateClassProgress mutation. SessionSeconds should be a timer incremented locally in-memory every second
   * the video is playing and reset back to 0 after each successful request to the updateClassProgress mutation.
   * SessionSeconds only increments when the video is playing. It should not increase when the video is paused.
   * It should continue to increment when the video is buffering or experiencing any latency issues.
   */
  sessionSeconds: Scalars["Int"];
  /**
   * The current second the user is on for the class video i.e. if a user is at a timestamp of 01:05:32
   * (1 hour, 5 minutes and 32 seconds) when the updateClassProgress request is made the client should send
   * (1 * 3600 seconds) + (5 * 60 seconds) + 32 seconds = 3932 for this field.
   */
  timestampSeconds: Scalars["Int"];
};

export type PlayedFragment = {
  end: Scalars["Int"];
  start: Scalars["Int"];
};

export type ClassSessionInput = {
  classId: Scalars["String"];
  context?: InputMaybe<Context>;
  /** The total amount of seconds that has elapsed when the user started watching the class INCLUDING pauses and since the last invocation of the updateClassSession mutation */
  sessionSeconds: Scalars["Int"];
};

export type TrackLicenseUpdateInput = {
  isLicensed: Scalars["Boolean"];
  isrc: Scalars["String"];
};

export type UserProfileUpdateInput = {
  bio?: InputMaybe<Scalars["String"]>;
  birthDate?: InputMaybe<Scalars["DateTime"]>;
  links?: InputMaybe<Array<UserProfileLinkInput>>;
  name?: InputMaybe<Scalars["String"]>;
  uid: Scalars["String"];
};

export type UserProfileLinkInput = {
  title?: InputMaybe<Scalars["String"]>;
  url: Scalars["String"];
};

export type WeeklyStreakGoalInput = {
  streakGoal: Scalars["Int"];
};

export type WeeklyStreakGoalOutput = {
  __typename?: "WeeklyStreakGoalOutput";
  streakGoal: Scalars["Int"];
};

export type UserAcknowledgeContentInput = {
  module: ContentModule;
  /** The slug identifying the content e.g. terms-and-conditions */
  slug: Scalars["String"];
};

/** The module or scope the content is associated with e.g. challenges, modals, etc. */
export enum ContentModule {
  Challenges = "challenges",
  ForYou = "for_you",
  Modals = "modals"
}

export type UserAuthUpdateInput = {
  authCode: Scalars["String"];
};

export type UserCheckUsernameInput = {
  username: Scalars["String"];
};

export type UserCreateReferralInviteInput = {
  advocateId: Scalars["String"];
};

export type UserNotificationPreferenceUpdateInput = {
  allowAll?: InputMaybe<Scalars["Boolean"]>;
  enabled: Scalars["Boolean"];
  /** Currently same value as source */
  id: Scalars["ID"];
  source: NotificationSourcePreference;
};

export type UserSetParentalControlsInput = {
  currentPin?: InputMaybe<Scalars["String"]>;
  isEnabled: Scalars["Boolean"];
  newPin?: InputMaybe<Scalars["String"]>;
};

export type UserSetProfilePhoto = {
  photoFile: Scalars["Upload"];
};

export type SetUsernameInput = {
  /** The new username the user wants to update to */
  newUsername: Scalars["String"];
};

export type UserUpdateInput = {
  hasCommunityAccess?: InputMaybe<Scalars["Boolean"]>;
  roles?: InputMaybe<Array<Scalars["String"]>>;
  userId: Scalars["String"];
};

export type UserBirthDateInput = {
  birthDate: Scalars["DateTime"];
};

export type UserNameInput = {
  name: Scalars["String"];
};

export type UserUpdatePaymentSourceInput = {
  gateway: GatewayInput;
  type: PaymentMethodType;
};

export type UserUpdateUsernameInput = {
  username: Scalars["String"];
};

export type VideoUploadAdminUpdateInput = {
  approvalStatus: VideoApprovalStatus;
  videoId: Scalars["String"];
};

export type VideoUploadCreateInput = {
  challengeId?: InputMaybe<Scalars["String"]>;
  classNumber?: InputMaybe<Scalars["Float"]>;
  parts: Scalars["Float"];
};

export type VideoUploadSubmitInput = {
  classNumber?: InputMaybe<Scalars["Float"]>;
  description?: InputMaybe<Scalars["String"]>;
  platform?: InputMaybe<Platform>;
  videoId: Scalars["String"];
};

export type VideoUploadUpdateInput = {
  description: Scalars["String"];
  videoId: Scalars["String"];
};

export enum CacheControlScope {
  Private = "PRIVATE",
  Public = "PUBLIC"
}

export type FollowInput = {
  /** The identifier of what the user is trying to follow. For example, this could be a class ID (Int/String are both applicable) or an instructor slug (String). */
  id: Scalars["ID"];
  /** A boolean value describing if the user is following (true) or unfollowing (false). */
  isFollowing: Scalars["Boolean"];
};

export type ChallengesBadgeFragment = {
  __typename?: "Badge";
  id: string;
  name: string;
  amountToEarn: number;
  activeImageUrl?: string | null;
  inactiveImageUrl?: string | null;
};

export type ChallengeUserProgressFragment = {
  __typename?: "UserProgressChallenge";
  achievementId: string;
  triggerType: AchievementTriggerType;
  currentBadgeProgress: number;
  currentBadge?: {
    __typename?: "Badge";
    id: string;
    name: string;
    amountToEarn: number;
    activeImageUrl?: string | null;
    inactiveImageUrl?: string | null;
  } | null;
  nextBadge?: {
    __typename?: "Badge";
    id: string;
    name: string;
    amountToEarn: number;
    activeImageUrl?: string | null;
    inactiveImageUrl?: string | null;
  } | null;
};

export type ChallengeCardFragment = {
  __typename?: "Challenge";
  id: string;
  title: string;
  startTime: any;
  endTime: any;
  achievement?: {
    __typename?: "Achievement";
    id: string;
    name: string;
    triggerType: AchievementTriggerType;
  } | null;
  badges: Array<{
    __typename?: "BadgeWithEarnedStatus";
    isEarned: boolean;
    badge: {
      __typename?: "Badge";
      id: string;
      name: string;
      amountToEarn: number;
      activeImageUrl?: string | null;
      inactiveImageUrl?: string | null;
    };
  }>;
  userProgress?: {
    __typename?: "UserProgressChallenge";
    achievementId: string;
    triggerType: AchievementTriggerType;
    currentBadgeProgress: number;
    currentBadge?: {
      __typename?: "Badge";
      id: string;
      name: string;
      amountToEarn: number;
      activeImageUrl?: string | null;
      inactiveImageUrl?: string | null;
    } | null;
    nextBadge?: {
      __typename?: "Badge";
      id: string;
      name: string;
      amountToEarn: number;
      activeImageUrl?: string | null;
      inactiveImageUrl?: string | null;
    } | null;
  } | null;
};

export type ChallengesParticipantLeaderboardFragment = {
  __typename?: "ChallengeParticipant";
  joinedAt: any;
  progressAmount: number;
  user: {
    __typename?: "User";
    id: string;
    username: string;
    photoURL?: string | null;
  };
};

export type ChallengeDetailsBadgeFragment = {
  __typename?: "Badge";
  activeImageUrl?: string | null;
  inactiveImageUrl?: string | null;
  amountToEarn: number;
  name: string;
  id: string;
  description?: string | null;
  achievement: {
    __typename?: "Achievement";
    id: string;
    triggerType: AchievementTriggerType;
  };
};

export type AchievementStudioClassFragment = {
  __typename?: "StudioClass";
  id: string;
  classId: number;
  title: string;
  thumbnailImageUrl?: string | null;
  level?: string | null;
  type?: string | null;
  accessType?: AccessType | null;
  instructor?: { __typename?: "ClassInstructor"; name?: string | null } | null;
  video: { __typename?: "ClassVideo"; durationInMs?: string | null };
  userProgress: {
    __typename?: "UserClassProgress";
    completed: boolean;
    percent: number;
    time: {
      __typename?: "TimeV2";
      hour: number;
      minute: number;
      second: number;
    };
  };
};

export type ChallengeDetailsPageFragment = {
  __typename?: "Challenge";
  id: string;
  title: string;
  description?: string | null;
  thumbnailImageUrl?: string | null;
  startTime: any;
  endTime: any;
  achievement?: {
    __typename?: "Achievement";
    id: string;
    triggerType: AchievementTriggerType;
    requiredPublishedStudioClasses?: Array<{
      __typename?: "StudioClass";
      id: string;
      classId: number;
      title: string;
      thumbnailImageUrl?: string | null;
      level?: string | null;
      type?: string | null;
      accessType?: AccessType | null;
      instructor?: {
        __typename?: "ClassInstructor";
        name?: string | null;
      } | null;
      video: { __typename?: "ClassVideo"; durationInMs?: string | null };
      userProgress: {
        __typename?: "UserClassProgress";
        completed: boolean;
        percent: number;
        time: {
          __typename?: "TimeV2";
          hour: number;
          minute: number;
          second: number;
        };
      };
    }> | null;
  } | null;
  badges: Array<{
    __typename?: "BadgeWithEarnedStatus";
    isEarned: boolean;
    badge: {
      __typename?: "Badge";
      activeImageUrl?: string | null;
      inactiveImageUrl?: string | null;
      amountToEarn: number;
      name: string;
      id: string;
      description?: string | null;
      achievement: {
        __typename?: "Achievement";
        id: string;
        triggerType: AchievementTriggerType;
      };
    };
  }>;
  displayText?: {
    __typename?: "ChallengeDisplayText";
    goalHeader?: string | null;
    subtitleHeader?: string | null;
    earnedByHeader?: string | null;
  } | null;
};

export type GetChallengeByIdQueryVariables = Exact<{
  challengeByIdId: Scalars["String"];
}>;

export type GetChallengeByIdQuery = {
  __typename?: "Query";
  challengeById?: {
    __typename?: "Challenge";
    id: string;
    title: string;
    description?: string | null;
    thumbnailImageUrl?: string | null;
    startTime: any;
    endTime: any;
    achievement?: {
      __typename?: "Achievement";
      id: string;
      triggerType: AchievementTriggerType;
      requiredPublishedStudioClasses?: Array<{
        __typename?: "StudioClass";
        id: string;
        classId: number;
        title: string;
        thumbnailImageUrl?: string | null;
        level?: string | null;
        type?: string | null;
        accessType?: AccessType | null;
        instructor?: {
          __typename?: "ClassInstructor";
          name?: string | null;
        } | null;
        video: { __typename?: "ClassVideo"; durationInMs?: string | null };
        userProgress: {
          __typename?: "UserClassProgress";
          completed: boolean;
          percent: number;
          time: {
            __typename?: "TimeV2";
            hour: number;
            minute: number;
            second: number;
          };
        };
      }> | null;
    } | null;
    badges: Array<{
      __typename?: "BadgeWithEarnedStatus";
      isEarned: boolean;
      badge: {
        __typename?: "Badge";
        activeImageUrl?: string | null;
        inactiveImageUrl?: string | null;
        amountToEarn: number;
        name: string;
        id: string;
        description?: string | null;
        achievement: {
          __typename?: "Achievement";
          id: string;
          triggerType: AchievementTriggerType;
        };
      };
    }>;
    displayText?: {
      __typename?: "ChallengeDisplayText";
      goalHeader?: string | null;
      subtitleHeader?: string | null;
      earnedByHeader?: string | null;
    } | null;
  } | null;
};

export type GetChallengeProgressByIdQueryVariables = Exact<{
  challengeByIdId: Scalars["String"];
}>;

export type GetChallengeProgressByIdQuery = {
  __typename?: "Query";
  challengeById?: {
    __typename?: "Challenge";
    id: string;
    title: string;
    startTime: any;
    endTime: any;
    achievement?: {
      __typename?: "Achievement";
      id: string;
      name: string;
      triggerType: AchievementTriggerType;
    } | null;
    badges: Array<{
      __typename?: "BadgeWithEarnedStatus";
      isEarned: boolean;
      badge: {
        __typename?: "Badge";
        id: string;
        name: string;
        amountToEarn: number;
        activeImageUrl?: string | null;
        inactiveImageUrl?: string | null;
      };
    }>;
    userProgress?: {
      __typename?: "UserProgressChallenge";
      achievementId: string;
      triggerType: AchievementTriggerType;
      currentBadgeProgress: number;
      currentBadge?: {
        __typename?: "Badge";
        id: string;
        name: string;
        amountToEarn: number;
        activeImageUrl?: string | null;
        inactiveImageUrl?: string | null;
      } | null;
      nextBadge?: {
        __typename?: "Badge";
        id: string;
        name: string;
        amountToEarn: number;
        activeImageUrl?: string | null;
        inactiveImageUrl?: string | null;
      } | null;
    } | null;
  } | null;
};

export type GetChallengeLeaderboardQueryVariables = Exact<{
  challengeByIdId: Scalars["String"];
}>;

export type GetChallengeLeaderboardQuery = {
  __typename?: "Query";
  challengeById?: {
    __typename?: "Challenge";
    id: string;
    participantLeaderboard: Array<{
      __typename?: "ChallengeParticipant";
      joinedAt: any;
      progressAmount: number;
      user: {
        __typename?: "User";
        id: string;
        username: string;
        photoURL?: string | null;
      };
    }>;
  } | null;
};

export type GeneratedStripePaymentIntentQueryVariables = Exact<{
  amountInCents: Scalars["Float"];
}>;

export type GeneratedStripePaymentIntentQuery = {
  __typename?: "Query";
  generateStripePaymentIntent?: {
    __typename?: "StripePaymentIntent";
    id: string;
    clientSecret: string;
  } | null;
};

export type CreatePlaySessionMutationVariables = Exact<{
  [key: string]: never;
}>;

export type CreatePlaySessionMutation = {
  __typename?: "Mutation";
  playSessionCreate: string;
};

export type RefreshPlaySessionMutationVariables = Exact<{
  playSessionId: Scalars["String"];
}>;

export type RefreshPlaySessionMutation = {
  __typename?: "Mutation";
  playSessionRefresh: boolean;
};

export type CalculateChallengesProgressMutationVariables = Exact<{
  triggerType: AchievementTriggerType;
}>;

export type CalculateChallengesProgressMutation = {
  __typename?: "Mutation";
  calculateChallengesProgress: {
    __typename?: "ChallengeProgressResult";
    challengesProgressed: Array<{
      __typename?: "CalculatedChallengeProgress";
      challenge: {
        __typename?: "Challenge";
        id: string;
        title: string;
        startTime: any;
        endTime: any;
        achievement?: {
          __typename?: "Achievement";
          id: string;
          name: string;
          triggerType: AchievementTriggerType;
        } | null;
        badges: Array<{
          __typename?: "BadgeWithEarnedStatus";
          isEarned: boolean;
          badge: {
            __typename?: "Badge";
            id: string;
            name: string;
            amountToEarn: number;
            activeImageUrl?: string | null;
            inactiveImageUrl?: string | null;
          };
        }>;
        userProgress?: {
          __typename?: "UserProgressChallenge";
          achievementId: string;
          triggerType: AchievementTriggerType;
          currentBadgeProgress: number;
          currentBadge?: {
            __typename?: "Badge";
            id: string;
            name: string;
            amountToEarn: number;
            activeImageUrl?: string | null;
            inactiveImageUrl?: string | null;
          } | null;
          nextBadge?: {
            __typename?: "Badge";
            id: string;
            name: string;
            amountToEarn: number;
            activeImageUrl?: string | null;
            inactiveImageUrl?: string | null;
          } | null;
        } | null;
      };
    }>;
    newlyEarnedBadges: Array<{
      __typename?: "UserBadge";
      badge: {
        __typename?: "Badge";
        id: string;
        name: string;
        activeImageUrl?: string | null;
        achievement: {
          __typename?: "Achievement";
          challenge?: { __typename?: "Challenge"; id: string } | null;
        };
      };
    }>;
  };
};

export type GetNotificationsQueryVariables = Exact<{
  pagination: ConnectionArgs;
}>;

export type GetNotificationsQuery = {
  __typename?: "Query";
  me?: {
    __typename?: "User";
    id: string;
    notifications: {
      __typename?: "NotificationConnection";
      totalCount: number;
      pageInfo: {
        __typename?: "PageInfo";
        hasNextPage: boolean;
        endCursor?: string | null;
      };
      edges: Array<{
        __typename?: "NotificationEdge";
        cursor: string;
        node: {
          __typename?: "Notification";
          id: string;
          header: string;
          message: string;
          timeSince: string;
          seen: boolean;
          sourceType: NotificationSourceType;
          sourceParamsCSV: string;
          senderProfile?: {
            __typename?: "UserProfile";
            id: string;
            uid?: string | null;
            username?: string | null;
            photoURL?: string | null;
          } | null;
        };
      }>;
    };
  } | null;
};

export type HasNewNotificationsQueryVariables = Exact<{ [key: string]: never }>;

export type HasNewNotificationsQuery = {
  __typename?: "Query";
  me?: { __typename?: "User"; id: string; hasNewNotifications: boolean } | null;
};

export type VideoUploadByIdPublicQueryVariables = Exact<{
  videoId: Scalars["String"];
}>;

export type VideoUploadByIdPublicQuery = {
  __typename?: "Query";
  videoUploadByIdPublic: {
    __typename?: "VideoUpload";
    id: string;
    isAuthoredByMe: boolean;
    reportedByMe: boolean;
    description?: string | null;
    thumbnailUrl?: string | null;
    playbackUrl?: string | null;
    encodingStatus: VideoEncodingStatus;
    userReactions?: Array<UserReactionType> | null;
    uploadedAt?: any | null;
    reactions: Array<{
      __typename?: "ActivityReactionsCount";
      reactionType: UserReactionType;
      totalCount: number;
    }>;
    uploadedBy: {
      __typename?: "UserProfile";
      id: string;
      uid?: string | null;
      username?: string | null;
    };
    studioClass?: {
      __typename?: "StudioClass";
      id: string;
      classId: number;
      title: string;
      free: boolean;
    } | null;
  };
};

export type GetClassByIdForPreviewModalQueryVariables = Exact<{
  classId: Scalars["String"];
}>;

export type GetClassByIdForPreviewModalQuery = {
  __typename?: "Query";
  classById: {
    __typename?: "Class";
    id: string;
    studioClassId: string;
    duration: string;
    duration_in_seconds: number;
    isFree: boolean;
    isSaved?: boolean | null;
    level?: string | null;
    preview_url: string;
    slug: string;
    style?: string | null;
    title: string;
    type: string;
    instructor?: {
      __typename?: "Instructor";
      name: string;
      slug: string;
    } | null;
    tracks: Array<{
      __typename?: "StudioClassTrack";
      startsAt: number;
      track: {
        __typename?: "Track";
        id: string;
        title?: string | null;
        artists: Array<string>;
        albumName?: string | null;
        image?: string | null;
        isExplicit: boolean;
        label?: string | null;
      };
    }>;
  };
};

export type GetNotificationPreferencesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetNotificationPreferencesQuery = {
  __typename?: "Query";
  me?: {
    __typename?: "User";
    id: string;
    notificationPreferences: Array<{
      __typename?: "NotificationPreference";
      id: string;
      source: NotificationSourcePreference;
      enabled: boolean;
      allowAll: boolean;
    }>;
  } | null;
};

export type UpdateUserNotificationPreferenceMutationVariables = Exact<{
  input: UserNotificationPreferenceUpdateInput;
}>;

export type UpdateUserNotificationPreferenceMutation = {
  __typename?: "Mutation";
  userNotificationPreferenceUpdate: {
    __typename?: "NotificationPreference";
    id: string;
    source: NotificationSourcePreference;
    enabled: boolean;
    allowAll: boolean;
  };
};

export type SubscriptionSwitchPlanMutationVariables = Exact<{
  subscriptionId: Scalars["String"];
  planId: Scalars["String"];
}>;

export type SubscriptionSwitchPlanMutation = {
  __typename?: "Mutation";
  subscriptionSwitchPlan: { __typename?: "Subscription"; id: string };
};

export type SubscriptionRemoveScheduledChangesMutationVariables = Exact<{
  subscriptionId: Scalars["String"];
}>;

export type SubscriptionRemoveScheduledChangesMutation = {
  __typename?: "Mutation";
  subscriptionRemoveScheduledChanges: {
    __typename?: "Subscription";
    id: string;
  };
};

export type UserCheckUsernameMutationVariables = Exact<{
  input: UserCheckUsernameInput;
}>;

export type UserCheckUsernameMutation = {
  __typename?: "Mutation";
  userCheckUsername: {
    __typename?: "UserUsername";
    username?: string | null;
    exists?: boolean | null;
  };
};

export type UserUpdateUsernameMutationVariables = Exact<{
  input: UserUpdateUsernameInput;
}>;

export type UserUpdateUsernameMutation = {
  __typename?: "Mutation";
  userUpdateUsername: { __typename?: "UserUsername"; username?: string | null };
};

export type UpdateUserNameMutationVariables = Exact<{
  input: UserNameInput;
}>;

export type UpdateUserNameMutation = {
  __typename?: "Mutation";
  userUpdateName: {
    __typename?: "User";
    id: string;
    uid: string;
    name?: string | null;
  };
};

export type GetChallengesQueryVariables = Exact<{ [key: string]: never }>;

export type GetChallengesQuery = {
  __typename?: "Query";
  challengesPromoted: Array<{
    __typename?: "Challenge";
    id: string;
    title: string;
    startTime: any;
    endTime: any;
    achievement?: {
      __typename?: "Achievement";
      id: string;
      name: string;
      triggerType: AchievementTriggerType;
    } | null;
    badges: Array<{
      __typename?: "BadgeWithEarnedStatus";
      isEarned: boolean;
      badge: {
        __typename?: "Badge";
        id: string;
        name: string;
        amountToEarn: number;
        activeImageUrl?: string | null;
        inactiveImageUrl?: string | null;
      };
    }>;
    userProgress?: {
      __typename?: "UserProgressChallenge";
      achievementId: string;
      triggerType: AchievementTriggerType;
      currentBadgeProgress: number;
      currentBadge?: {
        __typename?: "Badge";
        id: string;
        name: string;
        amountToEarn: number;
        activeImageUrl?: string | null;
        inactiveImageUrl?: string | null;
      } | null;
      nextBadge?: {
        __typename?: "Badge";
        id: string;
        name: string;
        amountToEarn: number;
        activeImageUrl?: string | null;
        inactiveImageUrl?: string | null;
      } | null;
    } | null;
  }>;
};

export type CreateSubscriptionMutationVariables = Exact<{
  planInfo: PlanInfoInput;
  gateway: GatewayInput;
  paymentMethodType: PaymentMethodType;
  trialOverrideTime?: InputMaybe<Scalars["Timestamp"]>;
  couponIds?: InputMaybe<Array<Scalars["String"]> | Scalars["String"]>;
  ipInfo?: InputMaybe<IpInfoInput>;
}>;

export type CreateSubscriptionMutation = {
  __typename?: "Mutation";
  subscriptionCreate: {
    __typename?: "Subscription";
    trialEndTime?: number | null;
    id: string;
    isActive: boolean;
    isCancelable: boolean;
    isReactivatableV2: boolean;
    isPauseScheduled: boolean;
    isPastDue: boolean;
    nextBillingAt?: number | null;
    status: SubscriptionStatus;
    currentTermEnd?: number | null;
    cancelationTime?: number | null;
    pauseTime?: number | null;
    resumeTime?: number | null;
    plan: {
      __typename?: "Plan";
      trialPeriod?: number | null;
      periodUnit?: BillingPeriodUnit | null;
      priceInCents?: number | null;
      id: string;
      name: string;
      currencyCode?: string | null;
      provider: { __typename?: "ProviderInfo"; id: string };
    };
    user: {
      __typename?: "User";
      id: string;
      uid: string;
      isActive: boolean;
      hasTrialed: boolean;
    };
    provider: { __typename?: "ProviderInfo"; id: string };
  };
};

export type SubscriptionFieldsFragment = {
  __typename?: "Subscription";
  id: string;
  isActive: boolean;
  isCancelable: boolean;
  isReactivatableV2: boolean;
  isPauseScheduled: boolean;
  isPastDue: boolean;
  nextBillingAt?: number | null;
  status: SubscriptionStatus;
  trialEndTime?: number | null;
  currentTermEnd?: number | null;
  cancelationTime?: number | null;
  pauseTime?: number | null;
  resumeTime?: number | null;
  provider: { __typename?: "ProviderInfo"; id: string };
};

export type PlanFieldsFragment = {
  __typename?: "Plan";
  id: string;
  name: string;
  currencyCode?: string | null;
};

export type PlansQueryVariables = Exact<{
  providerName: SubscriptionProvider;
  countryCode: Scalars["String"];
}>;

export type PlansQuery = {
  __typename?: "Query";
  plans: Array<{
    __typename?: "Plan";
    id: string;
    name: string;
    currencyCode?: string | null;
    accessType: AccessType;
    isBestValue: boolean;
    isSubscribed: boolean;
    monthlySavingsInPercent: number;
    monthlyCostInCents?: number | null;
    annualSavingsInCents: number;
    period: number;
    periodUnit?: BillingPeriodUnit | null;
    trialPeriod?: number | null;
    trialPeriodUnit?: BillingPeriodUnit | null;
    priceInCents?: number | null;
    canTrial: boolean;
    trialEndTime?: number | null;
    nextBillingAt?: number | null;
    invoiceEstimate?: {
      __typename?: "SubscriptionInvoiceEstimate";
      amountDue?: number | null;
      creditsApplied?: number | null;
      total?: number | null;
      subTotal?: number | null;
    } | null;
    changePlanEstimate?: {
      __typename?: "ChangePlanEstimate";
      changePlanType: ChangePlanType;
      isEndOfTerm: boolean;
      invoiceEstimate?: {
        __typename?: "SubscriptionInvoiceEstimate";
        amountDue?: number | null;
        total?: number | null;
      } | null;
    } | null;
    provider: {
      __typename?: "ProviderInfo";
      id: string;
      name: SubscriptionProvider;
    };
  }>;
};

export type GetClassAndUserPostsByIdQueryVariables = Exact<{
  classId: Scalars["String"];
}>;

export type GetClassAndUserPostsByIdQuery = {
  __typename?: "Query";
  classById: {
    __typename?: "Class";
    id: string;
    slug: string;
    isExplicit?: boolean | null;
    title: string;
    level?: string | null;
    duration_in_seconds: number;
    type: string;
    style?: string | null;
    thumbnail?: string | null;
    instructor?: {
      __typename?: "Instructor";
      name: string;
      slug: string;
    } | null;
    progress?: {
      __typename?: "ClassProgress";
      completed?: string | null;
      time?: {
        __typename?: "Time";
        hour?: number | null;
        minute?: number | null;
        second?: number | null;
      } | null;
    } | null;
    userVideos: {
      __typename?: "VideoUploadConnection";
      edges: Array<{
        __typename?: "VideoUploadEdge";
        cursor: string;
        node: {
          __typename?: "VideoUpload";
          id: string;
          isAuthoredByMe: boolean;
          reportedByMe: boolean;
          description?: string | null;
          thumbnailUrl?: string | null;
          playbackUrl?: string | null;
          uploadedAt?: any | null;
          encodingStatus: VideoEncodingStatus;
          userReactions?: Array<UserReactionType> | null;
          uploadedBy: {
            __typename?: "UserProfile";
            id: string;
            uid?: string | null;
            username?: string | null;
          };
          reactions: Array<{
            __typename?: "ActivityReactionsCount";
            reactionType: UserReactionType;
            totalCount: number;
          }>;
        };
      }>;
    };
  };
};

export type CoreVideoUploadsPublishedFieldsFragment = {
  __typename?: "VideoUpload";
  id: string;
  isAuthoredByMe: boolean;
  reportedByMe: boolean;
  description?: string | null;
  thumbnailUrl?: string | null;
  playbackUrl?: string | null;
  encodingStatus: VideoEncodingStatus;
  userReactions?: Array<UserReactionType> | null;
  uploadedAt?: any | null;
  reactions: Array<{
    __typename?: "ActivityReactionsCount";
    reactionType: UserReactionType;
    totalCount: number;
  }>;
  uploadedBy: {
    __typename?: "UserProfile";
    id: string;
    uid?: string | null;
    username?: string | null;
  };
  studioClass?: {
    __typename?: "StudioClass";
    id: string;
    classId: number;
    title: string;
    free: boolean;
  } | null;
  comments?: {
    __typename?: "ActivityCommentConnection";
    totalCount: number;
  } | null;
};

export type VideoUploadsPublishedQueryVariables = Exact<{
  pagination: ConnectionArgs;
}>;

export type VideoUploadsPublishedQuery = {
  __typename?: "Query";
  videoUploadsPublished: {
    __typename?: "VideoUploadConnection";
    pageInfo: {
      __typename?: "PageInfo";
      hasNextPage: boolean;
      endCursor?: string | null;
    };
    edges: Array<{
      __typename?: "VideoUploadEdge";
      node: {
        __typename?: "VideoUpload";
        id: string;
        isAuthoredByMe: boolean;
        reportedByMe: boolean;
        description?: string | null;
        thumbnailUrl?: string | null;
        playbackUrl?: string | null;
        encodingStatus: VideoEncodingStatus;
        userReactions?: Array<UserReactionType> | null;
        uploadedAt?: any | null;
        reactions: Array<{
          __typename?: "ActivityReactionsCount";
          reactionType: UserReactionType;
          totalCount: number;
        }>;
        uploadedBy: {
          __typename?: "UserProfile";
          id: string;
          uid?: string | null;
          username?: string | null;
        };
        studioClass?: {
          __typename?: "StudioClass";
          id: string;
          classId: number;
          title: string;
          free: boolean;
        } | null;
        comments?: {
          __typename?: "ActivityCommentConnection";
          totalCount: number;
        } | null;
      };
    }>;
  };
};

export type GetPersonalizedPlaylistQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetPersonalizedPlaylistQuery = {
  __typename?: "Query";
  myPersonalizedPlaylist?: {
    __typename?: "User";
    id: string;
    personalizedPlaylist?: Array<{
      __typename?: "Class";
      id: string;
      studioClassId: string;
      accessType: AccessType;
      refId?: string | null;
      isUnlocked: boolean;
      isExplicit?: boolean | null;
      isFamilyFriendly: boolean;
      title: string;
      duration: string;
      style?: string | null;
      categories: Array<string>;
      thumbnail?: string | null;
      slug: string;
      type: string;
      level?: string | null;
      preview_url: string;
      duration_in_seconds: number;
      isFree: boolean;
      isSaved?: boolean | null;
      isPreviewVideoMuted?: boolean | null;
      externalPreviewUrl?: string | null;
      songs?: Array<{
        __typename?: "Song";
        title?: string | null;
        artist?: string | null;
        isExplicit?: boolean | null;
      } | null> | null;
      instructor?: {
        __typename?: "Instructor";
        name: string;
        slug: string;
      } | null;
      progress?: {
        __typename?: "ClassProgress";
        completed?: string | null;
        started?: string | null;
        time?: {
          __typename?: "Time";
          hour?: number | null;
          minute?: number | null;
          second?: number | null;
        } | null;
      } | null;
      tracks: Array<{
        __typename?: "StudioClassTrack";
        startsAt: number;
        track: {
          __typename?: "Track";
          trackId?: string | null;
          title?: string | null;
          artists: Array<string>;
          albumName?: string | null;
          image?: string | null;
          isExplicit: boolean;
          label?: string | null;
          copyright?: string | null;
          releaseDate?: string | null;
          isrc: string;
          source: TrackSource;
          appleMusic?: string | null;
          spotify?: string | null;
          youtube?: string | null;
        };
      }>;
    }> | null;
  } | null;
};

export type GetPromotedChallengesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetPromotedChallengesQuery = {
  __typename?: "Query";
  challengesPromoted: Array<{
    __typename?: "Challenge";
    id: string;
    title: string;
    startTime: any;
    endTime: any;
    achievement?: {
      __typename?: "Achievement";
      id: string;
      name: string;
      triggerType: AchievementTriggerType;
    } | null;
    badges: Array<{
      __typename?: "BadgeWithEarnedStatus";
      isEarned: boolean;
      badge: {
        __typename?: "Badge";
        id: string;
        name: string;
        amountToEarn: number;
        activeImageUrl?: string | null;
        inactiveImageUrl?: string | null;
      };
    }>;
    userProgress?: {
      __typename?: "UserProgressChallenge";
      achievementId: string;
      triggerType: AchievementTriggerType;
      currentBadgeProgress: number;
      currentBadge?: {
        __typename?: "Badge";
        id: string;
        name: string;
        amountToEarn: number;
        activeImageUrl?: string | null;
        inactiveImageUrl?: string | null;
      } | null;
      nextBadge?: {
        __typename?: "Badge";
        id: string;
        name: string;
        amountToEarn: number;
        activeImageUrl?: string | null;
        inactiveImageUrl?: string | null;
      } | null;
    } | null;
  }>;
};

export type GetChallengeDetailsQueryVariables = Exact<{
  challengeId: Scalars["String"];
}>;

export type GetChallengeDetailsQuery = {
  __typename?: "Query";
  challengeById?: {
    __typename?: "Challenge";
    id: string;
    title: string;
    description?: string | null;
    thumbnailImageUrl?: string | null;
    startTime: any;
    endTime: any;
    achievement?: {
      __typename?: "Achievement";
      id: string;
      triggerType: AchievementTriggerType;
      requiredPublishedStudioClasses?: Array<{
        __typename?: "StudioClass";
        id: string;
        classId: number;
        title: string;
        thumbnailImageUrl?: string | null;
        level?: string | null;
        type?: string | null;
        accessType?: AccessType | null;
        instructor?: {
          __typename?: "ClassInstructor";
          name?: string | null;
        } | null;
        video: { __typename?: "ClassVideo"; durationInMs?: string | null };
        userProgress: {
          __typename?: "UserClassProgress";
          completed: boolean;
          percent: number;
          time: {
            __typename?: "TimeV2";
            hour: number;
            minute: number;
            second: number;
          };
        };
      }> | null;
    } | null;
    badges: Array<{
      __typename?: "BadgeWithEarnedStatus";
      isEarned: boolean;
      badge: {
        __typename?: "Badge";
        activeImageUrl?: string | null;
        inactiveImageUrl?: string | null;
        amountToEarn: number;
        name: string;
        id: string;
        description?: string | null;
        achievement: {
          __typename?: "Achievement";
          id: string;
          triggerType: AchievementTriggerType;
        };
      };
    }>;
    displayText?: {
      __typename?: "ChallengeDisplayText";
      goalHeader?: string | null;
      subtitleHeader?: string | null;
      earnedByHeader?: string | null;
    } | null;
  } | null;
};

export type FeaturedPlaylistFragment = {
  __typename?: "PlaylistV2";
  id: string;
  name: string;
  thumbnailImageUrl?: string | null;
  isSaved: boolean;
};

export type FeaturedClassFragment = {
  __typename?: "Class";
  id: string;
  accessType: AccessType;
  refId?: string | null;
  slug: string;
  type: string;
  isUnlocked: boolean;
  isExplicit?: boolean | null;
  title: string;
  duration: string;
  duration_in_seconds: number;
  style?: string | null;
  level?: string | null;
  preview_url: string;
  isFree: boolean;
  isPreviewVideoMuted?: boolean | null;
  externalPreviewUrl?: string | null;
  instructor?: { __typename?: "Instructor"; name: string; slug: string } | null;
  progress?: {
    __typename?: "ClassProgress";
    completed?: string | null;
    time?: {
      __typename?: "Time";
      hour?: number | null;
      minute?: number | null;
      second?: number | null;
    } | null;
  } | null;
};

export type GetHomeDataQueryVariables = Exact<{
  date: Scalars["String"];
}>;

export type GetHomeDataQuery = {
  __typename?: "Query";
  todaysPlaylist?: {
    __typename?: "Playlist";
    classes?: Array<{
      __typename?: "PlaylistClass";
      id: string;
      playlistId?: string | null;
      refId?: string | null;
      isUnlocked: boolean;
      isExplicit?: boolean | null;
      title: string;
      duration: string;
      style?: string | null;
      categories: Array<string>;
      thumbnail?: string | null;
      slug: string;
      type: string;
      level?: string | null;
      preview_url: string;
      duration_in_seconds: number;
      isFree: boolean;
      isSaved?: boolean | null;
      songs?: Array<{
        __typename?: "Song";
        title?: string | null;
        artist?: string | null;
        isExplicit?: boolean | null;
      } | null> | null;
      instructor?: {
        __typename?: "Instructor";
        name: string;
        slug: string;
      } | null;
      progress?: {
        __typename?: "PlaylistClassProgress";
        completed?: string | null;
      } | null;
      tracks: Array<{
        __typename?: "StudioClassTrack";
        startsAt: number;
        track: {
          __typename?: "Track";
          trackId?: string | null;
          title?: string | null;
          artists: Array<string>;
          albumName?: string | null;
          image?: string | null;
          isExplicit: boolean;
          label?: string | null;
          copyright?: string | null;
          releaseDate?: string | null;
          isrc: string;
          source: TrackSource;
          appleMusic?: string | null;
          spotify?: string | null;
          youtube?: string | null;
        };
      }>;
    } | null> | null;
  } | null;
  continueDancing: {
    __typename?: "SavedOrHistoryDataConnectionV2";
    classes: Array<{
      __typename?: "ClassProgramV2Edge";
      class:
        | {
            __typename?: "Class";
            id: string;
            studioClassId: string;
            accessType: AccessType;
            refId?: string | null;
            isUnlocked: boolean;
            isExplicit?: boolean | null;
            isFamilyFriendly: boolean;
            title: string;
            duration: string;
            style?: string | null;
            categories: Array<string>;
            thumbnail?: string | null;
            slug: string;
            type: string;
            level?: string | null;
            preview_url: string;
            duration_in_seconds: number;
            isFree: boolean;
            isSaved?: boolean | null;
            isPreviewVideoMuted?: boolean | null;
            externalPreviewUrl?: string | null;
            songs?: Array<{
              __typename?: "Song";
              title?: string | null;
              artist?: string | null;
              isExplicit?: boolean | null;
            } | null> | null;
            instructor?: {
              __typename?: "Instructor";
              name: string;
              slug: string;
            } | null;
            progress?: {
              __typename?: "ClassProgress";
              completed?: string | null;
              started?: string | null;
              time?: {
                __typename?: "Time";
                hour?: number | null;
                minute?: number | null;
                second?: number | null;
              } | null;
            } | null;
            tracks: Array<{
              __typename?: "StudioClassTrack";
              startsAt: number;
              track: {
                __typename?: "Track";
                trackId?: string | null;
                title?: string | null;
                artists: Array<string>;
                albumName?: string | null;
                image?: string | null;
                isExplicit: boolean;
                label?: string | null;
                copyright?: string | null;
                releaseDate?: string | null;
                isrc: string;
                source: TrackSource;
                appleMusic?: string | null;
                spotify?: string | null;
                youtube?: string | null;
              };
            }>;
          }
        | { __typename?: "ProgramV2"; programSlug: string };
    }>;
  };
  dancePrograms: {
    __typename?: "SearchProgramsV2Connection";
    programs: Array<{
      __typename?: "ProgramV2";
      totalClassesCount?: number | null;
      level?: string | null;
      slug: string;
      style?: string | null;
      title?: string | null;
      categories: Array<string>;
      isFree?: boolean | null;
      isSaved?: boolean | null;
      progress?: {
        __typename?: "ProgramProgressV2";
        completedClassesCount?: number | null;
      } | null;
      content?: {
        __typename?: "ProgramOverview";
        assets?: {
          __typename?: "ProgramAssets";
          thumbnailURL?: string | null;
        } | null;
      } | null;
      instructor?: {
        __typename?: "Instructor";
        name: string;
        slug: string;
      } | null;
    }>;
  };
  savedClasses: {
    __typename?: "SavedOrHistoryDataConnectionV2";
    classes: Array<{
      __typename?: "ClassProgramV2Edge";
      class:
        | {
            __typename?: "Class";
            id: string;
            studioClassId: string;
            accessType: AccessType;
            refId?: string | null;
            isUnlocked: boolean;
            isExplicit?: boolean | null;
            isFamilyFriendly: boolean;
            title: string;
            duration: string;
            style?: string | null;
            categories: Array<string>;
            thumbnail?: string | null;
            slug: string;
            type: string;
            level?: string | null;
            preview_url: string;
            duration_in_seconds: number;
            isFree: boolean;
            isSaved?: boolean | null;
            isPreviewVideoMuted?: boolean | null;
            externalPreviewUrl?: string | null;
            songs?: Array<{
              __typename?: "Song";
              title?: string | null;
              artist?: string | null;
              isExplicit?: boolean | null;
            } | null> | null;
            instructor?: {
              __typename?: "Instructor";
              name: string;
              slug: string;
            } | null;
            progress?: {
              __typename?: "ClassProgress";
              completed?: string | null;
              started?: string | null;
              time?: {
                __typename?: "Time";
                hour?: number | null;
                minute?: number | null;
                second?: number | null;
              } | null;
            } | null;
            tracks: Array<{
              __typename?: "StudioClassTrack";
              startsAt: number;
              track: {
                __typename?: "Track";
                trackId?: string | null;
                title?: string | null;
                artists: Array<string>;
                albumName?: string | null;
                image?: string | null;
                isExplicit: boolean;
                label?: string | null;
                copyright?: string | null;
                releaseDate?: string | null;
                isrc: string;
                source: TrackSource;
                appleMusic?: string | null;
                spotify?: string | null;
                youtube?: string | null;
              };
            }>;
          }
        | { __typename?: "ProgramV2" };
    }>;
  };
};

export type GetFeaturedContentQueryVariables = Exact<{ [key: string]: never }>;

export type GetFeaturedContentQuery = {
  __typename?: "Query";
  featuredClasses: Array<{
    __typename?: "FeaturedContent";
    sortIndex: number;
    content: {
      __typename?: "Class";
      id: string;
      accessType: AccessType;
      refId?: string | null;
      slug: string;
      type: string;
      isUnlocked: boolean;
      isExplicit?: boolean | null;
      title: string;
      duration: string;
      duration_in_seconds: number;
      style?: string | null;
      level?: string | null;
      preview_url: string;
      isFree: boolean;
      isPreviewVideoMuted?: boolean | null;
      externalPreviewUrl?: string | null;
      instructor?: {
        __typename?: "Instructor";
        name: string;
        slug: string;
      } | null;
      progress?: {
        __typename?: "ClassProgress";
        completed?: string | null;
        time?: {
          __typename?: "Time";
          hour?: number | null;
          minute?: number | null;
          second?: number | null;
        } | null;
      } | null;
    };
  }>;
  featuredPlaylists: Array<{
    __typename?: "PlaylistV2";
    id: string;
    name: string;
    thumbnailImageUrl?: string | null;
    isSaved: boolean;
  }>;
};

export type GetPreferredCategoriesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetPreferredCategoriesQuery = {
  __typename?: "Query";
  preferredCategories?: {
    __typename?: "User";
    id: string;
    preferred?: {
      __typename?: "PreferredContent";
      categories: Array<{
        __typename?: "PreferredCategory";
        slug: string;
        name: string;
        classes: Array<{
          __typename?: "Class";
          id: string;
          studioClassId: string;
          accessType: AccessType;
          refId?: string | null;
          isUnlocked: boolean;
          isExplicit?: boolean | null;
          isFamilyFriendly: boolean;
          title: string;
          duration: string;
          style?: string | null;
          categories: Array<string>;
          thumbnail?: string | null;
          slug: string;
          type: string;
          level?: string | null;
          preview_url: string;
          duration_in_seconds: number;
          isFree: boolean;
          isSaved?: boolean | null;
          isPreviewVideoMuted?: boolean | null;
          externalPreviewUrl?: string | null;
          songs?: Array<{
            __typename?: "Song";
            title?: string | null;
            artist?: string | null;
            isExplicit?: boolean | null;
          } | null> | null;
          instructor?: {
            __typename?: "Instructor";
            name: string;
            slug: string;
          } | null;
          progress?: {
            __typename?: "ClassProgress";
            completed?: string | null;
            started?: string | null;
            time?: {
              __typename?: "Time";
              hour?: number | null;
              minute?: number | null;
              second?: number | null;
            } | null;
          } | null;
          tracks: Array<{
            __typename?: "StudioClassTrack";
            startsAt: number;
            track: {
              __typename?: "Track";
              trackId?: string | null;
              title?: string | null;
              artists: Array<string>;
              albumName?: string | null;
              image?: string | null;
              isExplicit: boolean;
              label?: string | null;
              copyright?: string | null;
              releaseDate?: string | null;
              isrc: string;
              source: TrackSource;
              appleMusic?: string | null;
              spotify?: string | null;
              youtube?: string | null;
            };
          }>;
        }>;
      }>;
    } | null;
  } | null;
};

export type SearchClassesForDashboardQueryVariables = Exact<{
  filters: Scalars["String"];
}>;

export type SearchClassesForDashboardQuery = {
  __typename?: "Query";
  classesForDashboard: {
    __typename?: "AlgoliaClassesConnection";
    classes: Array<{
      __typename?: "ClassEdge";
      class: {
        __typename?: "Class";
        id: string;
        studioClassId: string;
        accessType: AccessType;
        refId?: string | null;
        isUnlocked: boolean;
        isExplicit?: boolean | null;
        isFamilyFriendly: boolean;
        title: string;
        duration: string;
        style?: string | null;
        categories: Array<string>;
        thumbnail?: string | null;
        slug: string;
        type: string;
        level?: string | null;
        preview_url: string;
        duration_in_seconds: number;
        isFree: boolean;
        isSaved?: boolean | null;
        isPreviewVideoMuted?: boolean | null;
        externalPreviewUrl?: string | null;
        songs?: Array<{
          __typename?: "Song";
          title?: string | null;
          artist?: string | null;
          isExplicit?: boolean | null;
        } | null> | null;
        instructor?: {
          __typename?: "Instructor";
          name: string;
          slug: string;
        } | null;
        progress?: {
          __typename?: "ClassProgress";
          completed?: string | null;
          started?: string | null;
          time?: {
            __typename?: "Time";
            hour?: number | null;
            minute?: number | null;
            second?: number | null;
          } | null;
        } | null;
        tracks: Array<{
          __typename?: "StudioClassTrack";
          startsAt: number;
          track: {
            __typename?: "Track";
            trackId?: string | null;
            title?: string | null;
            artists: Array<string>;
            albumName?: string | null;
            image?: string | null;
            isExplicit: boolean;
            label?: string | null;
            copyright?: string | null;
            releaseDate?: string | null;
            isrc: string;
            source: TrackSource;
            appleMusic?: string | null;
            spotify?: string | null;
            youtube?: string | null;
          };
        }>;
      };
    }>;
  };
};

export type CreateRecommendedSchedulePlaylistV2MutationVariables = Exact<{
  date: Scalars["String"];
}>;

export type CreateRecommendedSchedulePlaylistV2Mutation = {
  __typename?: "Mutation";
  createRecommendedSchedulePlaylistV2?: {
    __typename?: "Playlist";
    id?: string | null;
  } | null;
};

export type ProgramHistoryDataQueryVariables = Exact<{
  input?: InputMaybe<HistoryV3Input>;
}>;

export type ProgramHistoryDataQuery = {
  __typename?: "Query";
  programHistoryData: {
    __typename?: "SavedOrHistoryDataConnectionV2";
    pageInfo: {
      __typename?: "PageInfo";
      endCursor?: string | null;
      hasNextPage: boolean;
    };
    edges: Array<{
      __typename?: "ClassProgramV2Edge";
      node:
        | { __typename: "Class" }
        | {
            __typename: "ProgramV2";
            slug: string;
            progress?: {
              __typename?: "ProgramProgressV2";
              completedDate?: string | null;
            } | null;
          };
    }>;
  };
};

export type ClassHistoryDataQueryVariables = Exact<{
  input?: InputMaybe<HistoryV3Input>;
}>;

export type ClassHistoryDataQuery = {
  __typename?: "Query";
  classHistoryData: {
    __typename?: "SavedOrHistoryDataConnectionV2";
    pageInfo: {
      __typename?: "PageInfo";
      endCursor?: string | null;
      hasNextPage: boolean;
    };
    edges: Array<{
      __typename?: "ClassProgramV2Edge";
      node:
        | {
            __typename: "Class";
            accessType: AccessType;
            duration: string;
            duration_in_seconds: number;
            id: string;
            isFree: boolean;
            isPreviewVideoMuted?: boolean | null;
            externalPreviewUrl?: string | null;
            level?: string | null;
            preview_url: string;
            slug: string;
            style?: string | null;
            thumbnail?: string | null;
            title: string;
            type: string;
            categories: Array<string>;
            isExplicit?: boolean | null;
            instructor?: {
              __typename?: "Instructor";
              name: string;
              slug: string;
            } | null;
            progress?: {
              __typename?: "ClassProgress";
              completed?: string | null;
              time?: {
                __typename?: "Time";
                hour?: number | null;
                minute?: number | null;
                second?: number | null;
              } | null;
            } | null;
          }
        | { __typename: "ProgramV2" };
    }>;
  };
};

export type HistoryClassCardDataFragment = {
  __typename?: "Class";
  accessType: AccessType;
  duration: string;
  duration_in_seconds: number;
  id: string;
  isFree: boolean;
  isPreviewVideoMuted?: boolean | null;
  externalPreviewUrl?: string | null;
  level?: string | null;
  preview_url: string;
  slug: string;
  style?: string | null;
  thumbnail?: string | null;
  title: string;
  type: string;
  categories: Array<string>;
  isExplicit?: boolean | null;
  instructor?: { __typename?: "Instructor"; name: string; slug: string } | null;
  progress?: {
    __typename?: "ClassProgress";
    completed?: string | null;
    time?: {
      __typename?: "Time";
      hour?: number | null;
      minute?: number | null;
      second?: number | null;
    } | null;
  } | null;
};

export type GetInstructorProfileBySlugQueryVariables = Exact<{
  slug: Scalars["String"];
}>;

export type GetInstructorProfileBySlugQuery = {
  __typename?: "Query";
  instructorBySlugPublic?: {
    __typename?: "ClassInstructor";
    id: string;
    name?: string | null;
    bio?: string | null;
    slug: string;
    credits?: Array<string> | null;
    avatarImageUrl?: string | null;
    profileImageUrl?: string | null;
    location?: string | null;
    youtube?: string | null;
    facebook?: string | null;
    instagram?: string | null;
    twitter?: string | null;
    userProfile?: {
      __typename?: "UserProfile";
      id: string;
      username?: string | null;
      photoURL?: string | null;
    } | null;
  } | null;
};

export type IsPlaylistSavedFragment = {
  __typename?: "PlaylistV2";
  isSaved: boolean;
};

export type CorePlaylistV2FieldsFragment = {
  __typename?: "PlaylistV2";
  hidden: boolean;
  id: string;
  isSaved: boolean;
  name: string;
  thumbnailImageUrl?: string | null;
  owner?: {
    __typename?: "PlaylistOwner";
    id: string;
    uid?: string | null;
    username?: string | null;
    isMe: boolean;
  } | null;
};

export type CorePlaylistStudioClassFieldsFragment = {
  __typename?: "StudioClass";
  classId: number;
  id: string;
  isExplicit: boolean;
  level?: string | null;
  thumbnailImageUrl?: string | null;
  title: string;
  type?: string | null;
  accessType?: AccessType | null;
  instructor?: {
    __typename?: "ClassInstructor";
    name?: string | null;
    slug: string;
  } | null;
  previewVideo: {
    __typename?: "ClassVideo";
    id: string;
    hlsPlaybackUrls?: {
      __typename?: "VideoPlaybackResponse";
      defaultUrl: string;
    } | null;
  };
  userProgress: {
    __typename?: "UserClassProgress";
    id: string;
    percent: number;
    completed: boolean;
    time: {
      __typename?: "TimeV2";
      hour: number;
      minute: number;
      second: number;
    };
  };
  styleV2?: { __typename?: "ClassStyle"; name: string; slug: string } | null;
  video: { __typename?: "ClassVideo"; durationInMs?: string | null };
};

export type CorePersonalizedPlaylistClassFieldsFragment = {
  __typename?: "Class";
  id: string;
  studioClassId: string;
  duration: string;
  duration_in_seconds: number;
  isExplicit?: boolean | null;
  isPreviewVideoMuted?: boolean | null;
  externalPreviewUrl?: string | null;
  level?: string | null;
  preview_url: string;
  style?: string | null;
  thumbnail?: string | null;
  title: string;
  type: string;
  instructor?: { __typename?: "Instructor"; name: string; slug: string } | null;
  progress?: {
    __typename?: "ClassProgress";
    completed?: string | null;
    time?: {
      __typename?: "Time";
      hour?: number | null;
      minute?: number | null;
      second?: number | null;
    } | null;
  } | null;
};

export type CorePageInfoFieldsFragment = {
  __typename?: "PageInfo";
  endCursor?: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  startCursor?: string | null;
};

export type CreatePlaylistMutationVariables = Exact<{
  input: PlaylistCreateInput;
}>;

export type CreatePlaylistMutation = {
  __typename?: "Mutation";
  playlistCreate: {
    __typename?: "PlaylistV2";
    hidden: boolean;
    id: string;
    isSaved: boolean;
    name: string;
    thumbnailImageUrl?: string | null;
    owner?: {
      __typename?: "PlaylistOwner";
      id: string;
      uid?: string | null;
      username?: string | null;
      isMe: boolean;
    } | null;
  };
};

export type EditPlaylistMutationVariables = Exact<{
  input: PlaylistUpdateDetailsInput;
}>;

export type EditPlaylistMutation = {
  __typename?: "Mutation";
  playlistUpdateDetails: {
    __typename?: "PlaylistV2";
    hidden: boolean;
    id: string;
    isSaved: boolean;
    name: string;
    thumbnailImageUrl?: string | null;
    owner?: {
      __typename?: "PlaylistOwner";
      id: string;
      uid?: string | null;
      username?: string | null;
      isMe: boolean;
    } | null;
  };
};

export type DeletePlaylistMutationVariables = Exact<{
  input: PlaylistDeleteInput;
}>;

export type DeletePlaylistMutation = {
  __typename?: "Mutation";
  playlistDelete: boolean;
};

export type SavePlaylistMutationVariables = Exact<{
  input: PlaylistSaveOrUnsaveInput;
}>;

export type SavePlaylistMutation = {
  __typename?: "Mutation";
  playlistSave: boolean;
};

export type UnsavePlaylistMutationVariables = Exact<{
  input: PlaylistSaveOrUnsaveInput;
}>;

export type UnsavePlaylistMutation = {
  __typename?: "Mutation";
  playlistUnsave: boolean;
};

export type PlaylistAddStudioClassMutationVariables = Exact<{
  input: PlaylistAddOrRemoveStudioClassInput;
}>;

export type PlaylistAddStudioClassMutation = {
  __typename?: "Mutation";
  playlistAddStudioClass: {
    __typename?: "PlaylistHasStudioClass";
    id: string;
    studioClassId: string;
    hasStudioClass: boolean;
  };
};

export type PlaylistRemoveStudioClassMutationVariables = Exact<{
  input: PlaylistAddOrRemoveStudioClassInput;
}>;

export type PlaylistRemoveStudioClassMutation = {
  __typename?: "Mutation";
  playlistRemoveStudioClass: {
    __typename?: "PlaylistHasStudioClass";
    id: string;
    studioClassId: string;
    hasStudioClass: boolean;
  };
};

export type GetMyPlaylistsQueryVariables = Exact<{
  pagination: ConnectionArgs;
  studioClassIds: Array<Scalars["String"]> | Scalars["String"];
}>;

export type GetMyPlaylistsQuery = {
  __typename?: "Query";
  me?: {
    __typename?: "User";
    id: string;
    myPlaylists: {
      __typename?: "PlaylistV2Connection";
      pageInfo: {
        __typename?: "PageInfo";
        endCursor?: string | null;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
        startCursor?: string | null;
      };
      edges: Array<{
        __typename?: "PlaylistV2Edge";
        node: {
          __typename?: "PlaylistV2";
          hidden: boolean;
          id: string;
          isSaved: boolean;
          name: string;
          thumbnailImageUrl?: string | null;
          hasStudioClasses: Array<{
            __typename?: "PlaylistHasStudioClass";
            id: string;
            studioClassId: string;
            hasStudioClass: boolean;
          }>;
          owner?: {
            __typename?: "PlaylistOwner";
            id: string;
            uid?: string | null;
            username?: string | null;
            isMe: boolean;
          } | null;
        };
      }>;
    };
  } | null;
};

export type GetSavedPlaylistsQueryVariables = Exact<{
  pagination: ConnectionArgs;
}>;

export type GetSavedPlaylistsQuery = {
  __typename?: "Query";
  me?: {
    __typename?: "User";
    id: string;
    savedPlaylists: {
      __typename?: "PlaylistV2Connection";
      pageInfo: {
        __typename?: "PageInfo";
        endCursor?: string | null;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
        startCursor?: string | null;
      };
      edges: Array<{
        __typename?: "PlaylistV2Edge";
        node: {
          __typename?: "PlaylistV2";
          hidden: boolean;
          id: string;
          isSaved: boolean;
          name: string;
          thumbnailImageUrl?: string | null;
          owner?: {
            __typename?: "PlaylistOwner";
            id: string;
            uid?: string | null;
            username?: string | null;
            isMe: boolean;
          } | null;
        };
      }>;
    };
  } | null;
};

export type GetPlaylistsSteezyQueryVariables = Exact<{
  pagination: ConnectionArgs;
}>;

export type GetPlaylistsSteezyQuery = {
  __typename?: "Query";
  playlistsSteezy: {
    __typename?: "PlaylistV2Connection";
    pageInfo: {
      __typename?: "PageInfo";
      endCursor?: string | null;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor?: string | null;
    };
    edges: Array<{
      __typename?: "PlaylistV2Edge";
      node: {
        __typename?: "PlaylistV2";
        hidden: boolean;
        id: string;
        isSaved: boolean;
        name: string;
        thumbnailImageUrl?: string | null;
        owner?: {
          __typename?: "PlaylistOwner";
          id: string;
          uid?: string | null;
          username?: string | null;
          isMe: boolean;
        } | null;
      };
    }>;
  };
};

export type GetPersonalizedPlaylistForCreatedPageQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetPersonalizedPlaylistForCreatedPageQuery = {
  __typename?: "Query";
  myPersonalizedPlaylist?: {
    __typename?: "User";
    id: string;
    personalizedPlaylist?: Array<{
      __typename?: "Class";
      id: string;
      studioClassId: string;
      duration: string;
      duration_in_seconds: number;
      isExplicit?: boolean | null;
      isPreviewVideoMuted?: boolean | null;
      externalPreviewUrl?: string | null;
      level?: string | null;
      preview_url: string;
      style?: string | null;
      thumbnail?: string | null;
      title: string;
      type: string;
      instructor?: {
        __typename?: "Instructor";
        name: string;
        slug: string;
      } | null;
      progress?: {
        __typename?: "ClassProgress";
        completed?: string | null;
        time?: {
          __typename?: "Time";
          hour?: number | null;
          minute?: number | null;
          second?: number | null;
        } | null;
      } | null;
    }> | null;
  } | null;
};

export type GetPlaylistQueryVariables = Exact<{
  pagination: ConnectionArgs;
  playlistId: Scalars["String"];
  studioClassIds: Array<Scalars["String"]> | Scalars["String"];
}>;

export type GetPlaylistQuery = {
  __typename?: "Query";
  playlist: {
    __typename?: "PlaylistV2";
    hidden: boolean;
    id: string;
    isSaved: boolean;
    name: string;
    thumbnailImageUrl?: string | null;
    hasStudioClasses: Array<{
      __typename?: "PlaylistHasStudioClass";
      id: string;
      studioClassId: string;
      hasStudioClass: boolean;
    }>;
    studioClasses: {
      __typename?: "StudioClassConnection";
      totalCount: number;
      pageInfo: {
        __typename?: "PageInfo";
        endCursor?: string | null;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
        startCursor?: string | null;
      };
      edges: Array<{
        __typename?: "StudioClassEdge";
        node: {
          __typename?: "StudioClass";
          classId: number;
          id: string;
          isExplicit: boolean;
          level?: string | null;
          thumbnailImageUrl?: string | null;
          title: string;
          type?: string | null;
          accessType?: AccessType | null;
          instructor?: {
            __typename?: "ClassInstructor";
            name?: string | null;
            slug: string;
          } | null;
          previewVideo: {
            __typename?: "ClassVideo";
            id: string;
            hlsPlaybackUrls?: {
              __typename?: "VideoPlaybackResponse";
              defaultUrl: string;
            } | null;
          };
          userProgress: {
            __typename?: "UserClassProgress";
            id: string;
            percent: number;
            completed: boolean;
            time: {
              __typename?: "TimeV2";
              hour: number;
              minute: number;
              second: number;
            };
          };
          styleV2?: {
            __typename?: "ClassStyle";
            name: string;
            slug: string;
          } | null;
          video: { __typename?: "ClassVideo"; durationInMs?: string | null };
        };
      }>;
    };
    owner?: {
      __typename?: "PlaylistOwner";
      id: string;
      uid?: string | null;
      username?: string | null;
      isMe: boolean;
    } | null;
  };
};

export type GetPublicPlaylistDataQueryVariables = Exact<{
  playlistId: Scalars["String"];
}>;

export type GetPublicPlaylistDataQuery = {
  __typename?: "Query";
  playlist: {
    __typename?: "PlaylistV2";
    id: string;
    owner?: { __typename?: "PlaylistOwner"; id: string } | null;
  };
};

export type UserBadgeGroupFragment = {
  __typename?: "BadgeYearGroup";
  year: number;
  userBadges: Array<{
    __typename?: "UserBadge";
    earnedAt: any;
    badge: {
      __typename?: "Badge";
      activeImageUrl?: string | null;
      name: string;
      challenge?: {
        __typename?: "Challenge";
        title: string;
        id: string;
      } | null;
    };
  }>;
};

export type ProfileBadgeFragment = {
  __typename?: "UserBadge";
  earnedAt: any;
  badge: {
    __typename?: "Badge";
    activeImageUrl?: string | null;
    name: string;
    challenge?: { __typename?: "Challenge"; title: string; id: string } | null;
  };
};

export type GetUsersBadgesQueryVariables = Exact<{
  username: Scalars["String"];
}>;

export type GetUsersBadgesQuery = {
  __typename?: "Query";
  badgesByYear: Array<{
    __typename?: "BadgeYearGroup";
    year: number;
    userBadges: Array<{
      __typename?: "UserBadge";
      earnedAt: any;
      badge: {
        __typename?: "Badge";
        activeImageUrl?: string | null;
        name: string;
        challenge?: {
          __typename?: "Challenge";
          title: string;
          id: string;
        } | null;
      };
    }>;
  }>;
};

export type GetClassCompletedAchievementBadgesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetClassCompletedAchievementBadgesQuery = {
  __typename?: "Query";
  getClassCompletedAchievementBadges: {
    __typename?: "UserAchievement";
    earnedBadges: Array<{ __typename?: "UserBadge"; id: string }>;
    newBadges: Array<{ __typename?: "UserBadge"; id: string }>;
  };
};

export type InstructorStudioClassFragment = {
  __typename?: "StudioClass";
  id: string;
  classId: number;
  title: string;
  thumbnailImageUrl?: string | null;
  level?: string | null;
  type?: string | null;
  accessType?: AccessType | null;
  isExplicit: boolean;
  styleV2?: { __typename?: "ClassStyle"; name: string } | null;
  video: { __typename?: "ClassVideo"; durationInMs?: string | null };
  instructor?: {
    __typename?: "ClassInstructor";
    name?: string | null;
    slug: string;
  } | null;
  userProgress: {
    __typename?: "UserClassProgress";
    completed: boolean;
    percent: number;
    time: {
      __typename?: "TimeV2";
      hour: number;
      minute: number;
      second: number;
    };
  };
};

export type GetInstructorBySlugClassesQueryVariables = Exact<{
  instructorSlug: Scalars["String"];
  first?: InputMaybe<Scalars["Float"]>;
  after?: InputMaybe<Scalars["String"]>;
}>;

export type GetInstructorBySlugClassesQuery = {
  __typename?: "Query";
  instructorBySlugPublic?: {
    __typename?: "ClassInstructor";
    id: string;
    studioClasses: {
      __typename?: "StudioClassConnection";
      totalCount: number;
      edges: Array<{
        __typename?: "StudioClassEdge";
        node: {
          __typename?: "StudioClass";
          id: string;
          classId: number;
          title: string;
          thumbnailImageUrl?: string | null;
          level?: string | null;
          type?: string | null;
          accessType?: AccessType | null;
          isExplicit: boolean;
          styleV2?: { __typename?: "ClassStyle"; name: string } | null;
          video: { __typename?: "ClassVideo"; durationInMs?: string | null };
          instructor?: {
            __typename?: "ClassInstructor";
            name?: string | null;
            slug: string;
          } | null;
          userProgress: {
            __typename?: "UserClassProgress";
            completed: boolean;
            percent: number;
            time: {
              __typename?: "TimeV2";
              hour: number;
              minute: number;
              second: number;
            };
          };
        };
      }>;
      pageInfo: {
        __typename?: "PageInfo";
        hasNextPage: boolean;
        endCursor?: string | null;
      };
    };
  } | null;
};

export type UserProfileVideoUploadsFragment = {
  __typename?: "VideoUpload";
  id: string;
  description?: string | null;
  thumbnailUrl?: string | null;
  encodingStatus: VideoEncodingStatus;
  reportedByMe: boolean;
};

export type UserProfileWithVideosQueryVariables = Exact<{
  username: Scalars["String"];
  videoPagination: ConnectionArgs;
}>;

export type UserProfileWithVideosQuery = {
  __typename?: "Query";
  userProfileGetByUsername: {
    __typename?: "UserProfileWithVideos";
    id: string;
    isMe: boolean;
    name?: string | null;
    username?: string | null;
    uid?: string | null;
    photoURL?: string | null;
    totalLikesCount: number;
    bio?: string | null;
    instructorSlug?: string | null;
    links?: Array<{
      __typename?: "UserProfileLink";
      title?: string | null;
      url: string;
    }> | null;
    videoUploads: {
      __typename?: "VideoUploadConnection";
      totalCount: number;
      edges: Array<{
        __typename?: "VideoUploadEdge";
        cursor: string;
        node: {
          __typename?: "VideoUpload";
          id: string;
          description?: string | null;
          thumbnailUrl?: string | null;
          encodingStatus: VideoEncodingStatus;
          reportedByMe: boolean;
        };
      }>;
      pageInfo: {
        __typename?: "PageInfo";
        hasNextPage: boolean;
        endCursor?: string | null;
      };
    };
  };
};

export type GetSavedClassesQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]>;
  after?: InputMaybe<Scalars["String"]>;
}>;

export type GetSavedClassesQuery = {
  __typename?: "Query";
  savedClasses: {
    __typename?: "SavedOrHistoryDataConnectionV2";
    pageInfo: {
      __typename?: "PageInfo";
      hasNextPage: boolean;
      endCursor?: string | null;
    };
    edges: Array<{
      __typename?: "ClassProgramV2Edge";
      node:
        | {
            __typename?: "Class";
            id: string;
            studioClassId: string;
            accessType: AccessType;
            refId?: string | null;
            isUnlocked: boolean;
            isExplicit?: boolean | null;
            isFamilyFriendly: boolean;
            title: string;
            duration: string;
            style?: string | null;
            categories: Array<string>;
            thumbnail?: string | null;
            slug: string;
            type: string;
            level?: string | null;
            preview_url: string;
            duration_in_seconds: number;
            isFree: boolean;
            isSaved?: boolean | null;
            isPreviewVideoMuted?: boolean | null;
            externalPreviewUrl?: string | null;
            songs?: Array<{
              __typename?: "Song";
              title?: string | null;
              artist?: string | null;
              isExplicit?: boolean | null;
            } | null> | null;
            instructor?: {
              __typename?: "Instructor";
              name: string;
              slug: string;
            } | null;
            progress?: {
              __typename?: "ClassProgress";
              completed?: string | null;
              started?: string | null;
              time?: {
                __typename?: "Time";
                hour?: number | null;
                minute?: number | null;
                second?: number | null;
              } | null;
            } | null;
            tracks: Array<{
              __typename?: "StudioClassTrack";
              startsAt: number;
              track: {
                __typename?: "Track";
                trackId?: string | null;
                title?: string | null;
                artists: Array<string>;
                albumName?: string | null;
                image?: string | null;
                isExplicit: boolean;
                label?: string | null;
                copyright?: string | null;
                releaseDate?: string | null;
                isrc: string;
                source: TrackSource;
                appleMusic?: string | null;
                spotify?: string | null;
                youtube?: string | null;
              };
            }>;
          }
        | { __typename?: "ProgramV2" };
    }>;
  };
};

export type GetSavedProgramsQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]>;
  after?: InputMaybe<Scalars["String"]>;
}>;

export type GetSavedProgramsQuery = {
  __typename?: "Query";
  savedPrograms: {
    __typename?: "SavedOrHistoryDataConnectionV2";
    pageInfo: {
      __typename?: "PageInfo";
      hasNextPage: boolean;
      endCursor?: string | null;
    };
    edges: Array<{
      __typename?: "ClassProgramV2Edge";
      node:
        | { __typename?: "Class" }
        | { __typename?: "ProgramV2"; slug: string };
    }>;
  };
};

export type GetPersonalizedPlaylistForScheduleQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetPersonalizedPlaylistForScheduleQuery = {
  __typename?: "Query";
  myPersonalizedPlaylist?: {
    __typename?: "User";
    personalizedPlaylist?: Array<{
      __typename?: "Class";
      id: string;
      duration: string;
      thumbnail?: string | null;
      title: string;
      instructor?: { __typename?: "Instructor"; name: string } | null;
    }> | null;
  } | null;
};

export type ToggleSaveScheduleClassMutationVariables = Exact<{
  classId: Scalars["String"];
  willSave: Scalars["Boolean"];
}>;

export type ToggleSaveScheduleClassMutation = {
  __typename?: "Mutation";
  toggleSaveClass: {
    __typename?: "Class";
    id: string;
    refId?: string | null;
    isSaved?: boolean | null;
  };
};

export type GetCategoriesQueryVariables = Exact<{
  slugs: Array<Scalars["ID"]> | Scalars["ID"];
  filters?: InputMaybe<Array<CategoryFilter> | CategoryFilter>;
  goal?: InputMaybe<GoalType>;
}>;

export type GetCategoriesQuery = {
  __typename?: "Query";
  categories: Array<{
    __typename?: "Category";
    description?: string | null;
    isFollowing?: boolean | null;
    name: string;
    slug: string;
    previewThumbnailUrl?: string | null;
    previewVideoUrl?: string | null;
  }>;
};

export type GetCategoryQueryVariables = Exact<{
  slug: Scalars["ID"];
}>;

export type GetCategoryQuery = {
  __typename?: "Query";
  categories: Array<{
    __typename?: "Category";
    slug: string;
    name: string;
    programsV2: Array<{ __typename?: "ProgramV2"; slug: string }>;
  }>;
};

export type ChallengeFieldsFragment = {
  __typename?: "Challenge";
  id: string;
  title: string;
  description?: string | null;
  isActive: boolean;
  challengeStatus: ChallengeStatus;
  startTime: any;
  endTime: any;
  submissionsCount: number;
  userReactions?: Array<UserReactionType> | null;
  forClass?: {
    __typename?: "Class";
    id: string;
    title: string;
    isUnlocked: boolean;
    isFree: boolean;
    isSaved?: boolean | null;
    categories: Array<string>;
    duration: string;
    type: string;
    preview_url: string;
    thumbnail?: string | null;
    level?: string | null;
    style?: string | null;
    instructor?: {
      __typename?: "Instructor";
      name: string;
      slug: string;
    } | null;
  } | null;
  reactions: Array<{
    __typename?: "ActivityReactionsCount";
    reactionType: UserReactionType;
    totalCount: number;
  }>;
};

export type GetAvailableChallengesQueryVariables = Exact<{
  pagination: ConnectionArgs;
}>;

export type GetAvailableChallengesQuery = {
  __typename?: "Query";
  challengesAvailable: {
    __typename?: "ChallengeConnection";
    totalCount: number;
    edges: Array<{
      __typename?: "ChallengeEdge";
      cursor: string;
      node: {
        __typename?: "Challenge";
        id: string;
        title: string;
        description?: string | null;
        isActive: boolean;
        challengeStatus: ChallengeStatus;
        startTime: any;
        endTime: any;
        submissionsCount: number;
        userReactions?: Array<UserReactionType> | null;
        videos?: {
          __typename?: "VideoUploadConnection";
          totalCount: number;
          edges: Array<{
            __typename?: "VideoUploadEdge";
            cursor: string;
            node: {
              __typename?: "VideoUpload";
              id: string;
              isAuthoredByMe: boolean;
              reportedByMe: boolean;
              description?: string | null;
              thumbnailUrl?: string | null;
              playbackUrl?: string | null;
              uploadedAt?: any | null;
              uploadedBy: {
                __typename?: "UserProfile";
                id: string;
                uid?: string | null;
                username?: string | null;
              };
            };
          }>;
          pageInfo: {
            __typename?: "PageInfo";
            startCursor?: string | null;
            endCursor?: string | null;
            hasNextPage: boolean;
            hasPreviousPage: boolean;
          };
        } | null;
        forClass?: {
          __typename?: "Class";
          id: string;
          title: string;
          isUnlocked: boolean;
          isFree: boolean;
          isSaved?: boolean | null;
          categories: Array<string>;
          duration: string;
          type: string;
          preview_url: string;
          thumbnail?: string | null;
          level?: string | null;
          style?: string | null;
          instructor?: {
            __typename?: "Instructor";
            name: string;
            slug: string;
          } | null;
        } | null;
        reactions: Array<{
          __typename?: "ActivityReactionsCount";
          reactionType: UserReactionType;
          totalCount: number;
        }>;
      };
    }>;
    pageInfo: {
      __typename?: "PageInfo";
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    };
  };
};

export type CoreClassUserVideosFieldFragment = {
  __typename?: "VideoUpload";
  id: string;
  isAuthoredByMe: boolean;
  reportedByMe: boolean;
  description?: string | null;
  thumbnailUrl?: string | null;
  playbackUrl?: string | null;
  uploadedAt?: any | null;
  encodingStatus: VideoEncodingStatus;
  userReactions?: Array<UserReactionType> | null;
  uploadedBy: {
    __typename?: "UserProfile";
    id: string;
    uid?: string | null;
    username?: string | null;
  };
  reactions: Array<{
    __typename?: "ActivityReactionsCount";
    reactionType: UserReactionType;
    totalCount: number;
  }>;
};

export type GetClassByIdQueryVariables = Exact<{
  classId: Scalars["String"];
}>;

export type GetClassByIdQuery = {
  __typename?: "Query";
  classById: {
    __typename?: "Class";
    id: string;
    userVideos: {
      __typename?: "VideoUploadConnection";
      edges: Array<{
        __typename?: "VideoUploadEdge";
        cursor: string;
        node: {
          __typename?: "VideoUpload";
          id: string;
          isAuthoredByMe: boolean;
          reportedByMe: boolean;
          description?: string | null;
          thumbnailUrl?: string | null;
          playbackUrl?: string | null;
          uploadedAt?: any | null;
          encodingStatus: VideoEncodingStatus;
          userReactions?: Array<UserReactionType> | null;
          uploadedBy: {
            __typename?: "UserProfile";
            id: string;
            uid?: string | null;
            username?: string | null;
          };
          reactions: Array<{
            __typename?: "ActivityReactionsCount";
            reactionType: UserReactionType;
            totalCount: number;
          }>;
        };
      }>;
    };
  };
};

export type ActivityCommentFieldsFragment = {
  __typename?: "ActivityComment";
  id: string;
  body: string;
  createdAt: any;
  userReactions: Array<UserReactionType>;
  reportedByMe: boolean;
  reactions: Array<{
    __typename?: "ActivityReactionsCount";
    reactionType: UserReactionType;
    totalCount: number;
  }>;
  commentBy: {
    __typename?: "UserProfile";
    id: string;
    username?: string | null;
    photoURL?: string | null;
    uid?: string | null;
  };
};

export type ActivityCommentDeleteMutationVariables = Exact<{
  commentId: Scalars["String"];
}>;

export type ActivityCommentDeleteMutation = {
  __typename?: "Mutation";
  activityCommentDelete: boolean;
};

export type ActivityCommentCreateMutationVariables = Exact<{
  input: ActivityCommentCreateInput;
}>;

export type ActivityCommentCreateMutation = {
  __typename?: "Mutation";
  activityCommentCreate: {
    __typename?: "ActivityComment";
    id: string;
    body: string;
    createdAt: any;
    userReactions: Array<UserReactionType>;
    reportedByMe: boolean;
    reactions: Array<{
      __typename?: "ActivityReactionsCount";
      reactionType: UserReactionType;
      totalCount: number;
    }>;
    commentBy: {
      __typename?: "UserProfile";
      id: string;
      username?: string | null;
      photoURL?: string | null;
      uid?: string | null;
    };
  };
};

export type GetChallengeCommentsQueryVariables = Exact<{
  id: Scalars["String"];
  before?: InputMaybe<Scalars["String"]>;
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Float"]>;
  last?: InputMaybe<Scalars["Float"]>;
}>;

export type GetChallengeCommentsQuery = {
  __typename?: "Query";
  challengeById?: {
    __typename?: "Challenge";
    id: string;
    comments?: {
      __typename?: "ActivityCommentConnection";
      totalCount: number;
      edges: Array<{
        __typename?: "ActivityCommentEdge";
        cursor: string;
        node: {
          __typename?: "ActivityComment";
          id: string;
          body: string;
          createdAt: any;
          userReactions: Array<UserReactionType>;
          reportedByMe: boolean;
          reactions: Array<{
            __typename?: "ActivityReactionsCount";
            reactionType: UserReactionType;
            totalCount: number;
          }>;
          commentBy: {
            __typename?: "UserProfile";
            id: string;
            username?: string | null;
            photoURL?: string | null;
            uid?: string | null;
          };
        };
      }>;
      pageInfo: {
        __typename?: "PageInfo";
        startCursor?: string | null;
        endCursor?: string | null;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
      };
    } | null;
  } | null;
};

export type GetVideoUploadCommentsQueryVariables = Exact<{
  input: VideoUploadByIdInput;
  before?: InputMaybe<Scalars["String"]>;
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Float"]>;
  last?: InputMaybe<Scalars["Float"]>;
}>;

export type GetVideoUploadCommentsQuery = {
  __typename?: "Query";
  videoUploadByIdPublic: {
    __typename?: "VideoUpload";
    id: string;
    comments?: {
      __typename?: "ActivityCommentConnection";
      totalCount: number;
      edges: Array<{
        __typename?: "ActivityCommentEdge";
        cursor: string;
        node: {
          __typename?: "ActivityComment";
          id: string;
          body: string;
          createdAt: any;
          userReactions: Array<UserReactionType>;
          reportedByMe: boolean;
          reactions: Array<{
            __typename?: "ActivityReactionsCount";
            reactionType: UserReactionType;
            totalCount: number;
          }>;
          commentBy: {
            __typename?: "UserProfile";
            id: string;
            username?: string | null;
            photoURL?: string | null;
            uid?: string | null;
          };
        };
      }>;
      pageInfo: {
        __typename?: "PageInfo";
        startCursor?: string | null;
        endCursor?: string | null;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
      };
    } | null;
  };
};

export type GetCommentsRepliesQueryVariables = Exact<{
  id: Scalars["String"];
  before?: InputMaybe<Scalars["String"]>;
  after?: InputMaybe<Scalars["String"]>;
  first?: InputMaybe<Scalars["Float"]>;
  last?: InputMaybe<Scalars["Float"]>;
}>;

export type GetCommentsRepliesQuery = {
  __typename?: "Query";
  activityCommentById?: {
    __typename?: "ActivityComment";
    id: string;
    body: string;
    replies?: {
      __typename?: "ActivityCommentConnection";
      totalCount: number;
      edges: Array<{
        __typename?: "ActivityCommentEdge";
        cursor: string;
        node: {
          __typename?: "ActivityComment";
          id: string;
          body: string;
          createdAt: any;
          userReactions: Array<UserReactionType>;
          reportedByMe: boolean;
          reactions: Array<{
            __typename?: "ActivityReactionsCount";
            reactionType: UserReactionType;
            totalCount: number;
          }>;
          commentBy: {
            __typename?: "UserProfile";
            id: string;
            username?: string | null;
            photoURL?: string | null;
            uid?: string | null;
          };
        };
      }>;
      pageInfo: {
        __typename?: "PageInfo";
        startCursor?: string | null;
        endCursor?: string | null;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
      };
    } | null;
  } | null;
};

export type GetConfigQueryVariables = Exact<{ [key: string]: never }>;

export type GetConfigQuery = {
  __typename?: "Query";
  configs: {
    __typename?: "Config";
    featureFlags: Array<{
      __typename?: "FeatureFlag";
      enabled: boolean;
      name: string;
    }>;
  };
};

export type SetDanceLevelPreferenceMutationVariables = Exact<{
  slug: Scalars["ID"];
}>;

export type SetDanceLevelPreferenceMutation = {
  __typename?: "Mutation";
  setDanceLevelPreference: { __typename?: "LevelOption"; slug: string };
};

export type SetDanceReasonPreferenceMutationVariables = Exact<{
  slug: Scalars["ID"];
}>;

export type SetDanceReasonPreferenceMutation = {
  __typename?: "Mutation";
  setDanceReasonPreference: { __typename?: "ReasonOption"; slug: string };
};

export type SetFamilyGoalPreferenceMutationVariables = Exact<{
  slug: Scalars["ID"];
}>;

export type SetFamilyGoalPreferenceMutation = {
  __typename?: "Mutation";
  setFamilyGoalPreference: {
    __typename?: "FamilyGoalOption";
    slug: string;
    label: string;
  };
};

export type SetAccountTypePreferenceMutationVariables = Exact<{
  slug: Scalars["ID"];
}>;

export type SetAccountTypePreferenceMutation = {
  __typename?: "Mutation";
  setAccountTypePreference: { __typename?: "AccountTypeOption"; slug: string };
};

export type PreferenceOptionFieldsFragment = {
  __typename?: "UserPreferenceOption";
  slug: string;
  label: string;
  description: string;
  previewUrl: string;
  displayIndex: number;
};

export type GetOnboardingDataQueryVariables = Exact<{ [key: string]: never }>;

export type GetOnboardingDataQuery = {
  __typename?: "Query";
  onboardingData: {
    __typename?: "OnboardingData";
    levelOptions: Array<{
      __typename?: "LevelOption";
      slug: string;
      name: string;
      description: string;
      previewGIFUrl?: string | null;
    }>;
    durationOptions: Array<{
      __typename?: "DurationOption";
      slug: string;
      name: string;
      description: string;
      start: number;
      end: number;
    }>;
    reasonOptions: Array<{
      __typename?: "ReasonOption";
      slug: string;
      label?: string | null;
      description?: string | null;
      variant?: string | null;
      goal?: string | null;
      previewImgURL?: string | null;
    }>;
  };
};

export type UserPreferenceOptionsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type UserPreferenceOptionsQuery = {
  __typename?: "Query";
  familyGoals: Array<{
    __typename?: "UserPreferenceOption";
    slug: string;
    label: string;
    description: string;
    previewUrl: string;
    displayIndex: number;
  }>;
  levels: Array<{
    __typename?: "UserPreferenceOption";
    slug: string;
    label: string;
    description: string;
    previewUrl: string;
    displayIndex: number;
  }>;
  reasons: Array<{
    __typename?: "UserPreferenceOption";
    slug: string;
    label: string;
    description: string;
    previewUrl: string;
    displayIndex: number;
  }>;
  accountTypes: Array<{
    __typename?: "UserPreferenceOption";
    slug: string;
    label: string;
    description: string;
    previewUrl: string;
    displayIndex: number;
  }>;
};

export type SetExperimentMutationVariables = Exact<{
  experimentId: Scalars["ID"];
}>;

export type SetExperimentMutation = {
  __typename?: "Mutation";
  setExperiment: {
    __typename?: "SetExperimentOutput";
    experimentId: string;
    variant: string;
  };
};

export type CoreTrackFieldsFragment = {
  __typename?: "Track";
  id: string;
  createdAt: any;
  updatedAt: any;
  trackId?: string | null;
  songId?: string | null;
  isrc: string;
  title?: string | null;
  artists: Array<string>;
  label?: string | null;
  albumName?: string | null;
  copyright?: string | null;
  releaseDate?: string | null;
  image?: string | null;
  genre: Array<string>;
  isExplicit: boolean;
  youtube?: string | null;
  spotify?: string | null;
  appleMusic?: string | null;
  soundcloud?: string | null;
  tikTokSound?: string | null;
  source: TrackSource;
};

export type CoreClassFieldsFragment = {
  __typename?: "Class";
  id: string;
  studioClassId: string;
  accessType: AccessType;
  refId?: string | null;
  isUnlocked: boolean;
  isExplicit?: boolean | null;
  isFamilyFriendly: boolean;
  title: string;
  duration: string;
  style?: string | null;
  categories: Array<string>;
  thumbnail?: string | null;
  slug: string;
  type: string;
  level?: string | null;
  preview_url: string;
  duration_in_seconds: number;
  isFree: boolean;
  isSaved?: boolean | null;
  isPreviewVideoMuted?: boolean | null;
  externalPreviewUrl?: string | null;
  songs?: Array<{
    __typename?: "Song";
    title?: string | null;
    artist?: string | null;
    isExplicit?: boolean | null;
  } | null> | null;
  instructor?: { __typename?: "Instructor"; name: string; slug: string } | null;
  progress?: {
    __typename?: "ClassProgress";
    completed?: string | null;
    started?: string | null;
    time?: {
      __typename?: "Time";
      hour?: number | null;
      minute?: number | null;
      second?: number | null;
    } | null;
  } | null;
  tracks: Array<{
    __typename?: "StudioClassTrack";
    startsAt: number;
    track: {
      __typename?: "Track";
      trackId?: string | null;
      title?: string | null;
      artists: Array<string>;
      albumName?: string | null;
      image?: string | null;
      isExplicit: boolean;
      label?: string | null;
      copyright?: string | null;
      releaseDate?: string | null;
      isrc: string;
      source: TrackSource;
      appleMusic?: string | null;
      spotify?: string | null;
      youtube?: string | null;
    };
  }>;
};

export type CorePlaylistClassFieldsFragment = {
  __typename?: "PlaylistClass";
  id: string;
  playlistId?: string | null;
  refId?: string | null;
  isUnlocked: boolean;
  isExplicit?: boolean | null;
  title: string;
  duration: string;
  style?: string | null;
  categories: Array<string>;
  thumbnail?: string | null;
  slug: string;
  type: string;
  level?: string | null;
  preview_url: string;
  duration_in_seconds: number;
  isFree: boolean;
  isSaved?: boolean | null;
  songs?: Array<{
    __typename?: "Song";
    title?: string | null;
    artist?: string | null;
    isExplicit?: boolean | null;
  } | null> | null;
  instructor?: { __typename?: "Instructor"; name: string; slug: string } | null;
  progress?: {
    __typename?: "PlaylistClassProgress";
    completed?: string | null;
  } | null;
  tracks: Array<{
    __typename?: "StudioClassTrack";
    startsAt: number;
    track: {
      __typename?: "Track";
      trackId?: string | null;
      title?: string | null;
      artists: Array<string>;
      albumName?: string | null;
      image?: string | null;
      isExplicit: boolean;
      label?: string | null;
      copyright?: string | null;
      releaseDate?: string | null;
      isrc: string;
      source: TrackSource;
      appleMusic?: string | null;
      spotify?: string | null;
      youtube?: string | null;
    };
  }>;
};

export type GetProgramsHistoryQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]>;
  after?: InputMaybe<Scalars["String"]>;
}>;

export type GetProgramsHistoryQuery = {
  __typename?: "Query";
  programsHistory: {
    __typename?: "ProgramsHistoryData";
    connection?: {
      __typename?: "ProgramsHistoryConnection";
      pageInfo: {
        __typename?: "PageInfo";
        endCursor?: string | null;
        hasNextPage: boolean;
      };
      edges: Array<{
        __typename?: "ProgramV2Edge";
        node: {
          __typename?: "ProgramV2";
          slug: string;
          progress?: {
            __typename?: "ProgramProgressV2";
            completedDate?: string | null;
          } | null;
        };
      }>;
    } | null;
  };
};

export type GetParentalControlsQueryVariables = Exact<{ [key: string]: never }>;

export type GetParentalControlsQuery = {
  __typename?: "Query";
  me?: {
    __typename?: "User";
    id: string;
    uid: string;
    parentalControls: {
      __typename?: "ParentalControls";
      isEnabled: boolean;
      pin?: string | null;
    };
  } | null;
};

export type GetInstructorsPublicQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetInstructorsPublicQuery = {
  __typename?: "Query";
  instructorsPublic: {
    __typename?: "InstructorConnection";
    totalCount: number;
    edges: Array<{
      __typename?: "InstructorEdge";
      cursor: string;
      node: {
        __typename?: "ClassInstructor";
        id: string;
        name?: string | null;
        bio?: string | null;
        slug: string;
        avatarImageUrl?: string | null;
        profileImageUrl?: string | null;
        location?: string | null;
        userProfile?: {
          __typename?: "UserProfile";
          id: string;
          username?: string | null;
          photoURL?: string | null;
        } | null;
      };
    }>;
    pageInfo: {
      __typename?: "PageInfo";
      hasNextPage: boolean;
      endCursor?: string | null;
    };
  };
};

export type GetUserInstructorProfileBySlugPublicQueryVariables = Exact<{
  slug: Scalars["String"];
}>;

export type GetUserInstructorProfileBySlugPublicQuery = {
  __typename?: "Query";
  instructorBySlugPublic?: {
    __typename?: "ClassInstructor";
    id: string;
    name?: string | null;
    bio?: string | null;
    slug: string;
    avatarImageUrl?: string | null;
    profileImageUrl?: string | null;
    location?: string | null;
    userProfile?: {
      __typename?: "UserProfile";
      id: string;
      name?: string | null;
      username?: string | null;
      photoURL?: string | null;
    } | null;
  } | null;
};

export type GetUserProfileByUsernameQueryVariables = Exact<{
  username: Scalars["String"];
  videoPagination: ConnectionArgs;
}>;

export type GetUserProfileByUsernameQuery = {
  __typename?: "Query";
  userProfileGetByUsername: {
    __typename?: "UserProfileWithVideos";
    id: string;
    username?: string | null;
    photoURL?: string | null;
    totalLikesCount: number;
    uid?: string | null;
    bio?: string | null;
    links?: Array<{ __typename?: "UserProfileLink"; url: string }> | null;
    videoUploads: {
      __typename?: "VideoUploadConnection";
      totalCount: number;
      edges: Array<{
        __typename?: "VideoUploadEdge";
        cursor: string;
        node: {
          __typename?: "VideoUpload";
          id: string;
          description?: string | null;
          thumbnailUrl?: string | null;
          createdAt: any;
          encodingStatus: VideoEncodingStatus;
          reportedByMe: boolean;
          isAuthoredByMe: boolean;
          uploadedAt?: any | null;
          userReactions?: Array<UserReactionType> | null;
          reactions: Array<{
            __typename?: "ActivityReactionsCount";
            reactionType: UserReactionType;
            totalCount: number;
          }>;
        };
      }>;
      pageInfo: {
        __typename?: "PageInfo";
        hasNextPage: boolean;
        endCursor?: string | null;
      };
    };
    badges?: Array<{
      __typename?: "UserBadge";
      id: string;
      earnedAt: any;
      badge: {
        __typename?: "Badge";
        id: string;
        name: string;
        description?: string | null;
        activeImageUrl?: string | null;
        inactiveImageUrl?: string | null;
      };
    }> | null;
  };
};

export type TrackLogPlayMutationVariables = Exact<{
  input: TrackLogPlayInput;
}>;

export type TrackLogPlayMutation = {
  __typename?: "Mutation";
  trackLogPlay: boolean;
};

export type UserSetParentalControlsMutationVariables = Exact<{
  input: UserSetParentalControlsInput;
}>;

export type UserSetParentalControlsMutation = {
  __typename?: "Mutation";
  userSetParentalControls: {
    __typename?: "User";
    id: string;
    parentalControls: {
      __typename?: "ParentalControls";
      isEnabled: boolean;
      pin?: string | null;
    };
  };
};

export type UpdateUsersLastSeenMutationVariables = Exact<{
  [key: string]: never;
}>;

export type UpdateUsersLastSeenMutation = {
  __typename?: "Mutation";
  updateUsersLastSeen: {
    __typename?: "SuccessPayload";
    success?: boolean | null;
  };
};

export type UserValidatePinQueryVariables = Exact<{
  pin: Scalars["String"];
}>;

export type UserValidatePinQuery = {
  __typename?: "Query";
  userValidatePin: boolean;
};

export type GetUserProgressQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserProgressQuery = {
  __typename?: "Query";
  user?: {
    __typename?: "User";
    progress?: {
      __typename?: "UserProgress";
      total_time_spent: number;
      classes_completed: number;
    } | null;
  } | null;
};

export type SubscriptionCreateForCustomerMutationVariables = Exact<{
  planInfo: PlanInfoInput;
  couponIds?: InputMaybe<Array<Scalars["String"]> | Scalars["String"]>;
  ipInfo?: InputMaybe<IpInfoInput>;
}>;

export type SubscriptionCreateForCustomerMutation = {
  __typename?: "Mutation";
  subscriptionCreateForCustomer: {
    __typename?: "Subscription";
    id: string;
    isActive: boolean;
    isCancelable: boolean;
    isReactivatableV2: boolean;
    isPauseScheduled: boolean;
    isPastDue: boolean;
    nextBillingAt?: number | null;
    status: SubscriptionStatus;
    trialEndTime?: number | null;
    currentTermEnd?: number | null;
    cancelationTime?: number | null;
    pauseTime?: number | null;
    resumeTime?: number | null;
    provider: { __typename?: "ProviderInfo"; id: string };
    plan: {
      __typename?: "Plan";
      trialPeriod?: number | null;
      periodUnit?: BillingPeriodUnit | null;
      priceInCents?: number | null;
      id: string;
      name: string;
      currencyCode?: string | null;
      provider: { __typename?: "ProviderInfo"; id: string };
    };
    user: {
      __typename?: "User";
      id: string;
      uid: string;
      isActive: boolean;
      hasTrialed: boolean;
    };
  };
};

export type SwitchPlanFieldsFragment = {
  __typename?: "Plan";
  id: string;
  name: string;
  accessType: AccessType;
  currencyCode?: string | null;
};

export type SwitchablePlansQueryVariables = Exact<{ [key: string]: never }>;

export type SwitchablePlansQuery = {
  __typename?: "Query";
  switchablePlans: Array<{
    __typename?: "Plan";
    isBestValue: boolean;
    isSubscribed: boolean;
    monthlySavingsInPercent: number;
    monthlyCostInCents?: number | null;
    annualSavingsInCents: number;
    period: number;
    periodUnit?: BillingPeriodUnit | null;
    priceInCents?: number | null;
    id: string;
    name: string;
    accessType: AccessType;
    currencyCode?: string | null;
    invoiceEstimate?: {
      __typename?: "SubscriptionInvoiceEstimate";
      amountDue?: number | null;
      creditsApplied?: number | null;
      total?: number | null;
      subTotal?: number | null;
    } | null;
    changePlanEstimate?: {
      __typename?: "ChangePlanEstimate";
      changePlanType: ChangePlanType;
      isEndOfTerm: boolean;
      invoiceEstimate?: {
        __typename?: "SubscriptionInvoiceEstimate";
        amountDue?: number | null;
        total?: number | null;
      } | null;
    } | null;
    provider: {
      __typename?: "ProviderInfo";
      id: string;
      name: SubscriptionProvider;
    };
  }>;
};

export type GetCanUserTakeClassQueryVariables = Exact<{
  classId: Scalars["String"];
}>;

export type GetCanUserTakeClassQuery = {
  __typename?: "Query";
  classData: { __typename?: "Class"; id: string; canUserTakeClass: boolean };
};

export type SubscriptionPlanFieldsFragment = {
  __typename?: "Plan";
  id: string;
  name: string;
  accessType: AccessType;
  currencyCode?: string | null;
};

export type SubscriptionCancelMutationVariables = Exact<{
  subscriptionId: Scalars["String"];
  cancelReason?: InputMaybe<Scalars["String"]>;
  cancelNow?: InputMaybe<Scalars["Boolean"]>;
}>;

export type SubscriptionCancelMutation = {
  __typename?: "Mutation";
  subscriptionCancel: {
    __typename?: "Subscription";
    id: string;
    isActive: boolean;
    isCancelable: boolean;
    isReactivatableV2: boolean;
    isPauseScheduled: boolean;
    isPastDue: boolean;
    nextBillingAt?: number | null;
    status: SubscriptionStatus;
    trialEndTime?: number | null;
    currentTermEnd?: number | null;
    cancelationTime?: number | null;
    pauseTime?: number | null;
    resumeTime?: number | null;
    plan: {
      __typename?: "Plan";
      id: string;
      name: string;
      accessType: AccessType;
      currencyCode?: string | null;
    };
    user: { __typename?: "User"; id: string; isActive: boolean };
    provider: { __typename?: "ProviderInfo"; id: string };
  };
};

export type SubscriptionReactivateUsingCouponMutationVariables = Exact<{
  input: SubscriptionReactivateUsingCouponInput;
}>;

export type SubscriptionReactivateUsingCouponMutation = {
  __typename?: "Mutation";
  subscriptionReactivateUsingCoupon: {
    __typename?: "Subscription";
    id: string;
    isActive: boolean;
    isCancelable: boolean;
    isReactivatableV2: boolean;
    isPauseScheduled: boolean;
    isPastDue: boolean;
    nextBillingAt?: number | null;
    status: SubscriptionStatus;
    trialEndTime?: number | null;
    currentTermEnd?: number | null;
    cancelationTime?: number | null;
    pauseTime?: number | null;
    resumeTime?: number | null;
    provider: { __typename?: "ProviderInfo"; id: string };
  };
};

export type CreateCancelSurveyMutationVariables = Exact<{
  input: CancelSurveyInput;
}>;

export type CreateCancelSurveyMutation = {
  __typename?: "Mutation";
  createCancelSurvey: {
    __typename?: "CancelSurvey";
    id: string;
    createdAt: any;
    updatedAt: any;
    reason: CancelReason;
    otherReason?: string | null;
    joinAgainReason?: string | null;
    overallExperienceRating: number;
    additionalFeedback?: string | null;
    subscription: {
      __typename?: "Subscription";
      id: string;
      status: SubscriptionStatus;
      currentTermEnd?: number | null;
    };
  };
};

export type GetPrimarySubscriptionQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetPrimarySubscriptionQuery = {
  __typename?: "Query";
  me?: {
    __typename?: "User";
    id: string;
    primarySubscription?: {
      __typename?: "Subscription";
      id: string;
      isActive: boolean;
      isCancelable: boolean;
      isReactivatableV2: boolean;
      isPauseScheduled: boolean;
      isPastDue: boolean;
      nextBillingAt?: number | null;
      status: SubscriptionStatus;
      trialEndTime?: number | null;
      currentTermEnd?: number | null;
      cancelationTime?: number | null;
      pauseTime?: number | null;
      resumeTime?: number | null;
      provider: {
        __typename?: "ProviderInfo";
        id: string;
        name: SubscriptionProvider;
      };
      plan: {
        __typename?: "Plan";
        id: string;
        name: string;
        accessType: AccessType;
        isSpecial: boolean;
        isLegacy: boolean;
        periodUnit?: BillingPeriodUnit | null;
        platform: Platform;
        priceInCents?: number | null;
        monthlyCostInCents?: number | null;
        provider: {
          __typename?: "ProviderInfo";
          name: SubscriptionProvider;
          id: string;
        };
      };
      invoiceEstimate?: {
        __typename?: "SubscriptionInvoiceEstimate";
        amountDue?: number | null;
      } | null;
      invoiceDue?: {
        __typename?: "Invoice";
        id: string;
        amountDue: number;
        dunningAttemptsCount: number;
        nextRetryAt?: number | null;
        dueDate?: number | null;
      } | null;
    } | null;
    scheduledSubscriptionChange?: {
      __typename?: "Subscription";
      id: string;
      nextBillingAt?: number | null;
      invoiceDue?: { __typename?: "Invoice"; amountDue: number } | null;
      invoiceEstimate?: {
        __typename?: "SubscriptionInvoiceEstimate";
        amountDue?: number | null;
        total?: number | null;
      } | null;
      plan: { __typename?: "Plan"; id: string; name: string };
    } | null;
  } | null;
};

export type GetPrimaryPaymentSourceQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetPrimaryPaymentSourceQuery = {
  __typename?: "Query";
  me?: {
    __typename?: "User";
    primaryPaymentSource?: {
      __typename?: "PaymentSource";
      id: string;
      gateway: GatewayProvider;
      type: string;
      card?: {
        __typename?: "Card";
        lastFour?: string | null;
        brand?: string | null;
        fundingType?: string | null;
        object?: string | null;
      } | null;
    } | null;
  } | null;
};

export type GetUserHasTrialedQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserHasTrialedQuery = {
  __typename?: "Query";
  me?: { __typename?: "User"; hasTrialed: boolean } | null;
};

export type GetCancelSurveyBySubscriptionIdQueryVariables = Exact<{
  subscriptionId: Scalars["String"];
}>;

export type GetCancelSurveyBySubscriptionIdQuery = {
  __typename?: "Query";
  cancelSurvey: {
    __typename?: "CancelSurvey";
    id: string;
    reason: CancelReason;
    otherReason?: string | null;
    joinAgainReason?: string | null;
    overallExperienceRating: number;
    additionalFeedback?: string | null;
    createdAt: any;
    updatedAt: any;
    subscription: {
      __typename?: "Subscription";
      id: string;
      status: SubscriptionStatus;
      currentTermEnd?: number | null;
    };
  };
};

export type CheckSubscriptionCouponQueryVariables = Exact<{
  input: CheckSubscriptionCouponInput;
}>;

export type CheckSubscriptionCouponQuery = {
  __typename?: "Query";
  checkSubscriptionCoupon: boolean;
};

export type GetMeUserProfileQueryVariables = Exact<{ [key: string]: never }>;

export type GetMeUserProfileQuery = {
  __typename?: "Query";
  me?: {
    __typename?: "User";
    id: string;
    uid: string;
    username: string;
    name?: string | null;
    photoURL?: string | null;
    totalLikesCount: number;
  } | null;
};

export const ChallengesBadgeFragmentDoc = /*#__PURE__*/ gql`
  fragment ChallengesBadge on Badge {
    id
    name
    amountToEarn
    activeImageUrl
    inactiveImageUrl
  }
`;
export const ChallengeUserProgressFragmentDoc = /*#__PURE__*/ gql`
  fragment ChallengeUserProgress on UserProgressChallenge {
    achievementId
    triggerType
    currentBadgeProgress
    currentBadge {
      ...ChallengesBadge
    }
    nextBadge {
      ...ChallengesBadge
    }
  }
  ${ChallengesBadgeFragmentDoc}
`;
export const ChallengeCardFragmentDoc = /*#__PURE__*/ gql`
  fragment ChallengeCard on Challenge {
    id
    title
    startTime
    endTime
    achievement {
      id
      name
      triggerType
    }
    badges {
      badge {
        ...ChallengesBadge
      }
      isEarned
    }
    userProgress {
      ...ChallengeUserProgress
    }
  }
  ${ChallengesBadgeFragmentDoc}
  ${ChallengeUserProgressFragmentDoc}
`;
export const ChallengesParticipantLeaderboardFragmentDoc = /*#__PURE__*/ gql`
  fragment ChallengesParticipantLeaderboard on ChallengeParticipant {
    user {
      id
      username
      photoURL
    }
    joinedAt
    progressAmount
  }
`;
export const AchievementStudioClassFragmentDoc = /*#__PURE__*/ gql`
  fragment AchievementStudioClass on StudioClass {
    id
    classId
    title
    thumbnailImageUrl
    level
    type
    accessType
    instructor {
      name
    }
    video {
      durationInMs
    }
    userProgress {
      completed
      percent
      time {
        hour
        minute
        second
      }
    }
  }
`;
export const ChallengeDetailsBadgeFragmentDoc = /*#__PURE__*/ gql`
  fragment ChallengeDetailsBadge on Badge {
    activeImageUrl
    inactiveImageUrl
    amountToEarn
    name
    id
    description
    achievement {
      id
      triggerType
    }
  }
`;
export const ChallengeDetailsPageFragmentDoc = /*#__PURE__*/ gql`
  fragment ChallengeDetailsPage on Challenge {
    id
    title
    description
    thumbnailImageUrl
    startTime
    endTime
    achievement {
      id
      triggerType
      requiredPublishedStudioClasses {
        ...AchievementStudioClass
      }
    }
    badges {
      badge {
        ...ChallengeDetailsBadge
      }
      isEarned
    }
    displayText {
      goalHeader
      subtitleHeader
      earnedByHeader
    }
  }
  ${AchievementStudioClassFragmentDoc}
  ${ChallengeDetailsBadgeFragmentDoc}
`;
export const SubscriptionFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment SubscriptionFields on Subscription {
    id
    isActive
    isCancelable
    isReactivatableV2
    isPauseScheduled
    isPastDue
    nextBillingAt
    status
    trialEndTime
    currentTermEnd
    cancelationTime
    pauseTime
    resumeTime
    provider {
      id
    }
  }
`;
export const PlanFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment PlanFields on Plan {
    id
    name
    currencyCode
  }
`;
export const CoreVideoUploadsPublishedFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment CoreVideoUploadsPublishedFields on VideoUpload {
    id
    isAuthoredByMe
    reportedByMe
    description
    thumbnailUrl
    playbackUrl
    encodingStatus
    reactions {
      reactionType
      totalCount
    }
    userReactions
    uploadedAt
    uploadedBy {
      id
      uid
      username
    }
    studioClass {
      id
      classId
      title
      free
    }
    comments {
      totalCount
    }
  }
`;
export const FeaturedPlaylistFragmentDoc = /*#__PURE__*/ gql`
  fragment FeaturedPlaylist on PlaylistV2 {
    id
    name
    thumbnailImageUrl
    isSaved
  }
`;
export const FeaturedClassFragmentDoc = /*#__PURE__*/ gql`
  fragment FeaturedClass on Class {
    id
    accessType
    refId
    slug
    type
    isUnlocked
    isExplicit
    title
    duration
    duration_in_seconds
    style
    instructor {
      name
      slug
    }
    level
    preview_url
    isFree
    isPreviewVideoMuted
    externalPreviewUrl
    progress {
      time {
        hour
        minute
        second
      }
      completed
    }
  }
`;
export const HistoryClassCardDataFragmentDoc = /*#__PURE__*/ gql`
  fragment HistoryClassCardData on Class {
    accessType
    duration
    duration_in_seconds
    id
    isFree
    isPreviewVideoMuted
    externalPreviewUrl
    level
    preview_url
    slug
    style
    thumbnail
    title
    type
    categories
    instructor {
      name
      slug
    }
    isExplicit
    progress {
      time {
        hour
        minute
        second
      }
      completed
    }
  }
`;
export const IsPlaylistSavedFragmentDoc = /*#__PURE__*/ gql`
  fragment IsPlaylistSaved on PlaylistV2 {
    isSaved
  }
`;
export const CorePlaylistV2FieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment CorePlaylistV2Fields on PlaylistV2 {
    hidden
    id
    isSaved
    name
    thumbnailImageUrl
    owner {
      id
      uid
      username
      isMe
    }
  }
`;
export const CorePlaylistStudioClassFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment CorePlaylistStudioClassFields on StudioClass {
    classId
    id
    isExplicit
    level
    thumbnailImageUrl
    title
    type
    accessType
    instructor {
      name
      slug
    }
    previewVideo {
      id
      hlsPlaybackUrls {
        defaultUrl
      }
    }
    userProgress {
      id
      percent
      completed
      time {
        hour
        minute
        second
      }
    }
    styleV2 {
      name
      slug
    }
    video {
      durationInMs
    }
  }
`;
export const CorePersonalizedPlaylistClassFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment CorePersonalizedPlaylistClassFields on Class {
    id
    studioClassId
    duration
    duration_in_seconds
    isExplicit
    isPreviewVideoMuted
    externalPreviewUrl
    level
    preview_url
    style
    thumbnail
    title
    type
    instructor {
      name
      slug
    }
    progress {
      time {
        hour
        minute
        second
      }
      completed
    }
  }
`;
export const CorePageInfoFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment CorePageInfoFields on PageInfo {
    endCursor
    hasNextPage
    hasPreviousPage
    startCursor
  }
`;
export const ProfileBadgeFragmentDoc = /*#__PURE__*/ gql`
  fragment ProfileBadge on UserBadge {
    badge {
      challenge {
        title
        id
      }
      activeImageUrl
      name
    }
    earnedAt
  }
`;
export const UserBadgeGroupFragmentDoc = /*#__PURE__*/ gql`
  fragment UserBadgeGroup on BadgeYearGroup {
    userBadges {
      ...ProfileBadge
    }
    year
  }
  ${ProfileBadgeFragmentDoc}
`;
export const InstructorStudioClassFragmentDoc = /*#__PURE__*/ gql`
  fragment InstructorStudioClass on StudioClass {
    id
    classId
    title
    thumbnailImageUrl
    level
    type
    accessType
    isExplicit
    styleV2 {
      name
    }
    video {
      durationInMs
    }
    instructor {
      name
      slug
    }
    userProgress {
      completed
      percent
      time {
        hour
        minute
        second
      }
    }
  }
`;
export const UserProfileVideoUploadsFragmentDoc = /*#__PURE__*/ gql`
  fragment UserProfileVideoUploads on VideoUpload {
    id
    description
    thumbnailUrl
    encodingStatus
    reportedByMe
  }
`;
export const ChallengeFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment ChallengeFields on Challenge {
    id
    title
    description
    forClass {
      id
      title
      isUnlocked
      isFree
      isSaved
      categories
      duration
      type
      preview_url
      thumbnail
      level
      style
      duration
      isUnlocked
      isFree
      instructor {
        name
        slug
      }
    }
    isActive
    challengeStatus
    startTime
    endTime
    isActive
    submissionsCount
    reactions {
      reactionType
      totalCount
    }
    userReactions
  }
`;
export const CoreClassUserVideosFieldFragmentDoc = /*#__PURE__*/ gql`
  fragment CoreClassUserVideosField on VideoUpload {
    id
    isAuthoredByMe
    reportedByMe
    description
    thumbnailUrl
    playbackUrl
    uploadedAt
    uploadedBy {
      id
      uid
      username
    }
    encodingStatus
    reactions {
      reactionType
      totalCount
    }
    userReactions
  }
`;
export const ActivityCommentFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment ActivityCommentFields on ActivityComment {
    id
    body
    createdAt
    userReactions
    reactions {
      reactionType
      totalCount
    }
    commentBy {
      id
      username
      photoURL
      uid
    }
    reportedByMe
  }
`;
export const PreferenceOptionFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment PreferenceOptionFields on UserPreferenceOption {
    slug
    label
    description
    previewUrl
    displayIndex
  }
`;
export const CoreTrackFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment CoreTrackFields on Track {
    id
    createdAt
    updatedAt
    trackId
    songId
    isrc
    title
    artists
    label
    albumName
    copyright
    releaseDate
    image
    genre
    isExplicit
    youtube
    spotify
    appleMusic
    soundcloud
    tikTokSound
    source
  }
`;
export const CoreClassFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment CoreClassFields on Class {
    id
    studioClassId
    accessType
    refId
    isUnlocked
    isExplicit
    isFamilyFriendly
    title
    duration
    style
    songs {
      title
      artist
      isExplicit
    }
    categories
    thumbnail
    instructor {
      name
      slug
    }
    progress {
      completed
    }
    slug
    type
    level
    preview_url
    duration_in_seconds
    isFree
    isSaved
    isPreviewVideoMuted
    externalPreviewUrl
    progress {
      time {
        hour
        minute
        second
      }
      started
      completed
    }
    tracks {
      startsAt
      track {
        trackId
        title
        artists
        albumName
        image
        isExplicit
        label
        copyright
        releaseDate
        isrc
        source
        appleMusic
        spotify
        youtube
      }
    }
  }
`;
export const CorePlaylistClassFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment CorePlaylistClassFields on PlaylistClass {
    id
    playlistId
    refId
    isUnlocked
    isExplicit
    title
    duration
    style
    songs {
      title
      artist
      isExplicit
    }
    categories
    thumbnail
    instructor {
      name
      slug
    }
    progress {
      completed
    }
    slug
    type
    level
    preview_url
    duration_in_seconds
    isFree
    isSaved
    tracks {
      startsAt
      track {
        trackId
        title
        artists
        albumName
        image
        isExplicit
        label
        copyright
        releaseDate
        isrc
        source
        appleMusic
        spotify
        youtube
      }
    }
  }
`;
export const SwitchPlanFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment SwitchPlanFields on Plan {
    id
    name
    accessType
    currencyCode
  }
`;
export const SubscriptionPlanFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment SubscriptionPlanFields on Plan {
    id
    name
    accessType
    currencyCode
  }
`;
export const GetChallengeByIdDocument = /*#__PURE__*/ gql`
  query GetChallengeById($challengeByIdId: String!) {
    challengeById(id: $challengeByIdId) {
      ...ChallengeDetailsPage
    }
  }
  ${ChallengeDetailsPageFragmentDoc}
`;

/**
 * __useGetChallengeByIdQuery__
 *
 * To run a query within a React component, call `useGetChallengeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChallengeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChallengeByIdQuery({
 *   variables: {
 *      challengeByIdId: // value for 'challengeByIdId'
 *   },
 * });
 */
export function useGetChallengeByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetChallengeByIdQuery,
    GetChallengeByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetChallengeByIdQuery, GetChallengeByIdQueryVariables>(
    GetChallengeByIdDocument,
    options
  );
}
export function useGetChallengeByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetChallengeByIdQuery,
    GetChallengeByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetChallengeByIdQuery,
    GetChallengeByIdQueryVariables
  >(GetChallengeByIdDocument, options);
}
export type GetChallengeByIdQueryHookResult = ReturnType<
  typeof useGetChallengeByIdQuery
>;
export type GetChallengeByIdLazyQueryHookResult = ReturnType<
  typeof useGetChallengeByIdLazyQuery
>;
export type GetChallengeByIdQueryResult = Apollo.QueryResult<
  GetChallengeByIdQuery,
  GetChallengeByIdQueryVariables
>;
export const GetChallengeProgressByIdDocument = /*#__PURE__*/ gql`
  query GetChallengeProgressById($challengeByIdId: String!) {
    challengeById(id: $challengeByIdId) {
      ...ChallengeCard
    }
  }
  ${ChallengeCardFragmentDoc}
`;

/**
 * __useGetChallengeProgressByIdQuery__
 *
 * To run a query within a React component, call `useGetChallengeProgressByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChallengeProgressByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChallengeProgressByIdQuery({
 *   variables: {
 *      challengeByIdId: // value for 'challengeByIdId'
 *   },
 * });
 */
export function useGetChallengeProgressByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetChallengeProgressByIdQuery,
    GetChallengeProgressByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetChallengeProgressByIdQuery,
    GetChallengeProgressByIdQueryVariables
  >(GetChallengeProgressByIdDocument, options);
}
export function useGetChallengeProgressByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetChallengeProgressByIdQuery,
    GetChallengeProgressByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetChallengeProgressByIdQuery,
    GetChallengeProgressByIdQueryVariables
  >(GetChallengeProgressByIdDocument, options);
}
export type GetChallengeProgressByIdQueryHookResult = ReturnType<
  typeof useGetChallengeProgressByIdQuery
>;
export type GetChallengeProgressByIdLazyQueryHookResult = ReturnType<
  typeof useGetChallengeProgressByIdLazyQuery
>;
export type GetChallengeProgressByIdQueryResult = Apollo.QueryResult<
  GetChallengeProgressByIdQuery,
  GetChallengeProgressByIdQueryVariables
>;
export const GetChallengeLeaderboardDocument = /*#__PURE__*/ gql`
  query GetChallengeLeaderboard($challengeByIdId: String!) {
    challengeById(id: $challengeByIdId) {
      id
      participantLeaderboard {
        ...ChallengesParticipantLeaderboard
      }
    }
  }
  ${ChallengesParticipantLeaderboardFragmentDoc}
`;

/**
 * __useGetChallengeLeaderboardQuery__
 *
 * To run a query within a React component, call `useGetChallengeLeaderboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChallengeLeaderboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChallengeLeaderboardQuery({
 *   variables: {
 *      challengeByIdId: // value for 'challengeByIdId'
 *   },
 * });
 */
export function useGetChallengeLeaderboardQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetChallengeLeaderboardQuery,
    GetChallengeLeaderboardQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetChallengeLeaderboardQuery,
    GetChallengeLeaderboardQueryVariables
  >(GetChallengeLeaderboardDocument, options);
}
export function useGetChallengeLeaderboardLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetChallengeLeaderboardQuery,
    GetChallengeLeaderboardQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetChallengeLeaderboardQuery,
    GetChallengeLeaderboardQueryVariables
  >(GetChallengeLeaderboardDocument, options);
}
export type GetChallengeLeaderboardQueryHookResult = ReturnType<
  typeof useGetChallengeLeaderboardQuery
>;
export type GetChallengeLeaderboardLazyQueryHookResult = ReturnType<
  typeof useGetChallengeLeaderboardLazyQuery
>;
export type GetChallengeLeaderboardQueryResult = Apollo.QueryResult<
  GetChallengeLeaderboardQuery,
  GetChallengeLeaderboardQueryVariables
>;
export const GeneratedStripePaymentIntentDocument = /*#__PURE__*/ gql`
  query GeneratedStripePaymentIntent($amountInCents: Float!) {
    generateStripePaymentIntent(input: { amountInCents: $amountInCents }) {
      id
      clientSecret
    }
  }
`;

/**
 * __useGeneratedStripePaymentIntentQuery__
 *
 * To run a query within a React component, call `useGeneratedStripePaymentIntentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeneratedStripePaymentIntentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeneratedStripePaymentIntentQuery({
 *   variables: {
 *      amountInCents: // value for 'amountInCents'
 *   },
 * });
 */
export function useGeneratedStripePaymentIntentQuery(
  baseOptions: Apollo.QueryHookOptions<
    GeneratedStripePaymentIntentQuery,
    GeneratedStripePaymentIntentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GeneratedStripePaymentIntentQuery,
    GeneratedStripePaymentIntentQueryVariables
  >(GeneratedStripePaymentIntentDocument, options);
}
export function useGeneratedStripePaymentIntentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GeneratedStripePaymentIntentQuery,
    GeneratedStripePaymentIntentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GeneratedStripePaymentIntentQuery,
    GeneratedStripePaymentIntentQueryVariables
  >(GeneratedStripePaymentIntentDocument, options);
}
export type GeneratedStripePaymentIntentQueryHookResult = ReturnType<
  typeof useGeneratedStripePaymentIntentQuery
>;
export type GeneratedStripePaymentIntentLazyQueryHookResult = ReturnType<
  typeof useGeneratedStripePaymentIntentLazyQuery
>;
export type GeneratedStripePaymentIntentQueryResult = Apollo.QueryResult<
  GeneratedStripePaymentIntentQuery,
  GeneratedStripePaymentIntentQueryVariables
>;
export const CreatePlaySessionDocument = /*#__PURE__*/ gql`
  mutation CreatePlaySession {
    playSessionCreate
  }
`;
export type CreatePlaySessionMutationFn = Apollo.MutationFunction<
  CreatePlaySessionMutation,
  CreatePlaySessionMutationVariables
>;

/**
 * __useCreatePlaySessionMutation__
 *
 * To run a mutation, you first call `useCreatePlaySessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlaySessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlaySessionMutation, { data, loading, error }] = useCreatePlaySessionMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreatePlaySessionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreatePlaySessionMutation,
    CreatePlaySessionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreatePlaySessionMutation,
    CreatePlaySessionMutationVariables
  >(CreatePlaySessionDocument, options);
}
export type CreatePlaySessionMutationHookResult = ReturnType<
  typeof useCreatePlaySessionMutation
>;
export type CreatePlaySessionMutationResult = Apollo.MutationResult<
  CreatePlaySessionMutation
>;
export type CreatePlaySessionMutationOptions = Apollo.BaseMutationOptions<
  CreatePlaySessionMutation,
  CreatePlaySessionMutationVariables
>;
export const RefreshPlaySessionDocument = /*#__PURE__*/ gql`
  mutation RefreshPlaySession($playSessionId: String!) {
    playSessionRefresh(playSessionId: $playSessionId)
  }
`;
export type RefreshPlaySessionMutationFn = Apollo.MutationFunction<
  RefreshPlaySessionMutation,
  RefreshPlaySessionMutationVariables
>;

/**
 * __useRefreshPlaySessionMutation__
 *
 * To run a mutation, you first call `useRefreshPlaySessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshPlaySessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshPlaySessionMutation, { data, loading, error }] = useRefreshPlaySessionMutation({
 *   variables: {
 *      playSessionId: // value for 'playSessionId'
 *   },
 * });
 */
export function useRefreshPlaySessionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RefreshPlaySessionMutation,
    RefreshPlaySessionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RefreshPlaySessionMutation,
    RefreshPlaySessionMutationVariables
  >(RefreshPlaySessionDocument, options);
}
export type RefreshPlaySessionMutationHookResult = ReturnType<
  typeof useRefreshPlaySessionMutation
>;
export type RefreshPlaySessionMutationResult = Apollo.MutationResult<
  RefreshPlaySessionMutation
>;
export type RefreshPlaySessionMutationOptions = Apollo.BaseMutationOptions<
  RefreshPlaySessionMutation,
  RefreshPlaySessionMutationVariables
>;
export const CalculateChallengesProgressDocument = /*#__PURE__*/ gql`
  mutation CalculateChallengesProgress($triggerType: AchievementTriggerType!) {
    calculateChallengesProgress(triggerType: $triggerType) {
      challengesProgressed {
        challenge {
          ...ChallengeCard
        }
      }
      newlyEarnedBadges {
        badge {
          id
          name
          activeImageUrl
          achievement {
            challenge {
              id
            }
          }
        }
      }
    }
  }
  ${ChallengeCardFragmentDoc}
`;
export type CalculateChallengesProgressMutationFn = Apollo.MutationFunction<
  CalculateChallengesProgressMutation,
  CalculateChallengesProgressMutationVariables
>;

/**
 * __useCalculateChallengesProgressMutation__
 *
 * To run a mutation, you first call `useCalculateChallengesProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalculateChallengesProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calculateChallengesProgressMutation, { data, loading, error }] = useCalculateChallengesProgressMutation({
 *   variables: {
 *      triggerType: // value for 'triggerType'
 *   },
 * });
 */
export function useCalculateChallengesProgressMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CalculateChallengesProgressMutation,
    CalculateChallengesProgressMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CalculateChallengesProgressMutation,
    CalculateChallengesProgressMutationVariables
  >(CalculateChallengesProgressDocument, options);
}
export type CalculateChallengesProgressMutationHookResult = ReturnType<
  typeof useCalculateChallengesProgressMutation
>;
export type CalculateChallengesProgressMutationResult = Apollo.MutationResult<
  CalculateChallengesProgressMutation
>;
export type CalculateChallengesProgressMutationOptions = Apollo.BaseMutationOptions<
  CalculateChallengesProgressMutation,
  CalculateChallengesProgressMutationVariables
>;
export const GetNotificationsDocument = /*#__PURE__*/ gql`
  query GetNotifications($pagination: ConnectionArgs!) {
    me {
      id
      notifications(pagination: $pagination) {
        totalCount
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          cursor
          node {
            id
            header
            message
            timeSince
            seen
            sourceType
            sourceParamsCSV
            senderProfile {
              id
              uid
              username
              photoURL
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetNotificationsQuery__
 *
 * To run a query within a React component, call `useGetNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetNotificationsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetNotificationsQuery,
    GetNotificationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(
    GetNotificationsDocument,
    options
  );
}
export function useGetNotificationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetNotificationsQuery,
    GetNotificationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetNotificationsQuery,
    GetNotificationsQueryVariables
  >(GetNotificationsDocument, options);
}
export type GetNotificationsQueryHookResult = ReturnType<
  typeof useGetNotificationsQuery
>;
export type GetNotificationsLazyQueryHookResult = ReturnType<
  typeof useGetNotificationsLazyQuery
>;
export type GetNotificationsQueryResult = Apollo.QueryResult<
  GetNotificationsQuery,
  GetNotificationsQueryVariables
>;
export const HasNewNotificationsDocument = /*#__PURE__*/ gql`
  query HasNewNotifications {
    me {
      id
      hasNewNotifications
    }
  }
`;

/**
 * __useHasNewNotificationsQuery__
 *
 * To run a query within a React component, call `useHasNewNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasNewNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasNewNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useHasNewNotificationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    HasNewNotificationsQuery,
    HasNewNotificationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    HasNewNotificationsQuery,
    HasNewNotificationsQueryVariables
  >(HasNewNotificationsDocument, options);
}
export function useHasNewNotificationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    HasNewNotificationsQuery,
    HasNewNotificationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    HasNewNotificationsQuery,
    HasNewNotificationsQueryVariables
  >(HasNewNotificationsDocument, options);
}
export type HasNewNotificationsQueryHookResult = ReturnType<
  typeof useHasNewNotificationsQuery
>;
export type HasNewNotificationsLazyQueryHookResult = ReturnType<
  typeof useHasNewNotificationsLazyQuery
>;
export type HasNewNotificationsQueryResult = Apollo.QueryResult<
  HasNewNotificationsQuery,
  HasNewNotificationsQueryVariables
>;
export const VideoUploadByIdPublicDocument = /*#__PURE__*/ gql`
  query VideoUploadByIdPublic($videoId: String!) {
    videoUploadByIdPublic(input: { id: $videoId }) {
      id
      isAuthoredByMe
      reportedByMe
      description
      thumbnailUrl
      playbackUrl
      encodingStatus
      reactions {
        reactionType
        totalCount
      }
      userReactions
      uploadedAt
      uploadedBy {
        id
        uid
        username
      }
      studioClass {
        id
        classId
        title
        free
      }
    }
  }
`;

/**
 * __useVideoUploadByIdPublicQuery__
 *
 * To run a query within a React component, call `useVideoUploadByIdPublicQuery` and pass it any options that fit your needs.
 * When your component renders, `useVideoUploadByIdPublicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVideoUploadByIdPublicQuery({
 *   variables: {
 *      videoId: // value for 'videoId'
 *   },
 * });
 */
export function useVideoUploadByIdPublicQuery(
  baseOptions: Apollo.QueryHookOptions<
    VideoUploadByIdPublicQuery,
    VideoUploadByIdPublicQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    VideoUploadByIdPublicQuery,
    VideoUploadByIdPublicQueryVariables
  >(VideoUploadByIdPublicDocument, options);
}
export function useVideoUploadByIdPublicLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VideoUploadByIdPublicQuery,
    VideoUploadByIdPublicQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    VideoUploadByIdPublicQuery,
    VideoUploadByIdPublicQueryVariables
  >(VideoUploadByIdPublicDocument, options);
}
export type VideoUploadByIdPublicQueryHookResult = ReturnType<
  typeof useVideoUploadByIdPublicQuery
>;
export type VideoUploadByIdPublicLazyQueryHookResult = ReturnType<
  typeof useVideoUploadByIdPublicLazyQuery
>;
export type VideoUploadByIdPublicQueryResult = Apollo.QueryResult<
  VideoUploadByIdPublicQuery,
  VideoUploadByIdPublicQueryVariables
>;
export const GetClassByIdForPreviewModalDocument = /*#__PURE__*/ gql`
  query GetClassByIdForPreviewModal($classId: String!) {
    classById(id: $classId) {
      id
      studioClassId
      duration
      duration_in_seconds
      isFree
      isSaved
      level
      preview_url
      slug
      style
      title
      type
      instructor {
        name
        slug
      }
      tracks {
        startsAt
        track {
          id
          title
          artists
          albumName
          image
          isExplicit
          label
        }
      }
    }
  }
`;

/**
 * __useGetClassByIdForPreviewModalQuery__
 *
 * To run a query within a React component, call `useGetClassByIdForPreviewModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassByIdForPreviewModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassByIdForPreviewModalQuery({
 *   variables: {
 *      classId: // value for 'classId'
 *   },
 * });
 */
export function useGetClassByIdForPreviewModalQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetClassByIdForPreviewModalQuery,
    GetClassByIdForPreviewModalQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetClassByIdForPreviewModalQuery,
    GetClassByIdForPreviewModalQueryVariables
  >(GetClassByIdForPreviewModalDocument, options);
}
export function useGetClassByIdForPreviewModalLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetClassByIdForPreviewModalQuery,
    GetClassByIdForPreviewModalQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetClassByIdForPreviewModalQuery,
    GetClassByIdForPreviewModalQueryVariables
  >(GetClassByIdForPreviewModalDocument, options);
}
export type GetClassByIdForPreviewModalQueryHookResult = ReturnType<
  typeof useGetClassByIdForPreviewModalQuery
>;
export type GetClassByIdForPreviewModalLazyQueryHookResult = ReturnType<
  typeof useGetClassByIdForPreviewModalLazyQuery
>;
export type GetClassByIdForPreviewModalQueryResult = Apollo.QueryResult<
  GetClassByIdForPreviewModalQuery,
  GetClassByIdForPreviewModalQueryVariables
>;
export const GetNotificationPreferencesDocument = /*#__PURE__*/ gql`
  query GetNotificationPreferences {
    me {
      id
      notificationPreferences {
        id
        source
        enabled
        allowAll
      }
    }
  }
`;

/**
 * __useGetNotificationPreferencesQuery__
 *
 * To run a query within a React component, call `useGetNotificationPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationPreferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNotificationPreferencesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetNotificationPreferencesQuery,
    GetNotificationPreferencesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetNotificationPreferencesQuery,
    GetNotificationPreferencesQueryVariables
  >(GetNotificationPreferencesDocument, options);
}
export function useGetNotificationPreferencesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetNotificationPreferencesQuery,
    GetNotificationPreferencesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetNotificationPreferencesQuery,
    GetNotificationPreferencesQueryVariables
  >(GetNotificationPreferencesDocument, options);
}
export type GetNotificationPreferencesQueryHookResult = ReturnType<
  typeof useGetNotificationPreferencesQuery
>;
export type GetNotificationPreferencesLazyQueryHookResult = ReturnType<
  typeof useGetNotificationPreferencesLazyQuery
>;
export type GetNotificationPreferencesQueryResult = Apollo.QueryResult<
  GetNotificationPreferencesQuery,
  GetNotificationPreferencesQueryVariables
>;
export const UpdateUserNotificationPreferenceDocument = /*#__PURE__*/ gql`
  mutation UpdateUserNotificationPreference(
    $input: UserNotificationPreferenceUpdateInput!
  ) {
    userNotificationPreferenceUpdate(input: $input) {
      id
      source
      enabled
      allowAll
    }
  }
`;
export type UpdateUserNotificationPreferenceMutationFn = Apollo.MutationFunction<
  UpdateUserNotificationPreferenceMutation,
  UpdateUserNotificationPreferenceMutationVariables
>;

/**
 * __useUpdateUserNotificationPreferenceMutation__
 *
 * To run a mutation, you first call `useUpdateUserNotificationPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserNotificationPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserNotificationPreferenceMutation, { data, loading, error }] = useUpdateUserNotificationPreferenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserNotificationPreferenceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUserNotificationPreferenceMutation,
    UpdateUserNotificationPreferenceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateUserNotificationPreferenceMutation,
    UpdateUserNotificationPreferenceMutationVariables
  >(UpdateUserNotificationPreferenceDocument, options);
}
export type UpdateUserNotificationPreferenceMutationHookResult = ReturnType<
  typeof useUpdateUserNotificationPreferenceMutation
>;
export type UpdateUserNotificationPreferenceMutationResult = Apollo.MutationResult<
  UpdateUserNotificationPreferenceMutation
>;
export type UpdateUserNotificationPreferenceMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserNotificationPreferenceMutation,
  UpdateUserNotificationPreferenceMutationVariables
>;
export const SubscriptionSwitchPlanDocument = /*#__PURE__*/ gql`
  mutation SubscriptionSwitchPlan($subscriptionId: String!, $planId: String!) {
    subscriptionSwitchPlan(
      input: { subscriptionId: $subscriptionId, planId: $planId }
    ) {
      id
    }
  }
`;
export type SubscriptionSwitchPlanMutationFn = Apollo.MutationFunction<
  SubscriptionSwitchPlanMutation,
  SubscriptionSwitchPlanMutationVariables
>;

/**
 * __useSubscriptionSwitchPlanMutation__
 *
 * To run a mutation, you first call `useSubscriptionSwitchPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionSwitchPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscriptionSwitchPlanMutation, { data, loading, error }] = useSubscriptionSwitchPlanMutation({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *      planId: // value for 'planId'
 *   },
 * });
 */
export function useSubscriptionSwitchPlanMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubscriptionSwitchPlanMutation,
    SubscriptionSwitchPlanMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SubscriptionSwitchPlanMutation,
    SubscriptionSwitchPlanMutationVariables
  >(SubscriptionSwitchPlanDocument, options);
}
export type SubscriptionSwitchPlanMutationHookResult = ReturnType<
  typeof useSubscriptionSwitchPlanMutation
>;
export type SubscriptionSwitchPlanMutationResult = Apollo.MutationResult<
  SubscriptionSwitchPlanMutation
>;
export type SubscriptionSwitchPlanMutationOptions = Apollo.BaseMutationOptions<
  SubscriptionSwitchPlanMutation,
  SubscriptionSwitchPlanMutationVariables
>;
export const SubscriptionRemoveScheduledChangesDocument = /*#__PURE__*/ gql`
  mutation SubscriptionRemoveScheduledChanges($subscriptionId: String!) {
    subscriptionRemoveScheduledChanges(
      input: { subscriptionId: $subscriptionId }
    ) {
      id
    }
  }
`;
export type SubscriptionRemoveScheduledChangesMutationFn = Apollo.MutationFunction<
  SubscriptionRemoveScheduledChangesMutation,
  SubscriptionRemoveScheduledChangesMutationVariables
>;

/**
 * __useSubscriptionRemoveScheduledChangesMutation__
 *
 * To run a mutation, you first call `useSubscriptionRemoveScheduledChangesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionRemoveScheduledChangesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscriptionRemoveScheduledChangesMutation, { data, loading, error }] = useSubscriptionRemoveScheduledChangesMutation({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function useSubscriptionRemoveScheduledChangesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubscriptionRemoveScheduledChangesMutation,
    SubscriptionRemoveScheduledChangesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SubscriptionRemoveScheduledChangesMutation,
    SubscriptionRemoveScheduledChangesMutationVariables
  >(SubscriptionRemoveScheduledChangesDocument, options);
}
export type SubscriptionRemoveScheduledChangesMutationHookResult = ReturnType<
  typeof useSubscriptionRemoveScheduledChangesMutation
>;
export type SubscriptionRemoveScheduledChangesMutationResult = Apollo.MutationResult<
  SubscriptionRemoveScheduledChangesMutation
>;
export type SubscriptionRemoveScheduledChangesMutationOptions = Apollo.BaseMutationOptions<
  SubscriptionRemoveScheduledChangesMutation,
  SubscriptionRemoveScheduledChangesMutationVariables
>;
export const UserCheckUsernameDocument = /*#__PURE__*/ gql`
  mutation UserCheckUsername($input: UserCheckUsernameInput!) {
    userCheckUsername(input: $input) {
      username
      exists
    }
  }
`;
export type UserCheckUsernameMutationFn = Apollo.MutationFunction<
  UserCheckUsernameMutation,
  UserCheckUsernameMutationVariables
>;

/**
 * __useUserCheckUsernameMutation__
 *
 * To run a mutation, you first call `useUserCheckUsernameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserCheckUsernameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userCheckUsernameMutation, { data, loading, error }] = useUserCheckUsernameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserCheckUsernameMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UserCheckUsernameMutation,
    UserCheckUsernameMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UserCheckUsernameMutation,
    UserCheckUsernameMutationVariables
  >(UserCheckUsernameDocument, options);
}
export type UserCheckUsernameMutationHookResult = ReturnType<
  typeof useUserCheckUsernameMutation
>;
export type UserCheckUsernameMutationResult = Apollo.MutationResult<
  UserCheckUsernameMutation
>;
export type UserCheckUsernameMutationOptions = Apollo.BaseMutationOptions<
  UserCheckUsernameMutation,
  UserCheckUsernameMutationVariables
>;
export const UserUpdateUsernameDocument = /*#__PURE__*/ gql`
  mutation UserUpdateUsername($input: UserUpdateUsernameInput!) {
    userUpdateUsername(input: $input) {
      username
    }
  }
`;
export type UserUpdateUsernameMutationFn = Apollo.MutationFunction<
  UserUpdateUsernameMutation,
  UserUpdateUsernameMutationVariables
>;

/**
 * __useUserUpdateUsernameMutation__
 *
 * To run a mutation, you first call `useUserUpdateUsernameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserUpdateUsernameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userUpdateUsernameMutation, { data, loading, error }] = useUserUpdateUsernameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserUpdateUsernameMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UserUpdateUsernameMutation,
    UserUpdateUsernameMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UserUpdateUsernameMutation,
    UserUpdateUsernameMutationVariables
  >(UserUpdateUsernameDocument, options);
}
export type UserUpdateUsernameMutationHookResult = ReturnType<
  typeof useUserUpdateUsernameMutation
>;
export type UserUpdateUsernameMutationResult = Apollo.MutationResult<
  UserUpdateUsernameMutation
>;
export type UserUpdateUsernameMutationOptions = Apollo.BaseMutationOptions<
  UserUpdateUsernameMutation,
  UserUpdateUsernameMutationVariables
>;
export const UpdateUserNameDocument = /*#__PURE__*/ gql`
  mutation UpdateUserName($input: UserNameInput!) {
    userUpdateName(input: $input) {
      id
      uid
      name
    }
  }
`;
export type UpdateUserNameMutationFn = Apollo.MutationFunction<
  UpdateUserNameMutation,
  UpdateUserNameMutationVariables
>;

/**
 * __useUpdateUserNameMutation__
 *
 * To run a mutation, you first call `useUpdateUserNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserNameMutation, { data, loading, error }] = useUpdateUserNameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserNameMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUserNameMutation,
    UpdateUserNameMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateUserNameMutation,
    UpdateUserNameMutationVariables
  >(UpdateUserNameDocument, options);
}
export type UpdateUserNameMutationHookResult = ReturnType<
  typeof useUpdateUserNameMutation
>;
export type UpdateUserNameMutationResult = Apollo.MutationResult<
  UpdateUserNameMutation
>;
export type UpdateUserNameMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserNameMutation,
  UpdateUserNameMutationVariables
>;
export const GetChallengesDocument = /*#__PURE__*/ gql`
  query GetChallenges {
    challengesPromoted {
      ...ChallengeCard
    }
  }
  ${ChallengeCardFragmentDoc}
`;

/**
 * __useGetChallengesQuery__
 *
 * To run a query within a React component, call `useGetChallengesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChallengesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChallengesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetChallengesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetChallengesQuery,
    GetChallengesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetChallengesQuery, GetChallengesQueryVariables>(
    GetChallengesDocument,
    options
  );
}
export function useGetChallengesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetChallengesQuery,
    GetChallengesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetChallengesQuery, GetChallengesQueryVariables>(
    GetChallengesDocument,
    options
  );
}
export type GetChallengesQueryHookResult = ReturnType<
  typeof useGetChallengesQuery
>;
export type GetChallengesLazyQueryHookResult = ReturnType<
  typeof useGetChallengesLazyQuery
>;
export type GetChallengesQueryResult = Apollo.QueryResult<
  GetChallengesQuery,
  GetChallengesQueryVariables
>;
export const CreateSubscriptionDocument = /*#__PURE__*/ gql`
  mutation CreateSubscription(
    $planInfo: PlanInfoInput!
    $gateway: GatewayInput!
    $paymentMethodType: PaymentMethodType!
    $trialOverrideTime: Timestamp
    $couponIds: [String!]
    $ipInfo: IpInfoInput
  ) {
    subscriptionCreate(
      input: {
        planInfo: $planInfo
        gateway: $gateway
        paymentMethodType: $paymentMethodType
        trialOverrideTime: $trialOverrideTime
        couponIds: $couponIds
        ipInfo: $ipInfo
      }
    ) {
      ...SubscriptionFields
      trialEndTime
      plan {
        ...PlanFields
        trialPeriod
        periodUnit
        priceInCents
        provider {
          id
        }
      }
      user {
        id
        uid
        isActive
        hasTrialed
      }
    }
  }
  ${SubscriptionFieldsFragmentDoc}
  ${PlanFieldsFragmentDoc}
`;
export type CreateSubscriptionMutationFn = Apollo.MutationFunction<
  CreateSubscriptionMutation,
  CreateSubscriptionMutationVariables
>;

/**
 * __useCreateSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubscriptionMutation, { data, loading, error }] = useCreateSubscriptionMutation({
 *   variables: {
 *      planInfo: // value for 'planInfo'
 *      gateway: // value for 'gateway'
 *      paymentMethodType: // value for 'paymentMethodType'
 *      trialOverrideTime: // value for 'trialOverrideTime'
 *      couponIds: // value for 'couponIds'
 *      ipInfo: // value for 'ipInfo'
 *   },
 * });
 */
export function useCreateSubscriptionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateSubscriptionMutation,
    CreateSubscriptionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateSubscriptionMutation,
    CreateSubscriptionMutationVariables
  >(CreateSubscriptionDocument, options);
}
export type CreateSubscriptionMutationHookResult = ReturnType<
  typeof useCreateSubscriptionMutation
>;
export type CreateSubscriptionMutationResult = Apollo.MutationResult<
  CreateSubscriptionMutation
>;
export type CreateSubscriptionMutationOptions = Apollo.BaseMutationOptions<
  CreateSubscriptionMutation,
  CreateSubscriptionMutationVariables
>;
export const PlansDocument = /*#__PURE__*/ gql`
  query Plans($providerName: SubscriptionProvider!, $countryCode: String!) {
    plans: plans(
      input: { providerName: $providerName, countryCode: $countryCode }
    ) {
      id
      name
      currencyCode
      accessType
      isBestValue
      isSubscribed
      monthlySavingsInPercent
      monthlyCostInCents
      annualSavingsInCents
      period
      periodUnit
      trialPeriod
      trialPeriodUnit
      priceInCents
      canTrial(
        input: { providerName: $providerName, countryCode: $countryCode }
      )
      trialEndTime(
        input: { providerName: $providerName, countryCode: $countryCode }
      )
      nextBillingAt(
        input: { providerName: $providerName, countryCode: $countryCode }
      )
      invoiceEstimate {
        amountDue
        creditsApplied
        total
        subTotal
      }
      changePlanEstimate(
        input: { providerName: $providerName, countryCode: $countryCode }
      ) {
        changePlanType
        isEndOfTerm
        invoiceEstimate {
          amountDue
          total
        }
      }
      provider {
        id
        name
      }
    }
  }
`;

/**
 * __usePlansQuery__
 *
 * To run a query within a React component, call `usePlansQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlansQuery({
 *   variables: {
 *      providerName: // value for 'providerName'
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function usePlansQuery(
  baseOptions: Apollo.QueryHookOptions<PlansQuery, PlansQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PlansQuery, PlansQueryVariables>(
    PlansDocument,
    options
  );
}
export function usePlansLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PlansQuery, PlansQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PlansQuery, PlansQueryVariables>(
    PlansDocument,
    options
  );
}
export type PlansQueryHookResult = ReturnType<typeof usePlansQuery>;
export type PlansLazyQueryHookResult = ReturnType<typeof usePlansLazyQuery>;
export type PlansQueryResult = Apollo.QueryResult<
  PlansQuery,
  PlansQueryVariables
>;
export const GetClassAndUserPostsByIdDocument = /*#__PURE__*/ gql`
  query GetClassAndUserPostsById($classId: String!) {
    classById(id: $classId) {
      id
      slug
      isExplicit
      title
      level
      duration_in_seconds
      type
      instructor {
        name
        slug
      }
      style
      thumbnail
      progress {
        completed
        time {
          hour
          minute
          second
        }
      }
      userVideos {
        edges {
          cursor
          node {
            id
            isAuthoredByMe
            reportedByMe
            description
            thumbnailUrl
            playbackUrl
            uploadedAt
            uploadedBy {
              id
              uid
              username
            }
            encodingStatus
            reactions {
              reactionType
              totalCount
            }
            userReactions
          }
        }
      }
    }
  }
`;

/**
 * __useGetClassAndUserPostsByIdQuery__
 *
 * To run a query within a React component, call `useGetClassAndUserPostsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassAndUserPostsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassAndUserPostsByIdQuery({
 *   variables: {
 *      classId: // value for 'classId'
 *   },
 * });
 */
export function useGetClassAndUserPostsByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetClassAndUserPostsByIdQuery,
    GetClassAndUserPostsByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetClassAndUserPostsByIdQuery,
    GetClassAndUserPostsByIdQueryVariables
  >(GetClassAndUserPostsByIdDocument, options);
}
export function useGetClassAndUserPostsByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetClassAndUserPostsByIdQuery,
    GetClassAndUserPostsByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetClassAndUserPostsByIdQuery,
    GetClassAndUserPostsByIdQueryVariables
  >(GetClassAndUserPostsByIdDocument, options);
}
export type GetClassAndUserPostsByIdQueryHookResult = ReturnType<
  typeof useGetClassAndUserPostsByIdQuery
>;
export type GetClassAndUserPostsByIdLazyQueryHookResult = ReturnType<
  typeof useGetClassAndUserPostsByIdLazyQuery
>;
export type GetClassAndUserPostsByIdQueryResult = Apollo.QueryResult<
  GetClassAndUserPostsByIdQuery,
  GetClassAndUserPostsByIdQueryVariables
>;
export const VideoUploadsPublishedDocument = /*#__PURE__*/ gql`
  query VideoUploadsPublished($pagination: ConnectionArgs!) {
    videoUploadsPublished(pagination: $pagination) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          ...CoreVideoUploadsPublishedFields
        }
      }
    }
  }
  ${CoreVideoUploadsPublishedFieldsFragmentDoc}
`;

/**
 * __useVideoUploadsPublishedQuery__
 *
 * To run a query within a React component, call `useVideoUploadsPublishedQuery` and pass it any options that fit your needs.
 * When your component renders, `useVideoUploadsPublishedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVideoUploadsPublishedQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useVideoUploadsPublishedQuery(
  baseOptions: Apollo.QueryHookOptions<
    VideoUploadsPublishedQuery,
    VideoUploadsPublishedQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    VideoUploadsPublishedQuery,
    VideoUploadsPublishedQueryVariables
  >(VideoUploadsPublishedDocument, options);
}
export function useVideoUploadsPublishedLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VideoUploadsPublishedQuery,
    VideoUploadsPublishedQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    VideoUploadsPublishedQuery,
    VideoUploadsPublishedQueryVariables
  >(VideoUploadsPublishedDocument, options);
}
export type VideoUploadsPublishedQueryHookResult = ReturnType<
  typeof useVideoUploadsPublishedQuery
>;
export type VideoUploadsPublishedLazyQueryHookResult = ReturnType<
  typeof useVideoUploadsPublishedLazyQuery
>;
export type VideoUploadsPublishedQueryResult = Apollo.QueryResult<
  VideoUploadsPublishedQuery,
  VideoUploadsPublishedQueryVariables
>;
export const GetPersonalizedPlaylistDocument = /*#__PURE__*/ gql`
  query GetPersonalizedPlaylist {
    myPersonalizedPlaylist: me {
      id
      personalizedPlaylist {
        ...CoreClassFields
      }
    }
  }
  ${CoreClassFieldsFragmentDoc}
`;

/**
 * __useGetPersonalizedPlaylistQuery__
 *
 * To run a query within a React component, call `useGetPersonalizedPlaylistQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonalizedPlaylistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonalizedPlaylistQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPersonalizedPlaylistQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPersonalizedPlaylistQuery,
    GetPersonalizedPlaylistQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPersonalizedPlaylistQuery,
    GetPersonalizedPlaylistQueryVariables
  >(GetPersonalizedPlaylistDocument, options);
}
export function useGetPersonalizedPlaylistLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPersonalizedPlaylistQuery,
    GetPersonalizedPlaylistQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPersonalizedPlaylistQuery,
    GetPersonalizedPlaylistQueryVariables
  >(GetPersonalizedPlaylistDocument, options);
}
export type GetPersonalizedPlaylistQueryHookResult = ReturnType<
  typeof useGetPersonalizedPlaylistQuery
>;
export type GetPersonalizedPlaylistLazyQueryHookResult = ReturnType<
  typeof useGetPersonalizedPlaylistLazyQuery
>;
export type GetPersonalizedPlaylistQueryResult = Apollo.QueryResult<
  GetPersonalizedPlaylistQuery,
  GetPersonalizedPlaylistQueryVariables
>;
export const GetPromotedChallengesDocument = /*#__PURE__*/ gql`
  query GetPromotedChallenges {
    challengesPromoted {
      ...ChallengeCard
    }
  }
  ${ChallengeCardFragmentDoc}
`;

/**
 * __useGetPromotedChallengesQuery__
 *
 * To run a query within a React component, call `useGetPromotedChallengesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPromotedChallengesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPromotedChallengesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPromotedChallengesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPromotedChallengesQuery,
    GetPromotedChallengesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPromotedChallengesQuery,
    GetPromotedChallengesQueryVariables
  >(GetPromotedChallengesDocument, options);
}
export function useGetPromotedChallengesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPromotedChallengesQuery,
    GetPromotedChallengesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPromotedChallengesQuery,
    GetPromotedChallengesQueryVariables
  >(GetPromotedChallengesDocument, options);
}
export type GetPromotedChallengesQueryHookResult = ReturnType<
  typeof useGetPromotedChallengesQuery
>;
export type GetPromotedChallengesLazyQueryHookResult = ReturnType<
  typeof useGetPromotedChallengesLazyQuery
>;
export type GetPromotedChallengesQueryResult = Apollo.QueryResult<
  GetPromotedChallengesQuery,
  GetPromotedChallengesQueryVariables
>;
export const GetChallengeDetailsDocument = /*#__PURE__*/ gql`
  query GetChallengeDetails($challengeId: String!) {
    challengeById(id: $challengeId) {
      ...ChallengeDetailsPage
    }
  }
  ${ChallengeDetailsPageFragmentDoc}
`;

/**
 * __useGetChallengeDetailsQuery__
 *
 * To run a query within a React component, call `useGetChallengeDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChallengeDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChallengeDetailsQuery({
 *   variables: {
 *      challengeId: // value for 'challengeId'
 *   },
 * });
 */
export function useGetChallengeDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetChallengeDetailsQuery,
    GetChallengeDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetChallengeDetailsQuery,
    GetChallengeDetailsQueryVariables
  >(GetChallengeDetailsDocument, options);
}
export function useGetChallengeDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetChallengeDetailsQuery,
    GetChallengeDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetChallengeDetailsQuery,
    GetChallengeDetailsQueryVariables
  >(GetChallengeDetailsDocument, options);
}
export type GetChallengeDetailsQueryHookResult = ReturnType<
  typeof useGetChallengeDetailsQuery
>;
export type GetChallengeDetailsLazyQueryHookResult = ReturnType<
  typeof useGetChallengeDetailsLazyQuery
>;
export type GetChallengeDetailsQueryResult = Apollo.QueryResult<
  GetChallengeDetailsQuery,
  GetChallengeDetailsQueryVariables
>;
export const GetHomeDataDocument = /*#__PURE__*/ gql`
  query GetHomeData($date: String!) {
    todaysPlaylist: getPlaylist(date: $date) {
      classes {
        ...CorePlaylistClassFields
      }
    }
    continueDancing: getHistoryDataV2(input: { first: 5, after: "" }) {
      classes: edges {
        class: node {
          ...CoreClassFields
          ... on ProgramV2 {
            programSlug: slug
          }
        }
      }
    }
    dancePrograms: searchProgramsV2(
      input: { query: "", pagination: { count: 4, page: 0 } }
    ) {
      programs: programs {
        progress {
          completedClassesCount
        }
        totalClassesCount
        level
        slug
        style
        title
        content {
          assets {
            thumbnailURL
          }
        }
        instructor {
          name
          slug
        }
        categories
        isFree
        isSaved
      }
    }
    savedClasses: getSavedDataV2(
      input: { first: 5, after: "", contentType: CLASSES }
    ) {
      classes: edges {
        class: node {
          ... on Class {
            ...CoreClassFields
          }
        }
      }
    }
  }
  ${CorePlaylistClassFieldsFragmentDoc}
  ${CoreClassFieldsFragmentDoc}
`;

/**
 * __useGetHomeDataQuery__
 *
 * To run a query within a React component, call `useGetHomeDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHomeDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHomeDataQuery({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetHomeDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetHomeDataQuery,
    GetHomeDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetHomeDataQuery, GetHomeDataQueryVariables>(
    GetHomeDataDocument,
    options
  );
}
export function useGetHomeDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetHomeDataQuery,
    GetHomeDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetHomeDataQuery, GetHomeDataQueryVariables>(
    GetHomeDataDocument,
    options
  );
}
export type GetHomeDataQueryHookResult = ReturnType<typeof useGetHomeDataQuery>;
export type GetHomeDataLazyQueryHookResult = ReturnType<
  typeof useGetHomeDataLazyQuery
>;
export type GetHomeDataQueryResult = Apollo.QueryResult<
  GetHomeDataQuery,
  GetHomeDataQueryVariables
>;
export const GetFeaturedContentDocument = /*#__PURE__*/ gql`
  query getFeaturedContent {
    featuredClasses: featured {
      sortIndex
      content {
        ...FeaturedClass
      }
    }
    featuredPlaylists {
      ...FeaturedPlaylist
    }
  }
  ${FeaturedClassFragmentDoc}
  ${FeaturedPlaylistFragmentDoc}
`;

/**
 * __useGetFeaturedContentQuery__
 *
 * To run a query within a React component, call `useGetFeaturedContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeaturedContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeaturedContentQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFeaturedContentQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetFeaturedContentQuery,
    GetFeaturedContentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetFeaturedContentQuery,
    GetFeaturedContentQueryVariables
  >(GetFeaturedContentDocument, options);
}
export function useGetFeaturedContentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFeaturedContentQuery,
    GetFeaturedContentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetFeaturedContentQuery,
    GetFeaturedContentQueryVariables
  >(GetFeaturedContentDocument, options);
}
export type GetFeaturedContentQueryHookResult = ReturnType<
  typeof useGetFeaturedContentQuery
>;
export type GetFeaturedContentLazyQueryHookResult = ReturnType<
  typeof useGetFeaturedContentLazyQuery
>;
export type GetFeaturedContentQueryResult = Apollo.QueryResult<
  GetFeaturedContentQuery,
  GetFeaturedContentQueryVariables
>;
export const GetPreferredCategoriesDocument = /*#__PURE__*/ gql`
  query GetPreferredCategories {
    preferredCategories: me {
      id
      preferred {
        categories {
          slug
          name
          classes {
            ...CoreClassFields
          }
        }
      }
    }
  }
  ${CoreClassFieldsFragmentDoc}
`;

/**
 * __useGetPreferredCategoriesQuery__
 *
 * To run a query within a React component, call `useGetPreferredCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreferredCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreferredCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPreferredCategoriesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPreferredCategoriesQuery,
    GetPreferredCategoriesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPreferredCategoriesQuery,
    GetPreferredCategoriesQueryVariables
  >(GetPreferredCategoriesDocument, options);
}
export function useGetPreferredCategoriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPreferredCategoriesQuery,
    GetPreferredCategoriesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPreferredCategoriesQuery,
    GetPreferredCategoriesQueryVariables
  >(GetPreferredCategoriesDocument, options);
}
export type GetPreferredCategoriesQueryHookResult = ReturnType<
  typeof useGetPreferredCategoriesQuery
>;
export type GetPreferredCategoriesLazyQueryHookResult = ReturnType<
  typeof useGetPreferredCategoriesLazyQuery
>;
export type GetPreferredCategoriesQueryResult = Apollo.QueryResult<
  GetPreferredCategoriesQuery,
  GetPreferredCategoriesQueryVariables
>;
export const SearchClassesForDashboardDocument = /*#__PURE__*/ gql`
  query SearchClassesForDashboard($filters: String!) {
    classesForDashboard: searchClasses(
      input: {
        index: "classes"
        query: ""
        filters: $filters
        page: 0
        hitsPerPage: 5
      }
    ) {
      classes: edges {
        class: node {
          ...CoreClassFields
        }
      }
    }
  }
  ${CoreClassFieldsFragmentDoc}
`;

/**
 * __useSearchClassesForDashboardQuery__
 *
 * To run a query within a React component, call `useSearchClassesForDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchClassesForDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchClassesForDashboardQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useSearchClassesForDashboardQuery(
  baseOptions: Apollo.QueryHookOptions<
    SearchClassesForDashboardQuery,
    SearchClassesForDashboardQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SearchClassesForDashboardQuery,
    SearchClassesForDashboardQueryVariables
  >(SearchClassesForDashboardDocument, options);
}
export function useSearchClassesForDashboardLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SearchClassesForDashboardQuery,
    SearchClassesForDashboardQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SearchClassesForDashboardQuery,
    SearchClassesForDashboardQueryVariables
  >(SearchClassesForDashboardDocument, options);
}
export type SearchClassesForDashboardQueryHookResult = ReturnType<
  typeof useSearchClassesForDashboardQuery
>;
export type SearchClassesForDashboardLazyQueryHookResult = ReturnType<
  typeof useSearchClassesForDashboardLazyQuery
>;
export type SearchClassesForDashboardQueryResult = Apollo.QueryResult<
  SearchClassesForDashboardQuery,
  SearchClassesForDashboardQueryVariables
>;
export const CreateRecommendedSchedulePlaylistV2Document = /*#__PURE__*/ gql`
  mutation CreateRecommendedSchedulePlaylistV2($date: String!) {
    createRecommendedSchedulePlaylistV2(input: { date: $date }) {
      id
    }
  }
`;
export type CreateRecommendedSchedulePlaylistV2MutationFn = Apollo.MutationFunction<
  CreateRecommendedSchedulePlaylistV2Mutation,
  CreateRecommendedSchedulePlaylistV2MutationVariables
>;

/**
 * __useCreateRecommendedSchedulePlaylistV2Mutation__
 *
 * To run a mutation, you first call `useCreateRecommendedSchedulePlaylistV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRecommendedSchedulePlaylistV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRecommendedSchedulePlaylistV2Mutation, { data, loading, error }] = useCreateRecommendedSchedulePlaylistV2Mutation({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useCreateRecommendedSchedulePlaylistV2Mutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateRecommendedSchedulePlaylistV2Mutation,
    CreateRecommendedSchedulePlaylistV2MutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateRecommendedSchedulePlaylistV2Mutation,
    CreateRecommendedSchedulePlaylistV2MutationVariables
  >(CreateRecommendedSchedulePlaylistV2Document, options);
}
export type CreateRecommendedSchedulePlaylistV2MutationHookResult = ReturnType<
  typeof useCreateRecommendedSchedulePlaylistV2Mutation
>;
export type CreateRecommendedSchedulePlaylistV2MutationResult = Apollo.MutationResult<
  CreateRecommendedSchedulePlaylistV2Mutation
>;
export type CreateRecommendedSchedulePlaylistV2MutationOptions = Apollo.BaseMutationOptions<
  CreateRecommendedSchedulePlaylistV2Mutation,
  CreateRecommendedSchedulePlaylistV2MutationVariables
>;
export const ProgramHistoryDataDocument = /*#__PURE__*/ gql`
  query ProgramHistoryData($input: HistoryV3Input) {
    programHistoryData: getHistoryDataV3(input: $input) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          __typename
          ... on ProgramV2 {
            slug
            progress {
              completedDate
            }
          }
        }
      }
    }
  }
`;

/**
 * __useProgramHistoryDataQuery__
 *
 * To run a query within a React component, call `useProgramHistoryDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgramHistoryDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgramHistoryDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProgramHistoryDataQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ProgramHistoryDataQuery,
    ProgramHistoryDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ProgramHistoryDataQuery,
    ProgramHistoryDataQueryVariables
  >(ProgramHistoryDataDocument, options);
}
export function useProgramHistoryDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProgramHistoryDataQuery,
    ProgramHistoryDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ProgramHistoryDataQuery,
    ProgramHistoryDataQueryVariables
  >(ProgramHistoryDataDocument, options);
}
export type ProgramHistoryDataQueryHookResult = ReturnType<
  typeof useProgramHistoryDataQuery
>;
export type ProgramHistoryDataLazyQueryHookResult = ReturnType<
  typeof useProgramHistoryDataLazyQuery
>;
export type ProgramHistoryDataQueryResult = Apollo.QueryResult<
  ProgramHistoryDataQuery,
  ProgramHistoryDataQueryVariables
>;
export const ClassHistoryDataDocument = /*#__PURE__*/ gql`
  query ClassHistoryData($input: HistoryV3Input) {
    classHistoryData: getHistoryDataV3(input: $input) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          __typename
          ... on Class {
            ...HistoryClassCardData
          }
        }
      }
    }
  }
  ${HistoryClassCardDataFragmentDoc}
`;

/**
 * __useClassHistoryDataQuery__
 *
 * To run a query within a React component, call `useClassHistoryDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassHistoryDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassHistoryDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClassHistoryDataQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ClassHistoryDataQuery,
    ClassHistoryDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ClassHistoryDataQuery, ClassHistoryDataQueryVariables>(
    ClassHistoryDataDocument,
    options
  );
}
export function useClassHistoryDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClassHistoryDataQuery,
    ClassHistoryDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ClassHistoryDataQuery,
    ClassHistoryDataQueryVariables
  >(ClassHistoryDataDocument, options);
}
export type ClassHistoryDataQueryHookResult = ReturnType<
  typeof useClassHistoryDataQuery
>;
export type ClassHistoryDataLazyQueryHookResult = ReturnType<
  typeof useClassHistoryDataLazyQuery
>;
export type ClassHistoryDataQueryResult = Apollo.QueryResult<
  ClassHistoryDataQuery,
  ClassHistoryDataQueryVariables
>;
export const GetInstructorProfileBySlugDocument = /*#__PURE__*/ gql`
  query GetInstructorProfileBySlug($slug: String!) {
    instructorBySlugPublic(slug: $slug) {
      id
      name
      bio
      slug
      credits
      avatarImageUrl
      profileImageUrl
      location
      youtube
      facebook
      instagram
      twitter
      userProfile {
        id
        username
        photoURL
      }
    }
  }
`;

/**
 * __useGetInstructorProfileBySlugQuery__
 *
 * To run a query within a React component, call `useGetInstructorProfileBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstructorProfileBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstructorProfileBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetInstructorProfileBySlugQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetInstructorProfileBySlugQuery,
    GetInstructorProfileBySlugQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetInstructorProfileBySlugQuery,
    GetInstructorProfileBySlugQueryVariables
  >(GetInstructorProfileBySlugDocument, options);
}
export function useGetInstructorProfileBySlugLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetInstructorProfileBySlugQuery,
    GetInstructorProfileBySlugQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetInstructorProfileBySlugQuery,
    GetInstructorProfileBySlugQueryVariables
  >(GetInstructorProfileBySlugDocument, options);
}
export type GetInstructorProfileBySlugQueryHookResult = ReturnType<
  typeof useGetInstructorProfileBySlugQuery
>;
export type GetInstructorProfileBySlugLazyQueryHookResult = ReturnType<
  typeof useGetInstructorProfileBySlugLazyQuery
>;
export type GetInstructorProfileBySlugQueryResult = Apollo.QueryResult<
  GetInstructorProfileBySlugQuery,
  GetInstructorProfileBySlugQueryVariables
>;
export const CreatePlaylistDocument = /*#__PURE__*/ gql`
  mutation CreatePlaylist($input: PlaylistCreateInput!) {
    playlistCreate(input: $input) {
      ...CorePlaylistV2Fields
    }
  }
  ${CorePlaylistV2FieldsFragmentDoc}
`;
export type CreatePlaylistMutationFn = Apollo.MutationFunction<
  CreatePlaylistMutation,
  CreatePlaylistMutationVariables
>;

/**
 * __useCreatePlaylistMutation__
 *
 * To run a mutation, you first call `useCreatePlaylistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlaylistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlaylistMutation, { data, loading, error }] = useCreatePlaylistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePlaylistMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreatePlaylistMutation,
    CreatePlaylistMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreatePlaylistMutation,
    CreatePlaylistMutationVariables
  >(CreatePlaylistDocument, options);
}
export type CreatePlaylistMutationHookResult = ReturnType<
  typeof useCreatePlaylistMutation
>;
export type CreatePlaylistMutationResult = Apollo.MutationResult<
  CreatePlaylistMutation
>;
export type CreatePlaylistMutationOptions = Apollo.BaseMutationOptions<
  CreatePlaylistMutation,
  CreatePlaylistMutationVariables
>;
export const EditPlaylistDocument = /*#__PURE__*/ gql`
  mutation EditPlaylist($input: PlaylistUpdateDetailsInput!) {
    playlistUpdateDetails(input: $input) {
      ...CorePlaylistV2Fields
    }
  }
  ${CorePlaylistV2FieldsFragmentDoc}
`;
export type EditPlaylistMutationFn = Apollo.MutationFunction<
  EditPlaylistMutation,
  EditPlaylistMutationVariables
>;

/**
 * __useEditPlaylistMutation__
 *
 * To run a mutation, you first call `useEditPlaylistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPlaylistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPlaylistMutation, { data, loading, error }] = useEditPlaylistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditPlaylistMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EditPlaylistMutation,
    EditPlaylistMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    EditPlaylistMutation,
    EditPlaylistMutationVariables
  >(EditPlaylistDocument, options);
}
export type EditPlaylistMutationHookResult = ReturnType<
  typeof useEditPlaylistMutation
>;
export type EditPlaylistMutationResult = Apollo.MutationResult<
  EditPlaylistMutation
>;
export type EditPlaylistMutationOptions = Apollo.BaseMutationOptions<
  EditPlaylistMutation,
  EditPlaylistMutationVariables
>;
export const DeletePlaylistDocument = /*#__PURE__*/ gql`
  mutation DeletePlaylist($input: PlaylistDeleteInput!) {
    playlistDelete(input: $input)
  }
`;
export type DeletePlaylistMutationFn = Apollo.MutationFunction<
  DeletePlaylistMutation,
  DeletePlaylistMutationVariables
>;

/**
 * __useDeletePlaylistMutation__
 *
 * To run a mutation, you first call `useDeletePlaylistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePlaylistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePlaylistMutation, { data, loading, error }] = useDeletePlaylistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePlaylistMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeletePlaylistMutation,
    DeletePlaylistMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeletePlaylistMutation,
    DeletePlaylistMutationVariables
  >(DeletePlaylistDocument, options);
}
export type DeletePlaylistMutationHookResult = ReturnType<
  typeof useDeletePlaylistMutation
>;
export type DeletePlaylistMutationResult = Apollo.MutationResult<
  DeletePlaylistMutation
>;
export type DeletePlaylistMutationOptions = Apollo.BaseMutationOptions<
  DeletePlaylistMutation,
  DeletePlaylistMutationVariables
>;
export const SavePlaylistDocument = /*#__PURE__*/ gql`
  mutation SavePlaylist($input: PlaylistSaveOrUnsaveInput!) {
    playlistSave(input: $input)
  }
`;
export type SavePlaylistMutationFn = Apollo.MutationFunction<
  SavePlaylistMutation,
  SavePlaylistMutationVariables
>;

/**
 * __useSavePlaylistMutation__
 *
 * To run a mutation, you first call `useSavePlaylistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePlaylistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePlaylistMutation, { data, loading, error }] = useSavePlaylistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSavePlaylistMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SavePlaylistMutation,
    SavePlaylistMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SavePlaylistMutation,
    SavePlaylistMutationVariables
  >(SavePlaylistDocument, options);
}
export type SavePlaylistMutationHookResult = ReturnType<
  typeof useSavePlaylistMutation
>;
export type SavePlaylistMutationResult = Apollo.MutationResult<
  SavePlaylistMutation
>;
export type SavePlaylistMutationOptions = Apollo.BaseMutationOptions<
  SavePlaylistMutation,
  SavePlaylistMutationVariables
>;
export const UnsavePlaylistDocument = /*#__PURE__*/ gql`
  mutation UnsavePlaylist($input: PlaylistSaveOrUnsaveInput!) {
    playlistUnsave(input: $input)
  }
`;
export type UnsavePlaylistMutationFn = Apollo.MutationFunction<
  UnsavePlaylistMutation,
  UnsavePlaylistMutationVariables
>;

/**
 * __useUnsavePlaylistMutation__
 *
 * To run a mutation, you first call `useUnsavePlaylistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsavePlaylistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsavePlaylistMutation, { data, loading, error }] = useUnsavePlaylistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnsavePlaylistMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnsavePlaylistMutation,
    UnsavePlaylistMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UnsavePlaylistMutation,
    UnsavePlaylistMutationVariables
  >(UnsavePlaylistDocument, options);
}
export type UnsavePlaylistMutationHookResult = ReturnType<
  typeof useUnsavePlaylistMutation
>;
export type UnsavePlaylistMutationResult = Apollo.MutationResult<
  UnsavePlaylistMutation
>;
export type UnsavePlaylistMutationOptions = Apollo.BaseMutationOptions<
  UnsavePlaylistMutation,
  UnsavePlaylistMutationVariables
>;
export const PlaylistAddStudioClassDocument = /*#__PURE__*/ gql`
  mutation PlaylistAddStudioClass(
    $input: PlaylistAddOrRemoveStudioClassInput!
  ) {
    playlistAddStudioClass(input: $input) {
      id
      studioClassId
      hasStudioClass
    }
  }
`;
export type PlaylistAddStudioClassMutationFn = Apollo.MutationFunction<
  PlaylistAddStudioClassMutation,
  PlaylistAddStudioClassMutationVariables
>;

/**
 * __usePlaylistAddStudioClassMutation__
 *
 * To run a mutation, you first call `usePlaylistAddStudioClassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlaylistAddStudioClassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [playlistAddStudioClassMutation, { data, loading, error }] = usePlaylistAddStudioClassMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePlaylistAddStudioClassMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PlaylistAddStudioClassMutation,
    PlaylistAddStudioClassMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PlaylistAddStudioClassMutation,
    PlaylistAddStudioClassMutationVariables
  >(PlaylistAddStudioClassDocument, options);
}
export type PlaylistAddStudioClassMutationHookResult = ReturnType<
  typeof usePlaylistAddStudioClassMutation
>;
export type PlaylistAddStudioClassMutationResult = Apollo.MutationResult<
  PlaylistAddStudioClassMutation
>;
export type PlaylistAddStudioClassMutationOptions = Apollo.BaseMutationOptions<
  PlaylistAddStudioClassMutation,
  PlaylistAddStudioClassMutationVariables
>;
export const PlaylistRemoveStudioClassDocument = /*#__PURE__*/ gql`
  mutation PlaylistRemoveStudioClass(
    $input: PlaylistAddOrRemoveStudioClassInput!
  ) {
    playlistRemoveStudioClass(input: $input) {
      id
      studioClassId
      hasStudioClass
    }
  }
`;
export type PlaylistRemoveStudioClassMutationFn = Apollo.MutationFunction<
  PlaylistRemoveStudioClassMutation,
  PlaylistRemoveStudioClassMutationVariables
>;

/**
 * __usePlaylistRemoveStudioClassMutation__
 *
 * To run a mutation, you first call `usePlaylistRemoveStudioClassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlaylistRemoveStudioClassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [playlistRemoveStudioClassMutation, { data, loading, error }] = usePlaylistRemoveStudioClassMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePlaylistRemoveStudioClassMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PlaylistRemoveStudioClassMutation,
    PlaylistRemoveStudioClassMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PlaylistRemoveStudioClassMutation,
    PlaylistRemoveStudioClassMutationVariables
  >(PlaylistRemoveStudioClassDocument, options);
}
export type PlaylistRemoveStudioClassMutationHookResult = ReturnType<
  typeof usePlaylistRemoveStudioClassMutation
>;
export type PlaylistRemoveStudioClassMutationResult = Apollo.MutationResult<
  PlaylistRemoveStudioClassMutation
>;
export type PlaylistRemoveStudioClassMutationOptions = Apollo.BaseMutationOptions<
  PlaylistRemoveStudioClassMutation,
  PlaylistRemoveStudioClassMutationVariables
>;
export const GetMyPlaylistsDocument = /*#__PURE__*/ gql`
  query GetMyPlaylists(
    $pagination: ConnectionArgs!
    $studioClassIds: [String!]!
  ) {
    me {
      id
      myPlaylists(pagination: $pagination) {
        pageInfo {
          ...CorePageInfoFields
        }
        edges {
          node {
            ...CorePlaylistV2Fields
            hasStudioClasses(studioClassIds: $studioClassIds) {
              id
              studioClassId
              hasStudioClass
            }
          }
        }
      }
    }
  }
  ${CorePageInfoFieldsFragmentDoc}
  ${CorePlaylistV2FieldsFragmentDoc}
`;

/**
 * __useGetMyPlaylistsQuery__
 *
 * To run a query within a React component, call `useGetMyPlaylistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyPlaylistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyPlaylistsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      studioClassIds: // value for 'studioClassIds'
 *   },
 * });
 */
export function useGetMyPlaylistsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetMyPlaylistsQuery,
    GetMyPlaylistsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMyPlaylistsQuery, GetMyPlaylistsQueryVariables>(
    GetMyPlaylistsDocument,
    options
  );
}
export function useGetMyPlaylistsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMyPlaylistsQuery,
    GetMyPlaylistsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMyPlaylistsQuery, GetMyPlaylistsQueryVariables>(
    GetMyPlaylistsDocument,
    options
  );
}
export type GetMyPlaylistsQueryHookResult = ReturnType<
  typeof useGetMyPlaylistsQuery
>;
export type GetMyPlaylistsLazyQueryHookResult = ReturnType<
  typeof useGetMyPlaylistsLazyQuery
>;
export type GetMyPlaylistsQueryResult = Apollo.QueryResult<
  GetMyPlaylistsQuery,
  GetMyPlaylistsQueryVariables
>;
export const GetSavedPlaylistsDocument = /*#__PURE__*/ gql`
  query GetSavedPlaylists($pagination: ConnectionArgs!) {
    me {
      id
      savedPlaylists(pagination: $pagination) {
        pageInfo {
          ...CorePageInfoFields
        }
        edges {
          node {
            ...CorePlaylistV2Fields
          }
        }
      }
    }
  }
  ${CorePageInfoFieldsFragmentDoc}
  ${CorePlaylistV2FieldsFragmentDoc}
`;

/**
 * __useGetSavedPlaylistsQuery__
 *
 * To run a query within a React component, call `useGetSavedPlaylistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSavedPlaylistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSavedPlaylistsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetSavedPlaylistsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSavedPlaylistsQuery,
    GetSavedPlaylistsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSavedPlaylistsQuery,
    GetSavedPlaylistsQueryVariables
  >(GetSavedPlaylistsDocument, options);
}
export function useGetSavedPlaylistsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSavedPlaylistsQuery,
    GetSavedPlaylistsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSavedPlaylistsQuery,
    GetSavedPlaylistsQueryVariables
  >(GetSavedPlaylistsDocument, options);
}
export type GetSavedPlaylistsQueryHookResult = ReturnType<
  typeof useGetSavedPlaylistsQuery
>;
export type GetSavedPlaylistsLazyQueryHookResult = ReturnType<
  typeof useGetSavedPlaylistsLazyQuery
>;
export type GetSavedPlaylistsQueryResult = Apollo.QueryResult<
  GetSavedPlaylistsQuery,
  GetSavedPlaylistsQueryVariables
>;
export const GetPlaylistsSteezyDocument = /*#__PURE__*/ gql`
  query GetPlaylistsSteezy($pagination: ConnectionArgs!) {
    playlistsSteezy(pagination: $pagination) {
      pageInfo {
        ...CorePageInfoFields
      }
      edges {
        node {
          ...CorePlaylistV2Fields
        }
      }
    }
  }
  ${CorePageInfoFieldsFragmentDoc}
  ${CorePlaylistV2FieldsFragmentDoc}
`;

/**
 * __useGetPlaylistsSteezyQuery__
 *
 * To run a query within a React component, call `useGetPlaylistsSteezyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlaylistsSteezyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlaylistsSteezyQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetPlaylistsSteezyQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPlaylistsSteezyQuery,
    GetPlaylistsSteezyQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPlaylistsSteezyQuery,
    GetPlaylistsSteezyQueryVariables
  >(GetPlaylistsSteezyDocument, options);
}
export function useGetPlaylistsSteezyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPlaylistsSteezyQuery,
    GetPlaylistsSteezyQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPlaylistsSteezyQuery,
    GetPlaylistsSteezyQueryVariables
  >(GetPlaylistsSteezyDocument, options);
}
export type GetPlaylistsSteezyQueryHookResult = ReturnType<
  typeof useGetPlaylistsSteezyQuery
>;
export type GetPlaylistsSteezyLazyQueryHookResult = ReturnType<
  typeof useGetPlaylistsSteezyLazyQuery
>;
export type GetPlaylistsSteezyQueryResult = Apollo.QueryResult<
  GetPlaylistsSteezyQuery,
  GetPlaylistsSteezyQueryVariables
>;
export const GetPersonalizedPlaylistForCreatedPageDocument = /*#__PURE__*/ gql`
  query GetPersonalizedPlaylistForCreatedPage {
    myPersonalizedPlaylist: me {
      id
      personalizedPlaylist {
        ...CorePersonalizedPlaylistClassFields
      }
    }
  }
  ${CorePersonalizedPlaylistClassFieldsFragmentDoc}
`;

/**
 * __useGetPersonalizedPlaylistForCreatedPageQuery__
 *
 * To run a query within a React component, call `useGetPersonalizedPlaylistForCreatedPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonalizedPlaylistForCreatedPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonalizedPlaylistForCreatedPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPersonalizedPlaylistForCreatedPageQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPersonalizedPlaylistForCreatedPageQuery,
    GetPersonalizedPlaylistForCreatedPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPersonalizedPlaylistForCreatedPageQuery,
    GetPersonalizedPlaylistForCreatedPageQueryVariables
  >(GetPersonalizedPlaylistForCreatedPageDocument, options);
}
export function useGetPersonalizedPlaylistForCreatedPageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPersonalizedPlaylistForCreatedPageQuery,
    GetPersonalizedPlaylistForCreatedPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPersonalizedPlaylistForCreatedPageQuery,
    GetPersonalizedPlaylistForCreatedPageQueryVariables
  >(GetPersonalizedPlaylistForCreatedPageDocument, options);
}
export type GetPersonalizedPlaylistForCreatedPageQueryHookResult = ReturnType<
  typeof useGetPersonalizedPlaylistForCreatedPageQuery
>;
export type GetPersonalizedPlaylistForCreatedPageLazyQueryHookResult = ReturnType<
  typeof useGetPersonalizedPlaylistForCreatedPageLazyQuery
>;
export type GetPersonalizedPlaylistForCreatedPageQueryResult = Apollo.QueryResult<
  GetPersonalizedPlaylistForCreatedPageQuery,
  GetPersonalizedPlaylistForCreatedPageQueryVariables
>;
export const GetPlaylistDocument = /*#__PURE__*/ gql`
  query GetPlaylist(
    $pagination: ConnectionArgs!
    $playlistId: String!
    $studioClassIds: [String!]!
  ) {
    playlist(playlistId: $playlistId) {
      ...CorePlaylistV2Fields
      hasStudioClasses(studioClassIds: $studioClassIds) {
        id
        studioClassId
        hasStudioClass
      }
      studioClasses(pagination: $pagination) {
        pageInfo {
          ...CorePageInfoFields
        }
        edges {
          node {
            ...CorePlaylistStudioClassFields
          }
        }
        totalCount
      }
    }
  }
  ${CorePlaylistV2FieldsFragmentDoc}
  ${CorePageInfoFieldsFragmentDoc}
  ${CorePlaylistStudioClassFieldsFragmentDoc}
`;

/**
 * __useGetPlaylistQuery__
 *
 * To run a query within a React component, call `useGetPlaylistQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlaylistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlaylistQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      playlistId: // value for 'playlistId'
 *      studioClassIds: // value for 'studioClassIds'
 *   },
 * });
 */
export function useGetPlaylistQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPlaylistQuery,
    GetPlaylistQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPlaylistQuery, GetPlaylistQueryVariables>(
    GetPlaylistDocument,
    options
  );
}
export function useGetPlaylistLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPlaylistQuery,
    GetPlaylistQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPlaylistQuery, GetPlaylistQueryVariables>(
    GetPlaylistDocument,
    options
  );
}
export type GetPlaylistQueryHookResult = ReturnType<typeof useGetPlaylistQuery>;
export type GetPlaylistLazyQueryHookResult = ReturnType<
  typeof useGetPlaylistLazyQuery
>;
export type GetPlaylistQueryResult = Apollo.QueryResult<
  GetPlaylistQuery,
  GetPlaylistQueryVariables
>;
export const GetPublicPlaylistDataDocument = /*#__PURE__*/ gql`
  query GetPublicPlaylistData($playlistId: String!) {
    playlist(playlistId: $playlistId) {
      id
      owner {
        id
      }
    }
  }
`;

/**
 * __useGetPublicPlaylistDataQuery__
 *
 * To run a query within a React component, call `useGetPublicPlaylistDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicPlaylistDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicPlaylistDataQuery({
 *   variables: {
 *      playlistId: // value for 'playlistId'
 *   },
 * });
 */
export function useGetPublicPlaylistDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPublicPlaylistDataQuery,
    GetPublicPlaylistDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPublicPlaylistDataQuery,
    GetPublicPlaylistDataQueryVariables
  >(GetPublicPlaylistDataDocument, options);
}
export function useGetPublicPlaylistDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPublicPlaylistDataQuery,
    GetPublicPlaylistDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPublicPlaylistDataQuery,
    GetPublicPlaylistDataQueryVariables
  >(GetPublicPlaylistDataDocument, options);
}
export type GetPublicPlaylistDataQueryHookResult = ReturnType<
  typeof useGetPublicPlaylistDataQuery
>;
export type GetPublicPlaylistDataLazyQueryHookResult = ReturnType<
  typeof useGetPublicPlaylistDataLazyQuery
>;
export type GetPublicPlaylistDataQueryResult = Apollo.QueryResult<
  GetPublicPlaylistDataQuery,
  GetPublicPlaylistDataQueryVariables
>;
export const GetUsersBadgesDocument = /*#__PURE__*/ gql`
  query GetUsersBadges($username: String!) {
    badgesByYear(username: $username) {
      ...UserBadgeGroup
    }
  }
  ${UserBadgeGroupFragmentDoc}
`;

/**
 * __useGetUsersBadgesQuery__
 *
 * To run a query within a React component, call `useGetUsersBadgesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersBadgesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersBadgesQuery({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useGetUsersBadgesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetUsersBadgesQuery,
    GetUsersBadgesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUsersBadgesQuery, GetUsersBadgesQueryVariables>(
    GetUsersBadgesDocument,
    options
  );
}
export function useGetUsersBadgesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUsersBadgesQuery,
    GetUsersBadgesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUsersBadgesQuery, GetUsersBadgesQueryVariables>(
    GetUsersBadgesDocument,
    options
  );
}
export type GetUsersBadgesQueryHookResult = ReturnType<
  typeof useGetUsersBadgesQuery
>;
export type GetUsersBadgesLazyQueryHookResult = ReturnType<
  typeof useGetUsersBadgesLazyQuery
>;
export type GetUsersBadgesQueryResult = Apollo.QueryResult<
  GetUsersBadgesQuery,
  GetUsersBadgesQueryVariables
>;
export const GetClassCompletedAchievementBadgesDocument = /*#__PURE__*/ gql`
  query GetClassCompletedAchievementBadges {
    getClassCompletedAchievementBadges {
      earnedBadges {
        id
      }
      newBadges {
        id
      }
    }
  }
`;

/**
 * __useGetClassCompletedAchievementBadgesQuery__
 *
 * To run a query within a React component, call `useGetClassCompletedAchievementBadgesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassCompletedAchievementBadgesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassCompletedAchievementBadgesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetClassCompletedAchievementBadgesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetClassCompletedAchievementBadgesQuery,
    GetClassCompletedAchievementBadgesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetClassCompletedAchievementBadgesQuery,
    GetClassCompletedAchievementBadgesQueryVariables
  >(GetClassCompletedAchievementBadgesDocument, options);
}
export function useGetClassCompletedAchievementBadgesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetClassCompletedAchievementBadgesQuery,
    GetClassCompletedAchievementBadgesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetClassCompletedAchievementBadgesQuery,
    GetClassCompletedAchievementBadgesQueryVariables
  >(GetClassCompletedAchievementBadgesDocument, options);
}
export type GetClassCompletedAchievementBadgesQueryHookResult = ReturnType<
  typeof useGetClassCompletedAchievementBadgesQuery
>;
export type GetClassCompletedAchievementBadgesLazyQueryHookResult = ReturnType<
  typeof useGetClassCompletedAchievementBadgesLazyQuery
>;
export type GetClassCompletedAchievementBadgesQueryResult = Apollo.QueryResult<
  GetClassCompletedAchievementBadgesQuery,
  GetClassCompletedAchievementBadgesQueryVariables
>;
export const GetInstructorBySlugClassesDocument = /*#__PURE__*/ gql`
  query GetInstructorBySlugClasses(
    $instructorSlug: String!
    $first: Float
    $after: String
  ) {
    instructorBySlugPublic(slug: $instructorSlug) {
      id
      studioClasses(pagination: { first: $first, after: $after }) {
        edges {
          node {
            ...InstructorStudioClass
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
        totalCount
      }
    }
  }
  ${InstructorStudioClassFragmentDoc}
`;

/**
 * __useGetInstructorBySlugClassesQuery__
 *
 * To run a query within a React component, call `useGetInstructorBySlugClassesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstructorBySlugClassesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstructorBySlugClassesQuery({
 *   variables: {
 *      instructorSlug: // value for 'instructorSlug'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetInstructorBySlugClassesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetInstructorBySlugClassesQuery,
    GetInstructorBySlugClassesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetInstructorBySlugClassesQuery,
    GetInstructorBySlugClassesQueryVariables
  >(GetInstructorBySlugClassesDocument, options);
}
export function useGetInstructorBySlugClassesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetInstructorBySlugClassesQuery,
    GetInstructorBySlugClassesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetInstructorBySlugClassesQuery,
    GetInstructorBySlugClassesQueryVariables
  >(GetInstructorBySlugClassesDocument, options);
}
export type GetInstructorBySlugClassesQueryHookResult = ReturnType<
  typeof useGetInstructorBySlugClassesQuery
>;
export type GetInstructorBySlugClassesLazyQueryHookResult = ReturnType<
  typeof useGetInstructorBySlugClassesLazyQuery
>;
export type GetInstructorBySlugClassesQueryResult = Apollo.QueryResult<
  GetInstructorBySlugClassesQuery,
  GetInstructorBySlugClassesQueryVariables
>;
export const UserProfileWithVideosDocument = /*#__PURE__*/ gql`
  query UserProfileWithVideos(
    $username: String!
    $videoPagination: ConnectionArgs!
  ) {
    userProfileGetByUsername(
      input: { username: $username, videoPagination: $videoPagination }
    ) {
      id
      isMe
      name
      username
      uid
      photoURL
      totalLikesCount
      bio
      instructorSlug
      links {
        title
        url
      }
      videoUploads {
        edges {
          node {
            ...UserProfileVideoUploads
          }
          cursor
        }
        pageInfo {
          hasNextPage
          endCursor
        }
        totalCount
      }
    }
  }
  ${UserProfileVideoUploadsFragmentDoc}
`;

/**
 * __useUserProfileWithVideosQuery__
 *
 * To run a query within a React component, call `useUserProfileWithVideosQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProfileWithVideosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProfileWithVideosQuery({
 *   variables: {
 *      username: // value for 'username'
 *      videoPagination: // value for 'videoPagination'
 *   },
 * });
 */
export function useUserProfileWithVideosQuery(
  baseOptions: Apollo.QueryHookOptions<
    UserProfileWithVideosQuery,
    UserProfileWithVideosQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    UserProfileWithVideosQuery,
    UserProfileWithVideosQueryVariables
  >(UserProfileWithVideosDocument, options);
}
export function useUserProfileWithVideosLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserProfileWithVideosQuery,
    UserProfileWithVideosQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    UserProfileWithVideosQuery,
    UserProfileWithVideosQueryVariables
  >(UserProfileWithVideosDocument, options);
}
export type UserProfileWithVideosQueryHookResult = ReturnType<
  typeof useUserProfileWithVideosQuery
>;
export type UserProfileWithVideosLazyQueryHookResult = ReturnType<
  typeof useUserProfileWithVideosLazyQuery
>;
export type UserProfileWithVideosQueryResult = Apollo.QueryResult<
  UserProfileWithVideosQuery,
  UserProfileWithVideosQueryVariables
>;
export const GetSavedClassesDocument = /*#__PURE__*/ gql`
  query GetSavedClasses($first: Int, $after: String) {
    savedClasses: getSavedDataV2(
      input: { first: $first, after: $after, contentType: CLASSES }
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          ... on Class {
            ...CoreClassFields
          }
        }
      }
    }
  }
  ${CoreClassFieldsFragmentDoc}
`;

/**
 * __useGetSavedClassesQuery__
 *
 * To run a query within a React component, call `useGetSavedClassesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSavedClassesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSavedClassesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetSavedClassesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetSavedClassesQuery,
    GetSavedClassesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSavedClassesQuery, GetSavedClassesQueryVariables>(
    GetSavedClassesDocument,
    options
  );
}
export function useGetSavedClassesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSavedClassesQuery,
    GetSavedClassesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSavedClassesQuery,
    GetSavedClassesQueryVariables
  >(GetSavedClassesDocument, options);
}
export type GetSavedClassesQueryHookResult = ReturnType<
  typeof useGetSavedClassesQuery
>;
export type GetSavedClassesLazyQueryHookResult = ReturnType<
  typeof useGetSavedClassesLazyQuery
>;
export type GetSavedClassesQueryResult = Apollo.QueryResult<
  GetSavedClassesQuery,
  GetSavedClassesQueryVariables
>;
export const GetSavedProgramsDocument = /*#__PURE__*/ gql`
  query GetSavedPrograms($first: Int, $after: String) {
    savedPrograms: getSavedDataV2(
      input: { first: $first, after: $after, contentType: PROGRAMS }
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          ... on ProgramV2 {
            slug
          }
        }
      }
    }
  }
`;

/**
 * __useGetSavedProgramsQuery__
 *
 * To run a query within a React component, call `useGetSavedProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSavedProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSavedProgramsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetSavedProgramsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetSavedProgramsQuery,
    GetSavedProgramsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSavedProgramsQuery, GetSavedProgramsQueryVariables>(
    GetSavedProgramsDocument,
    options
  );
}
export function useGetSavedProgramsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSavedProgramsQuery,
    GetSavedProgramsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSavedProgramsQuery,
    GetSavedProgramsQueryVariables
  >(GetSavedProgramsDocument, options);
}
export type GetSavedProgramsQueryHookResult = ReturnType<
  typeof useGetSavedProgramsQuery
>;
export type GetSavedProgramsLazyQueryHookResult = ReturnType<
  typeof useGetSavedProgramsLazyQuery
>;
export type GetSavedProgramsQueryResult = Apollo.QueryResult<
  GetSavedProgramsQuery,
  GetSavedProgramsQueryVariables
>;
export const GetPersonalizedPlaylistForScheduleDocument = /*#__PURE__*/ gql`
  query GetPersonalizedPlaylistForSchedule {
    myPersonalizedPlaylist: me {
      personalizedPlaylist {
        id
        duration
        thumbnail
        title
        instructor {
          name
        }
      }
    }
  }
`;

/**
 * __useGetPersonalizedPlaylistForScheduleQuery__
 *
 * To run a query within a React component, call `useGetPersonalizedPlaylistForScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonalizedPlaylistForScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonalizedPlaylistForScheduleQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPersonalizedPlaylistForScheduleQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPersonalizedPlaylistForScheduleQuery,
    GetPersonalizedPlaylistForScheduleQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPersonalizedPlaylistForScheduleQuery,
    GetPersonalizedPlaylistForScheduleQueryVariables
  >(GetPersonalizedPlaylistForScheduleDocument, options);
}
export function useGetPersonalizedPlaylistForScheduleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPersonalizedPlaylistForScheduleQuery,
    GetPersonalizedPlaylistForScheduleQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPersonalizedPlaylistForScheduleQuery,
    GetPersonalizedPlaylistForScheduleQueryVariables
  >(GetPersonalizedPlaylistForScheduleDocument, options);
}
export type GetPersonalizedPlaylistForScheduleQueryHookResult = ReturnType<
  typeof useGetPersonalizedPlaylistForScheduleQuery
>;
export type GetPersonalizedPlaylistForScheduleLazyQueryHookResult = ReturnType<
  typeof useGetPersonalizedPlaylistForScheduleLazyQuery
>;
export type GetPersonalizedPlaylistForScheduleQueryResult = Apollo.QueryResult<
  GetPersonalizedPlaylistForScheduleQuery,
  GetPersonalizedPlaylistForScheduleQueryVariables
>;
export const ToggleSaveScheduleClassDocument = /*#__PURE__*/ gql`
  mutation ToggleSaveScheduleClass($classId: String!, $willSave: Boolean!) {
    toggleSaveClass(input: { classId: $classId, willSave: $willSave }) {
      id
      refId
      isSaved
    }
  }
`;
export type ToggleSaveScheduleClassMutationFn = Apollo.MutationFunction<
  ToggleSaveScheduleClassMutation,
  ToggleSaveScheduleClassMutationVariables
>;

/**
 * __useToggleSaveScheduleClassMutation__
 *
 * To run a mutation, you first call `useToggleSaveScheduleClassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleSaveScheduleClassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleSaveScheduleClassMutation, { data, loading, error }] = useToggleSaveScheduleClassMutation({
 *   variables: {
 *      classId: // value for 'classId'
 *      willSave: // value for 'willSave'
 *   },
 * });
 */
export function useToggleSaveScheduleClassMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ToggleSaveScheduleClassMutation,
    ToggleSaveScheduleClassMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ToggleSaveScheduleClassMutation,
    ToggleSaveScheduleClassMutationVariables
  >(ToggleSaveScheduleClassDocument, options);
}
export type ToggleSaveScheduleClassMutationHookResult = ReturnType<
  typeof useToggleSaveScheduleClassMutation
>;
export type ToggleSaveScheduleClassMutationResult = Apollo.MutationResult<
  ToggleSaveScheduleClassMutation
>;
export type ToggleSaveScheduleClassMutationOptions = Apollo.BaseMutationOptions<
  ToggleSaveScheduleClassMutation,
  ToggleSaveScheduleClassMutationVariables
>;
export const GetCategoriesDocument = /*#__PURE__*/ gql`
  query GetCategories(
    $slugs: [ID!]!
    $filters: [CategoryFilter!]
    $goal: GoalType
  ) {
    categories: getCategories(
      input: { slugs: $slugs, filters: $filters, goal: $goal }
    ) {
      description
      isFollowing
      name
      slug
      previewThumbnailUrl
      previewVideoUrl
    }
  }
`;

/**
 * __useGetCategoriesQuery__
 *
 * To run a query within a React component, call `useGetCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriesQuery({
 *   variables: {
 *      slugs: // value for 'slugs'
 *      filters: // value for 'filters'
 *      goal: // value for 'goal'
 *   },
 * });
 */
export function useGetCategoriesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCategoriesQuery,
    GetCategoriesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(
    GetCategoriesDocument,
    options
  );
}
export function useGetCategoriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCategoriesQuery,
    GetCategoriesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(
    GetCategoriesDocument,
    options
  );
}
export type GetCategoriesQueryHookResult = ReturnType<
  typeof useGetCategoriesQuery
>;
export type GetCategoriesLazyQueryHookResult = ReturnType<
  typeof useGetCategoriesLazyQuery
>;
export type GetCategoriesQueryResult = Apollo.QueryResult<
  GetCategoriesQuery,
  GetCategoriesQueryVariables
>;
export const GetCategoryDocument = /*#__PURE__*/ gql`
  query GetCategory($slug: ID!) {
    categories: getCategories(input: { slugs: [$slug] }) {
      slug
      name
      programsV2 {
        slug
      }
    }
  }
`;

/**
 * __useGetCategoryQuery__
 *
 * To run a query within a React component, call `useGetCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoryQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetCategoryQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCategoryQuery,
    GetCategoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCategoryQuery, GetCategoryQueryVariables>(
    GetCategoryDocument,
    options
  );
}
export function useGetCategoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCategoryQuery,
    GetCategoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCategoryQuery, GetCategoryQueryVariables>(
    GetCategoryDocument,
    options
  );
}
export type GetCategoryQueryHookResult = ReturnType<typeof useGetCategoryQuery>;
export type GetCategoryLazyQueryHookResult = ReturnType<
  typeof useGetCategoryLazyQuery
>;
export type GetCategoryQueryResult = Apollo.QueryResult<
  GetCategoryQuery,
  GetCategoryQueryVariables
>;
export const GetAvailableChallengesDocument = /*#__PURE__*/ gql`
  query GetAvailableChallenges($pagination: ConnectionArgs!) {
    challengesAvailable(pagination: $pagination) {
      edges {
        node {
          ...ChallengeFields
          videos {
            edges {
              cursor
              node {
                id
                isAuthoredByMe
                reportedByMe
                description
                thumbnailUrl
                playbackUrl
                uploadedAt
                uploadedBy {
                  id
                  uid
                  username
                }
              }
            }
            totalCount
            pageInfo {
              startCursor
              endCursor
              hasNextPage
              hasPreviousPage
            }
          }
        }
        cursor
      }
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
  ${ChallengeFieldsFragmentDoc}
`;

/**
 * __useGetAvailableChallengesQuery__
 *
 * To run a query within a React component, call `useGetAvailableChallengesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableChallengesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableChallengesQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetAvailableChallengesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAvailableChallengesQuery,
    GetAvailableChallengesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAvailableChallengesQuery,
    GetAvailableChallengesQueryVariables
  >(GetAvailableChallengesDocument, options);
}
export function useGetAvailableChallengesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAvailableChallengesQuery,
    GetAvailableChallengesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAvailableChallengesQuery,
    GetAvailableChallengesQueryVariables
  >(GetAvailableChallengesDocument, options);
}
export type GetAvailableChallengesQueryHookResult = ReturnType<
  typeof useGetAvailableChallengesQuery
>;
export type GetAvailableChallengesLazyQueryHookResult = ReturnType<
  typeof useGetAvailableChallengesLazyQuery
>;
export type GetAvailableChallengesQueryResult = Apollo.QueryResult<
  GetAvailableChallengesQuery,
  GetAvailableChallengesQueryVariables
>;
export const GetClassByIdDocument = /*#__PURE__*/ gql`
  query GetClassById($classId: String!) {
    classById(id: $classId) {
      id
      userVideos {
        edges {
          cursor
          node {
            ...CoreClassUserVideosField
          }
        }
      }
    }
  }
  ${CoreClassUserVideosFieldFragmentDoc}
`;

/**
 * __useGetClassByIdQuery__
 *
 * To run a query within a React component, call `useGetClassByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassByIdQuery({
 *   variables: {
 *      classId: // value for 'classId'
 *   },
 * });
 */
export function useGetClassByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetClassByIdQuery,
    GetClassByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetClassByIdQuery, GetClassByIdQueryVariables>(
    GetClassByIdDocument,
    options
  );
}
export function useGetClassByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetClassByIdQuery,
    GetClassByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetClassByIdQuery, GetClassByIdQueryVariables>(
    GetClassByIdDocument,
    options
  );
}
export type GetClassByIdQueryHookResult = ReturnType<
  typeof useGetClassByIdQuery
>;
export type GetClassByIdLazyQueryHookResult = ReturnType<
  typeof useGetClassByIdLazyQuery
>;
export type GetClassByIdQueryResult = Apollo.QueryResult<
  GetClassByIdQuery,
  GetClassByIdQueryVariables
>;
export const ActivityCommentDeleteDocument = /*#__PURE__*/ gql`
  mutation ActivityCommentDelete($commentId: String!) {
    activityCommentDelete(commentId: $commentId)
  }
`;
export type ActivityCommentDeleteMutationFn = Apollo.MutationFunction<
  ActivityCommentDeleteMutation,
  ActivityCommentDeleteMutationVariables
>;

/**
 * __useActivityCommentDeleteMutation__
 *
 * To run a mutation, you first call `useActivityCommentDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivityCommentDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activityCommentDeleteMutation, { data, loading, error }] = useActivityCommentDeleteMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *   },
 * });
 */
export function useActivityCommentDeleteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ActivityCommentDeleteMutation,
    ActivityCommentDeleteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ActivityCommentDeleteMutation,
    ActivityCommentDeleteMutationVariables
  >(ActivityCommentDeleteDocument, options);
}
export type ActivityCommentDeleteMutationHookResult = ReturnType<
  typeof useActivityCommentDeleteMutation
>;
export type ActivityCommentDeleteMutationResult = Apollo.MutationResult<
  ActivityCommentDeleteMutation
>;
export type ActivityCommentDeleteMutationOptions = Apollo.BaseMutationOptions<
  ActivityCommentDeleteMutation,
  ActivityCommentDeleteMutationVariables
>;
export const ActivityCommentCreateDocument = /*#__PURE__*/ gql`
  mutation ActivityCommentCreate($input: ActivityCommentCreateInput!) {
    activityCommentCreate(input: $input) {
      ...ActivityCommentFields
    }
  }
  ${ActivityCommentFieldsFragmentDoc}
`;
export type ActivityCommentCreateMutationFn = Apollo.MutationFunction<
  ActivityCommentCreateMutation,
  ActivityCommentCreateMutationVariables
>;

/**
 * __useActivityCommentCreateMutation__
 *
 * To run a mutation, you first call `useActivityCommentCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivityCommentCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activityCommentCreateMutation, { data, loading, error }] = useActivityCommentCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useActivityCommentCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ActivityCommentCreateMutation,
    ActivityCommentCreateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ActivityCommentCreateMutation,
    ActivityCommentCreateMutationVariables
  >(ActivityCommentCreateDocument, options);
}
export type ActivityCommentCreateMutationHookResult = ReturnType<
  typeof useActivityCommentCreateMutation
>;
export type ActivityCommentCreateMutationResult = Apollo.MutationResult<
  ActivityCommentCreateMutation
>;
export type ActivityCommentCreateMutationOptions = Apollo.BaseMutationOptions<
  ActivityCommentCreateMutation,
  ActivityCommentCreateMutationVariables
>;
export const GetChallengeCommentsDocument = /*#__PURE__*/ gql`
  query GetChallengeComments(
    $id: String!
    $before: String
    $after: String
    $first: Float
    $last: Float
  ) {
    challengeById(id: $id) {
      id
      comments(before: $before, after: $after, first: $first, last: $last) {
        edges {
          node {
            ...ActivityCommentFields
          }
          cursor
        }
        totalCount
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
      }
    }
  }
  ${ActivityCommentFieldsFragmentDoc}
`;

/**
 * __useGetChallengeCommentsQuery__
 *
 * To run a query within a React component, call `useGetChallengeCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChallengeCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChallengeCommentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useGetChallengeCommentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetChallengeCommentsQuery,
    GetChallengeCommentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetChallengeCommentsQuery,
    GetChallengeCommentsQueryVariables
  >(GetChallengeCommentsDocument, options);
}
export function useGetChallengeCommentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetChallengeCommentsQuery,
    GetChallengeCommentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetChallengeCommentsQuery,
    GetChallengeCommentsQueryVariables
  >(GetChallengeCommentsDocument, options);
}
export type GetChallengeCommentsQueryHookResult = ReturnType<
  typeof useGetChallengeCommentsQuery
>;
export type GetChallengeCommentsLazyQueryHookResult = ReturnType<
  typeof useGetChallengeCommentsLazyQuery
>;
export type GetChallengeCommentsQueryResult = Apollo.QueryResult<
  GetChallengeCommentsQuery,
  GetChallengeCommentsQueryVariables
>;
export const GetVideoUploadCommentsDocument = /*#__PURE__*/ gql`
  query GetVideoUploadComments(
    $input: VideoUploadByIdInput!
    $before: String
    $after: String
    $first: Float
    $last: Float
  ) {
    videoUploadByIdPublic(input: $input) {
      id
      comments(before: $before, after: $after, first: $first, last: $last) {
        edges {
          node {
            ...ActivityCommentFields
          }
          cursor
        }
        totalCount
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
      }
    }
  }
  ${ActivityCommentFieldsFragmentDoc}
`;

/**
 * __useGetVideoUploadCommentsQuery__
 *
 * To run a query within a React component, call `useGetVideoUploadCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideoUploadCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideoUploadCommentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useGetVideoUploadCommentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetVideoUploadCommentsQuery,
    GetVideoUploadCommentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetVideoUploadCommentsQuery,
    GetVideoUploadCommentsQueryVariables
  >(GetVideoUploadCommentsDocument, options);
}
export function useGetVideoUploadCommentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetVideoUploadCommentsQuery,
    GetVideoUploadCommentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetVideoUploadCommentsQuery,
    GetVideoUploadCommentsQueryVariables
  >(GetVideoUploadCommentsDocument, options);
}
export type GetVideoUploadCommentsQueryHookResult = ReturnType<
  typeof useGetVideoUploadCommentsQuery
>;
export type GetVideoUploadCommentsLazyQueryHookResult = ReturnType<
  typeof useGetVideoUploadCommentsLazyQuery
>;
export type GetVideoUploadCommentsQueryResult = Apollo.QueryResult<
  GetVideoUploadCommentsQuery,
  GetVideoUploadCommentsQueryVariables
>;
export const GetCommentsRepliesDocument = /*#__PURE__*/ gql`
  query GetCommentsReplies(
    $id: String!
    $before: String
    $after: String
    $first: Float
    $last: Float
  ) {
    activityCommentById(id: $id) {
      id
      body
      replies(before: $before, after: $after, first: $first, last: $last) {
        edges {
          node {
            ...ActivityCommentFields
          }
          cursor
        }
        totalCount
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
      }
    }
  }
  ${ActivityCommentFieldsFragmentDoc}
`;

/**
 * __useGetCommentsRepliesQuery__
 *
 * To run a query within a React component, call `useGetCommentsRepliesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommentsRepliesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommentsRepliesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useGetCommentsRepliesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCommentsRepliesQuery,
    GetCommentsRepliesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCommentsRepliesQuery,
    GetCommentsRepliesQueryVariables
  >(GetCommentsRepliesDocument, options);
}
export function useGetCommentsRepliesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCommentsRepliesQuery,
    GetCommentsRepliesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCommentsRepliesQuery,
    GetCommentsRepliesQueryVariables
  >(GetCommentsRepliesDocument, options);
}
export type GetCommentsRepliesQueryHookResult = ReturnType<
  typeof useGetCommentsRepliesQuery
>;
export type GetCommentsRepliesLazyQueryHookResult = ReturnType<
  typeof useGetCommentsRepliesLazyQuery
>;
export type GetCommentsRepliesQueryResult = Apollo.QueryResult<
  GetCommentsRepliesQuery,
  GetCommentsRepliesQueryVariables
>;
export const GetConfigDocument = /*#__PURE__*/ gql`
  query GetConfig {
    configs {
      featureFlags {
        enabled
        name
      }
    }
  }
`;

/**
 * __useGetConfigQuery__
 *
 * To run a query within a React component, call `useGetConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetConfigQuery(
  baseOptions?: Apollo.QueryHookOptions<GetConfigQuery, GetConfigQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetConfigQuery, GetConfigQueryVariables>(
    GetConfigDocument,
    options
  );
}
export function useGetConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetConfigQuery,
    GetConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetConfigQuery, GetConfigQueryVariables>(
    GetConfigDocument,
    options
  );
}
export type GetConfigQueryHookResult = ReturnType<typeof useGetConfigQuery>;
export type GetConfigLazyQueryHookResult = ReturnType<
  typeof useGetConfigLazyQuery
>;
export type GetConfigQueryResult = Apollo.QueryResult<
  GetConfigQuery,
  GetConfigQueryVariables
>;
export const SetDanceLevelPreferenceDocument = /*#__PURE__*/ gql`
  mutation SetDanceLevelPreference($slug: ID!) {
    setDanceLevelPreference(input: { slug: $slug }) {
      slug
    }
  }
`;
export type SetDanceLevelPreferenceMutationFn = Apollo.MutationFunction<
  SetDanceLevelPreferenceMutation,
  SetDanceLevelPreferenceMutationVariables
>;

/**
 * __useSetDanceLevelPreferenceMutation__
 *
 * To run a mutation, you first call `useSetDanceLevelPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDanceLevelPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDanceLevelPreferenceMutation, { data, loading, error }] = useSetDanceLevelPreferenceMutation({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useSetDanceLevelPreferenceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetDanceLevelPreferenceMutation,
    SetDanceLevelPreferenceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetDanceLevelPreferenceMutation,
    SetDanceLevelPreferenceMutationVariables
  >(SetDanceLevelPreferenceDocument, options);
}
export type SetDanceLevelPreferenceMutationHookResult = ReturnType<
  typeof useSetDanceLevelPreferenceMutation
>;
export type SetDanceLevelPreferenceMutationResult = Apollo.MutationResult<
  SetDanceLevelPreferenceMutation
>;
export type SetDanceLevelPreferenceMutationOptions = Apollo.BaseMutationOptions<
  SetDanceLevelPreferenceMutation,
  SetDanceLevelPreferenceMutationVariables
>;
export const SetDanceReasonPreferenceDocument = /*#__PURE__*/ gql`
  mutation SetDanceReasonPreference($slug: ID!) {
    setDanceReasonPreference(input: { slug: $slug }) {
      slug
    }
  }
`;
export type SetDanceReasonPreferenceMutationFn = Apollo.MutationFunction<
  SetDanceReasonPreferenceMutation,
  SetDanceReasonPreferenceMutationVariables
>;

/**
 * __useSetDanceReasonPreferenceMutation__
 *
 * To run a mutation, you first call `useSetDanceReasonPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDanceReasonPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDanceReasonPreferenceMutation, { data, loading, error }] = useSetDanceReasonPreferenceMutation({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useSetDanceReasonPreferenceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetDanceReasonPreferenceMutation,
    SetDanceReasonPreferenceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetDanceReasonPreferenceMutation,
    SetDanceReasonPreferenceMutationVariables
  >(SetDanceReasonPreferenceDocument, options);
}
export type SetDanceReasonPreferenceMutationHookResult = ReturnType<
  typeof useSetDanceReasonPreferenceMutation
>;
export type SetDanceReasonPreferenceMutationResult = Apollo.MutationResult<
  SetDanceReasonPreferenceMutation
>;
export type SetDanceReasonPreferenceMutationOptions = Apollo.BaseMutationOptions<
  SetDanceReasonPreferenceMutation,
  SetDanceReasonPreferenceMutationVariables
>;
export const SetFamilyGoalPreferenceDocument = /*#__PURE__*/ gql`
  mutation SetFamilyGoalPreference($slug: ID!) {
    setFamilyGoalPreference(input: { slug: $slug }) {
      slug
      label
    }
  }
`;
export type SetFamilyGoalPreferenceMutationFn = Apollo.MutationFunction<
  SetFamilyGoalPreferenceMutation,
  SetFamilyGoalPreferenceMutationVariables
>;

/**
 * __useSetFamilyGoalPreferenceMutation__
 *
 * To run a mutation, you first call `useSetFamilyGoalPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetFamilyGoalPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setFamilyGoalPreferenceMutation, { data, loading, error }] = useSetFamilyGoalPreferenceMutation({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useSetFamilyGoalPreferenceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetFamilyGoalPreferenceMutation,
    SetFamilyGoalPreferenceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetFamilyGoalPreferenceMutation,
    SetFamilyGoalPreferenceMutationVariables
  >(SetFamilyGoalPreferenceDocument, options);
}
export type SetFamilyGoalPreferenceMutationHookResult = ReturnType<
  typeof useSetFamilyGoalPreferenceMutation
>;
export type SetFamilyGoalPreferenceMutationResult = Apollo.MutationResult<
  SetFamilyGoalPreferenceMutation
>;
export type SetFamilyGoalPreferenceMutationOptions = Apollo.BaseMutationOptions<
  SetFamilyGoalPreferenceMutation,
  SetFamilyGoalPreferenceMutationVariables
>;
export const SetAccountTypePreferenceDocument = /*#__PURE__*/ gql`
  mutation SetAccountTypePreference($slug: ID!) {
    setAccountTypePreference(input: { slug: $slug }) {
      slug
    }
  }
`;
export type SetAccountTypePreferenceMutationFn = Apollo.MutationFunction<
  SetAccountTypePreferenceMutation,
  SetAccountTypePreferenceMutationVariables
>;

/**
 * __useSetAccountTypePreferenceMutation__
 *
 * To run a mutation, you first call `useSetAccountTypePreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAccountTypePreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAccountTypePreferenceMutation, { data, loading, error }] = useSetAccountTypePreferenceMutation({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useSetAccountTypePreferenceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetAccountTypePreferenceMutation,
    SetAccountTypePreferenceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetAccountTypePreferenceMutation,
    SetAccountTypePreferenceMutationVariables
  >(SetAccountTypePreferenceDocument, options);
}
export type SetAccountTypePreferenceMutationHookResult = ReturnType<
  typeof useSetAccountTypePreferenceMutation
>;
export type SetAccountTypePreferenceMutationResult = Apollo.MutationResult<
  SetAccountTypePreferenceMutation
>;
export type SetAccountTypePreferenceMutationOptions = Apollo.BaseMutationOptions<
  SetAccountTypePreferenceMutation,
  SetAccountTypePreferenceMutationVariables
>;
export const GetOnboardingDataDocument = /*#__PURE__*/ gql`
  query GetOnboardingData {
    onboardingData: getOnboardingData {
      levelOptions {
        slug
        name
        description
        previewGIFUrl
      }
      durationOptions {
        slug
        name
        description
        start
        end
      }
      reasonOptions {
        slug
        label
        description
        variant
        goal
        previewImgURL
      }
    }
  }
`;

/**
 * __useGetOnboardingDataQuery__
 *
 * To run a query within a React component, call `useGetOnboardingDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOnboardingDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOnboardingDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOnboardingDataQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetOnboardingDataQuery,
    GetOnboardingDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetOnboardingDataQuery,
    GetOnboardingDataQueryVariables
  >(GetOnboardingDataDocument, options);
}
export function useGetOnboardingDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOnboardingDataQuery,
    GetOnboardingDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetOnboardingDataQuery,
    GetOnboardingDataQueryVariables
  >(GetOnboardingDataDocument, options);
}
export type GetOnboardingDataQueryHookResult = ReturnType<
  typeof useGetOnboardingDataQuery
>;
export type GetOnboardingDataLazyQueryHookResult = ReturnType<
  typeof useGetOnboardingDataLazyQuery
>;
export type GetOnboardingDataQueryResult = Apollo.QueryResult<
  GetOnboardingDataQuery,
  GetOnboardingDataQueryVariables
>;
export const UserPreferenceOptionsDocument = /*#__PURE__*/ gql`
  query UserPreferenceOptions {
    familyGoals: userPreferenceOptions(type: family_goal) {
      ...PreferenceOptionFields
    }
    levels: userPreferenceOptions(type: level) {
      ...PreferenceOptionFields
    }
    reasons: userPreferenceOptions(type: reason) {
      ...PreferenceOptionFields
    }
    accountTypes: userPreferenceOptions(type: account_type) {
      ...PreferenceOptionFields
    }
  }
  ${PreferenceOptionFieldsFragmentDoc}
`;

/**
 * __useUserPreferenceOptionsQuery__
 *
 * To run a query within a React component, call `useUserPreferenceOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPreferenceOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPreferenceOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserPreferenceOptionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UserPreferenceOptionsQuery,
    UserPreferenceOptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    UserPreferenceOptionsQuery,
    UserPreferenceOptionsQueryVariables
  >(UserPreferenceOptionsDocument, options);
}
export function useUserPreferenceOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserPreferenceOptionsQuery,
    UserPreferenceOptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    UserPreferenceOptionsQuery,
    UserPreferenceOptionsQueryVariables
  >(UserPreferenceOptionsDocument, options);
}
export type UserPreferenceOptionsQueryHookResult = ReturnType<
  typeof useUserPreferenceOptionsQuery
>;
export type UserPreferenceOptionsLazyQueryHookResult = ReturnType<
  typeof useUserPreferenceOptionsLazyQuery
>;
export type UserPreferenceOptionsQueryResult = Apollo.QueryResult<
  UserPreferenceOptionsQuery,
  UserPreferenceOptionsQueryVariables
>;
export const SetExperimentDocument = /*#__PURE__*/ gql`
  mutation SetExperiment($experimentId: ID!) {
    setExperiment(input: { experimentId: $experimentId }) {
      experimentId
      variant
    }
  }
`;
export type SetExperimentMutationFn = Apollo.MutationFunction<
  SetExperimentMutation,
  SetExperimentMutationVariables
>;

/**
 * __useSetExperimentMutation__
 *
 * To run a mutation, you first call `useSetExperimentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetExperimentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setExperimentMutation, { data, loading, error }] = useSetExperimentMutation({
 *   variables: {
 *      experimentId: // value for 'experimentId'
 *   },
 * });
 */
export function useSetExperimentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetExperimentMutation,
    SetExperimentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetExperimentMutation,
    SetExperimentMutationVariables
  >(SetExperimentDocument, options);
}
export type SetExperimentMutationHookResult = ReturnType<
  typeof useSetExperimentMutation
>;
export type SetExperimentMutationResult = Apollo.MutationResult<
  SetExperimentMutation
>;
export type SetExperimentMutationOptions = Apollo.BaseMutationOptions<
  SetExperimentMutation,
  SetExperimentMutationVariables
>;
export const GetProgramsHistoryDocument = /*#__PURE__*/ gql`
  query GetProgramsHistory($first: Int, $after: String) {
    programsHistory: getProgramsHistory(
      input: { first: $first, after: $after }
    ) {
      connection {
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            slug
            progress {
              completedDate
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetProgramsHistoryQuery__
 *
 * To run a query within a React component, call `useGetProgramsHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgramsHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgramsHistoryQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetProgramsHistoryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetProgramsHistoryQuery,
    GetProgramsHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetProgramsHistoryQuery,
    GetProgramsHistoryQueryVariables
  >(GetProgramsHistoryDocument, options);
}
export function useGetProgramsHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProgramsHistoryQuery,
    GetProgramsHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetProgramsHistoryQuery,
    GetProgramsHistoryQueryVariables
  >(GetProgramsHistoryDocument, options);
}
export type GetProgramsHistoryQueryHookResult = ReturnType<
  typeof useGetProgramsHistoryQuery
>;
export type GetProgramsHistoryLazyQueryHookResult = ReturnType<
  typeof useGetProgramsHistoryLazyQuery
>;
export type GetProgramsHistoryQueryResult = Apollo.QueryResult<
  GetProgramsHistoryQuery,
  GetProgramsHistoryQueryVariables
>;
export const GetParentalControlsDocument = /*#__PURE__*/ gql`
  query GetParentalControls {
    me {
      id
      uid
      parentalControls {
        isEnabled
        pin
      }
    }
  }
`;

/**
 * __useGetParentalControlsQuery__
 *
 * To run a query within a React component, call `useGetParentalControlsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParentalControlsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParentalControlsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetParentalControlsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetParentalControlsQuery,
    GetParentalControlsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetParentalControlsQuery,
    GetParentalControlsQueryVariables
  >(GetParentalControlsDocument, options);
}
export function useGetParentalControlsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetParentalControlsQuery,
    GetParentalControlsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetParentalControlsQuery,
    GetParentalControlsQueryVariables
  >(GetParentalControlsDocument, options);
}
export type GetParentalControlsQueryHookResult = ReturnType<
  typeof useGetParentalControlsQuery
>;
export type GetParentalControlsLazyQueryHookResult = ReturnType<
  typeof useGetParentalControlsLazyQuery
>;
export type GetParentalControlsQueryResult = Apollo.QueryResult<
  GetParentalControlsQuery,
  GetParentalControlsQueryVariables
>;
export const GetInstructorsPublicDocument = /*#__PURE__*/ gql`
  query GetInstructorsPublic {
    instructorsPublic {
      edges {
        node {
          id
          name
          bio
          slug
          avatarImageUrl
          profileImageUrl
          location
          userProfile {
            id
            username
            photoURL
          }
        }
        cursor
      }
      pageInfo {
        hasNextPage
        endCursor
      }
      totalCount
    }
  }
`;

/**
 * __useGetInstructorsPublicQuery__
 *
 * To run a query within a React component, call `useGetInstructorsPublicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstructorsPublicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstructorsPublicQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInstructorsPublicQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetInstructorsPublicQuery,
    GetInstructorsPublicQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetInstructorsPublicQuery,
    GetInstructorsPublicQueryVariables
  >(GetInstructorsPublicDocument, options);
}
export function useGetInstructorsPublicLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetInstructorsPublicQuery,
    GetInstructorsPublicQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetInstructorsPublicQuery,
    GetInstructorsPublicQueryVariables
  >(GetInstructorsPublicDocument, options);
}
export type GetInstructorsPublicQueryHookResult = ReturnType<
  typeof useGetInstructorsPublicQuery
>;
export type GetInstructorsPublicLazyQueryHookResult = ReturnType<
  typeof useGetInstructorsPublicLazyQuery
>;
export type GetInstructorsPublicQueryResult = Apollo.QueryResult<
  GetInstructorsPublicQuery,
  GetInstructorsPublicQueryVariables
>;
export const GetUserInstructorProfileBySlugPublicDocument = /*#__PURE__*/ gql`
  query GetUserInstructorProfileBySlugPublic($slug: String!) {
    instructorBySlugPublic(slug: $slug) {
      id
      name
      bio
      slug
      avatarImageUrl
      profileImageUrl
      location
      userProfile {
        id
        name
        username
        photoURL
      }
    }
  }
`;

/**
 * __useGetUserInstructorProfileBySlugPublicQuery__
 *
 * To run a query within a React component, call `useGetUserInstructorProfileBySlugPublicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserInstructorProfileBySlugPublicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserInstructorProfileBySlugPublicQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetUserInstructorProfileBySlugPublicQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetUserInstructorProfileBySlugPublicQuery,
    GetUserInstructorProfileBySlugPublicQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetUserInstructorProfileBySlugPublicQuery,
    GetUserInstructorProfileBySlugPublicQueryVariables
  >(GetUserInstructorProfileBySlugPublicDocument, options);
}
export function useGetUserInstructorProfileBySlugPublicLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserInstructorProfileBySlugPublicQuery,
    GetUserInstructorProfileBySlugPublicQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetUserInstructorProfileBySlugPublicQuery,
    GetUserInstructorProfileBySlugPublicQueryVariables
  >(GetUserInstructorProfileBySlugPublicDocument, options);
}
export type GetUserInstructorProfileBySlugPublicQueryHookResult = ReturnType<
  typeof useGetUserInstructorProfileBySlugPublicQuery
>;
export type GetUserInstructorProfileBySlugPublicLazyQueryHookResult = ReturnType<
  typeof useGetUserInstructorProfileBySlugPublicLazyQuery
>;
export type GetUserInstructorProfileBySlugPublicQueryResult = Apollo.QueryResult<
  GetUserInstructorProfileBySlugPublicQuery,
  GetUserInstructorProfileBySlugPublicQueryVariables
>;
export const GetUserProfileByUsernameDocument = /*#__PURE__*/ gql`
  query GetUserProfileByUsername(
    $username: String!
    $videoPagination: ConnectionArgs!
  ) {
    userProfileGetByUsername(
      input: { username: $username, videoPagination: $videoPagination }
    ) {
      id
      username
      photoURL
      totalLikesCount
      uid
      bio
      links {
        url
      }
      videoUploads {
        edges {
          node {
            id
            description
            thumbnailUrl
            createdAt
            encodingStatus
            reportedByMe
            isAuthoredByMe
            uploadedAt
            reactions {
              reactionType
              totalCount
            }
            userReactions
          }
          cursor
        }
        pageInfo {
          hasNextPage
          endCursor
        }
        totalCount
      }
      badges {
        id
        badge {
          id
          name
          description
          activeImageUrl
          inactiveImageUrl
        }
        earnedAt
      }
    }
  }
`;

/**
 * __useGetUserProfileByUsernameQuery__
 *
 * To run a query within a React component, call `useGetUserProfileByUsernameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserProfileByUsernameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserProfileByUsernameQuery({
 *   variables: {
 *      username: // value for 'username'
 *      videoPagination: // value for 'videoPagination'
 *   },
 * });
 */
export function useGetUserProfileByUsernameQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetUserProfileByUsernameQuery,
    GetUserProfileByUsernameQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetUserProfileByUsernameQuery,
    GetUserProfileByUsernameQueryVariables
  >(GetUserProfileByUsernameDocument, options);
}
export function useGetUserProfileByUsernameLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserProfileByUsernameQuery,
    GetUserProfileByUsernameQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetUserProfileByUsernameQuery,
    GetUserProfileByUsernameQueryVariables
  >(GetUserProfileByUsernameDocument, options);
}
export type GetUserProfileByUsernameQueryHookResult = ReturnType<
  typeof useGetUserProfileByUsernameQuery
>;
export type GetUserProfileByUsernameLazyQueryHookResult = ReturnType<
  typeof useGetUserProfileByUsernameLazyQuery
>;
export type GetUserProfileByUsernameQueryResult = Apollo.QueryResult<
  GetUserProfileByUsernameQuery,
  GetUserProfileByUsernameQueryVariables
>;
export const TrackLogPlayDocument = /*#__PURE__*/ gql`
  mutation TrackLogPlay($input: TrackLogPlayInput!) {
    trackLogPlay(input: $input)
  }
`;
export type TrackLogPlayMutationFn = Apollo.MutationFunction<
  TrackLogPlayMutation,
  TrackLogPlayMutationVariables
>;

/**
 * __useTrackLogPlayMutation__
 *
 * To run a mutation, you first call `useTrackLogPlayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackLogPlayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackLogPlayMutation, { data, loading, error }] = useTrackLogPlayMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTrackLogPlayMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TrackLogPlayMutation,
    TrackLogPlayMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TrackLogPlayMutation,
    TrackLogPlayMutationVariables
  >(TrackLogPlayDocument, options);
}
export type TrackLogPlayMutationHookResult = ReturnType<
  typeof useTrackLogPlayMutation
>;
export type TrackLogPlayMutationResult = Apollo.MutationResult<
  TrackLogPlayMutation
>;
export type TrackLogPlayMutationOptions = Apollo.BaseMutationOptions<
  TrackLogPlayMutation,
  TrackLogPlayMutationVariables
>;
export const UserSetParentalControlsDocument = /*#__PURE__*/ gql`
  mutation UserSetParentalControls($input: UserSetParentalControlsInput!) {
    userSetParentalControls(input: $input) {
      id
      parentalControls {
        isEnabled
        pin
      }
    }
  }
`;
export type UserSetParentalControlsMutationFn = Apollo.MutationFunction<
  UserSetParentalControlsMutation,
  UserSetParentalControlsMutationVariables
>;

/**
 * __useUserSetParentalControlsMutation__
 *
 * To run a mutation, you first call `useUserSetParentalControlsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserSetParentalControlsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userSetParentalControlsMutation, { data, loading, error }] = useUserSetParentalControlsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserSetParentalControlsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UserSetParentalControlsMutation,
    UserSetParentalControlsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UserSetParentalControlsMutation,
    UserSetParentalControlsMutationVariables
  >(UserSetParentalControlsDocument, options);
}
export type UserSetParentalControlsMutationHookResult = ReturnType<
  typeof useUserSetParentalControlsMutation
>;
export type UserSetParentalControlsMutationResult = Apollo.MutationResult<
  UserSetParentalControlsMutation
>;
export type UserSetParentalControlsMutationOptions = Apollo.BaseMutationOptions<
  UserSetParentalControlsMutation,
  UserSetParentalControlsMutationVariables
>;
export const UpdateUsersLastSeenDocument = /*#__PURE__*/ gql`
  mutation UpdateUsersLastSeen {
    updateUsersLastSeen {
      success
    }
  }
`;
export type UpdateUsersLastSeenMutationFn = Apollo.MutationFunction<
  UpdateUsersLastSeenMutation,
  UpdateUsersLastSeenMutationVariables
>;

/**
 * __useUpdateUsersLastSeenMutation__
 *
 * To run a mutation, you first call `useUpdateUsersLastSeenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUsersLastSeenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUsersLastSeenMutation, { data, loading, error }] = useUpdateUsersLastSeenMutation({
 *   variables: {
 *   },
 * });
 */
export function useUpdateUsersLastSeenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUsersLastSeenMutation,
    UpdateUsersLastSeenMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateUsersLastSeenMutation,
    UpdateUsersLastSeenMutationVariables
  >(UpdateUsersLastSeenDocument, options);
}
export type UpdateUsersLastSeenMutationHookResult = ReturnType<
  typeof useUpdateUsersLastSeenMutation
>;
export type UpdateUsersLastSeenMutationResult = Apollo.MutationResult<
  UpdateUsersLastSeenMutation
>;
export type UpdateUsersLastSeenMutationOptions = Apollo.BaseMutationOptions<
  UpdateUsersLastSeenMutation,
  UpdateUsersLastSeenMutationVariables
>;
export const UserValidatePinDocument = /*#__PURE__*/ gql`
  query UserValidatePin($pin: String!) {
    userValidatePin(input: { pin: $pin })
  }
`;

/**
 * __useUserValidatePinQuery__
 *
 * To run a query within a React component, call `useUserValidatePinQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserValidatePinQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserValidatePinQuery({
 *   variables: {
 *      pin: // value for 'pin'
 *   },
 * });
 */
export function useUserValidatePinQuery(
  baseOptions: Apollo.QueryHookOptions<
    UserValidatePinQuery,
    UserValidatePinQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UserValidatePinQuery, UserValidatePinQueryVariables>(
    UserValidatePinDocument,
    options
  );
}
export function useUserValidatePinLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserValidatePinQuery,
    UserValidatePinQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    UserValidatePinQuery,
    UserValidatePinQueryVariables
  >(UserValidatePinDocument, options);
}
export type UserValidatePinQueryHookResult = ReturnType<
  typeof useUserValidatePinQuery
>;
export type UserValidatePinLazyQueryHookResult = ReturnType<
  typeof useUserValidatePinLazyQuery
>;
export type UserValidatePinQueryResult = Apollo.QueryResult<
  UserValidatePinQuery,
  UserValidatePinQueryVariables
>;
export const GetUserProgressDocument = /*#__PURE__*/ gql`
  query GetUserProgress {
    user {
      progress {
        total_time_spent
        classes_completed
      }
    }
  }
`;

/**
 * __useGetUserProgressQuery__
 *
 * To run a query within a React component, call `useGetUserProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserProgressQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserProgressQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetUserProgressQuery,
    GetUserProgressQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUserProgressQuery, GetUserProgressQueryVariables>(
    GetUserProgressDocument,
    options
  );
}
export function useGetUserProgressLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserProgressQuery,
    GetUserProgressQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetUserProgressQuery,
    GetUserProgressQueryVariables
  >(GetUserProgressDocument, options);
}
export type GetUserProgressQueryHookResult = ReturnType<
  typeof useGetUserProgressQuery
>;
export type GetUserProgressLazyQueryHookResult = ReturnType<
  typeof useGetUserProgressLazyQuery
>;
export type GetUserProgressQueryResult = Apollo.QueryResult<
  GetUserProgressQuery,
  GetUserProgressQueryVariables
>;
export const SubscriptionCreateForCustomerDocument = /*#__PURE__*/ gql`
  mutation SubscriptionCreateForCustomer(
    $planInfo: PlanInfoInput!
    $couponIds: [String!]
    $ipInfo: IpInfoInput
  ) {
    subscriptionCreateForCustomer(
      input: { planInfo: $planInfo, couponIds: $couponIds, ipInfo: $ipInfo }
    ) {
      id
      isActive
      isCancelable
      isReactivatableV2
      isPauseScheduled
      isPastDue
      nextBillingAt
      status
      trialEndTime
      currentTermEnd
      cancelationTime
      pauseTime
      resumeTime
      provider {
        id
      }
      trialEndTime
      plan {
        ...PlanFields
        trialPeriod
        periodUnit
        priceInCents
        provider {
          id
        }
      }
      user {
        id
        uid
        isActive
        hasTrialed
      }
    }
  }
  ${PlanFieldsFragmentDoc}
`;
export type SubscriptionCreateForCustomerMutationFn = Apollo.MutationFunction<
  SubscriptionCreateForCustomerMutation,
  SubscriptionCreateForCustomerMutationVariables
>;

/**
 * __useSubscriptionCreateForCustomerMutation__
 *
 * To run a mutation, you first call `useSubscriptionCreateForCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionCreateForCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscriptionCreateForCustomerMutation, { data, loading, error }] = useSubscriptionCreateForCustomerMutation({
 *   variables: {
 *      planInfo: // value for 'planInfo'
 *      couponIds: // value for 'couponIds'
 *      ipInfo: // value for 'ipInfo'
 *   },
 * });
 */
export function useSubscriptionCreateForCustomerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubscriptionCreateForCustomerMutation,
    SubscriptionCreateForCustomerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SubscriptionCreateForCustomerMutation,
    SubscriptionCreateForCustomerMutationVariables
  >(SubscriptionCreateForCustomerDocument, options);
}
export type SubscriptionCreateForCustomerMutationHookResult = ReturnType<
  typeof useSubscriptionCreateForCustomerMutation
>;
export type SubscriptionCreateForCustomerMutationResult = Apollo.MutationResult<
  SubscriptionCreateForCustomerMutation
>;
export type SubscriptionCreateForCustomerMutationOptions = Apollo.BaseMutationOptions<
  SubscriptionCreateForCustomerMutation,
  SubscriptionCreateForCustomerMutationVariables
>;
export const SwitchablePlansDocument = /*#__PURE__*/ gql`
  query SwitchablePlans {
    switchablePlans {
      ...SwitchPlanFields
      isBestValue
      isSubscribed
      monthlySavingsInPercent
      monthlyCostInCents
      annualSavingsInCents
      period
      periodUnit
      priceInCents
      invoiceEstimate {
        amountDue
        creditsApplied
        total
        subTotal
      }
      changePlanEstimate {
        changePlanType
        isEndOfTerm
        invoiceEstimate {
          amountDue
          total
        }
      }
      provider {
        id
        name
      }
    }
  }
  ${SwitchPlanFieldsFragmentDoc}
`;

/**
 * __useSwitchablePlansQuery__
 *
 * To run a query within a React component, call `useSwitchablePlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useSwitchablePlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSwitchablePlansQuery({
 *   variables: {
 *   },
 * });
 */
export function useSwitchablePlansQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SwitchablePlansQuery,
    SwitchablePlansQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SwitchablePlansQuery, SwitchablePlansQueryVariables>(
    SwitchablePlansDocument,
    options
  );
}
export function useSwitchablePlansLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SwitchablePlansQuery,
    SwitchablePlansQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SwitchablePlansQuery,
    SwitchablePlansQueryVariables
  >(SwitchablePlansDocument, options);
}
export type SwitchablePlansQueryHookResult = ReturnType<
  typeof useSwitchablePlansQuery
>;
export type SwitchablePlansLazyQueryHookResult = ReturnType<
  typeof useSwitchablePlansLazyQuery
>;
export type SwitchablePlansQueryResult = Apollo.QueryResult<
  SwitchablePlansQuery,
  SwitchablePlansQueryVariables
>;
export const GetCanUserTakeClassDocument = /*#__PURE__*/ gql`
  query GetCanUserTakeClass($classId: String!) {
    classData: classById(id: $classId) {
      id
      canUserTakeClass
    }
  }
`;

/**
 * __useGetCanUserTakeClassQuery__
 *
 * To run a query within a React component, call `useGetCanUserTakeClassQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCanUserTakeClassQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCanUserTakeClassQuery({
 *   variables: {
 *      classId: // value for 'classId'
 *   },
 * });
 */
export function useGetCanUserTakeClassQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCanUserTakeClassQuery,
    GetCanUserTakeClassQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCanUserTakeClassQuery,
    GetCanUserTakeClassQueryVariables
  >(GetCanUserTakeClassDocument, options);
}
export function useGetCanUserTakeClassLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCanUserTakeClassQuery,
    GetCanUserTakeClassQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCanUserTakeClassQuery,
    GetCanUserTakeClassQueryVariables
  >(GetCanUserTakeClassDocument, options);
}
export type GetCanUserTakeClassQueryHookResult = ReturnType<
  typeof useGetCanUserTakeClassQuery
>;
export type GetCanUserTakeClassLazyQueryHookResult = ReturnType<
  typeof useGetCanUserTakeClassLazyQuery
>;
export type GetCanUserTakeClassQueryResult = Apollo.QueryResult<
  GetCanUserTakeClassQuery,
  GetCanUserTakeClassQueryVariables
>;
export const SubscriptionCancelDocument = /*#__PURE__*/ gql`
  mutation SubscriptionCancel(
    $subscriptionId: String!
    $cancelReason: String
    $cancelNow: Boolean
  ) {
    subscriptionCancel(
      input: {
        subscriptionId: $subscriptionId
        cancelReason: $cancelReason
        cancelNow: $cancelNow
      }
    ) {
      ...SubscriptionFields
      plan {
        ...SubscriptionPlanFields
      }
      user {
        id
        isActive
      }
    }
  }
  ${SubscriptionFieldsFragmentDoc}
  ${SubscriptionPlanFieldsFragmentDoc}
`;
export type SubscriptionCancelMutationFn = Apollo.MutationFunction<
  SubscriptionCancelMutation,
  SubscriptionCancelMutationVariables
>;

/**
 * __useSubscriptionCancelMutation__
 *
 * To run a mutation, you first call `useSubscriptionCancelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionCancelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscriptionCancelMutation, { data, loading, error }] = useSubscriptionCancelMutation({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *      cancelReason: // value for 'cancelReason'
 *      cancelNow: // value for 'cancelNow'
 *   },
 * });
 */
export function useSubscriptionCancelMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubscriptionCancelMutation,
    SubscriptionCancelMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SubscriptionCancelMutation,
    SubscriptionCancelMutationVariables
  >(SubscriptionCancelDocument, options);
}
export type SubscriptionCancelMutationHookResult = ReturnType<
  typeof useSubscriptionCancelMutation
>;
export type SubscriptionCancelMutationResult = Apollo.MutationResult<
  SubscriptionCancelMutation
>;
export type SubscriptionCancelMutationOptions = Apollo.BaseMutationOptions<
  SubscriptionCancelMutation,
  SubscriptionCancelMutationVariables
>;
export const SubscriptionReactivateUsingCouponDocument = /*#__PURE__*/ gql`
  mutation SubscriptionReactivateUsingCoupon(
    $input: SubscriptionReactivateUsingCouponInput!
  ) {
    subscriptionReactivateUsingCoupon(input: $input) {
      ...SubscriptionFields
    }
  }
  ${SubscriptionFieldsFragmentDoc}
`;
export type SubscriptionReactivateUsingCouponMutationFn = Apollo.MutationFunction<
  SubscriptionReactivateUsingCouponMutation,
  SubscriptionReactivateUsingCouponMutationVariables
>;

/**
 * __useSubscriptionReactivateUsingCouponMutation__
 *
 * To run a mutation, you first call `useSubscriptionReactivateUsingCouponMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionReactivateUsingCouponMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscriptionReactivateUsingCouponMutation, { data, loading, error }] = useSubscriptionReactivateUsingCouponMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubscriptionReactivateUsingCouponMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubscriptionReactivateUsingCouponMutation,
    SubscriptionReactivateUsingCouponMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SubscriptionReactivateUsingCouponMutation,
    SubscriptionReactivateUsingCouponMutationVariables
  >(SubscriptionReactivateUsingCouponDocument, options);
}
export type SubscriptionReactivateUsingCouponMutationHookResult = ReturnType<
  typeof useSubscriptionReactivateUsingCouponMutation
>;
export type SubscriptionReactivateUsingCouponMutationResult = Apollo.MutationResult<
  SubscriptionReactivateUsingCouponMutation
>;
export type SubscriptionReactivateUsingCouponMutationOptions = Apollo.BaseMutationOptions<
  SubscriptionReactivateUsingCouponMutation,
  SubscriptionReactivateUsingCouponMutationVariables
>;
export const CreateCancelSurveyDocument = /*#__PURE__*/ gql`
  mutation CreateCancelSurvey($input: CancelSurveyInput!) {
    createCancelSurvey(input: $input) {
      id
      createdAt
      updatedAt
      reason
      otherReason
      joinAgainReason
      overallExperienceRating
      additionalFeedback
      subscription {
        id
        status
        currentTermEnd
      }
    }
  }
`;
export type CreateCancelSurveyMutationFn = Apollo.MutationFunction<
  CreateCancelSurveyMutation,
  CreateCancelSurveyMutationVariables
>;

/**
 * __useCreateCancelSurveyMutation__
 *
 * To run a mutation, you first call `useCreateCancelSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCancelSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCancelSurveyMutation, { data, loading, error }] = useCreateCancelSurveyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCancelSurveyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCancelSurveyMutation,
    CreateCancelSurveyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateCancelSurveyMutation,
    CreateCancelSurveyMutationVariables
  >(CreateCancelSurveyDocument, options);
}
export type CreateCancelSurveyMutationHookResult = ReturnType<
  typeof useCreateCancelSurveyMutation
>;
export type CreateCancelSurveyMutationResult = Apollo.MutationResult<
  CreateCancelSurveyMutation
>;
export type CreateCancelSurveyMutationOptions = Apollo.BaseMutationOptions<
  CreateCancelSurveyMutation,
  CreateCancelSurveyMutationVariables
>;
export const GetPrimarySubscriptionDocument = /*#__PURE__*/ gql`
  query GetPrimarySubscription {
    me {
      id
      primarySubscription {
        id
        isActive
        isCancelable
        isReactivatableV2
        isPauseScheduled
        isPastDue
        nextBillingAt
        status
        trialEndTime
        currentTermEnd
        cancelationTime
        pauseTime
        resumeTime
        provider {
          id
        }
        plan {
          id
          name
          accessType
          isSpecial
          isLegacy
          periodUnit
          platform
          priceInCents
          monthlyCostInCents
          provider {
            name
            id
          }
        }
        invoiceEstimate {
          amountDue
        }
        invoiceDue {
          id
          amountDue
          dunningAttemptsCount
          nextRetryAt
          dueDate
        }
        provider {
          name
        }
      }
      scheduledSubscriptionChange {
        id
        nextBillingAt
        invoiceDue {
          amountDue
        }
        invoiceEstimate {
          amountDue
          total
        }
        plan {
          id
          name
        }
      }
    }
  }
`;

/**
 * __useGetPrimarySubscriptionQuery__
 *
 * To run a query within a React component, call `useGetPrimarySubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrimarySubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrimarySubscriptionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPrimarySubscriptionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPrimarySubscriptionQuery,
    GetPrimarySubscriptionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPrimarySubscriptionQuery,
    GetPrimarySubscriptionQueryVariables
  >(GetPrimarySubscriptionDocument, options);
}
export function useGetPrimarySubscriptionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPrimarySubscriptionQuery,
    GetPrimarySubscriptionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPrimarySubscriptionQuery,
    GetPrimarySubscriptionQueryVariables
  >(GetPrimarySubscriptionDocument, options);
}
export type GetPrimarySubscriptionQueryHookResult = ReturnType<
  typeof useGetPrimarySubscriptionQuery
>;
export type GetPrimarySubscriptionLazyQueryHookResult = ReturnType<
  typeof useGetPrimarySubscriptionLazyQuery
>;
export type GetPrimarySubscriptionQueryResult = Apollo.QueryResult<
  GetPrimarySubscriptionQuery,
  GetPrimarySubscriptionQueryVariables
>;
export const GetPrimaryPaymentSourceDocument = /*#__PURE__*/ gql`
  query GetPrimaryPaymentSource {
    me {
      primaryPaymentSource {
        id
        gateway
        type
        card {
          lastFour
          brand
          fundingType
          object
        }
      }
    }
  }
`;

/**
 * __useGetPrimaryPaymentSourceQuery__
 *
 * To run a query within a React component, call `useGetPrimaryPaymentSourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrimaryPaymentSourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrimaryPaymentSourceQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPrimaryPaymentSourceQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPrimaryPaymentSourceQuery,
    GetPrimaryPaymentSourceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPrimaryPaymentSourceQuery,
    GetPrimaryPaymentSourceQueryVariables
  >(GetPrimaryPaymentSourceDocument, options);
}
export function useGetPrimaryPaymentSourceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPrimaryPaymentSourceQuery,
    GetPrimaryPaymentSourceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPrimaryPaymentSourceQuery,
    GetPrimaryPaymentSourceQueryVariables
  >(GetPrimaryPaymentSourceDocument, options);
}
export type GetPrimaryPaymentSourceQueryHookResult = ReturnType<
  typeof useGetPrimaryPaymentSourceQuery
>;
export type GetPrimaryPaymentSourceLazyQueryHookResult = ReturnType<
  typeof useGetPrimaryPaymentSourceLazyQuery
>;
export type GetPrimaryPaymentSourceQueryResult = Apollo.QueryResult<
  GetPrimaryPaymentSourceQuery,
  GetPrimaryPaymentSourceQueryVariables
>;
export const GetUserHasTrialedDocument = /*#__PURE__*/ gql`
  query GetUserHasTrialed {
    me {
      hasTrialed
    }
  }
`;

/**
 * __useGetUserHasTrialedQuery__
 *
 * To run a query within a React component, call `useGetUserHasTrialedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserHasTrialedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserHasTrialedQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserHasTrialedQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetUserHasTrialedQuery,
    GetUserHasTrialedQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetUserHasTrialedQuery,
    GetUserHasTrialedQueryVariables
  >(GetUserHasTrialedDocument, options);
}
export function useGetUserHasTrialedLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserHasTrialedQuery,
    GetUserHasTrialedQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetUserHasTrialedQuery,
    GetUserHasTrialedQueryVariables
  >(GetUserHasTrialedDocument, options);
}
export type GetUserHasTrialedQueryHookResult = ReturnType<
  typeof useGetUserHasTrialedQuery
>;
export type GetUserHasTrialedLazyQueryHookResult = ReturnType<
  typeof useGetUserHasTrialedLazyQuery
>;
export type GetUserHasTrialedQueryResult = Apollo.QueryResult<
  GetUserHasTrialedQuery,
  GetUserHasTrialedQueryVariables
>;
export const GetCancelSurveyBySubscriptionIdDocument = /*#__PURE__*/ gql`
  query GetCancelSurveyBySubscriptionId($subscriptionId: String!) {
    cancelSurvey: getCancelSurveyBySubscriptionId(
      subscriptionId: $subscriptionId
    ) {
      id
      reason
      otherReason
      joinAgainReason
      overallExperienceRating
      additionalFeedback
      createdAt
      updatedAt
      subscription {
        id
        status
        currentTermEnd
      }
    }
  }
`;

/**
 * __useGetCancelSurveyBySubscriptionIdQuery__
 *
 * To run a query within a React component, call `useGetCancelSurveyBySubscriptionIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCancelSurveyBySubscriptionIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCancelSurveyBySubscriptionIdQuery({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function useGetCancelSurveyBySubscriptionIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCancelSurveyBySubscriptionIdQuery,
    GetCancelSurveyBySubscriptionIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCancelSurveyBySubscriptionIdQuery,
    GetCancelSurveyBySubscriptionIdQueryVariables
  >(GetCancelSurveyBySubscriptionIdDocument, options);
}
export function useGetCancelSurveyBySubscriptionIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCancelSurveyBySubscriptionIdQuery,
    GetCancelSurveyBySubscriptionIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCancelSurveyBySubscriptionIdQuery,
    GetCancelSurveyBySubscriptionIdQueryVariables
  >(GetCancelSurveyBySubscriptionIdDocument, options);
}
export type GetCancelSurveyBySubscriptionIdQueryHookResult = ReturnType<
  typeof useGetCancelSurveyBySubscriptionIdQuery
>;
export type GetCancelSurveyBySubscriptionIdLazyQueryHookResult = ReturnType<
  typeof useGetCancelSurveyBySubscriptionIdLazyQuery
>;
export type GetCancelSurveyBySubscriptionIdQueryResult = Apollo.QueryResult<
  GetCancelSurveyBySubscriptionIdQuery,
  GetCancelSurveyBySubscriptionIdQueryVariables
>;
export const CheckSubscriptionCouponDocument = /*#__PURE__*/ gql`
  query CheckSubscriptionCoupon($input: CheckSubscriptionCouponInput!) {
    checkSubscriptionCoupon(input: $input)
  }
`;

/**
 * __useCheckSubscriptionCouponQuery__
 *
 * To run a query within a React component, call `useCheckSubscriptionCouponQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckSubscriptionCouponQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckSubscriptionCouponQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckSubscriptionCouponQuery(
  baseOptions: Apollo.QueryHookOptions<
    CheckSubscriptionCouponQuery,
    CheckSubscriptionCouponQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CheckSubscriptionCouponQuery,
    CheckSubscriptionCouponQueryVariables
  >(CheckSubscriptionCouponDocument, options);
}
export function useCheckSubscriptionCouponLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CheckSubscriptionCouponQuery,
    CheckSubscriptionCouponQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CheckSubscriptionCouponQuery,
    CheckSubscriptionCouponQueryVariables
  >(CheckSubscriptionCouponDocument, options);
}
export type CheckSubscriptionCouponQueryHookResult = ReturnType<
  typeof useCheckSubscriptionCouponQuery
>;
export type CheckSubscriptionCouponLazyQueryHookResult = ReturnType<
  typeof useCheckSubscriptionCouponLazyQuery
>;
export type CheckSubscriptionCouponQueryResult = Apollo.QueryResult<
  CheckSubscriptionCouponQuery,
  CheckSubscriptionCouponQueryVariables
>;
export const GetMeUserProfileDocument = /*#__PURE__*/ gql`
  query GetMeUserProfile {
    me {
      id
      uid
      username
      name
      photoURL
      totalLikesCount
    }
  }
`;

/**
 * __useGetMeUserProfileQuery__
 *
 * To run a query within a React component, call `useGetMeUserProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeUserProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeUserProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeUserProfileQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetMeUserProfileQuery,
    GetMeUserProfileQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMeUserProfileQuery, GetMeUserProfileQueryVariables>(
    GetMeUserProfileDocument,
    options
  );
}
export function useGetMeUserProfileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMeUserProfileQuery,
    GetMeUserProfileQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetMeUserProfileQuery,
    GetMeUserProfileQueryVariables
  >(GetMeUserProfileDocument, options);
}
export type GetMeUserProfileQueryHookResult = ReturnType<
  typeof useGetMeUserProfileQuery
>;
export type GetMeUserProfileLazyQueryHookResult = ReturnType<
  typeof useGetMeUserProfileLazyQuery
>;
export type GetMeUserProfileQueryResult = Apollo.QueryResult<
  GetMeUserProfileQuery,
  GetMeUserProfileQueryVariables
>;
